import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  DateTimeType: { input: Date; output: Date; }
  DateType: { input: any; output: any; }
  EmailType: { input: string; output: string; }
  JSON: { input: any; output: any; }
  UuidType: { input: string; output: string; }
};

/** Access owner */
export enum AccessOwner {
  Accountant = 'Accountant',
  Enty = 'Enty',
  User = 'User'
}

export type AccessToken = {
  app: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  dateTo: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  user?: InputMaybe<User>;
  userId: Scalars['String']['input'];
};

export type AccessTokenType = {
  __typename?: 'AccessTokenType';
  app: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  dateTo: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  user?: Maybe<UserType>;
  userId: Scalars['String']['output'];
};

export type AccountantCabinetCompanyData = {
  __typename?: 'AccountantCabinetCompanyData';
  company: CompanyOpeningType;
  planId?: Maybe<Scalars['String']['output']>;
};

/** Information of accountant */
export type AccountantDto = {
  __typename?: 'AccountantDto';
  /** Accountant access type */
  access: Scalars['String']['output'];
  /** Accountant email */
  email?: Maybe<Scalars['String']['output']>;
  /** Accountant role as user */
  role?: Maybe<Scalars['String']['output']>;
  /** Accountant ID */
  userId: Scalars['UuidType']['output'];
};

/** Status of accountant feedback for a period */
export enum AccountantFeedbackStatus {
  EarlyBird = 'EarlyBird',
  FirstReminder = 'FirstReminder',
  HasDebts = 'HasDebts',
  NeedsAttention = 'NeedsAttention',
  NotDefined = 'NotDefined',
  OnTrack = 'OnTrack',
  ReportNotSubmittedNoReason = 'ReportNotSubmittedNoReason',
  ReportNotSubmittedWithReason = 'ReportNotSubmittedWithReason',
  ReportSubmitted = 'ReportSubmitted',
  SecondReminder = 'SecondReminder',
  ThirdReminder = 'ThirdReminder',
  Upcoming = 'Upcoming',
  WellPrepared = 'WellPrepared'
}

export type AccountantFeedbackStatusType = {
  __typename?: 'AccountantFeedbackStatusType';
  /** The accountant feedback status for the period */
  status: AccountantFeedbackStatus;
};

/** Documents list with pagination */
export type AccountantListDto = {
  __typename?: 'AccountantListDto';
  /** Accountant list */
  accountants: Array<AccountantDto>;
  /** Limitation on the maximum number of documents */
  limit: Scalars['Int']['output'];
  /** Limitation on the maximum number of documents */
  offset: Scalars['Int']['output'];
  /** Total count documents */
  total: Scalars['Int']['output'];
};

/** Active accountant with the firms they work in — an option of the company list filter */
export type AccountantWithFirms = {
  __typename?: 'AccountantWithFirms';
  /** Accountant email */
  email: Scalars['String']['output'];
  /** Firms the accountant works in */
  firms: Array<AssignedAccountingFirm>;
  /** Accountant user ID */
  id: Scalars['UuidType']['output'];
  /** Accountant first name */
  name?: Maybe<Scalars['String']['output']>;
  /** Accountant last name */
  surname?: Maybe<Scalars['String']['output']>;
};

/** Information about users active plans */
export type AccountingActivePeriodType = {
  __typename?: 'AccountingActivePeriodType';
  /** Report month */
  month: Scalars['Int']['output'];
  /** Name of the period */
  name: Scalars['String']['output'];
  /** Report quarter */
  quarter: Scalars['Int']['output'];
  /** Period type */
  type: AccountingReportPeriodEnum;
  /** Report year */
  year: Scalars['Int']['output'];
};

export type AccountingCompanyContractFolderWithFilesDto = {
  __typename?: 'AccountingCompanyContractFolderWithFilesDto';
  contractsFiles: Array<ContractsFileType>;
  contractsFolder: ContractsFolder;
};

export type AccountingCompanyContractsFoldersDto = {
  __typename?: 'AccountingCompanyContractsFoldersDto';
  company: CompanyOpeningType;
  companyFolder: CompanyFolder;
  contractsFolders: Array<ContractsFolder>;
};

export type AccountingCompanyPeriodFolder = {
  __typename?: 'AccountingCompanyPeriodFolder';
  periodFolder: AccountingReportType;
};

export type AccountingCompanyPeriodSubfolderWithFiles = {
  __typename?: 'AccountingCompanyPeriodSubfolderWithFiles';
  /** Files with their associated customer VAT numbers */
  files: Array<AccountingFileType>;
  subFolder: PeriodsSubfolderType;
};

export type AccountingCompanyPeriodWithSubfolders = {
  __typename?: 'AccountingCompanyPeriodWithSubfolders';
  period: AccountingReportType;
  subfolders: Array<PeriodsSubfolderType>;
};

export type AccountingCompanyWithFolders = {
  __typename?: 'AccountingCompanyWithFolders';
  company: CompanyOpeningType;
  companyFolder: CompanyFolder;
  folders: Array<YearFolder>;
};

export type AccountingCompanyYearFolderWithPeriods = {
  __typename?: 'AccountingCompanyYearFolderWithPeriods';
  periods: Array<AccountingReportType>;
  yearFolder: YearFolder;
};

/** Information of document */
export type AccountingDocument = {
  __typename?: 'AccountingDocument';
  /** Accounting status */
  accStatusId: FileAccStatus;
  /** Counterparty name */
  counterparty?: Maybe<Scalars['String']['output']>;
  /** Date`s document */
  date?: Maybe<Scalars['DateTimeType']['output']>;
  /** File ID */
  id: Scalars['UuidType']['output'];
  /** Info about of Invoicing Or Monite */
  invoicingOrMonite?: Maybe<Scalars['String']['output']>;
  /** File name */
  name?: Maybe<Scalars['String']['output']>;
  /** Rejection comment */
  rejectionComment?: Maybe<Scalars['String']['output']>;
  /** Rejection reason */
  rejectionReasonId?: Maybe<FileRejectionReason>;
  /** Source of file */
  source?: Maybe<Scalars['String']['output']>;
  /** File status */
  status?: Maybe<Scalars['String']['output']>;
  /** Currency with amount */
  sum?: Maybe<Scalars['String']['output']>;
  /** File type */
  type?: Maybe<FileType>;
};

/** Information of accounting documents */
export type AccountingDocumentsDocumentsByStatus = {
  __typename?: 'AccountingDocumentsDocumentsByStatus';
  /** StatusId */
  accStatusId: FileAccStatus;
  /** Total documents grouped by status */
  docsCount: Scalars['Int']['output'];
};

/** Documents list with pagination */
export type AccountingDocumentsList = {
  __typename?: 'AccountingDocumentsList';
  /** Document files */
  docs: Array<AccountingDocument>;
  /** Limitation on the maximum number of documents */
  limit: Scalars['Int']['output'];
  /** Limitation on the maximum number of documents */
  offset: Scalars['Int']['output'];
  /** Total count documents */
  total: Scalars['Int']['output'];
};

/** Information of accounting documents */
export type AccountingDocumentsStatistics = {
  __typename?: 'AccountingDocumentsStatistics';
  /** Total documents grouped by status */
  documentsByStatus: Array<AccountingDocumentsDocumentsByStatus>;
  /** Total uploaded accounting documents */
  totalUploadedAccDocuments: Scalars['Int']['output'];
};

export type AccountingFileInputType = {
  /** Identifier of the uploaded file */
  fileId: Scalars['String']['input'];
  /** Is this file was uploaded from transactions module */
  fromTransactions?: Scalars['Boolean']['input'];
  /** Group type */
  groupType?: InputMaybe<GroupTypeEnum>;
  /** Report month */
  month?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the uploaded file */
  name: Scalars['String']['input'];
  /** Period to which the file belongs */
  period?: InputMaybe<AccountingReportPeriodEnum>;
  /** Report quarter */
  quarter?: InputMaybe<Scalars['Int']['input']>;
  /** How the file was uploaded */
  source?: InputMaybe<FileSource>;
  /** File status */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Type of the file */
  type: AccountingReportPartTypeEnum;
  /** File type */
  type_file?: InputMaybe<FileType>;
  /** Report year */
  year: Scalars['Int']['input'];
};

/** Information about a file related to the accounting */
export type AccountingFileType = {
  __typename?: 'AccountingFileType';
  /** Accounting status */
  accStatusId: FileAccStatus;
  /** Company ID */
  companyId: Scalars['UuidType']['output'];
  /** Time when file information was created */
  createdAt?: Maybe<Scalars['DateTimeType']['output']>;
  /** Customer VAT number */
  customerVatNumber?: Maybe<Scalars['String']['output']>;
  /** Group type */
  groupType: GroupTypeEnum;
  /** File ID */
  id: Scalars['UuidType']['output'];
  /** Associated invoicing credit note */
  invoicingCreditNote?: Maybe<InvoicingCreditNoteEntity>;
  /** Associated invoicing document */
  invoicingDocument?: Maybe<InvoicingDocumentEntity>;
  /** True when the period was assigned automatically (OCR), not manually */
  isPeriodAutoAssigned: Scalars['Boolean']['output'];
  /** Is file read by accountant or not */
  isRead: Scalars['Boolean']['output'];
  /** Merit invoice ID */
  meritInvoiceId?: Maybe<Scalars['String']['output']>;
  /** Merit payment ID */
  meritPaymentId?: Maybe<Scalars['String']['output']>;
  /** Merit ref no */
  meritRefNo?: Maybe<Scalars['String']['output']>;
  /** Why the last attempt to send this file to Merit failed */
  meritShipmentError?: Maybe<Scalars['String']['output']>;
  /** Result of the last attempt to send this file to Merit. Null when the file was never sent or the relation was not loaded */
  meritShipmentStatus?: Maybe<MeritInvoiceShipmentResult>;
  moniteInvoice?: Maybe<MoniteInvoiceEntity>;
  /** File name */
  name: Scalars['String']['output'];
  /** Need to be transfered after OCR */
  needTransfer?: Maybe<Scalars['Boolean']['output']>;
  periodsSubfolder?: Maybe<PeriodsSubfolderType>;
  /** ID of the section to which the file belongs */
  periodsSubfolderId?: Maybe<Scalars['String']['output']>;
  /** Rejection comment */
  rejectionComment?: Maybe<Scalars['String']['output']>;
  /** Rejection reason */
  rejectionReasonId?: Maybe<FileRejectionReason>;
  /** How the file was uploaded */
  source?: Maybe<FileSource>;
  /** File status */
  status?: Maybe<Scalars['String']['output']>;
  /** File type */
  type?: Maybe<FileType>;
  /** User ID */
  userId: Scalars['UuidType']['output'];
};

export type AccountingMutation = {
  __typename?: 'AccountingMutation';
  /** Add company(ies) for accountant */
  addCompanyForAccountant: Scalars['Boolean']['output'];
  /** Add or update Merit Key for company */
  addOrUpdateMeritApiKey: Scalars['Boolean']['output'];
  /** Connect e-commerce platform */
  changeAccessOwnerForAccountant: Scalars['Boolean']['output'];
  /** Change accountant role */
  changeAccountantRole: Scalars['Boolean']['output'];
  /**
   * Change file status
   * @deprecated Use changeFilesStatus instead
   */
  changeFileStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Change status for multiple files at once */
  changeFilesStatus?: Maybe<Scalars['Boolean']['output']>;
  /** period status changes on Processing docs */
  changePeriodStatusToProcessingDocs?: Maybe<Scalars['Boolean']['output']>;
  /** Change period type */
  changePeriodType?: Maybe<Scalars['Boolean']['output']>;
  changeSourceFile: Scalars['Boolean']['output'];
  /** Connect e-commerce platform */
  connectEcomPlatform: EcomShopAccessCreatedDto;
  /** Copy Report files from the previous year folder to the current one */
  copyReportFilesToPreviousYear: Scalars['Boolean']['output'];
  /** Create custom e-commerce platform */
  createCustomEcomShop: EcomShopEntity;
  /** Connect e-commerce platform */
  createEcomPlatformAccess: EcomShopAccessCreatedDto;
  /** Connect e-commerce platform */
  createEcomPlatformAccessForAccountant: EcomShopAccessCreatedDto;
  /** Initiate ecom shops connections for prod clients with known platforms */
  createExistingEcomShopAccessess: Scalars['Boolean']['output'];
  /** Add user for a firm */
  createFirmUser: Scalars['Boolean']['output'];
  /** Delete accountant */
  deleteAccountant: Scalars['Boolean']['output'];
  deleteBadFoldersMonthNull: Scalars['Boolean']['output'];
  /** Delete accounting file with its document info and transaction connections. Allowed for a manager, an accountant with access to the company and for the company own users */
  deleteCompanyFile?: Maybe<Scalars['Boolean']['output']>;
  /** Delete file from accounting */
  deleteContract: Scalars['Boolean']['output'];
  /** Delete e-commerce platform connection */
  deleteEcomShopAccess: Scalars['Boolean']['output'];
  /** Delete file from accounting */
  deleteFile: Scalars['Boolean']['output'];
  /** Delete Merit Key for company */
  deleteMeritApiKey: Scalars['Boolean']['output'];
  /** Soft delete Merit bank account (Manager and Accountant only) */
  deleteMeritBankAccount: Scalars['Boolean']['output'];
  /** Delete Merit payment (Aktiva v1/deletepayment) for the transaction: resolves meritPaymentId from merit_payment_shipment and companyId from banking account. Managers and accountants only. */
  deleteMeritPayment: Scalars['Boolean']['output'];
  /** Delete purchase invoice in Merit and unlink from accounting file */
  deleteMeritPurchaseInvoice: Scalars['Boolean']['output'];
  /** Delete period folder by id (Manager and Accountant only) */
  deletePeriodFolder: Scalars['Boolean']['output'];
  downloadReportsFromGDrive: Scalars['Boolean']['output'];
  /** Connect e-commerce platform */
  editEcomPlatformAccess: Scalars['Boolean']['output'];
  editFileIsRead: Scalars['Boolean']['output'];
  fillFieldYearFolderId: Scalars['Boolean']['output'];
  fixBadFoldersMonthNull: Scalars['Boolean']['output'];
  fixPeriodsFoldersInProd: Scalars['Boolean']['output'];
  /**
   * Delete file from filestorage
   * @deprecated Use deleteCompanyFile instead: it checks access to the company of the file
   */
  hardDeleteFile?: Maybe<Scalars['Boolean']['output']>;
  /** Link or unlink Merit bank account to Banking account (Manager and Accountant only) */
  linkMeritBankAccountToBankingAccount: Scalars['Boolean']['output'];
  /** Link or unlink Merit e-commerce account to the company e-commerce platform access (Manager and Accountant only) */
  linkMeritEcomShopToEcomShopAccess: Scalars['Boolean']['output'];
  manualRunAccOnboardingStatusNotif: Scalars['Boolean']['output'];
  /** Move file from one folder to another */
  moveContract?: Maybe<AccountingFileType>;
  /** Move file from one folder to another */
  moveFile?: Maybe<Scalars['Boolean']['output']>;
  /** Refresh Merit bank accounts for a specific company */
  refreshMeritBankAccounts: Scalars['Boolean']['output'];
  /** Rename file */
  renameFile?: Maybe<Scalars['Boolean']['output']>;
  restoreSubscrs: Scalars['Boolean']['output'];
  /** Remove company(ies) for accountant */
  rmCompanyForAccountant: Scalars['Boolean']['output'];
  saveFileFromChargebee: Array<AccountingFileType>;
  saveFiles: Array<AccountingFileType>;
  saveFilesInContractsFolder: Array<ContractsFileType>;
  saveFilesInSubfolderId: Array<AccountingFileType>;
  saveSalesReportFiles: Array<AccountingFileType>;
  saveTransferFiles: Array<AccountingFileType>;
  /** Save TSD and link for company */
  saveTsdLink: Scalars['Boolean']['output'];
  /** Create or update TSD tax link record */
  saveTsdTaxLink: TsdTaxLinkEntity;
  /** Save VAT and link for company */
  saveVatLink: Scalars['Boolean']['output'];
  /** Send Chargebee invoice to Merit as purchase invoice */
  sendChargebeeInvoiceToMerit: SendChargebeeInvoiceToMeritResultType;
  /** Send expense payment to Merit by transaction ID (managers and accountants only) */
  sendExpensePaymentToMerit: SendExpensePaymentToMeritResultType;
  /** Send income payment to Merit by transaction ID (managers and accountants only) */
  sendIncomePaymentToMerit: SendIncomePaymentToMeritResultType;
  /** Send purchase invoice to Merit */
  sendPurchaseInvoiceToMerit: SendChargebeeInvoiceToMeritResultType;
  /** Mark Merit bank account as the intermediary account for FX difference handling (Manager and Accountant only) */
  setMeritBankAccountIntermediary: Scalars['Boolean']['output'];
  /** Change period type for user */
  setPeriodTypeToProcessingDocs?: Maybe<Scalars['Boolean']['output']>;
  /** Set task for Chaser */
  setTaskForChaser: Scalars['Boolean']['output'];
  updateACompanyFolder: Scalars['Boolean']['output'];
  updateACompanyFolderByAdmin: Scalars['Boolean']['output'];
  /** Update isAccessAllowed for e-commerce platform (Manager only) */
  updateEcomPlatformIsAccessAllowed: Scalars['Boolean']['output'];
  /** Update e-com shop access by accountant & set waitForCheck to false */
  updateEcomShopAccess: EcomShopAccessEntity;
  /** Update the accountant-facing shop name override (does not affect the user-provided name) */
  updateEcomShopNameForAccountant: Scalars['Boolean']['output'];
  /** Validate Chargebee invoice before sending to Merit */
  validateChargebeeInvoiceForMerit: ChargebeeInvoiceValidationResultType;
  /** Validate an accountant draft (chat message or ticket subject) before sending: advisory only, returns issues, an improved English version and a back-translation into the source language */
  validateClientText: ValidateClientTextResult;
  /** Validate a whole ticket draft (subject + first message) in one call: the subject is checked using the AI-cleaned message as context. Advisory only. */
  validateTicketDraft: ValidateTicketDraftResult;
  /** Write off the FX difference from the intermediary Merit bank account at month end via GL batch (Manager and Accountant only) */
  writeOffMeritFxDifference: Scalars['Boolean']['output'];
};


export type AccountingMutationAddCompanyForAccountantArgs = {
  accountantUserId: Scalars['String']['input'];
  companyIds: Array<Scalars['UuidType']['input']>;
};


export type AccountingMutationAddOrUpdateMeritApiKeyArgs = {
  apiId: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};


export type AccountingMutationChangeAccessOwnerForAccountantArgs = {
  accessOwner?: InputMaybe<AccessOwner>;
  connectionId: Scalars['String']['input'];
};


export type AccountingMutationChangeAccountantRoleArgs = {
  accountantUserId: Scalars['String']['input'];
  firmId: Scalars['String']['input'];
  newAccess: Scalars['String']['input'];
};


export type AccountingMutationChangeFileStatusArgs = {
  accStatusId: FileAccStatus;
  fileId: Scalars['String']['input'];
  rejectionComment?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonId?: InputMaybe<FileRejectionReason>;
};


export type AccountingMutationChangeFilesStatusArgs = {
  accStatusId: FileAccStatus;
  fileIds: Array<Scalars['String']['input']>;
  rejectionComment?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonId?: InputMaybe<FileRejectionReason>;
};


export type AccountingMutationChangePeriodStatusToProcessingDocsArgs = {
  periodsFolderId: Scalars['String']['input'];
  statusApproved: Scalars['Boolean']['input'];
};


export type AccountingMutationChangePeriodTypeArgs = {
  periodId: Scalars['String']['input'];
  periodType: AccountingReportPeriodTypeEnum;
  reason?: InputMaybe<Array<AccountingReportPeriodReason>>;
};


export type AccountingMutationChangeSourceFileArgs = {
  password: Scalars['String']['input'];
};


export type AccountingMutationConnectEcomPlatformArgs = {
  accessOwner?: InputMaybe<AccessOwner>;
  platformId: Scalars['String']['input'];
  stripeApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingMutationCopyReportFilesToPreviousYearArgs = {
  sourcePeriodFolderId: Scalars['UuidType']['input'];
};


export type AccountingMutationCreateCustomEcomShopArgs = {
  platformName: Scalars['String']['input'];
  platformUrl: Scalars['String']['input'];
};


export type AccountingMutationCreateEcomPlatformAccessArgs = {
  accessOwner?: InputMaybe<AccessOwner>;
  platformId: Scalars['String']['input'];
  shopName: Scalars['String']['input'];
  stripeApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingMutationCreateEcomPlatformAccessForAccountantArgs = {
  accessOwner?: InputMaybe<AccessOwner>;
  companyId: Scalars['String']['input'];
  platformId: Scalars['String']['input'];
  shopName: Scalars['String']['input'];
  stripeApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingMutationCreateFirmUserArgs = {
  accessLevel: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firmId: Scalars['String']['input'];
};


export type AccountingMutationDeleteAccountantArgs = {
  accountantUserId: Scalars['String']['input'];
  firmId: Scalars['String']['input'];
};


export type AccountingMutationDeleteBadFoldersMonthNullArgs = {
  password: Scalars['String']['input'];
};


export type AccountingMutationDeleteCompanyFileArgs = {
  fileId: Scalars['String']['input'];
};


export type AccountingMutationDeleteContractArgs = {
  contractId: Scalars['String']['input'];
};


export type AccountingMutationDeleteEcomShopAccessArgs = {
  connectionId: Scalars['String']['input'];
};


export type AccountingMutationDeleteFileArgs = {
  fileId: Scalars['String']['input'];
};


export type AccountingMutationDeleteMeritApiKeyArgs = {
  companyId: Scalars['String']['input'];
};


export type AccountingMutationDeleteMeritBankAccountArgs = {
  companyId: Scalars['String']['input'];
  meritBankAccountId: Scalars['String']['input'];
};


export type AccountingMutationDeleteMeritPaymentArgs = {
  transactionId: Scalars['String']['input'];
};


export type AccountingMutationDeleteMeritPurchaseInvoiceArgs = {
  accountingFileId: Scalars['UuidType']['input'];
};


export type AccountingMutationDeletePeriodFolderArgs = {
  periodFolderId: Scalars['String']['input'];
};


export type AccountingMutationDownloadReportsFromGDriveArgs = {
  endDate: Scalars['String']['input'];
  password: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type AccountingMutationEditEcomPlatformAccessArgs = {
  accessOwner?: InputMaybe<AccessOwner>;
  connectionId: Scalars['String']['input'];
  shopName: Scalars['String']['input'];
  stripeApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingMutationEditFileIsReadArgs = {
  fileId: Scalars['String']['input'];
  isRead: Scalars['Boolean']['input'];
};


export type AccountingMutationFillFieldYearFolderIdArgs = {
  password: Scalars['String']['input'];
};


export type AccountingMutationFixBadFoldersMonthNullArgs = {
  password: Scalars['String']['input'];
};


export type AccountingMutationFixPeriodsFoldersInProdArgs = {
  password: Scalars['String']['input'];
};


export type AccountingMutationHardDeleteFileArgs = {
  fileId: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type AccountingMutationLinkMeritBankAccountToBankingAccountArgs = {
  bankingAccountId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  meritBankAccountId: Scalars['String']['input'];
};


export type AccountingMutationLinkMeritEcomShopToEcomShopAccessArgs = {
  companyId: Scalars['String']['input'];
  ecomShopsAccessId?: InputMaybe<Scalars['String']['input']>;
  meritEcomShopId: Scalars['String']['input'];
};


export type AccountingMutationManualRunAccOnboardingStatusNotifArgs = {
  companyId: Scalars['String']['input'];
};


export type AccountingMutationMoveContractArgs = {
  contractId: Scalars['String']['input'];
  periodsSubfolderId: Scalars['String']['input'];
};


export type AccountingMutationMoveFileArgs = {
  fileId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type AccountingMutationRefreshMeritBankAccountsArgs = {
  companyId: Scalars['String']['input'];
};


export type AccountingMutationRenameFileArgs = {
  fileId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type AccountingMutationRestoreSubscrsArgs = {
  password: Scalars['String']['input'];
};


export type AccountingMutationRmCompanyForAccountantArgs = {
  accountantUserId: Scalars['String']['input'];
  companyIds: Array<Scalars['UuidType']['input']>;
};


export type AccountingMutationSaveFileFromChargebeeArgs = {
  companyId: Scalars['UuidType']['input'];
  file: FromChargebeeInput;
  invoiceDate: Scalars['DateTime']['input'];
};


export type AccountingMutationSaveFilesArgs = {
  companyId: Scalars['UuidType']['input'];
  files: Array<InputMaybe<AccountingFileInputType>>;
};


export type AccountingMutationSaveFilesInContractsFolderArgs = {
  companyId: Scalars['UuidType']['input'];
  files: Array<InputMaybe<FileInContractsFolderInput>>;
};


export type AccountingMutationSaveFilesInSubfolderIdArgs = {
  companyId: Scalars['UuidType']['input'];
  files: Array<InputMaybe<FileInSubfolderIdInput>>;
};


export type AccountingMutationSaveSalesReportFilesArgs = {
  accessId: Scalars['UuidType']['input'];
  companyId: Scalars['UuidType']['input'];
  files: Array<InputMaybe<AccountingFileInputType>>;
};


export type AccountingMutationSaveTransferFilesArgs = {
  companyId: Scalars['UuidType']['input'];
  files: Array<AccountingTransferFileInputType>;
};


export type AccountingMutationSaveTsdLinkArgs = {
  periodFolderId: Scalars['String']['input'];
  tsdLink: Scalars['String']['input'];
  tsdSum: Scalars['Float']['input'];
};


export type AccountingMutationSaveTsdTaxLinkArgs = {
  input: UpsertTsdTaxLinkInputDto;
};


export type AccountingMutationSaveVatLinkArgs = {
  periodFolderId: Scalars['String']['input'];
  vatLink: Scalars['String']['input'];
  vatSum: Scalars['Float']['input'];
};


export type AccountingMutationSendChargebeeInvoiceToMeritArgs = {
  chargebeeInvoiceId: Scalars['String']['input'];
  forceSubmit?: Scalars['Boolean']['input'];
};


export type AccountingMutationSendExpensePaymentToMeritArgs = {
  transactionId: Scalars['String']['input'];
};


export type AccountingMutationSendIncomePaymentToMeritArgs = {
  transactionId: Scalars['String']['input'];
};


export type AccountingMutationSendPurchaseInvoiceToMeritArgs = {
  accountingFileId: Scalars['UuidType']['input'];
  ignoreScore?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccountingMutationSetMeritBankAccountIntermediaryArgs = {
  companyId: Scalars['String']['input'];
  isIntermediary: Scalars['Boolean']['input'];
  meritBankAccountId: Scalars['String']['input'];
};


export type AccountingMutationSetPeriodTypeToProcessingDocsArgs = {
  periodId: Scalars['String']['input'];
};


export type AccountingMutationSetTaskForChaserArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  deadline: Scalars['String']['input'];
  periodId: Scalars['String']['input'];
};


export type AccountingMutationUpdateACompanyFolderArgs = {
  data: UpdateCompanyFolderInputDto;
};


export type AccountingMutationUpdateACompanyFolderByAdminArgs = {
  companyId: Scalars['String']['input'];
  data: UpdateCompanyFolderByAdminInputDto;
};


export type AccountingMutationUpdateEcomPlatformIsAccessAllowedArgs = {
  isAccessAllowed: Scalars['Boolean']['input'];
  platformId: Scalars['String']['input'];
};


export type AccountingMutationUpdateEcomShopAccessArgs = {
  connectionId: Scalars['String']['input'];
  isAccessConfirmed: Scalars['Boolean']['input'];
};


export type AccountingMutationUpdateEcomShopNameForAccountantArgs = {
  connectionId: Scalars['String']['input'];
  shopName: Scalars['String']['input'];
};


export type AccountingMutationValidateChargebeeInvoiceForMeritArgs = {
  chargebeeInvoiceId: Scalars['String']['input'];
};


export type AccountingMutationValidateClientTextArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
  draft: Scalars['String']['input'];
  kind?: InputMaybe<ValidationKind>;
};


export type AccountingMutationValidateTicketDraftArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingMutationWriteOffMeritFxDifferenceArgs = {
  amount: Scalars['Float']['input'];
  companyId: Scalars['String']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type AccountingOnboardingResponseDto = {
  __typename?: 'AccountingOnboardingResponseDto';
  mainStatus: AccountingOnboardingStatus;
  steps: Array<AccountingOnboardingStep>;
};

/** Статусы онбординга бухгалтерии */
export enum AccountingOnboardingStatus {
  Completed = 'Completed',
  NeedsAttention = 'NeedsAttention',
  NotStarted = 'NotStarted',
  UnderReview = 'UnderReview'
}

export type AccountingOnboardingStep = {
  __typename?: 'AccountingOnboardingStep';
  name: AccountingOnboardingStepNames;
  status: AccountingOnboardingStepItemStatus;
};

/** Статусы шага онбординга бухгалтерии */
export enum AccountingOnboardingStepItemStatus {
  Completed = 'Completed',
  NeedsAttention = 'NeedsAttention',
  NotStarted = 'NotStarted',
  UnderReview = 'UnderReview'
}

/** Шаги онбординга бухгалтерии */
export enum AccountingOnboardingStepNames {
  ComplianceAllMembers = 'ComplianceAllMembers',
  ConnectBankAccount = 'ConnectBankAccount',
  SignIncorporationDocs = 'SignIncorporationDocs',
  TaxOfficeAccess = 'TaxOfficeAccess',
  TransferCompany = 'TransferCompany',
  UploadTransferDocuments = 'UploadTransferDocuments'
}

/** Information about users active plans */
export type AccountingPeriod = {
  /** Report month */
  month?: InputMaybe<Scalars['Int']['input']>;
  /** Report quarter */
  quarter?: InputMaybe<Scalars['Int']['input']>;
  /** Period type */
  type: AccountingReportPeriodEnum;
  /** Report year */
  year: Scalars['Int']['input'];
};

/** Declarations and reports info for a period */
export type AccountingPeriodDeclarationsDto = {
  __typename?: 'AccountingPeriodDeclarationsDto';
  /** Is TSD declaration available for this company */
  isTsdAvailable: Scalars['Boolean']['output'];
  /** TSD declaration deadline */
  tsdDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** TSD link */
  tsdLink?: Maybe<Scalars['String']['output']>;
  /** Declaration documents (TSD) */
  tsdReports: Array<AccountingDocument>;
  /** TSD sum */
  tsdSum?: Maybe<Scalars['Float']['output']>;
  /** VAT declaration deadline */
  vatDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** VAT link */
  vatLink?: Maybe<Scalars['String']['output']>;
  /** Report documents */
  vatReports: Array<AccountingDocument>;
  /** VAT sum */
  vatSum?: Maybe<Scalars['Float']['output']>;
};

export type AccountingPeriodDto = {
  __typename?: 'AccountingPeriodDto';
  month?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  periodType?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

export type AccountingPlanSettingsType = {
  __typename?: 'AccountingPlanSettingsType';
  /** Allowed reporting periods for document uploads */
  activePeriods: Array<AccountingActivePeriodType>;
  /** Limit for document uploads per period */
  docsLimit: Scalars['Int']['output'];
  /** Active reporting period type */
  type: AccountingReportPeriodEnum;
};

export type AccountingQuery = {
  __typename?: 'AccountingQuery';
  aCompanyFolder: CompanyFolder;
  aCompanyFolderAdmin: CompanyFolder;
  /** Companies for accountants */
  accountantCompanies: CompaniesListForAccountantsDto;
  /** Accountant's firms and roles */
  accountantInfo: Array<UserFirmType>;
  accountantsList: AccountantListDto;
  /** Documents from files */
  accountingDocumentsList: AccountingDocumentsList;
  /** Documents by status */
  accountingDocumentsStatistics: AccountingDocumentsStatistics;
  /** Declarations and Reports documents for a period */
  accountingPeriodDeclarations: AccountingPeriodDeclarationsDto;
  /** List of accounting ticket templates (Accountants and managers only). Returns id, name, subject, message */
  accountingTicketTemplatesForAccountants: Array<AccountingTicketTemplateType>;
  /** Documents from yearly folder and all monthly folders for calendar year. Used for annual reports. */
  accountingYearlyDocumentsList: AccountingYearlyDocumentsList;
  archiveAllFiles: ExportDocumentsReponseDto;
  /** Pre-flight check for byte-identical duplicates before uploading. Returns the already existing documents that matched by sha256 */
  checkDuplicateFiles: Array<DuplicateFileType>;
  /** Check if declaration was submitted for the previous period (for current user company) */
  checkPreviousPeriodDeclarationStatus: PreviousPeriodDeclarationStatusDto;
  /** Check if declaration was submitted for the previous period (for accountants/managers with specific company) */
  checkPreviousPeriodDeclarationStatusForCompany: PreviousPeriodDeclarationStatusDto;
  /** Companies for accountants */
  chiefCompanies: CompaniesListForAccountantsDto;
  /** Distinct years that have documents for the company (descending) */
  companyArchiveYears: Array<Scalars['Int']['output']>;
  /** Active accountants of all firms — options of the "assigned to" filter in the manager company list */
  companyListAccountants: Array<AccountantWithFirms>;
  countDocsAndTransactions: CountDocsAndTransactions;
  customerVatNumber?: Maybe<Scalars['String']['output']>;
  /** Getting a link to the accountant's cabinet */
  getAccountantCabinetUrl: Scalars['String']['output'];
  /** Get accountant feedback status for a period (for regular users) */
  getAccountantFeedbackStatus: AccountantFeedbackStatusType;
  /** List of all companies */
  getCompanies?: Maybe<CompanyFoldersListDto>;
  /** Company with a list of contract folders */
  getCompanyContractsFolders?: Maybe<AccountingCompanyContractsFoldersDto>;
  /** Company data for accountant cabinet */
  getCompanyForAccountantCabinet?: Maybe<AccountantCabinetCompanyData>;
  /** Details of the subfolder along with files */
  getCompanyPeriodSubFolder?: Maybe<AccountingCompanyPeriodSubfolderWithFiles>;
  /** Calculate company readiness metric for a specific period */
  getCompanyReadinessMetric: CompanyReadinessMetricType;
  /** Company with folders */
  getCompanyWithFolders?: Maybe<AccountingCompanyWithFolders>;
  /** Annual folder with periods */
  getCompanyYearFolderWithPeriods?: Maybe<AccountingCompanyYearFolderWithPeriods>;
  /**
   * Get connected e-commerce shops for company
   * @deprecated Use listConnectedPlatforms instead
   */
  getConnectedEcomShops?: Maybe<Array<EcomShopAccessEntity>>;
  /** Get connected e-commerce shops by company for accountant */
  getConnectedEcomShopsForAccountant?: Maybe<Array<EcomShopAccessEntity>>;
  /** Contract folder with contracts (files) */
  getContractsFolderWithFiles?: Maybe<AccountingCompanyContractFolderWithFilesDto>;
  /** Get current period folder and aggregated data for current user company / getCurrentPeriodForCard */
  getCurrentPeriod: CurrentPeriodType;
  getDocLocation: GetDocLocation;
  /** Files meta information */
  getFilesMetaInfo?: Maybe<Array<AccountingFileType>>;
  /** List of all markets */
  getMarkets?: Maybe<Array<Market>>;
  /** Get chart of accounts from Merit for a company (Manager and Accountant only) */
  getMeritAccounts: Array<MeritAccountDto>;
  /** Show if Merit Key for company exists */
  getMeritApiKey: Scalars['Boolean']['output'];
  /** Get Merit bank accounts for a company (Manager and Accountant only) */
  getMeritBankAccounts: Array<MeritBankAccountDto>;
  /** Get Merit e-commerce accounts for a company (Manager and Accountant only) */
  getMeritEcomShops: Array<MeritEcomShopDto>;
  /** Calculate all deadlines for a given period */
  getPeriodDeadlines: PeriodDeadlinesType;
  /** Period documents summary for Merit export (invoices + statements) */
  getPeriodDocumentsSummary: Array<PeriodDocumentSummaryItem>;
  /** Get period folder by ID for current user */
  getPeriodFolderById?: Maybe<AccountingCompanyPeriodFolder>;
  /** Get period issues (open questions, missing transactions, denied documents) for current user company */
  getPeriodIssues: PeriodIssuesType;
  /** Get period issues for a specific company (Manager and Accountant only) */
  getPeriodIssuesForCompany: PeriodIssuesType;
  /** Period transactions summary for Merit export (transactions by transactionDate) */
  getPeriodTransactionsSummary: Array<PeriodTransactionSummaryItem>;
  /** Period details and list of subfolders (Default/In/Out/Report) */
  getPeriodWithSubfolders?: Maybe<AccountingCompanyPeriodWithSubfolders>;
  /** Get potential tax to pay for selected period: taxes grouped by rate, extra tax 28% and total */
  getPotentialTaxToPay: PotentialTaxSummaryDto;
  /** Get standard e-commerce shops list */
  getStandardEcomShops?: Maybe<Array<EcomShopEntity>>;
  /** Список файлов с groupType=transfer */
  getTransferFiles?: Maybe<TransferFileListDto>;
  /** Список файлов с groupType=transfer */
  getTransferFilesForUser?: Maybe<TransferFileListDto>;
  /** Flag that user has an advanced subscription (Standard, Pro, or E-commerce) */
  haveAdvancedSubscription: Scalars['Boolean']['output'];
  /** Get connected payment platforms for company (includes hasSalesReport flag) */
  listConnectedPlatforms?: Maybe<Array<EcomShopAccessEntity>>;
  /** List of all annual folders by company along with the period */
  mainAccounting?: Maybe<Array<YearFolder>>;
  /** Information about accounting subscriptions */
  planSettings?: Maybe<AccountingPlanSettingsType>;
  report: AccountingReportType;
  searchFiles: SearchFilesListType;
  /** Get all existing TSD tax links for the current year folder */
  tsdTaxLinks: Array<TsdTaxLinkEntity>;
};


export type AccountingQueryACompanyFolderAdminArgs = {
  companyId: Scalars['String']['input'];
};


export type AccountingQueryAccountantCompaniesArgs = {
  isAutopilotClient?: InputMaybe<Scalars['Boolean']['input']>;
  marketId?: InputMaybe<Scalars['Float']['input']>;
  pagination: PaginationInputType;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingQueryAccountantsListArgs = {
  firmId: Scalars['String']['input'];
  pagination: PaginationInputType;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingQueryAccountingDocumentsListArgs = {
  accStatuses?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  periodsFolderId: Scalars['String']['input'];
  report: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingQueryAccountingPeriodDeclarationsArgs = {
  periodsFolderId: Scalars['String']['input'];
};


export type AccountingQueryAccountingYearlyDocumentsListArgs = {
  accStatuses?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination: PaginationInputType;
  periodsFolderId: Scalars['String']['input'];
  report: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingQueryArchiveAllFilesArgs = {
  companyId: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountingQueryCheckDuplicateFilesArgs = {
  companyId: Scalars['UuidType']['input'];
  hashes: Array<Scalars['String']['input']>;
  targetPeriodsFolderId?: InputMaybe<Scalars['UuidType']['input']>;
};


export type AccountingQueryCheckPreviousPeriodDeclarationStatusArgs = {
  periodFolderId: Scalars['String']['input'];
};


export type AccountingQueryCheckPreviousPeriodDeclarationStatusForCompanyArgs = {
  companyId: Scalars['String']['input'];
  periodFolderId: Scalars['String']['input'];
};


export type AccountingQueryChiefCompaniesArgs = {
  accountantId?: InputMaybe<Scalars['String']['input']>;
  isAutopilotClient?: InputMaybe<Scalars['Boolean']['input']>;
  marketId?: InputMaybe<Scalars['Float']['input']>;
  pagination: PaginationInputType;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingQueryCompanyArchiveYearsArgs = {
  companyId: Scalars['String']['input'];
};


export type AccountingQueryCountDocsAndTransactionsArgs = {
  periodId: Scalars['String']['input'];
};


export type AccountingQueryGetAccountantFeedbackStatusArgs = {
  periodId: Scalars['String']['input'];
  testDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type AccountingQueryGetCompaniesArgs = {
  accountantId?: InputMaybe<Scalars['UuidType']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  isAutopilotClient?: InputMaybe<Scalars['Boolean']['input']>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  pagination: PaginationInputType;
  regCode?: InputMaybe<Scalars['String']['input']>;
  withoutAccountant?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccountingQueryGetCompanyContractsFoldersArgs = {
  id_company?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingQueryGetCompanyForAccountantCabinetArgs = {
  id_company?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingQueryGetCompanyPeriodSubFolderArgs = {
  period_subfolder_id?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortFields?: InputMaybe<Array<GetCompanyPeriodSubFolderSortFieldDtoInputType>>;
};


export type AccountingQueryGetCompanyReadinessMetricArgs = {
  periodId: Scalars['String']['input'];
};


export type AccountingQueryGetCompanyWithFoldersArgs = {
  id_company?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingQueryGetCompanyYearFolderWithPeriodsArgs = {
  id_year_folder?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingQueryGetConnectedEcomShopsArgs = {
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingQueryGetConnectedEcomShopsForAccountantArgs = {
  companyId: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingQueryGetContractsFolderWithFilesArgs = {
  id_contracts_folder?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingQueryGetDocLocationArgs = {
  fileId: Scalars['String']['input'];
};


export type AccountingQueryGetFilesMetaInfoArgs = {
  endDate: Scalars['DateTime']['input'];
  registryCode: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type AccountingQueryGetMeritAccountsArgs = {
  companyId: Scalars['String']['input'];
};


export type AccountingQueryGetMeritApiKeyArgs = {
  companyId: Scalars['String']['input'];
};


export type AccountingQueryGetMeritBankAccountsArgs = {
  companyId: Scalars['String']['input'];
};


export type AccountingQueryGetMeritEcomShopsArgs = {
  companyId: Scalars['String']['input'];
};


export type AccountingQueryGetPeriodDeadlinesArgs = {
  periodId: Scalars['String']['input'];
  testDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type AccountingQueryGetPeriodDocumentsSummaryArgs = {
  onlyInvoices?: Scalars['Boolean']['input'];
  periodsFolderId: Scalars['String']['input'];
};


export type AccountingQueryGetPeriodFolderByIdArgs = {
  periodFolderId: Scalars['String']['input'];
};


export type AccountingQueryGetPeriodIssuesArgs = {
  periodId: Scalars['String']['input'];
};


export type AccountingQueryGetPeriodIssuesForCompanyArgs = {
  companyId: Scalars['String']['input'];
  periodId: Scalars['String']['input'];
};


export type AccountingQueryGetPeriodTransactionsSummaryArgs = {
  periodsFolderId: Scalars['String']['input'];
};


export type AccountingQueryGetPeriodWithSubfoldersArgs = {
  id_period_folder?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingQueryGetPotentialTaxToPayArgs = {
  periodId: Scalars['String']['input'];
};


export type AccountingQueryGetStandardEcomShopsArgs = {
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingQueryGetTransferFilesArgs = {
  companyId: Scalars['String']['input'];
  pagination: PaginationInputType;
};


export type AccountingQueryGetTransferFilesForUserArgs = {
  pagination: PaginationInputType;
};


export type AccountingQueryListConnectedPlatformsArgs = {
  periodId: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type AccountingQueryMainAccountingArgs = {
  year?: InputMaybe<Scalars['Float']['input']>;
};


export type AccountingQueryReportArgs = {
  filter?: InputMaybe<AccountingReportQueryFilterInputType>;
};


export type AccountingQuerySearchFilesArgs = {
  companyId: Scalars['String']['input'];
  pagination: PaginationInputType;
  search: Scalars['String']['input'];
};


export type AccountingQueryTsdTaxLinksArgs = {
  yearFolderId: Scalars['String']['input'];
};

/** Types of report sections */
export enum AccountingReportPartTypeEnum {
  Default = 'Default',
  Incoming = 'Incoming',
  Internal = 'Internal',
  MissingDocuments = 'MissingDocuments',
  Outgoing = 'Outgoing',
  Report = 'Report',
  Tsd = 'TSD'
}

/** Types of report statuses */
export enum AccountingReportPeriodEnum {
  MonthlyAcc = 'MonthlyAcc',
  QuarterlyAcc = 'QuarterlyAcc',
  YearlyAcc = 'YearlyAcc'
}

/** Report accountant reason */
export enum AccountingReportPeriodReason {
  Accountant = 'Accountant',
  Auto = 'Auto',
  IncorrectDocs = 'Incorrect_docs',
  LateSubmission = 'Late_submission',
  Manager = 'Manager',
  MissingDocs = 'Missing_docs',
  NoAccessToEcomPlatforms = 'NoAccessToEcomPlatforms',
  NoBanks = 'No_banks',
  NotEnoughDocs = 'Not_enough_docs',
  Questions = 'Questions',
  User = 'User'
}

/** Types of report periods */
export enum AccountingReportPeriodTypeEnum {
  CollectingDocs = 'Collecting_docs',
  NotReady = 'Not_Ready',
  ProcessingDocs = 'Processing_docs',
  Ready = 'Ready',
  ReportNotSubmitted = 'Report_not_submitted',
  ReportSubmitted = 'Report_submitted',
  Upcoming = 'Upcoming'
}

export type AccountingReportQueryFilterInputType = {
  /** Report ID */
  id: Scalars['UuidType']['input'];
};

/** Accounting report */
export type AccountingReportType = {
  __typename?: 'AccountingReportType';
  /** Report period type */
  accountingType: AccountingReportPeriodEnum;
  chaserTaskId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyOpeningType>;
  /** Company ID */
  companyId?: Maybe<Scalars['String']['output']>;
  /** Report creation time */
  createdAt: Scalars['DateTimeType']['output'];
  /** Information about documents attached to the report */
  docsMetaInfo: ReportDocsMetaInfoType;
  /** Periods folder identifier */
  id: Scalars['UuidType']['output'];
  /** Report month */
  month?: Maybe<Scalars['Int']['output']>;
  /** Report name */
  name: Scalars['String']['output'];
  /** Components of the report */
  parts: Array<PeriodsSubfolderType>;
  /** Report period type */
  periodType?: Maybe<AccountingReportPeriodTypeEnum>;
  periodsSubfolder?: Maybe<Array<PeriodsSubfolderType>>;
  /** Report quarter */
  quarter?: Maybe<Scalars['Int']['output']>;
  /** Report accountant reason */
  reason: Array<AccountingReportPeriodReason>;
  statusApproved?: Maybe<Scalars['Boolean']['output']>;
  totalFilesQty?: Maybe<Scalars['Float']['output']>;
  /** Link for TSD tax payment */
  tsdLink?: Maybe<Scalars['String']['output']>;
  /** TSD tax sum to pay */
  tsdSum?: Maybe<Scalars['Float']['output']>;
  unreadFilesQty?: Maybe<Scalars['Float']['output']>;
  /** Unread messages count */
  unreadMessagesCount?: Maybe<Scalars['Int']['output']>;
  vatLink?: Maybe<Scalars['String']['output']>;
  vatSum?: Maybe<Scalars['Float']['output']>;
  /** Report year */
  year: Scalars['Int']['output'];
  yearFolder?: Maybe<YearFolder>;
  /** Link to the annual folder */
  yearFolderId?: Maybe<Scalars['String']['output']>;
};

export enum AccountingTicketTemplateName {
  BankStatementRequest = 'BANK_STATEMENT_REQUEST',
  BusinessTripReportRequest = 'BUSINESS_TRIP_REPORT_REQUEST',
  ClarificationOnDocument = 'CLARIFICATION_ON_DOCUMENT',
  MissingDocumentsRequest = 'MISSING_DOCUMENTS_REQUEST',
  PlatformSalesReportRequest = 'PLATFORM_SALES_REPORT_REQUEST'
}

export type AccountingTicketTemplateType = {
  __typename?: 'AccountingTicketTemplateType';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  name: AccountingTicketTemplateName;
  subject: Scalars['String']['output'];
};

export type AccountingTransferFileInputType = {
  /** Identifier of the uploaded file */
  fileId: Scalars['String']['input'];
  /** Group type */
  groupType?: InputMaybe<GroupTypeEnum>;
  /** Name of the uploaded file */
  name: Scalars['String']['input'];
  /** File type */
  type_file?: InputMaybe<FileType>;
};

/** Information of yearly document with period info */
export type AccountingYearlyDocument = {
  __typename?: 'AccountingYearlyDocument';
  /** Accounting status */
  accStatusId?: Maybe<FileAccStatus>;
  /** Counterparty name */
  counterparty?: Maybe<Scalars['String']['output']>;
  /** Date`s document */
  date?: Maybe<Scalars['DateTimeType']['output']>;
  /** File ID */
  id: Scalars['UuidType']['output'];
  /** Info about of Invoicing Or Monite */
  invoicingOrMonite?: Maybe<Scalars['String']['output']>;
  /** Month number (1-12) when document was uploaded, null if uploaded to yearly folder */
  month?: Maybe<Scalars['Int']['output']>;
  /** File name */
  name?: Maybe<Scalars['String']['output']>;
  /** Period folder ID from which this file originates */
  periodFolderId: Scalars['UuidType']['output'];
  /** Rejection comment */
  rejectionComment?: Maybe<Scalars['String']['output']>;
  /** Rejection reason */
  rejectionReasonId?: Maybe<FileRejectionReason>;
  /** Source of file */
  source?: Maybe<Scalars['String']['output']>;
  /** File status */
  status?: Maybe<Scalars['String']['output']>;
  /** Currency with amount */
  sum?: Maybe<Scalars['String']['output']>;
  /** File type */
  type?: Maybe<FileType>;
};

/** Yearly documents list with pagination */
export type AccountingYearlyDocumentsList = {
  __typename?: 'AccountingYearlyDocumentsList';
  /** Document files */
  docs: Array<AccountingYearlyDocument>;
  /** Limitation on the maximum number of documents */
  limit: Scalars['Int']['output'];
  /** Offset for pagination */
  offset: Scalars['Int']['output'];
  /** Total count documents */
  total: Scalars['Int']['output'];
};

export type AddNewCsRequestInput = {
  /** Creation Date */
  createdAt: Scalars['DateTimeType']['input'];
  /** Is the request completed? */
  done: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  requestText: Scalars['String']['input'];
  /** Which service is the request for */
  serviceId: Scalars['String']['input'];
  /** Who made the request */
  userId: Scalars['String']['input'];
};

export type AdminMutation = {
  __typename?: 'AdminMutation';
  /** Clears cache */
  clearCache: Scalars['Boolean']['output'];
  /** Creates accounting folder for any period */
  createFolder: Scalars['Boolean']['output'];
  /** loginByUser */
  loginByUser: Scalars['Boolean']['output'];
};


export type AdminMutationCreateFolderArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  quarter?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


export type AdminMutationLoginByUserArgs = {
  userId: Scalars['String']['input'];
};

export type AdminQuery = {
  __typename?: 'AdminQuery';
  /** Get manager actions with pagination and filters */
  getManagerActions: GetManagerActionsResponse;
};


export type AdminQueryGetManagerActionsArgs = {
  filters?: InputMaybe<GetManagerActionsFilterInput>;
  pagination: PaginationInputType;
};

export type AlbatoInvoice = {
  __typename?: 'AlbatoInvoice';
  additionalComment?: Maybe<Scalars['String']['output']>;
  company: CompanyOpeningType;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currencyCode: Scalars['String']['output'];
  datePaid?: Maybe<Scalars['DateTime']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  fileId: Scalars['ID']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  fileType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  issueDate: Scalars['DateTime']['output'];
  note?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  taxAmount: Scalars['Float']['output'];
  totalWithTax: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AmplitudeEventDto = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  device_brand?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  device_manufacturer?: InputMaybe<Scalars['String']['input']>;
  device_model?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  event_type: Scalars['String']['input'];
  initial_utm_campaign?: InputMaybe<Scalars['String']['input']>;
  initial_utm_content?: InputMaybe<Scalars['String']['input']>;
  initial_utm_medium?: InputMaybe<Scalars['String']['input']>;
  initial_utm_source?: InputMaybe<Scalars['String']['input']>;
  initial_utm_term?: InputMaybe<Scalars['String']['input']>;
  initital_referrer?: InputMaybe<Scalars['String']['input']>;
  initital_referrer_domain?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  os_name?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  referrer_domain?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['Float']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
};

export type AmplitudeMutation = {
  __typename?: 'AmplitudeMutation';
  logEvent: Scalars['Boolean']['output'];
};


export type AmplitudeMutationLogEventArgs = {
  event: AmplitudeEventDto;
};

/** AI doc review result */
export type AnalyzeContractDto = {
  __typename?: 'AnalyzeContractDto';
  a1: Scalars['String']['output'];
  a2: Scalars['String']['output'];
  a3: Scalars['String']['output'];
  a4: Scalars['String']['output'];
  a5: Scalars['String']['output'];
  reqId: Scalars['String']['output'];
};

export type ApiToken = {
  __typename?: 'ApiToken';
  /** The user's current access in that company: "editor", "reader", or "none" when no longer a member (the token then fails) */
  access: Scalars['String']['output'];
  /** Company the token works for */
  companyId: Scalars['String']['output'];
  /** Null when the company was deleted */
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expired: Scalars['Boolean']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  /** Null when never used */
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** Prefix and last characters, e.g. "enty_pat_…a1b2" */
  tokenPreview: Scalars['String']['output'];
};

export type ApiTokenCreatePayload = {
  __typename?: 'ApiTokenCreatePayload';
  apiToken: ApiToken;
  /** The secret. Returned only here: it is stored hashed and cannot be shown again */
  token: Scalars['String']['output'];
};

export type ArchiveNotificationsInput = {
  /** true - archive, false - unarchive */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID notifications for archiving. If not specified, all notifications of the company will be processed */
  notificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Tag for KB article */
export type ArticleTag = {
  __typename?: 'ArticleTag';
  free: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** Accountant the company is assigned to (a_user_firm_company) */
export type AssignedAccountant = {
  __typename?: 'AssignedAccountant';
  /** Accountant email */
  email: Scalars['String']['output'];
  /** Accountant user ID */
  id: Scalars['UuidType']['output'];
  /** Accountant first name */
  name?: Maybe<Scalars['String']['output']>;
  /** Accountant last name */
  surname?: Maybe<Scalars['String']['output']>;
};

/** Accounting firm the company is bound to (a_firm_company) */
export type AssignedAccountingFirm = {
  __typename?: 'AssignedAccountingFirm';
  /** Firm ID */
  id: Scalars['UuidType']['output'];
  /** Firm name */
  name: Scalars['String']['output'];
};

export type AttachedDocumentDto = {
  __typename?: 'AttachedDocumentDto';
  /** File id, also the id of the accounting document (a_file.id) */
  fileId: Scalars['String']['output'];
  /** File name */
  name: Scalars['String']['output'];
};

export type AutomatchingCompletedDto = {
  __typename?: 'AutomatchingCompletedDto';
  companyId: Scalars['String']['output'];
  docId: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export type BSubscriptionInputType = {
  /** CustomerId in billsby */
  customerId: Scalars['String']['input'];
  /** Extended subscription data by user */
  extendedInfo: BillsbySubscriptionDetail;
  /** Subscription id */
  id: Scalars['String']['input'];
  /** Subscription data by user */
  info: BillsbySubscription;
  /** Subscription plan name */
  planName: Scalars['String']['input'];
  /** Subscription status */
  status: Scalars['String']['input'];
};

/** Response to the transaction graph request */
export type BankTransactionsGraphicByPeriodData = {
  __typename?: 'BankTransactionsGraphicByPeriodData';
  breakdownByDates: Array<Scalars['DateTime']['output']>;
  breakdownBySum: Array<Scalars['String']['output']>;
  netProfit: Scalars['Float']['output'];
  totalIncome: Scalars['Float']['output'];
  totalOutcome: Scalars['Float']['output'];
};

export type BankingAccountDto = {
  accountName: Scalars['String']['input'];
  accountNo?: InputMaybe<Scalars['String']['input']>;
  achRoutingNo?: InputMaybe<Scalars['String']['input']>;
  bankAddress?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  iban: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  wireRoutingNo?: InputMaybe<Scalars['String']['input']>;
};

export type BankingAccountEntity = {
  __typename?: 'BankingAccountEntity';
  accountName?: Maybe<Scalars['String']['output']>;
  /** Account number for USA */
  accountNo?: Maybe<Scalars['String']['output']>;
  /** ACH routing number for USA */
  achRoutingNo?: Maybe<Scalars['String']['output']>;
  balances?: Maybe<Array<BankingBalanceEntity>>;
  bank?: Maybe<BankingBankEntity>;
  bankAddress?: Maybe<Scalars['String']['output']>;
  bankId?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  cashAccountType?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  connectionType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  custom?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Account name to display: meritAccountName if there is a merit link, otherwise accountName */
  displayAccountName?: Maybe<Scalars['String']['output']>;
  /** ID from provider */
  externalAccountId?: Maybe<Scalars['String']['output']>;
  /** @deprecated unused, will be deleted */
  flowId?: Maybe<Scalars['String']['output']>;
  hasStatement: Scalars['Boolean']['output'];
  hasTransactions: Scalars['Boolean']['output'];
  /** Shown only in the accountant cabinet, never to the company users (created by the accountant for a statement import) */
  hiddenFromClient: Scalars['Boolean']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** @deprecated Moved to banking_bank */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDefault: Scalars['Boolean']['output'];
  /** @deprecated unused, will be deleted */
  klarnaAccountId?: Maybe<Scalars['String']['output']>;
  /** Raw name from the linked merit_bank_account, or null if there is no link */
  meritAccountName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerAddressUnstructured?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  /** @deprecated unused, will be deleted */
  pdfFileId?: Maybe<Scalars['String']['output']>;
  requisition?: Maybe<BankingRequisitionEntity>;
  /** @deprecated unused, will be deleted */
  requisitionId?: Maybe<Scalars['String']['output']>;
  /** Get bank application status */
  requisitionStatus?: Maybe<Scalars['String']['output']>;
  saltedgeConnection?: Maybe<SaltedgeConnectionEntity>;
  saltedgeConnectionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  swift?: Maybe<Scalars['String']['output']>;
  transactions?: Maybe<Array<BankingTransactionEntity>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated unused, will be deleted */
  usage?: Maybe<Scalars['String']['output']>;
  /** Wire routing number for USA */
  wireRoutingNo?: Maybe<Scalars['String']['output']>;
  /** @deprecated unused, will be deleted */
  xlsxFileId?: Maybe<Scalars['String']['output']>;
};

export type BankingAccountInfoDto = {
  __typename?: 'BankingAccountInfoDto';
  currency?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BankingAccountStatementBodyDto = {
  __typename?: 'BankingAccountStatementBodyDto';
  accountId: Scalars['String']['output'];
  pdfFileId: Scalars['String']['output'];
  xlsxFileId: Scalars['String']['output'];
};

export type BankingAccountUpdateDto = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNo?: InputMaybe<Scalars['String']['input']>;
  achRoutingNo?: InputMaybe<Scalars['String']['input']>;
  bankAddress?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  wireRoutingNo?: InputMaybe<Scalars['String']['input']>;
};

export type BankingAccountsInfoDto = {
  __typename?: 'BankingAccountsInfoDto';
  /** Whether the user has any accounts */
  hasAccounts: Scalars['Boolean']['output'];
  /** Whether the user has any active accounts connected through external providers */
  hasActiveProviderAccounts: Scalars['Boolean']['output'];
  /** Whether the user has any custom accounts */
  hasCustomAccounts: Scalars['Boolean']['output'];
  /** Whether the user has any transactions for custom accounts */
  hasCustomAccountsTransactions: Scalars['Boolean']['output'];
  /** Whether the user has any expired or revoked accounts */
  hasExpiredOrRevokedAccounts: Scalars['Boolean']['output'];
  /** Whether there are any transactions for the given date filter */
  hasTransactions: Scalars['Boolean']['output'];
};

export type BankingBalanceByPeriodDto = {
  __typename?: 'BankingBalanceByPeriodDto';
  /** Sum of all amount values with a “+” sign for transactions during the period */
  creditTurnover?: Maybe<Scalars['Float']['output']>;
  /** Sum of all amount values with a “-” sign for transactions during the period */
  debitTurnover?: Maybe<Scalars['Float']['output']>;
  /** Value of final balance from the banking_historical_balance table for the specified period (December 2024) */
  finalBalance?: Maybe<Scalars['Float']['output']>;
  /** Value of closing_balance from the banking_transaction table for the last transaction within the specified period */
  finalClosingBalance?: Maybe<Scalars['Float']['output']>;
  /** Value of closing_balance from the banking_transaction table for the first transaction within the specified period */
  startClosingBalance?: Maybe<Scalars['Float']['output']>;
  /** Value of final balance from the banking_historical_balance table for the previous period */
  startFinalBalance?: Maybe<Scalars['Float']['output']>;
};

export type BankingBalanceEntity = {
  __typename?: 'BankingBalanceEntity';
  account?: Maybe<BankingAccountEntity>;
  amount: Scalars['String']['output'];
  amountInDashboardCurrency?: Maybe<Scalars['String']['output']>;
  balanceType: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  flowId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BankingBankEntity = {
  __typename?: 'BankingBankEntity';
  accounts?: Maybe<Array<BankingAccountEntity>>;
  /** The name of the bank */
  bankName?: Maybe<Scalars['String']['output']>;
  /** The company */
  company?: Maybe<CompanyOpeningType>;
  /** The company id */
  companyId: Scalars['String']['output'];
  /** The created at date */
  createdAt: Scalars['DateTime']['output'];
  /** The deleted at date */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** Is custom bank */
  isCustom: Scalars['Boolean']['output'];
  /** The owner name */
  ownerName?: Maybe<Scalars['String']['output']>;
  saltedgeConnection?: Maybe<SaltedgeConnectionEntity>;
  /** The saltedge connection id */
  saltedgeConnectionId?: Maybe<Scalars['String']['output']>;
  /** The updated at date */
  updatedAt: Scalars['DateTime']['output'];
};

export type BankingCategorizationMutation = {
  __typename?: 'BankingCategorizationMutation';
  /** ONE TIME REQUEST - Add new categories for those who have already generated */
  addNewCategoriesForCategorization: Scalars['Float']['output'];
  /** Clear confirmedAt, set stepSetup to 1 */
  backToEditCategories?: Maybe<Scalars['Boolean']['output']>;
  /** Confirm categories that are not deletedAt */
  confirmCategories?: Maybe<Array<BankingCategoryGroupEntity>>;
  /** Create/Update rows in banking_category_groups */
  createOrUpdateCategoryGroups?: Maybe<Array<BankingCategoryGroupEntity>>;
  /** Create/Update rows in banking_category_items */
  createOrUpdateCategoryItems?: Maybe<Array<BankingCategoryGroupEntity>>;
  generateCategoriesWithWebsite?: Maybe<Array<BankingCategoryGroupEntity>>;
  /** Generate fake categories */
  generateFakeCategories?: Maybe<Array<BankingCategoryGroupEntity>>;
  /** Remove Merit item ID from a banking category item */
  removeCategoryItemMeritItemId: Scalars['Boolean']['output'];
  /** Remove Merit tax ID from a banking category item */
  removeCategoryItemMeritTaxId: Scalars['Boolean']['output'];
  /** Return to the initial state of categorization */
  resetCategorization?: Maybe<Scalars['Boolean']['output']>;
  restartUncategorizedTransactions?: Maybe<CategorizationResultWithTimeDto>;
  /** Run categorization for company */
  runCategorization?: Maybe<Scalars['Boolean']['output']>;
  /** Set Merit item ID for a banking category item */
  setCategoryItemMeritItemId: Scalars['Boolean']['output'];
  /** Set Merit tax ID for a banking category item */
  setCategoryItemMeritTaxId: Scalars['Boolean']['output'];
  /** ONE TIME REQUEST - Set internal transfer for old transactions */
  setInternalTransferForOldTransactions: Scalars['Boolean']['output'];
  /** Start matching, the response includes the number of tasks queued */
  startMatchingCategoriesWithTransactions?: Maybe<CategorizationResultWithTimeDto>;
};


export type BankingCategorizationMutationAddNewCategoriesForCategorizationArgs = {
  password: Scalars['String']['input'];
};


export type BankingCategorizationMutationCreateOrUpdateCategoryGroupsArgs = {
  categoryInput: Array<BankingCategoryGroupInput>;
};


export type BankingCategorizationMutationCreateOrUpdateCategoryItemsArgs = {
  categoryInput: Array<BankingCategoryItemInput>;
};


export type BankingCategorizationMutationGenerateCategoriesWithWebsiteArgs = {
  companyDescription?: InputMaybe<GenerateCategoriesFromDescriptionInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type BankingCategorizationMutationRemoveCategoryItemMeritItemIdArgs = {
  categoryItemId: Scalars['String']['input'];
};


export type BankingCategorizationMutationRemoveCategoryItemMeritTaxIdArgs = {
  categoryItemId: Scalars['String']['input'];
};


export type BankingCategorizationMutationRunCategorizationArgs = {
  companyId: Scalars['String']['input'];
};


export type BankingCategorizationMutationSetCategoryItemMeritItemIdArgs = {
  categoryItemId: Scalars['String']['input'];
  meritItemId: Scalars['String']['input'];
};


export type BankingCategorizationMutationSetCategoryItemMeritTaxIdArgs = {
  categoryItemId: Scalars['String']['input'];
  meritTaxId: Scalars['String']['input'];
};


export type BankingCategorizationMutationSetInternalTransferForOldTransactionsArgs = {
  password: Scalars['String']['input'];
};

export type BankingCategorizationQuery = {
  __typename?: 'BankingCategorizationQuery';
  financesSetting: FinancesSettings;
  getCategories?: Maybe<Array<BankingCategoryGroupEntity>>;
};


export type BankingCategorizationQueryGetCategoriesArgs = {
  categoryStatusToShow?: CategoryStatus;
  categoryType?: InputMaybe<Scalars['String']['input']>;
};

export type BankingCategoryGroupEntity = {
  __typename?: 'BankingCategoryGroupEntity';
  categories?: Maybe<Array<BankingCategoryItemEntity>>;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  groupName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BankingCategoryGroupInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BankingCategoryItemEntity = {
  __typename?: 'BankingCategoryItemEntity';
  colour: Scalars['String']['output'];
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Merit API ItemId (not FK to merit_item) */
  meritItemId?: Maybe<Scalars['String']['output']>;
  meritTaxId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  transactions?: Maybe<Array<BankingTransactionEntity>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BankingCategoryItemInput = {
  colour?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type BankingConnectionErrorDto = {
  __typename?: 'BankingConnectionErrorDto';
  /** Stable error code for UI to map to a localized message if needed */
  code: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  /** Localized error message (falls back to English) */
  message: Scalars['String']['output'];
};

export type BankingMonthlySummaryDto = {
  __typename?: 'BankingMonthlySummaryDto';
  /** Balance */
  balance?: Maybe<Scalars['Float']['output']>;
  /** Incoming transactions */
  incoming?: Maybe<Scalars['Float']['output']>;
  /** Outgoing transactions */
  outgoing?: Maybe<Scalars['Float']['output']>;
};

export type BankingMonthlySummaryDto2 = {
  __typename?: 'BankingMonthlySummaryDto2';
  /** Total amount of all issued invoices */
  expectedIncome?: Maybe<Scalars['Float']['output']>;
  /** Percentage ratio of current to previous incoming transactions */
  incomingPercentage?: Maybe<Scalars['Float']['output']>;
  /** Incoming transactions for the previous month */
  incomingPrevMonth?: Maybe<Scalars['Float']['output']>;
  /** Incoming transactions for the current month */
  incomingThisMonth?: Maybe<Scalars['Float']['output']>;
  /** Percentage ratio of current to previous outgoing transactions */
  outgoingPercentage?: Maybe<Scalars['Float']['output']>;
  /** Outgoing transactions for the previous month */
  outgoingPrevMonth?: Maybe<Scalars['Float']['output']>;
  /** Outgoing transactions for the current month */
  outgoingThisMonth?: Maybe<Scalars['Float']['output']>;
  /** Data on all issued invoices */
  outstandingInvoicesData?: Maybe<ExpectedIncomeDetails>;
};

export type BankingMutation = {
  __typename?: 'BankingMutation';
  /** Change banking account name */
  changeAccountName: Scalars['Boolean']['output'];
  /** Update finances settings */
  changeFinancesSettings?: Maybe<FinancesSettings>;
  /** Create custom bank account */
  createCustomBankAccount: BankingAccountEntity;
  /** Create a bank account of the company shown only in the accountant cabinet, for a statement import (managers and accountants only) */
  createHiddenBankAccount: BankingAccountEntity;
  /** Create or update banking transaction */
  createOrUpdateTransaction?: Maybe<Scalars['Boolean']['output']>;
  /** Create Saltedge session */
  createSaltedgeSession?: Maybe<Scalars['String']['output']>;
  cronGenerateFakeCategoriesForSubscribedCompanies: Scalars['Boolean']['output'];
  deleteBankingBank: Scalars['Boolean']['output'];
  /** Multiple action - Soft delete transactions */
  deleteTransactions?: Maybe<Scalars['Boolean']['output']>;
  /** Change banking account details */
  editAccountDetails: Scalars['Boolean']['output'];
  /** Generate fake categories for multiple companies based on their activity description from RIK. Accessible only for managers and accountants. */
  generateFakeCategoriesForCompanies: GenerateFakeCategoriesForCompaniesResult;
  /** Generate statement */
  generateStatement: Scalars['Boolean']['output'];
  /** Generate a statement for the accountant office */
  generateStatementForAccounting: Scalars['Boolean']['output'];
  /** Generate random test transactions for banking account (Dev/QA purpose) */
  generateTestTransactions: Scalars['Boolean']['output'];
  /** Create the chosen transactions of a bank statement on an account; they are shown only in the accountant cabinet (managers and accountants only) */
  importStatementTransactions: StatementImportResult;
  /** Link two transactions as the outgoing and the incoming leg of one internal transfer; both get the internal-transfer category (managers and accountants only) */
  linkInternalTransfer: Scalars['Boolean']['output'];
  /** Link accounting file with banking account */
  linkStatementWithAccount: Scalars['Boolean']['output'];
  /** Mark transaction for missing file */
  markTransactionMissingFile: Scalars['Boolean']['output'];
  /** Reconnect Saltedge session */
  reconnectSaltEdgeSession?: Maybe<Scalars['String']['output']>;
  /** Updating banking data no more than once every 15 minutes for those with a subscription, 1 hour for others */
  refreshKlarnaDataIn5Min: RefreshTransactionsDto;
  /** Refresh Saltedge session */
  refreshSaltEdgeSession?: Maybe<Scalars['String']['output']>;
  removeAccount: Scalars['Boolean']['output'];
  /** Generate statement and send it to email */
  sendStatementViaEmail: Scalars['Boolean']['output'];
  /** Set counterparty for transaction */
  setCounterpartyToTransaction?: Maybe<BankingTransactionEntity>;
  /** Set default currency for dashboard */
  setDashboardCurrency?: Maybe<Scalars['Boolean']['output']>;
  setDefaultAccount: Scalars['Boolean']['output'];
  /** Multiple action - Set includeTransaction for transactions */
  setIncludeTransactions?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple action - Set category for transactions */
  setTransactionsCategory?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple action - Set counterparty for transactions (PENDING are skipped) */
  setTransactionsCounterparty?: Maybe<Scalars['Boolean']['output']>;
  /** Remove mark from transaction for missing file */
  unMarkTransactionMissingFile: Scalars['Boolean']['output'];
  /** Remove the internal-transfer link between a transaction and its pair; both stay categorized as internal transfers (managers and accountants only) */
  unlinkInternalTransfer: Scalars['Boolean']['output'];
  /** Update custom bank account */
  updateCustomBankAccount: BankingAccountEntity;
  /** Update extraTaxAgree field for transaction (only works when docNeeded is true) */
  updateExtraTaxAgreeForDocNeededTransaction?: Maybe<Scalars['Boolean']['output']>;
  /** Partially update transaction details without overwriting other fields */
  updateTransactionDetails: Scalars['Boolean']['output'];
  /** Set docNeeded for a transaction with specific reason */
  updateTransactionDocNeededStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Set comment for transactions */
  updateTransactionsComment?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Set docNeeded for transactions
   * @deprecated Use updateTransactionDocNeededStatus instead
   */
  updateTransactionsDocNeeded?: Maybe<Scalars['Boolean']['output']>;
};


export type BankingMutationChangeAccountNameArgs = {
  accountId: Scalars['String']['input'];
  accountName: Scalars['String']['input'];
};


export type BankingMutationChangeFinancesSettingsArgs = {
  settings: UpdateFinancesSettingsInput;
};


export type BankingMutationCreateCustomBankAccountArgs = {
  account: BankingAccountDto;
};


export type BankingMutationCreateHiddenBankAccountArgs = {
  account: HiddenBankAccountInput;
};


export type BankingMutationCreateOrUpdateTransactionArgs = {
  transactionInput: BankingTransactionsInputDto;
};


export type BankingMutationCronGenerateFakeCategoriesForSubscribedCompaniesArgs = {
  password: Scalars['String']['input'];
};


export type BankingMutationDeleteBankingBankArgs = {
  bankId: Scalars['String']['input'];
};


export type BankingMutationDeleteTransactionsArgs = {
  transactionsId: Array<Scalars['String']['input']>;
};


export type BankingMutationEditAccountDetailsArgs = {
  accountId: Scalars['String']['input'];
  options: BankingAccountUpdateDto;
};


export type BankingMutationGenerateFakeCategoriesForCompaniesArgs = {
  companyIds: Array<Scalars['String']['input']>;
};


export type BankingMutationGenerateStatementArgs = {
  accountId: Scalars['String']['input'];
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
};


export type BankingMutationGenerateStatementForAccountingArgs = {
  accountId: Scalars['String']['input'];
  periodEnd: Scalars['String']['input'];
  periodStart: Scalars['String']['input'];
};


export type BankingMutationGenerateTestTransactionsArgs = {
  accountId: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type BankingMutationImportStatementTransactionsArgs = {
  input: StatementImportInput;
};


export type BankingMutationLinkInternalTransferArgs = {
  pairTransactionId: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};


export type BankingMutationLinkStatementWithAccountArgs = {
  aFileId: Scalars['String']['input'];
  bankingAccountId: Scalars['String']['input'];
};


export type BankingMutationMarkTransactionMissingFileArgs = {
  transactionIds: Array<Scalars['String']['input']>;
};


export type BankingMutationReconnectSaltEdgeSessionArgs = {
  connectionId: Scalars['String']['input'];
};


export type BankingMutationRefreshSaltEdgeSessionArgs = {
  connectionId: Scalars['String']['input'];
};


export type BankingMutationRemoveAccountArgs = {
  accountId: Scalars['String']['input'];
};


export type BankingMutationSendStatementViaEmailArgs = {
  accountId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
};


export type BankingMutationSetCounterpartyToTransactionArgs = {
  counterpartyId: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};


export type BankingMutationSetDashboardCurrencyArgs = {
  currency: Scalars['String']['input'];
};


export type BankingMutationSetDefaultAccountArgs = {
  accountId: Scalars['String']['input'];
};


export type BankingMutationSetIncludeTransactionsArgs = {
  includeTransaction: Scalars['Boolean']['input'];
  transactionsId: Array<Scalars['String']['input']>;
};


export type BankingMutationSetTransactionsCategoryArgs = {
  categoryLibraryId?: InputMaybe<Scalars['String']['input']>;
  transactionsId: Array<Scalars['String']['input']>;
};


export type BankingMutationSetTransactionsCounterpartyArgs = {
  counterpartyId: Scalars['String']['input'];
  transactionsId: Array<Scalars['String']['input']>;
};


export type BankingMutationUnMarkTransactionMissingFileArgs = {
  transactionIds: Array<Scalars['String']['input']>;
};


export type BankingMutationUnlinkInternalTransferArgs = {
  transactionId: Scalars['String']['input'];
};


export type BankingMutationUpdateCustomBankAccountArgs = {
  account: BankingAccountDto;
  accountId: Scalars['String']['input'];
};


export type BankingMutationUpdateExtraTaxAgreeForDocNeededTransactionArgs = {
  extraTaxAgree?: InputMaybe<Scalars['Boolean']['input']>;
  transactionId: Scalars['String']['input'];
};


export type BankingMutationUpdateTransactionDetailsArgs = {
  input: UpdateTransactionDetailsInput;
};


export type BankingMutationUpdateTransactionDocNeededStatusArgs = {
  docNeeded: Scalars['Boolean']['input'];
  reasonNotNeeded?: InputMaybe<ReasonNotNeededEnum>;
  transactionId: Scalars['String']['input'];
};


export type BankingMutationUpdateTransactionsCommentArgs = {
  accountId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};


export type BankingMutationUpdateTransactionsDocNeededArgs = {
  accountId: Scalars['String']['input'];
  docNeeded: Scalars['Boolean']['input'];
  transactionId: Scalars['String']['input'];
};

export type BankingQuery = {
  __typename?: 'BankingQuery';
  /** Get list of accounts for company */
  accountsList?: Maybe<Array<BankingAccountEntity>>;
  /** Accounts list of such company for manager */
  accountsListForManager: Array<BankingAccountEntity>;
  /**
   * Get list of accounts for company
   * @deprecated Use banksTree instead
   */
  banksList: Array<BanksListDto>;
  banksTree: Array<BankingBankEntity>;
  /** Get category summary */
  categorySummary: CategorySummaryDto;
  connectionIsActive: Scalars['Boolean']['output'];
  /** For check connection is saved */
  connectionIsSaved: Scalars['Boolean']['output'];
  /** Get category summary */
  counterpartySummary: CategorySummaryDto;
  /** Transactions list by such period and account */
  exportTransactions: Scalars['String']['output'];
  /**
   * Transactions list by such period and account
   * @deprecated Use exportTransactions instead
   */
  exportTransactionsCsv: Scalars['String']['output'];
  /**
   * Get list of active filters for transactionsList2
   * @deprecated Use filterData2 instead
   */
  filterData: TransactionsFiltersDto;
  /** Get list of active filters for transactionsList2 */
  filterData2: TransactionsFiltersDto2;
  /** Get accounting files connected to the banking transaction (for accountant cabinet) */
  getAccountingFilesByTransactionId: Array<AccountingFileType>;
  /** Get total balance for accounts */
  getBalanceForCfo: Scalars['Float']['output'];
  /** Account balance by period */
  getBalanceInfoByPeriod: BankingBalanceByPeriodDto;
  /** Get data for cfo cards */
  getCfoCardsData?: Maybe<CfoCardsDto>;
  /** Get data for CFO chart */
  getCfoChartData: CfoChartDto;
  /** Get cat.groups with company and common categories */
  getCompanyCategories: Array<CategoryTreeDto>;
  /**
   * Get transaction by transactionId
   * @deprecated Deprecated. Use getAccountingFilesByTransactionId
   */
  getConnectedDocsByTransactionId: BankingTransactionDto;
  /** Count of conversion tasks */
  getCountConversionTasks: Scalars['Float']['output'];
  /** Count of save transactions tasks */
  getCountSaveTransactionsTasks: Scalars['Float']['output'];
  /** Currency for banking account */
  getCurrencyForAccount: Scalars['String']['output'];
  /** Banking data for 2024 year Wrapped */
  getEntyWrapped: Scalars['Boolean']['output'];
  /** Get financial report */
  getFinancialReport: CfoReportDto;
  /** Transactions on the other accounts of the company that can be linked with this one as an internal transfer, most likely first (managers and accountants only) */
  getInternalTransferCandidates: Array<InternalTransferCandidate>;
  /** Transactions OCR recognized in a bank statement, with the ones that look already imported to the account (managers and accountants only) */
  getStatementImportPreview: StatementImportPreview;
  /** Get transaction by transactionId */
  getTransactionById: BankingTransactionDto;
  /** Get transaction details */
  getTransactionDetails: TransactionDetailsDto;
  /** Get full file data connected to a specific transaction (Client Portal only) */
  getTransactionDocuments: Array<AccountingFileType>;
  /** Transactions list by such period and account */
  getTransactionsList: PaginatedGetTransactionsListDto;
  getUserAccountsInfo: BankingAccountsInfoDto;
  /** Monthly transactions summary */
  monthlyTransactionsSummary?: Maybe<BankingMonthlySummaryDto>;
  /** Monthly transactions summary */
  monthlyTransactionsSummary2?: Maybe<BankingMonthlySummaryDto2>;
  /** Get count transaction in company */
  transactionsCount: Scalars['Float']['output'];
  /** Get transactions data for graphic by period */
  transactionsGraphicByPeriod: BankTransactionsGraphicByPeriodData;
  /** Get list of transactions for account */
  transactionsList: BankingTransactionsListType;
  /** Get list of transactions for account */
  transactionsList2: BankingTransactionsListType2;
  /** Transactions quantity statistics */
  transactionsStatistics: TransactionsStatisticsDto;
};


export type BankingQueryAccountsListArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type BankingQueryAccountsListForManagerArgs = {
  companyId: Scalars['String']['input'];
  dateEnd?: InputMaybe<Scalars['String']['input']>;
  dateStart?: InputMaybe<Scalars['String']['input']>;
  periodId?: InputMaybe<Scalars['String']['input']>;
};


export type BankingQueryCategorySummaryArgs = {
  accountIds: Array<Scalars['String']['input']>;
  dates?: InputMaybe<DateFilterDto>;
  pagination: PaginationInputType;
  period: CfoPeriodsUnitsEnum;
  sort?: InputMaybe<SortInputType>;
  transactionsType?: TransactionTypeEnum;
};


export type BankingQueryConnectionIsActiveArgs = {
  connectionId: Scalars['String']['input'];
};


export type BankingQueryConnectionIsSavedArgs = {
  connectionId: Scalars['String']['input'];
};


export type BankingQueryCounterpartySummaryArgs = {
  accountIds: Array<Scalars['String']['input']>;
  dates?: InputMaybe<DateFilterDto>;
  pagination: PaginationInputType;
  period: CfoPeriodsUnitsEnum;
  sort?: InputMaybe<SortInputType>;
  transactionsType?: TransactionTypeEnum;
};


export type BankingQueryExportTransactionsArgs = {
  accountId: Scalars['String']['input'];
  dateEnd: Scalars['String']['input'];
  dateStart: Scalars['String']['input'];
  format: Scalars['String']['input'];
};


export type BankingQueryExportTransactionsCsvArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  periodId: Scalars['String']['input'];
};


export type BankingQueryGetAccountingFilesByTransactionIdArgs = {
  companyId: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};


export type BankingQueryGetBalanceForCfoArgs = {
  accountId: Array<Scalars['String']['input']>;
};


export type BankingQueryGetBalanceInfoByPeriodArgs = {
  accountId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  periodFolderId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type BankingQueryGetCfoCardsDataArgs = {
  accountId: Array<Scalars['String']['input']>;
  dates?: InputMaybe<DateFilterDto>;
  period: CfoPeriodsUnitsEnum;
};


export type BankingQueryGetCfoChartDataArgs = {
  accountId: Array<Scalars['String']['input']>;
  dates?: InputMaybe<DateFilterDto>;
  period: CfoPeriodsUnitsEnum;
};


export type BankingQueryGetCompanyCategoriesArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type BankingQueryGetConnectedDocsByTransactionIdArgs = {
  transactionId: Scalars['String']['input'];
};


export type BankingQueryGetCurrencyForAccountArgs = {
  accountId: Scalars['String']['input'];
};


export type BankingQueryGetEntyWrappedArgs = {
  part: Scalars['Float']['input'];
};


export type BankingQueryGetFinancialReportArgs = {
  accountIds: Array<Scalars['String']['input']>;
  dates?: InputMaybe<DateFilterDto>;
  period: ReportPeriodsUnitsEnum;
};


export type BankingQueryGetInternalTransferCandidatesArgs = {
  transactionId: Scalars['String']['input'];
};


export type BankingQueryGetStatementImportPreviewArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['String']['input'];
};


export type BankingQueryGetTransactionByIdArgs = {
  transactionId: Scalars['String']['input'];
};


export type BankingQueryGetTransactionDetailsArgs = {
  transactionId: Scalars['String']['input'];
};


export type BankingQueryGetTransactionDocumentsArgs = {
  transactionId: Scalars['String']['input'];
};


export type BankingQueryGetTransactionsListArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  dateEnd?: InputMaybe<Scalars['String']['input']>;
  dateStart?: InputMaybe<Scalars['String']['input']>;
  docNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInputType>;
  periodId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  transactionDocConnections?: InputMaybe<Scalars['Boolean']['input']>;
  transactionType?: InputMaybe<Scalars['String']['input']>;
};


export type BankingQueryGetUserAccountsInfoArgs = {
  dateFilter?: InputMaybe<DateFilterDto>;
  periodFolderId?: InputMaybe<Scalars['String']['input']>;
};


export type BankingQueryMonthlyTransactionsSummary2Args = {
  accountId?: InputMaybe<Array<Scalars['String']['input']>>;
  dates?: InputMaybe<DateFilterDto>;
  period?: InputMaybe<CfoPeriodsUnitsEnum>;
};


export type BankingQueryTransactionsGraphicByPeriodArgs = {
  accountId: Scalars['String']['input'];
  horizontalSeparation?: InputMaybe<Scalars['Float']['input']>;
  periodEnd?: InputMaybe<Scalars['String']['input']>;
  periodStart?: InputMaybe<Scalars['String']['input']>;
  transactionType: TransactionTypeEnum;
  verticalSeparation?: InputMaybe<Scalars['Float']['input']>;
};


export type BankingQueryTransactionsListArgs = {
  accountId: Scalars['String']['input'];
  filter?: InputMaybe<BankingTransactionsListFilterInputDto>;
  pagination: PaginationInputType;
};


export type BankingQueryTransactionsList2Args = {
  filter?: InputMaybe<BankingTransactionsListFilterInputDto2>;
  pagination: PaginationInputType;
  sort?: InputMaybe<SortInputType>;
};


export type BankingQueryTransactionsStatisticsArgs = {
  accountIds: Array<Scalars['String']['input']>;
  dateEnd: Scalars['String']['input'];
  dateStart: Scalars['String']['input'];
};

export type BankingRequisitionEntity = {
  __typename?: 'BankingRequisitionEntity';
  accounts?: Maybe<Array<BankingAccountEntity>>;
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BankingTransactionDto = {
  __typename?: 'BankingTransactionDto';
  account?: Maybe<BankingAccountEntity>;
  /** @deprecated unused, will be deleted */
  additionalInformation?: Maybe<Scalars['String']['output']>;
  amount: Scalars['String']['output'];
  amountInDashboardCurrency?: Maybe<Scalars['String']['output']>;
  /** @deprecated unused, will be deleted */
  bankTransactionCode?: Maybe<Scalars['String']['output']>;
  bankingCategoryItem?: Maybe<BankingCategoryItemEntity>;
  bankingCategoryItemId?: Maybe<Scalars['String']['output']>;
  bookingDate: Scalars['DateTime']['output'];
  category?: Maybe<Scalars['String']['output']>;
  categoryLibrary?: Maybe<CategoryLibraryEntity>;
  /**
   * ID from category_library
   * @deprecated unused, will be deleted
   */
  categoryLibraryId?: Maybe<Scalars['String']['output']>;
  closingBalance?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  counterparty?: Maybe<CounterpartyEntity>;
  counterpartyIban?: Maybe<Scalars['String']['output']>;
  /** CounterpartyID */
  counterpartyId?: Maybe<Scalars['String']['output']>;
  counterpartyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated unused, will be deleted */
  creditorIban?: Maybe<Scalars['String']['output']>;
  /** @deprecated unused, will be deleted */
  creditorName?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  /** @deprecated unused, will be deleted */
  debtorIban?: Maybe<Scalars['String']['output']>;
  /** @deprecated unused, will be deleted */
  debtorName?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  docNeeded?: Maybe<Scalars['Boolean']['output']>;
  exchangeRate?: Maybe<Scalars['String']['output']>;
  extraId?: Maybe<Scalars['String']['output']>;
  /** Extra tax agreement */
  extraTaxAgree: Scalars['Boolean']['output'];
  /** @deprecated unused, will be deleted */
  flowId?: Maybe<Scalars['String']['output']>;
  /** Shown only in the accountant cabinet, never to the company users (imported by the accountant from a PDF statement) */
  hiddenFromClient: Scalars['Boolean']['output'];
  /** @deprecated unused, will be deleted */
  id: Scalars['Float']['output'];
  importId?: Maybe<Scalars['String']['output']>;
  includeTransaction: Scalars['Boolean']['output'];
  internalTransferTransactionId?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  oldSaltedgeTransactionId?: Maybe<Scalars['String']['output']>;
  parentTransactionId?: Maybe<Scalars['String']['output']>;
  postingDate?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated unused, will be deleted */
  purposeCode?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reasonNotNeeded?: Maybe<ReasonNotNeededEnum>;
  /** @deprecated unused, will be deleted */
  remittanceInformationStructured?: Maybe<Scalars['String']['output']>;
  /** @deprecated unused, will be deleted */
  remittanceInformationUnstructured?: Maybe<Scalars['String']['output']>;
  saltedgeTransactionId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceAmount?: Maybe<Scalars['String']['output']>;
  sourceCurrency?: Maybe<Scalars['String']['output']>;
  /** Accounting file (a_file) of the bank statement the transaction was imported from */
  statementFileId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
  transactionDocConnections?: Maybe<Array<TransactionsDocsDto>>;
  transactionDocConnectionsCount?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** @deprecated unused, will be deleted */
  valueDate?: Maybe<Scalars['DateTime']['output']>;
};

export type BankingTransactionEntity = {
  __typename?: 'BankingTransactionEntity';
  account?: Maybe<BankingAccountEntity>;
  /** @deprecated unused, will be deleted */
  additionalInformation?: Maybe<Scalars['String']['output']>;
  amount: Scalars['String']['output'];
  amountInDashboardCurrency?: Maybe<Scalars['String']['output']>;
  /** @deprecated unused, will be deleted */
  bankTransactionCode?: Maybe<Scalars['String']['output']>;
  bankingCategoryItem?: Maybe<BankingCategoryItemEntity>;
  bankingCategoryItemId?: Maybe<Scalars['String']['output']>;
  bookingDate: Scalars['DateTime']['output'];
  category?: Maybe<Scalars['String']['output']>;
  categoryLibrary?: Maybe<CategoryLibraryEntity>;
  /**
   * ID from category_library
   * @deprecated unused, will be deleted
   */
  categoryLibraryId?: Maybe<Scalars['String']['output']>;
  closingBalance?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  counterparty?: Maybe<CounterpartyEntity>;
  counterpartyIban?: Maybe<Scalars['String']['output']>;
  /** CounterpartyID */
  counterpartyId?: Maybe<Scalars['String']['output']>;
  counterpartyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated unused, will be deleted */
  creditorIban?: Maybe<Scalars['String']['output']>;
  /** @deprecated unused, will be deleted */
  creditorName?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  /** @deprecated unused, will be deleted */
  debtorIban?: Maybe<Scalars['String']['output']>;
  /** @deprecated unused, will be deleted */
  debtorName?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  docNeeded?: Maybe<Scalars['Boolean']['output']>;
  exchangeRate?: Maybe<Scalars['String']['output']>;
  extraId?: Maybe<Scalars['String']['output']>;
  /** Extra tax agreement */
  extraTaxAgree: Scalars['Boolean']['output'];
  /** @deprecated unused, will be deleted */
  flowId?: Maybe<Scalars['String']['output']>;
  /** Shown only in the accountant cabinet, never to the company users (imported by the accountant from a PDF statement) */
  hiddenFromClient: Scalars['Boolean']['output'];
  /** @deprecated unused, will be deleted */
  id: Scalars['Float']['output'];
  importId?: Maybe<Scalars['String']['output']>;
  includeTransaction: Scalars['Boolean']['output'];
  internalTransferTransactionId?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  oldSaltedgeTransactionId?: Maybe<Scalars['String']['output']>;
  parentTransactionId?: Maybe<Scalars['String']['output']>;
  postingDate?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated unused, will be deleted */
  purposeCode?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reasonNotNeeded?: Maybe<ReasonNotNeededEnum>;
  /** @deprecated unused, will be deleted */
  remittanceInformationStructured?: Maybe<Scalars['String']['output']>;
  /** @deprecated unused, will be deleted */
  remittanceInformationUnstructured?: Maybe<Scalars['String']['output']>;
  saltedgeTransactionId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceAmount?: Maybe<Scalars['String']['output']>;
  sourceCurrency?: Maybe<Scalars['String']['output']>;
  /** Accounting file (a_file) of the bank statement the transaction was imported from */
  statementFileId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
  transactionDocConnectionsCount?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** @deprecated unused, will be deleted */
  valueDate?: Maybe<Scalars['DateTime']['output']>;
};

export type BankingTransactionRuleEntity = {
  __typename?: 'BankingTransactionRuleEntity';
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isAutoGenerated: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Transaction distribution rule */
  rule: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BankingTransactionsDto2 = {
  __typename?: 'BankingTransactionsDto2';
  /** Accounting document status */
  accStatusId?: Maybe<FileAccStatus>;
  accountId: Scalars['String']['output'];
  /** Account (bank) name */
  accountName?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  amountInDashboardCurrency?: Maybe<Scalars['Float']['output']>;
  /** Attached document files, unique per file */
  attachedDocuments?: Maybe<Array<AttachedDocumentDto>>;
  /** BookingDate date */
  bookingDate: Scalars['DateTime']['output'];
  categoryItem?: Maybe<BankingCategoryItemEntity>;
  categoryItemId?: Maybe<Scalars['String']['output']>;
  /** Saltedge category */
  categoryLibrary?: Maybe<CategoryLibraryEntity>;
  categoryLibraryId?: Maybe<Scalars['String']['output']>;
  counterpartyId?: Maybe<Scalars['String']['output']>;
  /** Transaction currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** Transaction description */
  description?: Maybe<Scalars['String']['output']>;
  docNeeded?: Maybe<Scalars['Boolean']['output']>;
  /** Extra tax agreement */
  extraTaxAgree: Scalars['Boolean']['output'];
  /** Counterparty first name */
  firstName?: Maybe<Scalars['String']['output']>;
  importId?: Maybe<Scalars['String']['output']>;
  includeTransaction: Scalars['Boolean']['output'];
  /** Counterparty last name */
  lastName?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  /** Transaction status */
  status?: Maybe<Scalars['String']['output']>;
  /** Transaction date */
  transactionDate: Scalars['DateTime']['output'];
  transactionDocConnectionsCount?: Maybe<Scalars['Float']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
};

export type BankingTransactionsInputDto = {
  accountId: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  bookingDate: Scalars['DateTime']['input'];
  categoryItemId?: InputMaybe<Scalars['String']['input']>;
  categoryLibraryId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  counterpartyId?: InputMaybe<Scalars['String']['input']>;
  counterpartyName?: InputMaybe<Scalars['String']['input']>;
  creditorName?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  debtorName?: InputMaybe<Scalars['String']['input']>;
  includeTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  /** Transaction date (posting/operation date) */
  transactionDate: Scalars['DateTime']['input'];
  transactionId?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<Scalars['String']['input']>;
};

export type BankingTransactionsListFilterInputDto = {
  /** Incoming transactions */
  incoming?: InputMaybe<Scalars['Boolean']['input']>;
  /** debtor or creditor name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Outgoing transactions */
  outgoing?: InputMaybe<Scalars['Boolean']['input']>;
  /** String format 22-02-28 */
  periodEnd?: InputMaybe<Scalars['String']['input']>;
  /** String format 22-02-01 */
  periodStart?: InputMaybe<Scalars['String']['input']>;
};

export type BankingTransactionsListFilterInputDto2 = {
  accStatusId?: InputMaybe<Array<FiltersItemInput>>;
  accountsId?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by amount */
  amount?: InputMaybe<TransactionsAmountFilterInputDto>;
  attachment?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<FiltersItemInput>>;
  counterparty?: InputMaybe<Array<FiltersItemInput>>;
  /** Document needed */
  docNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  /** импортирована ли транзакция из csv (или создана вручную, importId = 1), в value строка true/false */
  imported?: InputMaybe<FiltersItemInput>;
  /** Consider in calculations, value is a true/false string */
  includeTransaction?: InputMaybe<FiltersItemInput>;
  invoiceVat?: InputMaybe<Array<FiltersItemInput>>;
  /** debtor or creditor name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Reason for document absence */
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<FiltersItemInput>>;
  /** String true/false */
  suspiciousAlert?: InputMaybe<FiltersItemInput>;
  /** Filter by transactionDate (preferred over bookingDate) */
  transactionDate?: InputMaybe<DateFilterDto>;
  /** Transaction type */
  transactionType?: InputMaybe<Scalars['String']['input']>;
  transactionsId?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Tansactions list by bank account */
export type BankingTransactionsListType = {
  __typename?: 'BankingTransactionsListType';
  /** List */
  list?: Maybe<Array<BankingTransactionEntity>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export type BankingTransactionsListType2 = {
  __typename?: 'BankingTransactionsListType2';
  /** List */
  list?: Maybe<Array<BankingTransactionsDto2>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export type BanksListDto = {
  __typename?: 'BanksListDto';
  accounts: Array<BankingAccountEntity>;
};

/** List of clicks in billsby */
export type BillsbyClicksListType = {
  __typename?: 'BillsbyClicksListType';
  /** List */
  list?: Maybe<Array<BillsbyClicksType>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

/** Click in Billsby */
export type BillsbyClicksType = {
  __typename?: 'BillsbyClicksType';
  /** Amount */
  amount: Scalars['String']['output'];
  createdAt: Scalars['DateTimeType']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Product name */
  product: Scalars['String']['output'];
};

/** Billsby extended subscription info */
export type BillsbyExtendedSubscriptionInfoType = {
  __typename?: 'BillsbyExtendedSubscriptionInfoType';
  /** Time when the subscription was created */
  createdOn: Scalars['DateTimeType']['output'];
  /** Amount of the next payment */
  nextBillingAmount: Scalars['Int']['output'];
  /** Date of the next payment */
  nextBillingDate: Scalars['DateTimeType']['output'];
};

/** Information about the item included in the subscription */
export type BillsbyInvoiceSubscriptionItemType = {
  __typename?: 'BillsbyInvoiceSubscriptionItemType';
  /** Cost */
  amount: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /** Quantity */
  units: Scalars['Int']['output'];
};

/** billsby invoice */
export type BillsbyInvoiceType = {
  __typename?: 'BillsbyInvoiceType';
  /** Amount in EUR cents */
  amount: Scalars['Int']['output'];
  /** Customer id in billsby */
  customerId: Scalars['String']['output'];
  /** Invoice id */
  id: Scalars['String']['output'];
  /** Created at */
  invoiceDate: Scalars['DateTimeType']['output'];
  /** Invoice status */
  status: Scalars['String']['output'];
};

export type BillsbySubscription = {
  /** Time when the subscription was created */
  createdOn: Scalars['DateTimeType']['input'];
  /** Time when the next payment will occur */
  nextBilling: Scalars['DateTimeType']['input'];
  /** Plan ID to which the subscription belongs */
  planId: Scalars['Int']['input'];
  /** Formatted amount of the next payment */
  revenue: Scalars['String']['input'];
  /** Subscription identifier */
  subscriptionId: Scalars['String']['input'];
};

export type BillsbySubscriptionDetail = {
  /** Time when the subscription was created */
  createdOn: Scalars['DateTimeType']['input'];
  /** Amount of the next payment */
  nextBillingAmount: Scalars['Int']['input'];
  /** Date of the next payment */
  nextBillingDate: Scalars['DateTimeType']['input'];
};

/** Brief information about the billsby subscription */
export type BillsbySubscriptionInfoType = {
  __typename?: 'BillsbySubscriptionInfoType';
  /** Time when the subscription was created */
  createdOn: Scalars['DateTimeType']['output'];
  /** Time when the next payment will occur */
  nextBilling: Scalars['DateTimeType']['output'];
  /** Plan ID to which the subscription belongs */
  planId: Scalars['Int']['output'];
  /** Formatted amount of the next payment */
  revenue: Scalars['String']['output'];
  /** Subscription identifier */
  subscriptionId: Scalars['String']['output'];
};

/** Billsby subscription */
export type BillsbySubscriptionType = {
  __typename?: 'BillsbySubscriptionType';
  /** CustomerId in billsby */
  customerId: Scalars['String']['output'];
  /** Extended subscription data by user */
  extendedInfo: BillsbyExtendedSubscriptionInfoType;
  /** Subscription id */
  id: Scalars['String']['output'];
  /** Subscription data by user */
  info: BillsbySubscriptionInfoType;
  /** Subscription plan name */
  planName: Scalars['String']['output'];
  /** Subscription status */
  status: Scalars['String']['output'];
};

export type CmDoc = {
  __typename?: 'CMDoc';
  /** AI response after document review */
  aiReview?: Maybe<Scalars['JSON']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  /** Contract end date */
  contractEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Contract start date */
  contractStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** Counterparty */
  counterparty?: Maybe<CounterpartyEntity>;
  /** Contractor ID */
  counterpartyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deal?: Maybe<Deal>;
  dealId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document file ID (docx) */
  docFileId?: Maybe<Scalars['String']['output']>;
  esignDoc?: Maybe<EsignDocsEntity>;
  /** Row ID from esign_docs table */
  esignDocId?: Maybe<Scalars['String']['output']>;
  esignedFileId?: Maybe<Scalars['String']['output']>;
  /** Document file ID (pdf) */
  fileId?: Maybe<Scalars['String']['output']>;
  /** Document file ID (html) */
  htmlFileId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Edited file */
  isEdited?: Maybe<Scalars['Boolean']['output']>;
  /** Document language code (e.g. en, ru) */
  lang?: Maybe<Scalars['String']['output']>;
  /** Document file ID (md) */
  mdFileId?: Maybe<Scalars['String']['output']>;
  /** Custom file name when uploading document */
  name?: Maybe<Scalars['String']['output']>;
  /** Reference to original document if this is a translation */
  originalDocId?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<ProductInCmDoc>>;
  /** Typeform request ID */
  requestId?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Numeric field, user assigns sequential document number within typeform */
  seqNumber?: Maybe<Scalars['Float']['output']>;
  /** Signed document file ID */
  signedFileId?: Maybe<Scalars['String']['output']>;
  /** Status */
  status?: Maybe<CmDocStatusEnum>;
  /** Template */
  template?: Maybe<CmDocTemplate>;
  templateId: Scalars['String']['output'];
  /** Document type */
  type: CmDocTypeEnum;
  /** Generated from template settings when creating document/draft */
  typeformUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  worker?: Maybe<HrWorkerEntity>;
  /** Employee ID */
  workerId?: Maybe<Scalars['String']['output']>;
};

/** Documents list */
export type CmDocByClientListType = {
  __typename?: 'CMDocByClientListType';
  allCount: Scalars['Int']['output'];
  draftsCount: Scalars['Int']['output'];
  generatedCount: Scalars['Int']['output'];
  /** List */
  list?: Maybe<Array<CmDoc>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
  sentCount: Scalars['Int']['output'];
  signedCount: Scalars['Int']['output'];
};

export type CmDocInputType = {
  /** AI response after document review */
  aiReview?: InputMaybe<Scalars['JSON']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  /** Contract end date */
  contractEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Contract start date */
  contractStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Contractor ID */
  counterpartyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deal?: InputMaybe<DealInputType>;
  dealId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Document file ID (docx) */
  docFileId?: InputMaybe<Scalars['String']['input']>;
  esignDoc?: InputMaybe<EsignDocsInputType>;
  /** Row ID from esign_docs table */
  esignDocId?: InputMaybe<Scalars['String']['input']>;
  esignedFileId?: InputMaybe<Scalars['String']['input']>;
  /** Document file ID (pdf) */
  fileId?: InputMaybe<Scalars['String']['input']>;
  /** Document file ID (html) */
  htmlFileId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** Edited file */
  isEdited?: InputMaybe<Scalars['Boolean']['input']>;
  /** Document language code (e.g. en, ru) */
  lang?: InputMaybe<Scalars['String']['input']>;
  /** Document file ID (md) */
  mdFileId?: InputMaybe<Scalars['String']['input']>;
  /** Custom file name when uploading document */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Reference to original document if this is a translation */
  originalDocId?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<ProductInCmDocInputType>>;
  /** Typeform request ID */
  requestId?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Numeric field, user assigns sequential document number within typeform */
  seqNumber?: InputMaybe<Scalars['Float']['input']>;
  /** Signed document file ID */
  signedFileId?: InputMaybe<Scalars['String']['input']>;
  /** Status */
  status?: InputMaybe<CmDocStatusEnum>;
  templateId: Scalars['String']['input'];
  /** Document type */
  type?: CmDocTypeEnum;
  /** Generated from template settings when creating document/draft */
  typeformUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker?: InputMaybe<HrWorkerInputType>;
  /** Employee ID */
  workerId?: InputMaybe<Scalars['String']['input']>;
};

/** Documents list */
export type CmDocListType = {
  __typename?: 'CMDocListType';
  allCount: Scalars['Int']['output'];
  draftsCount: Scalars['Int']['output'];
  generatedCount: Scalars['Int']['output'];
  /** List */
  list?: Maybe<Array<CmDoc>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
  sentCount: Scalars['Int']['output'];
  signedCount: Scalars['Int']['output'];
};

export enum CmDocStatusEnum {
  Draft = 'Draft',
  Generated = 'Generated',
  SignedByCounterparty = 'SignedByCounterparty',
  SinedByUser = 'SinedByUser'
}

export type CmDocTemplate = {
  __typename?: 'CMDocTemplate';
  /** Alternative names for template search by search query */
  alterNames?: Maybe<Scalars['String']['output']>;
  cm_documents?: Maybe<Array<CmDoc>>;
  description: Scalars['String']['output'];
  docType?: Maybe<Scalars['String']['output']>;
  financialDoc: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isFreeDoc?: Maybe<Scalars['Boolean']['output']>;
  /** Template language */
  lang?: Maybe<Scalars['String']['output']>;
  marketId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Order or sorting */
  order?: Maybe<Scalars['Int']['output']>;
  /** Template tag, comma separated */
  tag?: Maybe<Scalars['String']['output']>;
  /** Template preview file id */
  templatePreviewFileId?: Maybe<Scalars['String']['output']>;
  /** File name for preview */
  templatePreviewName?: Maybe<Scalars['String']['output']>;
  typeFormDocId: Scalars['String']['output'];
  withDocModal: Scalars['Boolean']['output'];
};

export type CmDocTemplateInputType = {
  /** Alternative names for template search by search query */
  alterNames?: InputMaybe<Scalars['String']['input']>;
  cm_documents?: InputMaybe<Array<CmDocInputType>>;
  description: Scalars['String']['input'];
  docType?: InputMaybe<Scalars['String']['input']>;
  financialDoc: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isFreeDoc?: InputMaybe<Scalars['Boolean']['input']>;
  /** Template language */
  lang?: InputMaybe<Scalars['String']['input']>;
  marketId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  /** Order or sorting */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Template tag, comma separated */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Template preview file id */
  templatePreviewFileId?: InputMaybe<Scalars['String']['input']>;
  /** File name for preview */
  templatePreviewName?: InputMaybe<Scalars['String']['input']>;
  typeFormDocId: Scalars['String']['input'];
  withDocModal: Scalars['Boolean']['input'];
};

export type CmMuation = {
  __typename?: 'CMMuation';
  /** Add counterparty for uploaded document */
  addCounterpartyToUploadedDoc: Scalars['Boolean']['output'];
  /** AI document review */
  analyzeContract: Scalars['Boolean']['output'];
  /** Edit/create cmTemplate from admin panel */
  changeCmTemplateByAdmin: Scalars['Boolean']['output'];
  /** Change Start date for CM document */
  changeDocStartDate: CmDoc;
  /** Generate invoice for CM document */
  createInvoiceFromCm?: Maybe<Scalars['String']['output']>;
  /** Create new cm_doc instance from uploaded document */
  createUploadedDoc: CmDoc;
  /** Delete draft document */
  deleteDraftDoc: Scalars['Boolean']['output'];
  /** Delete document temporarily uploaded to Google Docs */
  deleteTempGoogleDoc: Scalars['Boolean']['output'];
  /** Save request from user for a new document/contract template */
  newDocRequest: Scalars['Boolean']['output'];
  /** Find/create CM document with particular file format */
  prepareDocFormat: Scalars['String']['output'];
  /** Upload document to Google Docs to redirect user to the editor */
  prepareGoogleDocForEditing: Scalars['String']['output'];
  /** Rename CM document */
  renameDoc: CmDoc;
  /** Save CM document */
  saveDoc: CmDoc;
  /** Save result of editing in Google Doc into cm_doc table */
  saveEditedGoogleDoc: Scalars['String']['output'];
  /** Save company representative */
  saveRepresentative: CmRepresentative;
  /** Save pdf with signature for CM document */
  saveSignedDoc: Scalars['Boolean']['output'];
  /** Send PDF document to the counterparty */
  sendToCounterparty: Scalars['Boolean']['output'];
  /** Start document translation */
  translateDoc: TranslationJob;
};


export type CmMuationAddCounterpartyToUploadedDocArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  docId: Scalars['String']['input'];
};


export type CmMuationAnalyzeContractArgs = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['String']['input'];
  q1?: InputMaybe<Scalars['String']['input']>;
  q2?: InputMaybe<Scalars['String']['input']>;
  q3?: InputMaybe<Scalars['String']['input']>;
  q4?: InputMaybe<Scalars['String']['input']>;
  q5?: InputMaybe<Scalars['String']['input']>;
  reqId?: InputMaybe<Scalars['String']['input']>;
};


export type CmMuationChangeCmTemplateByAdminArgs = {
  cmTemplate: TemplateInputType;
};


export type CmMuationChangeDocStartDateArgs = {
  docId: Scalars['String']['input'];
  newDate: Scalars['DateTime']['input'];
};


export type CmMuationCreateInvoiceFromCmArgs = {
  contractId: Scalars['String']['input'];
};


export type CmMuationCreateUploadedDocArgs = {
  doc: UploadCmDocInputType;
};


export type CmMuationDeleteDraftDocArgs = {
  docId: Scalars['String']['input'];
};


export type CmMuationDeleteTempGoogleDocArgs = {
  docId: Scalars['String']['input'];
  googleDocLink: Scalars['String']['input'];
};


export type CmMuationNewDocRequestArgs = {
  counterpartyNeeded: Scalars['Boolean']['input'];
  docYouNeed: Scalars['String']['input'];
  requirements?: InputMaybe<Scalars['String']['input']>;
};


export type CmMuationPrepareDocFormatArgs = {
  docId: Scalars['String']['input'];
  format: Scalars['String']['input'];
};


export type CmMuationPrepareGoogleDocForEditingArgs = {
  docId: Scalars['String']['input'];
};


export type CmMuationRenameDocArgs = {
  docId: Scalars['String']['input'];
  newName: Scalars['String']['input'];
};


export type CmMuationSaveDocArgs = {
  doc: CmDocInputType;
  serviceAgreementType?: InputMaybe<Scalars['String']['input']>;
};


export type CmMuationSaveEditedGoogleDocArgs = {
  docId: Scalars['String']['input'];
  googleDocLink: Scalars['String']['input'];
};


export type CmMuationSaveRepresentativeArgs = {
  representative: CmRepresentativeInputType;
};


export type CmMuationSaveSignedDocArgs = {
  docId: Scalars['String']['input'];
  signedFileId: Scalars['String']['input'];
};


export type CmMuationSendToCounterpartyArgs = {
  docId: Scalars['String']['input'];
  remind: Scalars['Boolean']['input'];
};


export type CmMuationTranslateDocArgs = {
  docId: Scalars['String']['input'];
  targetLanguage: Scalars['String']['input'];
};

export type CmQuery = {
  __typename?: 'CMQuery';
  /** Get list of all CM document templates for admin */
  cmTemplatesListAdmin: CmTemplatesByAdminListType;
  /** Get DocAi by ID */
  docAi?: Maybe<DocAi>;
  /** Get AI prompts configuration (works only in dev mode) */
  docAiPrompts: DocAiPrompts;
  /** All docs of the counterparty */
  docsByClient?: Maybe<CmDocByClientListType>;
  /** One document by id */
  document: CmDoc;
  documents?: Maybe<CmDocListType>;
  /** Get list of active filters for documents */
  filterData: DocsDataFiltersDto;
  /** Number of generated documents (status=2) */
  generatedDocsCount: Scalars['Int']['output'];
  /** Company representative */
  representative?: Maybe<CmRepresentative>;
  /** Search by CMDocTemplate */
  searchCmTemplates: Array<CmDocTemplate>;
  templates: Array<CmDocTemplate>;
};


export type CmQueryCmTemplatesListAdminArgs = {
  pagination?: InputMaybe<PaginationInputType>;
};


export type CmQueryDocAiArgs = {
  id: Scalars['String']['input'];
};


export type CmQueryDocsByClientArgs = {
  filter?: InputMaybe<DocsByClientQueryFilterInputType>;
  pagination?: InputMaybe<PaginationInputType>;
  sort?: InputMaybe<SortInputType>;
};


export type CmQueryDocumentArgs = {
  id: Scalars['String']['input'];
};


export type CmQueryDocumentsArgs = {
  filter?: InputMaybe<DocumentsQueryFilterInputType>;
  pagination: PaginationInputType;
  sort?: InputMaybe<SortInputType>;
};


export type CmQuerySearchCmTemplatesArgs = {
  search: TemplateFilterInputType;
};

/** Conpany representative */
export type CmRepresentative = {
  __typename?: 'CMRepresentative';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  companyId?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  /** Phone number. Format: country code, whitespace, number */
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
};

export type CmRepresentativeInputType = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  /** Phone number. Format: country code, whitespace, number */
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
};

/** Document templates list for admin */
export type CmTemplatesByAdminListType = {
  __typename?: 'CMTemplatesByAdminListType';
  /** List */
  list?: Maybe<Array<CmDocTemplate>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export type CsService = {
  __typename?: 'CSService';
  /** group */
  group: CsServiceGroup;
  groupId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  /** Image file path */
  imagePath?: Maybe<Scalars['String']['output']>;
  marketId: Scalars['Int']['output'];
  /** Service name */
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  previewText: Scalars['String']['output'];
  requiresEres: Scalars['Boolean']['output'];
  /** Service type for request form */
  serviceType: Scalars['Int']['output'];
  taxFree18: Scalars['Boolean']['output'];
};

export type CsServiceGroup = {
  __typename?: 'CSServiceGroup';
  id: Scalars['Int']['output'];
  /** Service group name */
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** All services of the group */
  services: Array<CsService>;
};

export type CsServiceGroupInputType = {
  id: Scalars['Int']['input'];
  /** Service group name */
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type CsServiceInputType = {
  groupId: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  /** Image file path */
  imagePath?: InputMaybe<Scalars['String']['input']>;
  marketId: Scalars['Int']['input'];
  /** Service name */
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  previewText: Scalars['String']['input'];
  requiresEres: Scalars['Boolean']['input'];
  /** Service type for request form */
  serviceType: Scalars['Int']['input'];
  taxFree18: Scalars['Boolean']['input'];
};

export type CsServiceMutation = {
  __typename?: 'CSServiceMutation';
  /** New user request */
  addRequest: Scalars['Boolean']['output'];
  /** Request processed */
  doneRequest: Scalars['Boolean']['output'];
  /** Service update */
  saveService: Scalars['Boolean']['output'];
};


export type CsServiceMutationAddRequestArgs = {
  request: AddNewCsRequestInput;
};


export type CsServiceMutationDoneRequestArgs = {
  id: Scalars['String']['input'];
};


export type CsServiceMutationSaveServiceArgs = {
  service: CsServiceInputType;
};

export type CsServiceQuery = {
  __typename?: 'CSServiceQuery';
  /** All cs services groups */
  groups: Array<CsServiceGroup>;
  /** Get users requests */
  requests: Array<CsServiceRequest>;
  /** All services */
  services: Array<CsService>;
};

export type CsServiceRequest = {
  __typename?: 'CSServiceRequest';
  /** Creation date */
  createdAt: Scalars['DateTimeType']['output'];
  /** Has the request been processed? */
  done: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  requestText: Scalars['String']['output'];
  /** Which service the request was made for */
  service: CsService;
  /** Service that has been requested */
  serviceId: Scalars['String']['output'];
  /** User who made the request */
  user: UserType;
  /** User that authored the request */
  userId: Scalars['String']['output'];
};

export type CsServiceRequestInputType = {
  /** Creation date */
  createdAt: Scalars['DateTimeType']['input'];
  /** Has the request been processed? */
  done: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  requestText: Scalars['String']['input'];
  /** Service that has been requested */
  serviceId: Scalars['String']['input'];
  /** User that authored the request */
  userId: Scalars['String']['input'];
};

export type CategoriesFilterDto = {
  __typename?: 'CategoriesFilterDto';
  filterName: Scalars['String']['output'];
  localeKey: Scalars['String']['output'];
  values: Array<CategoriesFilterItemDto>;
};

export type CategoriesFilterItemDto = {
  __typename?: 'CategoriesFilterItemDto';
  categories: Array<FiltersItem2>;
  categoryGroupId: Scalars['String']['output'];
  categoryGroupName: Scalars['String']['output'];
};

export type CategorizationResultWithTimeDto = {
  __typename?: 'CategorizationResultWithTimeDto';
  averageTimeToEnd: Scalars['Float']['output'];
  companyId: Scalars['String']['output'];
  leftTransactions: Scalars['Float']['output'];
};

export type CategoryGroupCategoriesDto = {
  __typename?: 'CategoryGroupCategoriesDto';
  categoryId: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  colour: Scalars['String']['output'];
  moneyValues: Array<CategoryMoneyValuesDto>;
};

export type CategoryLibraryEntity = {
  __typename?: 'CategoryLibraryEntity';
  categoryName: Scalars['String']['output'];
  colour?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  custom: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  groupCategoryName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  transactions?: Maybe<Array<BankingTransactionEntity>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CategoryListItem = {
  __typename?: 'CategoryListItem';
  colour?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Merit API ItemId (AccountCode) */
  meritItemId?: Maybe<Scalars['String']['output']>;
  meritTaxId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CategoryMoneyValuesDto = {
  __typename?: 'CategoryMoneyValuesDto';
  percent?: Maybe<Scalars['Float']['output']>;
  value: Scalars['String']['output'];
};

/** Steps for the categorization setup process */
export enum CategorySetupStep {
  ErrorOnFirstBatch = 'ErrorOnFirstBatch',
  FirstBatchProcessed = 'FirstBatchProcessed',
  Initial = 'Initial',
  QueueProcessed = 'QueueProcessed',
  StructureConfirmed = 'StructureConfirmed',
  StructureCreated = 'StructureCreated'
}

/** Which category need to return */
export enum CategoryStatus {
  All = 'All',
  OnlyConfirmed = 'OnlyConfirmed',
  OnlyUnConfirmed = 'OnlyUnConfirmed'
}

export type CategorySummaryDto = {
  __typename?: 'CategorySummaryDto';
  items: Array<CategorySummaryDtoItem>;
  totalAmount: Scalars['Float']['output'];
};

export type CategorySummaryDtoItem = {
  __typename?: 'CategorySummaryDtoItem';
  amount: Scalars['Float']['output'];
  average?: Maybe<Scalars['Float']['output']>;
  colour?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  transactionsCount?: Maybe<Scalars['Float']['output']>;
};

export type CategoryTreeDto = {
  __typename?: 'CategoryTreeDto';
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Array<CategoryListItem>;
};

export type CfoCardsDto = {
  __typename?: 'CfoCardsDto';
  averageIncoming?: Maybe<Scalars['Float']['output']>;
  averageOutgoing?: Maybe<Scalars['Float']['output']>;
  averageRevenue?: Maybe<Scalars['Float']['output']>;
  expectedIncome?: Maybe<Scalars['Float']['output']>;
  incomingPercentage?: Maybe<Scalars['Float']['output']>;
  incomingPrevPeriod?: Maybe<Scalars['Float']['output']>;
  incomingThisPeriod?: Maybe<Scalars['Float']['output']>;
  outgoingPercentage?: Maybe<Scalars['Float']['output']>;
  outgoingPrevPeriod?: Maybe<Scalars['Float']['output']>;
  outgoingThisPeriod?: Maybe<Scalars['Float']['output']>;
  outstandingInvoicesData?: Maybe<ExpectedIncomeDetails>;
};

export type CfoChartDto = {
  __typename?: 'CfoChartDto';
  datesPoints: Array<Scalars['String']['output']>;
  totalNetCashFlow: Scalars['Float']['output'];
  valuesPoints: Array<CfoChartValueType>;
};

export type CfoChartValueType = {
  __typename?: 'CfoChartValueType';
  incoming: Scalars['Float']['output'];
  incomingPrev: Scalars['Float']['output'];
  netCashFlow: Scalars['Float']['output'];
  netCashFlowPrev: Scalars['Float']['output'];
  outgoing: Scalars['Float']['output'];
  outgoingPrev: Scalars['Float']['output'];
};

export enum CfoPeriodsUnitsEnum {
  Custom = 'Custom',
  ThisHalfYear = 'ThisHalfYear',
  ThisMonth = 'ThisMonth',
  ThisQuarter = 'ThisQuarter',
  ThisWeek = 'ThisWeek',
  ThisYear = 'ThisYear'
}

export type CfoReportDto = {
  __typename?: 'CfoReportDto';
  dates: Array<Scalars['String']['output']>;
  reports: Array<CfoReportItemDto>;
};

export type CfoReportItemDto = {
  __typename?: 'CfoReportItemDto';
  reportCategoryGroups: Array<ReportCategoryGroupDto>;
  reportIdLocale: Scalars['String']['output'];
  reportName: Scalars['String']['output'];
};

export type ChangeCompanyRoleInput = {
  /** New role of the user */
  role: UserCompanyRole;
  /** ID of the user whose role will be changed */
  userId: Scalars['String']['input'];
};

export enum ChargebeeBillingPeriod {
  Month = 'month',
  Semiyearly = 'semiyearly',
  Year = 'year'
}

/** Checkout totals from the Chargebee invoice estimate, for the summary UI next to Payment Components. All amounts are in cents. The frontend must render these values as is and never calculate discounts itself */
export type ChargebeeCheckoutBreakdownType = {
  __typename?: 'ChargebeeCheckoutBreakdownType';
  /** Amount due today; equals paymentIntent.amount */
  amountDue: Scalars['Int']['output'];
  /** Coupon id actually applied by Chargebee, if any */
  appliedCouponId?: Maybe<Scalars['String']['output']>;
  /** Credits applied to this invoice */
  creditsApplied: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  /** Sum of all discounts in cents */
  discountAmount: Scalars['Int']['output'];
  discounts: Array<ChargebeeCheckoutDiscountType>;
  /** Estimated amount of the next recurring invoice, when Chargebee provides it */
  nextBillingAmount?: Maybe<Scalars['Int']['output']>;
  /** Unix timestamp (seconds) of the next billing, when Chargebee provides it */
  nextBillingAt?: Maybe<Scalars['Int']['output']>;
  /** Amount excluding taxes, after discounts */
  subTotal: Scalars['Int']['output'];
  /** Total tax (VAT) amount */
  taxAmount: Scalars['Int']['output'];
  /** Tax (VAT) rate in percent; null when no tax or multiple different rates apply */
  taxRate?: Maybe<Scalars['Float']['output']>;
  /** Individual tax lines */
  taxes: Array<ChargebeeCheckoutTaxType>;
  /** Invoice total including taxes */
  total: Scalars['Int']['output'];
};

/** A single discount line from the Chargebee invoice estimate */
export type ChargebeeCheckoutDiscountType = {
  __typename?: 'ChargebeeCheckoutDiscountType';
  /** Discount amount in cents */
  amount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Coupon id for coupon discounts */
  entityId?: Maybe<Scalars['String']['output']>;
  /** Discount origin: item_level_coupon | document_level_coupon | promotional_credits | prorated_credits | item_level_discount | document_level_discount */
  entityType: Scalars['String']['output'];
};

/** A single tax line of the checkout invoice estimate */
export type ChargebeeCheckoutTaxType = {
  __typename?: 'ChargebeeCheckoutTaxType';
  /** Tax amount in cents */
  amount: Scalars['Int']['output'];
  /** Tax name as configured in Chargebee, e.g. "VAT" */
  name: Scalars['String']['output'];
  /** Tax rate in percent; null when line items are taxed at different rates */
  rate?: Maybe<Scalars['Float']['output']>;
};

/** Generated coupon for friends */
export type ChargebeeCouponType = {
  __typename?: 'ChargebeeCouponType';
  /** Coupon id in chargebee */
  couponId: Scalars['String']['output'];
  /** Creation date */
  createdAt: Scalars['DateTimeType']['output'];
  /** Customer id in chargebee */
  customerId: Scalars['String']['output'];
  /** Expires date (chargebee created_at + coupon duration) */
  expiresAt: Scalars['DateTimeType']['output'];
  /** Unique row id */
  id: Scalars['String']['output'];
};

export type ChargebeeCustomerUpdateDto = {
  cf_uid?: InputMaybe<Scalars['String']['input']>;
};

export type ChargebeeInvoiceListQueryFilterInputType = {
  /** User identifier in the chargebee system */
  customerId: Scalars['String']['input'];
  /** Subscription identifier in the chargebee system */
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargebeeInvoiceListQuerySortInputType = {
  /** Sorting field */
  field?: InputMaybe<Scalars['String']['input']>;
  /** Sorting order */
  type?: InputMaybe<SortTypeEnum>;
};

/** User subscriptions in the chargebee system */
export type ChargebeeInvoiceListType = {
  __typename?: 'ChargebeeInvoiceListType';
  /** List */
  list?: Maybe<Array<ChargebeeInvoiceType>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

/** Information about the paid service in the invoice */
export type ChargebeeInvoiceLiteItemType = {
  __typename?: 'ChargebeeInvoiceLiteItemType';
  /** Amount of the invoice item */
  amount: Scalars['Int']['output'];
  /** Name of the item */
  description: Scalars['String']['output'];
  /** Subscription name */
  entityId: Scalars['String']['output'];
  /** Quantity */
  quantity: Scalars['Int']['output'];
};

/** Invoice */
export type ChargebeeInvoiceType = {
  __typename?: 'ChargebeeInvoiceType';
  /** Amount in EUR cents */
  amount: Scalars['Int']['output'];
  /** Customer id in chargebee */
  customerId: Scalars['String']['output'];
  /** Invoice id */
  id: Scalars['String']['output'];
  /** Created at */
  invoiceDate: Scalars['DateTimeType']['output'];
  /** FileId for chargebee invoice */
  invoiceFileId?: Maybe<Scalars['String']['output']>;
  /** Information about invoice items */
  items: Array<ChargebeeInvoiceLiteItemType>;
  /** Invoice status */
  status: Scalars['String']['output'];
};

export type ChargebeeInvoiceValidationResultType = {
  __typename?: 'ChargebeeInvoiceValidationResultType';
  /** Expected company name */
  companyNameExpected?: Maybe<Scalars['String']['output']>;
  /** Company name from invoice */
  companyNameFromInvoice?: Maybe<Scalars['String']['output']>;
  /** Does company name match */
  companyNameMatch: Scalars['Boolean']['output'];
  /** List of validation errors */
  errors: Array<Scalars['String']['output']>;
  /** Is the invoice valid for sending to Merit */
  isValid: Scalars['Boolean']['output'];
  /** Expected VAT number */
  vatNumberExpected?: Maybe<Scalars['String']['output']>;
  /** VAT number from invoice */
  vatNumberFromInvoice?: Maybe<Scalars['String']['output']>;
  /** Does VAT number match */
  vatNumberMatch: Scalars['Boolean']['output'];
};

export type ChargebeeMutation = {
  __typename?: 'ChargebeeMutation';
  /** Generate coupon for company in Chargebee */
  generateCoupon: ChargebeeCouponType;
  /** Customer refresh in Chargebee */
  updateCustomerInChargebee: Scalars['Boolean']['output'];
};


export type ChargebeeMutationUpdateCustomerInChargebeeArgs = {
  chargebeeCustomer: ChargebeeCustomerUpdateDto;
};

/** Chargebee payment intent for the Payment Components checkout */
export type ChargebeePaymentIntentType = {
  __typename?: 'ChargebeePaymentIntentType';
  /** Amount in cents, calculated on the backend */
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  /** Unix timestamp (seconds) when the intent expires */
  expiresAt: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  /** Intent status: inited | in_progress | authorized | consumed | expired */
  status: Scalars['String']['output'];
};

/** Plan Chargebee */
export type ChargebeePlan = {
  __typename?: 'ChargebeePlan';
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Billing period */
  billingPeriod: ChargebeeBillingPeriod;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documents?: Maybe<Scalars['Int']['output']>;
  haveControlPanel: Scalars['Boolean']['output'];
  /** Plan ID */
  id: Scalars['String']['output'];
  /** Name(type) plan */
  name?: Maybe<Scalars['String']['output']>;
  period?: Maybe<AccountingReportPeriodEnum>;
  planType?: Maybe<PlanTypeEntity>;
  planTypeId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  /** Plan type (Starter, Pro, ...) */
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ChargebeePlanInputType = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Billing period */
  billingPeriod: ChargebeeBillingPeriod;
  documents?: InputMaybe<Scalars['Int']['input']>;
  haveControlPanel: Scalars['Boolean']['input'];
  /** Plan ID */
  id: Scalars['String']['input'];
  /** Name(type) plan */
  name?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<AccountingReportPeriodEnum>;
  planType?: InputMaybe<PlanTypeInputType>;
  planTypeId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  /** Plan type (Starter, Pro, ...) */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ChargebeeQuery = {
  __typename?: 'ChargebeeQuery';
  chargebeePlansList: Array<ChargebeePlan>;
  /** Get generated coupon in Chargebee for company */
  getCompanyCoupon?: Maybe<ChargebeeCouponType>;
};

/** Parameters for stopping the chargebee subscription */
export type ChargebeeStopSubscriptionInputType = {
  /** User identifier in the chargebee system */
  customerId: Scalars['String']['input'];
  /** Enable or disable subscription */
  pauseSubscription: Scalars['Boolean']['input'];
  /** Subscription identifier */
  subscriptionId: Scalars['String']['input'];
};

/** Information about the chargebee subscription addon */
export type ChargebeeSubscriptionInfoAddonType = {
  __typename?: 'ChargebeeSubscriptionInfoAddonType';
  /** Addon Price */
  amount: Scalars['Int']['output'];
  /** Addon ID */
  id: Scalars['String']['output'];
  /** Number of addon units */
  quantity: Scalars['Int']['output'];
};

/** Brief information about the chargebee subscription */
export type ChargebeeSubscriptionInfoType = {
  __typename?: 'ChargebeeSubscriptionInfoType';
  /** Add-ons to the subscription */
  addons?: Maybe<Array<ChargebeeSubscriptionInfoAddonType>>;
  /** Billing period */
  billingPeriod?: Maybe<Scalars['String']['output']>;
  /** Time when the subscription was created */
  createdOn: Scalars['DateTimeType']['output'];
  /** Number of documents */
  documents?: Maybe<Scalars['Float']['output']>;
  /** Time when the next payment will occur */
  nextBilling?: Maybe<Scalars['DateTimeType']['output']>;
  /** Time when the subscription was stopped */
  pauseDate?: Maybe<Scalars['DateTimeType']['output']>;
  /** Plan ID to which the subscription belongs */
  planId: Scalars['String']['output'];
  /** Plan name */
  planName?: Maybe<Scalars['String']['output']>;
  /** Amount of the next payment */
  revenue: Scalars['String']['output'];
};

/** Chargebee subscription */
export type ChargebeeSubscriptionType = {
  __typename?: 'ChargebeeSubscriptionType';
  /** User identifier in the chargebee system */
  customerId: Scalars['String']['output'];
  /** Subscription identifier */
  id: Scalars['String']['output'];
  /** User subscription information */
  info: ChargebeeSubscriptionInfoType;
  /** Subscription status */
  status: Scalars['String']['output'];
};

export enum ChatStatusEnum {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Review = 'REVIEW'
}

export type CheckoutComponentsFinalizePayload = {
  __typename?: 'CheckoutComponentsFinalizePayload';
  /** Invoice generated for the checkout, if any */
  invoiceId?: Maybe<Scalars['String']['output']>;
  /** Chargebee subscription created or updated by the checkout */
  subscriptionId: Scalars['String']['output'];
  /** Chargebee subscription status after the checkout */
  subscriptionStatus: Scalars['String']['output'];
};

export type CheckoutComponentsIntentCreatePayload = {
  __typename?: 'CheckoutComponentsIntentCreatePayload';
  /** Checkout totals for the summary UI, from the same estimate as paymentIntent.amount */
  breakdown: ChargebeeCheckoutBreakdownType;
  paymentIntent: ChargebeePaymentIntentType;
  /** Chargebee publishable key for Chargebee.init on the frontend */
  publishableKey: Scalars['String']['output'];
  /** Chargebee site name for Chargebee.init on the frontend */
  siteName: Scalars['String']['output'];
};

export type CheckoutSessionAddonsInputType = {
  additionalShareholder?: InputMaybe<CreateCheckoutAddonInputType>;
  incorporationWithE?: InputMaybe<CreateCheckoutAddonInputType>;
  incorporationWithEWithEntyFee?: InputMaybe<CreateCheckoutAddonInputType>;
  incorporationWithoutE?: InputMaybe<CreateCheckoutAddonInputType>;
  trademarkRegistration?: InputMaybe<CreateCheckoutAddonInputType>;
  virtualOffice?: InputMaybe<CreateCheckoutAddonInputType>;
};

export type CheckoutSessionCreatePayload = {
  __typename?: 'CheckoutSessionCreatePayload';
  created_at: Scalars['Int']['output'];
  embed: Scalars['Boolean']['output'];
  expires_at: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  object: Scalars['String']['output'];
  resource_version: Scalars['Float']['output'];
  state: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type ClientsListFilterInputDto = {
  individual?: InputMaybe<Scalars['Boolean']['input']>;
  isClient?: InputMaybe<Scalars['Boolean']['input']>;
  isProvider?: InputMaybe<Scalars['Boolean']['input']>;
  legalEntity?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Company clients list */
export type ClientsOfOrganizationListType = {
  __typename?: 'ClientsOfOrganizationListType';
  allCount: Scalars['Int']['output'];
  clientsCount: Scalars['Int']['output'];
  individualCount: Scalars['Int']['output'];
  legalEntityCount: Scalars['Int']['output'];
  /** List */
  list?: Maybe<Array<CounterpartyEntity>>;
  othersCount: Scalars['Int']['output'];
  /** Pagination */
  pagination?: Maybe<PaginationType>;
  providersCount: Scalars['Int']['output'];
};

export type CloseNotificationsInput = {
  /** IDs of the notifications to close (dismiss). Required and must not be empty */
  notificationIds: Array<Scalars['String']['input']>;
};

/** Type of document */
export enum CmDocTypeEnum {
  Ai = 'AI',
  Common = 'COMMON',
  Translation = 'TRANSLATION',
  Uploaded = 'UPLOADED'
}

export type CmTranslationCompletedDto = {
  __typename?: 'CmTranslationCompletedDto';
  doc: CmDoc;
  job: TranslationJob;
};

export type CmTranslationFailedDto = {
  __typename?: 'CmTranslationFailedDto';
  job: TranslationJob;
};

export type ComingServicesListResponse = {
  __typename?: 'ComingServicesListResponse';
  id: Scalars['String']['output'];
  like: Scalars['Boolean']['output'];
  /** Users that have liked the service */
  likeThem: Array<Scalars['String']['output']>;
  likesCount: Scalars['Float']['output'];
  /** Service name */
  name: Scalars['String']['output'];
};

export type ComingServicesMutation = {
  __typename?: 'ComingServicesMutation';
  /** Like update for coming services */
  updateLikeThem: Scalars['Boolean']['output'];
};


export type ComingServicesMutationUpdateLikeThemArgs = {
  serviceId: Scalars['String']['input'];
};

export type ComingServicesQuery = {
  __typename?: 'ComingServicesQuery';
  /** Get list of all coming services */
  comingServicesList: Array<ComingServicesListResponse>;
};

/** Companies list for accountants with pagination */
export type CompaniesListForAccountantsDto = {
  __typename?: 'CompaniesListForAccountantsDto';
  /** Accountant list */
  companies: Array<CompanyOpeningType>;
  /** Limitation on the maximum number of companies */
  limit: Scalars['Int']['output'];
  /** Number of companies to skip */
  offset: Scalars['Int']['output'];
  /** Total count companies */
  total: Scalars['Int']['output'];
};

export type Company = {
  /** Accounting folder ID */
  accountingFolderId?: InputMaybe<Scalars['UuidType']['input']>;
  /** Activity code */
  activityCode: Scalars['String']['input'];
  /** Company articles of association */
  articlesOfAssociation?: InputMaybe<Scalars['String']['input']>;
  /** Customer ID in the chargebee system */
  chargebeeCustomerId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyLogoFileId?: InputMaybe<Scalars['String']['input']>;
  /** Contact email address */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Court ruling result for company opening */
  courtRulingStatus: CourtRulingStatusEnum;
  /** Creation date */
  createdAt: Scalars['DateTimeType']['input'];
  /** CRM account ID */
  crmCompanyId?: InputMaybe<Scalars['String']['input']>;
  /** Deleted date */
  deletedAt?: InputMaybe<Scalars['DateTimeType']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Details about the field of activity */
  details: Scalars['String']['input'];
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Field of activity */
  fieldOfActivity: Scalars['String']['input'];
  firmCompanies?: InputMaybe<Array<FirmCompanyType>>;
  /** HitHorizonsId */
  hitHorizonsId?: InputMaybe<Scalars['String']['input']>;
  hrPaymentsPeriods?: InputMaybe<Array<HrPaymentPeriodEntity>>;
  /** ID */
  id: Scalars['String']['input'];
  /** Company incorporation date */
  incorporationDate?: InputMaybe<Scalars['DateTimeType']['input']>;
  insuranceContribution?: InputMaybe<Scalars['String']['input']>;
  /** Flag indicating whether the company is an autopilot client */
  isAutopilotClient?: Scalars['Boolean']['input'];
  /** Flag indicating the completion of the company onboarding (initial setup) */
  isCompletedOnboarding?: Scalars['Boolean']['input'];
  /** Digitization */
  isDigitalStuff: Scalars['Boolean']['input'];
  /** Was this company created through a transfer? */
  isTransferred?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identifier of the country the user is working with (market) */
  marketId?: InputMaybe<Scalars['Int']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Some Dutch field */
  obNummer?: InputMaybe<Scalars['String']['input']>;
  /** Contact person deadline */
  officeDeadlineDate?: InputMaybe<Scalars['String']['input']>;
  paymentsConnectionStatus?: InputMaybe<Scalars['String']['input']>;
  payrollTaxNumber?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  politicallyExposedPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /** Current company processing stage */
  processStep: CompanyOpeningProcessStepEnum;
  /** Company registry address */
  registryAddress?: InputMaybe<Scalars['String']['input']>;
  /** Company registration card */
  registryCard?: InputMaybe<Scalars['String']['input']>;
  /** Company registry code */
  registryCode?: InputMaybe<Scalars['String']['input']>;
  /** Comment on the registered company */
  registryComment?: InputMaybe<Scalars['String']['input']>;
  /** Company registry date */
  registryDate?: InputMaybe<Scalars['DateTimeType']['input']>;
  resultSumSub?: InputMaybe<CompanyComplianceStatusEnum>;
  /** Netherlands RSIN number */
  rsin?: InputMaybe<Scalars['String']['input']>;
  /** Saltedge customer ID */
  saltedgeCustomerId?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  /** Share capital in euros */
  shareCapital?: InputMaybe<Scalars['Float']['input']>;
  /** Company shareholders list */
  shareholdersList?: InputMaybe<Scalars['String']['input']>;
  sumSubStarted?: InputMaybe<Scalars['Boolean']['input']>;
  totalFilesQty?: InputMaybe<Scalars['Float']['input']>;
  unreadFilesQty?: InputMaybe<Scalars['Float']['input']>;
  /** Unread messages count */
  unreadMessagesCount?: InputMaybe<Scalars['Int']['input']>;
  /** Last edit date */
  updatedAt: Scalars['DateTimeType']['input'];
  user: User;
  userCompanies: Array<UserCompany>;
  userFirmCompanies?: InputMaybe<Array<UserFirmCompany>>;
  /** User ID */
  userId?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  vatStatus?: InputMaybe<CompanyVatStatus>;
  /** Website */
  website?: InputMaybe<Scalars['String']['input']>;
  /** Confirmed Digital Id */
  withDigitalId: Scalars['Boolean']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyActiviteCodeGenerateType = {
  __typename?: 'CompanyActiviteCodeGenerateType';
  activityCode: Scalars['String']['output'];
  fieldOfActivity: Scalars['String']['output'];
};

export type CompanyAddressEntity = {
  __typename?: 'CompanyAddressEntity';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  county: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  house: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zip: Scalars['String']['output'];
};

export type CompanyAddressInputType = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  county: Scalars['String']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  house: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type CompanyAdminUpdateInputType = {
  /** userID in chargebee */
  chargebeeCustomerId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Result of the court review for company opening */
  courtRulingStatus: CourtRulingStatusEnum;
  /** ID */
  id: Scalars['String']['input'];
  /** Company registry code */
  registryCode?: InputMaybe<Scalars['String']['input']>;
  /** Company registry date */
  registryDate?: InputMaybe<Scalars['DateTime']['input']>;
  resultSumSub?: InputMaybe<CompanyComplianceStatusEnum>;
  sumSubStarted?: InputMaybe<Scalars['Boolean']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Company card is ready */
export type CompanyCardDocumentReadyEventType = {
  __typename?: 'CompanyCardDocumentReadyEventType';
  /** Company to generate card for */
  company: CompanyOpeningType;
  fileId: Scalars['String']['output'];
  googleDocId: Scalars['String']['output'];
};

export type CompanyCategoryGenerationResult = {
  __typename?: 'CompanyCategoryGenerationResult';
  companyId: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Company compliance status */
export enum CompanyComplianceStatusEnum {
  Green = 'GREEN',
  NotStarted = 'NotStarted',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type CompanyDebtType = {
  __typename?: 'CompanyDebtType';
  amount: Scalars['Float']['output'];
  firstInvoiceDate: Scalars['DateTime']['output'];
};

export enum CompanyDocTypeEnum {
  ArticlesOfAssociation = 'ArticlesOfAssociation',
  RegistryCard = 'RegistryCard',
  Unknown = 'Unknown'
}

/** The company must be registered with the tax authority as an employer */
export type CompanyEmployerInput = {
  /** CompanyID */
  companyId: Scalars['UuidType']['input'];
  insuranceContribution: Scalars['String']['input'];
  payrollTaxNumber: Scalars['String']['input'];
  sector: Scalars['String']['input'];
};

export type CompanyFolder = {
  __typename?: 'CompanyFolder';
  aTransferDate?: Maybe<Scalars['DateTime']['output']>;
  accountingOnboardingStatus?: Maybe<Scalars['String']['output']>;
  airtableBanks?: Maybe<Scalars['String']['output']>;
  /** Client description Q&A imported historically from Airtable */
  airtableClientDescription?: Maybe<Scalars['String']['output']>;
  airtableEcomPlatforms?: Maybe<Scalars['String']['output']>;
  /** Accountants the company is assigned to. Only for the accountant cabinet (Manager/Accountant) and only in getCompanies; null otherwise */
  assignedAccountants?: Maybe<Array<AssignedAccountant>>;
  /** Accounting firms the company is bound to. Only for the accountant cabinet (Manager/Accountant) and only in getCompanies; null otherwise */
  assignedFirms?: Maybe<Array<AssignedAccountingFirm>>;
  company?: Maybe<CompanyOpeningType>;
  /** Ответы на вопросы внутри sumsub */
  companyActivityQuestions?: Maybe<Scalars['JSON']['output']>;
  /** Company ID */
  companyId: Scalars['UuidType']['output'];
  /** File information creation time */
  createdAt?: Maybe<Scalars['DateTimeType']['output']>;
  /** Name to display: "New (ex Old)" in the accountant cabinet, plain new name for the client */
  displayName: Scalars['String']['output'];
  /** Identifier */
  id: Scalars['UuidType']['output'];
  /** Flag indicating whether the company is an autopilot client */
  isAutopilotClient?: Maybe<Scalars['Boolean']['output']>;
  /** Folder name */
  name: Scalars['String']['output'];
  /** Folder name before the last company rename. Only for the accountant cabinet (Manager/Accountant); null for the client */
  previousName?: Maybe<Scalars['String']['output']>;
  taxOfficeAccessStatus: Scalars['Float']['output'];
  unreadFilesQty?: Maybe<Scalars['Float']['output']>;
  /** Unread messages count */
  unreadMessagesCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Company folders list with pagination */
export type CompanyFoldersListDto = {
  __typename?: 'CompanyFoldersListDto';
  /** Company folders list */
  companyFolders: Array<CompanyFolder>;
  /** Quantity of items to take */
  limit: Scalars['Int']['output'];
  /** Quantity of items to skip */
  offset: Scalars['Int']['output'];
  /** Total quantity */
  total: Scalars['Int']['output'];
};

/** Same names company registered */
export type CompanyForTransfer = {
  __typename?: 'CompanyForTransfer';
  /** Address */
  address?: Maybe<Scalars['String']['output']>;
  /** Registry code */
  code: Scalars['String']['output'];
  /** ID from HitHorizon */
  hitHorizonId?: Maybe<Scalars['String']['output']>;
  /** Company name */
  name: Scalars['String']['output'];
};

/** Information about the company */
export type CompanyInfoByRegisterCodeCompanyType = {
  __typename?: 'CompanyInfoByRegisterCodeCompanyType';
  /** Company address */
  address?: Maybe<Scalars['String']['output']>;
  /** Company registration number */
  code: Scalars['String']['output'];
  /** Company name */
  name: Scalars['String']['output'];
};

/** Information about existing companies by registration number */
export type CompanyInfoByRegisterCodeType = {
  __typename?: 'CompanyInfoByRegisterCodeType';
  /** Are there companies with the specified registration number */
  available: Scalars['Boolean']['output'];
  companies: Array<CompanyInfoByRegisterCodeCompanyType>;
  /** How many companies with the specified registration number were previously registered */
  count: Scalars['Int']['output'];
};

export type CompanyLogoGenerateInputType = {
  backgroundColour: Scalars['String']['input'];
  characteristics: Scalars['String']['input'];
  style: Scalars['String']['input'];
  symbol: Scalars['String']['input'];
};

export type CompanyManualTransferDto = {
  name: Scalars['String']['input'];
  registryAddress: Scalars['String']['input'];
  registryCode: Scalars['String']['input'];
  vatNumber: Scalars['String']['input'];
};

export type CompanyMemberListInputType = {
  /** FAKE */
  fake?: InputMaybe<Scalars['String']['input']>;
};

export enum CompanyMemberSumSubStepEnum {
  NeedRetry = 'needRetry',
  NotStarted = 'notStarted',
  Rejected = 'rejected',
  Review = 'review',
  Verified = 'verified'
}

export type CompanyMutation = {
  __typename?: 'CompanyMutation';
  adminChangeMarket: Scalars['Boolean']['output'];
  adminDeleteCompany: Scalars['Boolean']['output'];
  changeCompanyRegisterInfo: CompanyOpeningType;
  changeCompanyStatus: CompanyOpeningType;
  changeFreshworksId: Scalars['Boolean']['output'];
  companyAddressSave: Scalars['Boolean']['output'];
  companyAdminUpdate: Scalars['Boolean']['output'];
  companyDocumentDelete: CompanyOpeningDocumentType;
  companyDocumentSave: CompanyOpeningDocumentType;
  companyMemberSave: CompanyOpeningMemberType;
  companyOpenLead?: Maybe<Scalars['Boolean']['output']>;
  /** Trigger the creation of accounts (companies) in CRM */
  createCRMCompanies: Scalars['String']['output'];
  /** @deprecated unused, will be deleted (Stripe checkout is not used anymore) */
  createCheckoutSession: Scalars['String']['output'];
  createCompanyCard: Scalars['String']['output'];
  createFakePayment: Scalars['Boolean']['output'];
  createNewCompany: CompanyOpeningType;
  deleteCreateCompanyRequest: Scalars['Boolean']['output'];
  deleteUserCompanies: Scalars['Boolean']['output'];
  digitalIdAttachPayment: Scalars['Boolean']['output'];
  digitalIdAuthCheck: Scalars['Boolean']['output'];
  digitalIdGeneratePayRef: Scalars['Boolean']['output'];
  digitalIdManagerSigned: Scalars['Boolean']['output'];
  digitalIdOpenCompany: DigitalIdCreateResType;
  digitalIdOpenCompanyConfirm: Scalars['Boolean']['output'];
  digitalIdSetPayDate: Scalars['Boolean']['output'];
  estoniaCompanyInformation: CompanyInfoByRegisterCodeType;
  estoniaCompanyInit: EstoniaCompanyOpeningType;
  estoniaCompanyNameValidate: CompanyOpeningNameValidateType;
  estoniaCompanyNameValidate2: CompanyOpeningNameValidateType;
  estoniaCompanySave: EstoniaCompanyOpeningType;
  estoniaCompanyTransfer: EstoniaCompanyOpeningType;
  /** Generate and save ActivityCode and FieldOfActivity */
  generateActivityCodeAndFieldOfActivity?: Maybe<CompanyActiviteCodeGenerateType>;
  invoiceRequest: Scalars['Boolean']['output'];
  leadCreate: IncorporationLeadCreatePayload;
  /** Manual transfer company */
  manualTransferCompany: EstoniaCompanyOpeningType;
  meetCreate: IncorporationMeetType;
  /** Trigger the creation of users and accounts (companies) in the correct CRM */
  moveCRMDataFromSandbox: Scalars['String']['output'];
  questionCreate: Scalars['UuidType']['output'];
  resetCompanyRikRefCode: DigitalIdPayment;
  resetIncorporationApplication: Scalars['Boolean']['output'];
  saveCompanyEmployerInfo: CompanyOpeningType;
  /** Sale logo to company */
  saveCompanyLogo?: Maybe<Scalars['String']['output']>;
  /** Download the file from RIK for all users from Estonia with WithCompany and save it with us; execute once and delete */
  saveRikDocForAllCompanies: Scalars['String']['output'];
  sendCompanyCardViaEmail: Scalars['String']['output'];
  sendRequestForCreateCompanyDocument: Scalars['String']['output'];
  /** Set isAutopilotClient flag for the company. Only for users with manager role. */
  setAutopilotClient: CompanyOpeningType;
  /** Saving the selected market for an additional company */
  setMarketByCompanyId: Scalars['Boolean']['output'];
  /** Setting Obb-Nummer for NL company */
  setObNummer: CompanyOpeningType;
  /** Setting vatNumber */
  setVatNumber: CompanyOpeningType;
  /** Trigger the update and saving of freshworkId and the update of old contacts in CRM */
  updateCRMUsers: Scalars['String']['output'];
  /** Update Company */
  updateCompanyInfo: CompanyOpeningType;
  /** Remove company from settings */
  userDeleteCompany: Scalars['Boolean']['output'];
};


export type CompanyMutationAdminChangeMarketArgs = {
  companyId: Scalars['String']['input'];
  marketId: Scalars['Float']['input'];
};


export type CompanyMutationAdminDeleteCompanyArgs = {
  companyId: Scalars['String']['input'];
};


export type CompanyMutationChangeCompanyRegisterInfoArgs = {
  activityCode?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['UuidType']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  fieldOfActivity?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  registryAddress?: InputMaybe<Scalars['String']['input']>;
  registryCode?: InputMaybe<Scalars['String']['input']>;
  registryComment?: InputMaybe<Scalars['String']['input']>;
  registryDate?: InputMaybe<Scalars['DateTimeType']['input']>;
  shareCapital?: InputMaybe<Scalars['Float']['input']>;
};


export type CompanyMutationChangeCompanyStatusArgs = {
  company: Scalars['UuidType']['input'];
  status: CompanyOpeningProcessStepEnum;
};


export type CompanyMutationChangeFreshworksIdArgs = {
  companyId: Scalars['String']['input'];
  freshworksId: Scalars['String']['input'];
};


export type CompanyMutationCompanyAddressSaveArgs = {
  companyId: Scalars['String']['input'];
  data: CompanyAddressInputType;
};


export type CompanyMutationCompanyAdminUpdateArgs = {
  company: CompanyAdminUpdateInputType;
};


export type CompanyMutationCompanyDocumentDeleteArgs = {
  documentId: Scalars['UuidType']['input'];
};


export type CompanyMutationCompanyDocumentSaveArgs = {
  document: CompanyOpeningDocumentInputType;
};


export type CompanyMutationCompanyMemberSaveArgs = {
  company: Scalars['UuidType']['input'];
  member: CompanyOpeningMemberSaveInputType;
  regenerateDocs: Scalars['Boolean']['input'];
};


export type CompanyMutationCompanyOpenLeadArgs = {
  isTransfer: Scalars['Boolean']['input'];
};


export type CompanyMutationCreateCheckoutSessionArgs = {
  companyId: Scalars['UuidType']['input'];
};


export type CompanyMutationCreateCompanyCardArgs = {
  companyId: Scalars['UuidType']['input'];
};


export type CompanyMutationCreateFakePaymentArgs = {
  companyId: Scalars['String']['input'];
};


export type CompanyMutationDeleteCreateCompanyRequestArgs = {
  companyId: Scalars['String']['input'];
  rikId: Scalars['String']['input'];
};


export type CompanyMutationDeleteUserCompaniesArgs = {
  userId: Scalars['UuidType']['input'];
};


export type CompanyMutationDigitalIdAttachPaymentArgs = {
  userId: Scalars['String']['input'];
};


export type CompanyMutationDigitalIdAuthCheckArgs = {
  birthday: Scalars['String']['input'];
  code: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type CompanyMutationDigitalIdManagerSignedArgs = {
  companyId: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
};


export type CompanyMutationDigitalIdOpenCompanyArgs = {
  companyId: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type CompanyMutationDigitalIdOpenCompanyConfirmArgs = {
  companyId: Scalars['String']['input'];
};


export type CompanyMutationDigitalIdSetPayDateArgs = {
  payDate: Scalars['DateTimeType']['input'];
  refId: Scalars['String']['input'];
};


export type CompanyMutationEstoniaCompanyInformationArgs = {
  registryCode: Scalars['String']['input'];
};


export type CompanyMutationEstoniaCompanyNameValidateArgs = {
  name: Scalars['String']['input'];
};


export type CompanyMutationEstoniaCompanyNameValidate2Args = {
  name: Scalars['String']['input'];
};


export type CompanyMutationEstoniaCompanySaveArgs = {
  estonia: EstoniaCompanyOpeningInputType;
};


export type CompanyMutationEstoniaCompanyTransferArgs = {
  registryCode: Scalars['String']['input'];
};


export type CompanyMutationGenerateActivityCodeAndFieldOfActivityArgs = {
  desc: Scalars['String']['input'];
};


export type CompanyMutationInvoiceRequestArgs = {
  companyId: Scalars['UuidType']['input'];
  userId: Scalars['UuidType']['input'];
};


export type CompanyMutationLeadCreateArgs = {
  input: IncorporationLeadCreateInputType;
};


export type CompanyMutationManualTransferCompanyArgs = {
  companyData: CompanyManualTransferDto;
};


export type CompanyMutationMeetCreateArgs = {
  meet: IncorporationMeetCreateInputType;
};


export type CompanyMutationMoveCrmDataFromSandboxArgs = {
  limit: Scalars['Float']['input'];
};


export type CompanyMutationQuestionCreateArgs = {
  question: IncorporationQuestionInputType;
};


export type CompanyMutationResetCompanyRikRefCodeArgs = {
  companyId: Scalars['String']['input'];
};


export type CompanyMutationResetIncorporationApplicationArgs = {
  companyId: Scalars['UuidType']['input'];
};


export type CompanyMutationSaveCompanyEmployerInfoArgs = {
  emplInfo: CompanyEmployerInput;
};


export type CompanyMutationSaveCompanyLogoArgs = {
  fileIdOrLink: Scalars['String']['input'];
};


export type CompanyMutationSendCompanyCardViaEmailArgs = {
  companyId: Scalars['UuidType']['input'];
  email: Scalars['String']['input'];
};


export type CompanyMutationSendRequestForCreateCompanyDocumentArgs = {
  companyId: Scalars['UuidType']['input'];
  documentType: Scalars['Float']['input'];
};


export type CompanyMutationSetAutopilotClientArgs = {
  companyId: Scalars['UuidType']['input'];
  value: Scalars['Boolean']['input'];
};


export type CompanyMutationSetMarketByCompanyIdArgs = {
  companyId: Scalars['String']['input'];
  marketId: Scalars['Float']['input'];
};


export type CompanyMutationSetObNummerArgs = {
  companyId: Scalars['UuidType']['input'];
  obNummer: Scalars['String']['input'];
};


export type CompanyMutationSetVatNumberArgs = {
  companyId: Scalars['UuidType']['input'];
  vatNumber: Scalars['String']['input'];
};


export type CompanyMutationUpdateCompanyInfoArgs = {
  updateData: UpdateCompanyInputType;
};

export type CompanyNameRateType = {
  __typename?: 'CompanyNameRateType';
  criteriaDescription: Scalars['String']['output'];
  criteriaName: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
};

export type CompanyNameSiggestionsInputType = {
  /** company description [innovative, fun, bring the tailor-made solution] */
  companyBeLike?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Activity code */
  companyScope?: InputMaybe<Scalars['String']['input']>;
};

/** Suggestions for company names */
export type CompanyNameSiggestionsListType = {
  __typename?: 'CompanyNameSiggestionsListType';
  /** Name */
  companyName: Scalars['String']['output'];
};

export type CompanyNotificationsSettingsType = {
  __typename?: 'CompanyNotificationsSettingsType';
  whatsapp: WhatsappNotificationSettingsType;
};

/** Model for creating/saving a company document */
export type CompanyOpeningDocumentInputType = {
  /** Field of activity */
  companyId: Scalars['String']['input'];
  /** Document type (1 - Articles of association, 2 - Registry card) */
  docType: CompanyDocTypeEnum;
  /** Document identifier */
  fileId: Scalars['UuidType']['input'];
  /** Identifier */
  id?: InputMaybe<Scalars['UuidType']['input']>;
  /** Document name */
  name: Scalars['String']['input'];
};

/** Registered company documents */
export type CompanyOpeningDocumentListType = {
  __typename?: 'CompanyOpeningDocumentListType';
  /** List */
  list?: Maybe<Array<CompanyOpeningDocumentType>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

/** Document of a registered company */
export type CompanyOpeningDocumentType = {
  __typename?: 'CompanyOpeningDocumentType';
  /** CompanyID */
  companyId: Scalars['UuidType']['output'];
  /** Creation date */
  createdAt: Scalars['DateTimeType']['output'];
  /** Document type (1 - Articles of association, 2 - Registry card) */
  docType: CompanyDocTypeEnum;
  /** DocumentID */
  fileId: Scalars['UuidType']['output'];
  /** ID */
  id: Scalars['UuidType']['output'];
  /** Document name */
  name: Scalars['String']['output'];
  /** Update date */
  updatedAt: Scalars['DateTimeType']['output'];
};

/** Document generated for Estonian company */
export type CompanyOpeningEstoniaDocumentReadyEventType = {
  __typename?: 'CompanyOpeningEstoniaDocumentReadyEventType';
  /** Company */
  estonia: EstoniaCompanyOpeningType;
};

/** Company */
export type CompanyOpeningInputType = {
  /** Activity code */
  activityCode?: InputMaybe<Scalars['String']['input']>;
  /** Actual address of the company */
  address?: InputMaybe<CompanyAddressInputType>;
  /** Company description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Information about the field of activity */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Field of activity */
  fieldOfActivity?: InputMaybe<Scalars['String']['input']>;
  /** Identifier */
  id: Scalars['UuidType']['input'];
  /** Digitization */
  isDigitalStuff?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has the questionnaire been sent for review */
  isSent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Company employees */
  members?: InputMaybe<Array<CompanyOpeningMemberInputType>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  politicallyExposedPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /** Share capital in euros */
  shareCapital?: InputMaybe<Scalars['Float']['input']>;
  sumSubStarted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyOpeningMemberDocsType = {
  __typename?: 'CompanyOpeningMemberDocsType';
  /** Added document for the member */
  documentPicture?: Maybe<Scalars['String']['output']>;
  /** Power of attorney document identifier */
  powerOfAttorney?: Maybe<Scalars['String']['output']>;
  /** Identifier of the Power of Attorney document in Google Docs */
  powerOfAttorneyGoogle?: Maybe<Scalars['String']['output']>;
  /** Statement document identifier */
  statement?: Maybe<Scalars['String']['output']>;
  /** Identifier of the Power of attorney in Google Docs */
  statementGoogle?: Maybe<Scalars['String']['output']>;
};

/** Company member document generated */
export type CompanyOpeningMemberDocumentReadyEventType = {
  __typename?: 'CompanyOpeningMemberDocumentReadyEventType';
  /** Company */
  company: CompanyOpeningType;
  /** Company member */
  member: CompanyOpeningMemberType;
};

/** Company member */
export type CompanyOpeningMemberInputType = {
  /** Address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Birthday */
  birthday?: InputMaybe<Scalars['DateTimeType']['input']>;
  /** City */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** E-resident number */
  digitalIdNumber?: InputMaybe<Scalars['String']['input']>;
  /** Type of e-resident document */
  digitalIdType?: InputMaybe<Scalars['String']['input']>;
  /** Date of issuance of the identity document */
  documentIssuanceDate?: InputMaybe<Scalars['DateTimeType']['input']>;
  /** Identity document number */
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /** File uploaded by the user */
  documentPicture?: InputMaybe<Scalars['String']['input']>;
  /** Type of identity document */
  documentType?: InputMaybe<Scalars['String']['input']>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['UuidType']['input']>;
  /** Is a director of the company */
  isDirector?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is a shareholder of the company */
  isShareholder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalType?: InputMaybe<Scalars['String']['input']>;
  /** Middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Percentage of shares owned by the employee */
  sharesAmount?: InputMaybe<Scalars['Float']['input']>;
  sumSubResult?: InputMaybe<Scalars['String']['input']>;
  sumSubStep?: InputMaybe<Scalars['String']['input']>;
};

/** Company employees */
export type CompanyOpeningMemberListType = {
  __typename?: 'CompanyOpeningMemberListType';
  /** FAKE */
  fake?: Maybe<Scalars['String']['output']>;
  /** List */
  list?: Maybe<Array<CompanyOpeningMemberType>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

/** Creation, updating, and deletion of a company employee */
export type CompanyOpeningMemberSaveInputType = {
  /** ID */
  add?: InputMaybe<CompanyOpeningMemberInputType>;
  /** ID of member for delete */
  delete?: InputMaybe<Scalars['UuidType']['input']>;
  /** Member for update */
  update?: InputMaybe<CompanyOpeningMemberInputType>;
};

export type CompanyOpeningMemberType = {
  __typename?: 'CompanyOpeningMemberType';
  /** Address */
  address?: Maybe<Scalars['String']['output']>;
  applicantId?: Maybe<Scalars['String']['output']>;
  /** Date of birth */
  birthday?: Maybe<Scalars['DateTimeType']['output']>;
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Company identifier */
  companyId: Scalars['String']['output'];
  /** Country */
  country?: Maybe<Scalars['String']['output']>;
  /** E-resident number */
  digitalIdNumber?: Maybe<Scalars['String']['output']>;
  /** E-resident document type */
  digitalIdType?: Maybe<Scalars['String']['output']>;
  /** Company member documents */
  docs?: Maybe<CompanyOpeningMemberDocsType>;
  /** E-resident document type */
  documentIssuanceDate?: Maybe<Scalars['DateTimeType']['output']>;
  /** Identity document number */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** Type of identity document */
  documentType?: Maybe<Scalars['String']['output']>;
  /** Email address */
  email: Scalars['String']['output'];
  /** First name */
  firstName: Scalars['String']['output'];
  /** Identifier */
  id: Scalars['String']['output'];
  /** Is a company director */
  isDirector: Scalars['Boolean']['output'];
  /** Is a company shareholder */
  isShareholder: Scalars['Boolean']['output'];
  /** Last name */
  lastName: Scalars['String']['output'];
  legalType: Scalars['String']['output'];
  levelName?: Maybe<Scalars['String']['output']>;
  /** Middle name */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Personal code */
  personalCode: Scalars['String']['output'];
  /** Phone number */
  phone?: Maybe<Scalars['String']['output']>;
  /** Postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Company registration method */
  registrationMethod?: Maybe<Scalars['String']['output']>;
  riskLabels?: Maybe<Scalars['String']['output']>;
  /** Percentage of shares owned by the member */
  sharesAmount: Scalars['Float']['output'];
  sumSubResult?: Maybe<Scalars['String']['output']>;
  /** Has the compliance been sent to SumSub? */
  sumSubStarted?: Maybe<Scalars['Boolean']['output']>;
  sumSubStep?: Maybe<CompanyMemberSumSubStepEnum>;
};

/** Company status */
export enum CompanyOpeningNameValidateCompanyStatusEnum {
  /** The company existed previously but is now deleted */
  K = 'K',
  L = 'L',
  /** The company exists */
  R = 'R'
}

/** Companies with similar names have been registered before */
export type CompanyOpeningNameValidateCompanyType = {
  __typename?: 'CompanyOpeningNameValidateCompanyType';
  /** Company name */
  name: Scalars['String']['output'];
  /** How many companies with similar names have been registered before */
  status: CompanyOpeningNameValidateCompanyStatusEnum;
};

/** Information about the validity of the company name */
export type CompanyOpeningNameValidateType = {
  __typename?: 'CompanyOpeningNameValidateType';
  /** ID */
  available: Scalars['Boolean']['output'];
  companies?: Maybe<Array<CompanyOpeningNameValidateCompanyType>>;
  /** How many companies with similar names have been registered before */
  count: Scalars['Int']['output'];
  /** Error */
  errorText?: Maybe<Scalars['String']['output']>;
  /** Error type */
  errorType?: Maybe<Scalars['String']['output']>;
};

/** Company status change history */
export type CompanyOpeningProcessHistoryListType = {
  __typename?: 'CompanyOpeningProcessHistoryListType';
  /** List */
  list?: Maybe<Array<CompanyOpeningProcessHistoryType>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export type CompanyOpeningProcessHistoryType = {
  __typename?: 'CompanyOpeningProcessHistoryType';
  /** Company identifier */
  companyId: Scalars['UuidType']['output'];
  /** Creation date */
  createdAt: Scalars['DateTimeType']['output'];
  /** Identifier */
  id: Scalars['UuidType']['output'];
  /** Company processing stage */
  processStep: CompanyOpeningProcessStepEnum;
  /** Identifier of the user who changed the status */
  userId: Scalars['String']['output'];
};

/** Steps of company opening process */
export enum CompanyOpeningProcessStepEnum {
  EmptyCompany = 'EmptyCompany',
  Incorporating = 'Incorporating',
  IncorporationPaid = 'IncorporationPaid',
  ProcessStarted = 'ProcessStarted',
  WithCompany = 'WithCompany'
}

/** Company */
export type CompanyOpeningType = {
  __typename?: 'CompanyOpeningType';
  /** Accounting folder ID */
  accountingFolderId?: Maybe<Scalars['UuidType']['output']>;
  /** Activity code */
  activityCode: Scalars['String']['output'];
  /** Decryption of the company activity code field */
  activityCodeDecryption: Scalars['String']['output'];
  /** Address */
  address?: Maybe<CompanyAddressEntity>;
  /** Company articles of association */
  articlesOfAssociation?: Maybe<Scalars['String']['output']>;
  /** Customer ID in the chargebee system */
  chargebeeCustomerId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  companyLogoFileId?: Maybe<Scalars['String']['output']>;
  /** Contact email address */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Court ruling result for company opening */
  courtRulingStatus: CourtRulingStatusEnum;
  /** Creation date */
  createdAt: Scalars['DateTimeType']['output'];
  /** CRM account ID */
  crmCompanyId?: Maybe<Scalars['String']['output']>;
  /** Deleted date */
  deletedAt?: Maybe<Scalars['DateTimeType']['output']>;
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Details about the field of activity */
  details: Scalars['String']['output'];
  /** Name to display: "New (ex Old)" in the accountant cabinet, plain current name for the client */
  displayName: Scalars['String']['output'];
  /** Email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Field of activity */
  fieldOfActivity: Scalars['String']['output'];
  /** Decryption of the company field of activity */
  fieldOfActivityDecryption: Scalars['String']['output'];
  firmCompanies?: Maybe<Array<FirmCompany>>;
  /** HitHorizonsId */
  hitHorizonsId?: Maybe<Scalars['String']['output']>;
  hrPaymentsPeriods?: Maybe<Array<HrPaymentPeriodType>>;
  /** ID */
  id: Scalars['String']['output'];
  /** Company incorporation date */
  incorporationDate?: Maybe<Scalars['DateTimeType']['output']>;
  insuranceContribution?: Maybe<Scalars['String']['output']>;
  /** Flag indicating whether the company is an autopilot client */
  isAutopilotClient: Scalars['Boolean']['output'];
  /** Flag indicating the completion of the company onboarding (initial setup) */
  isCompletedOnboarding: Scalars['Boolean']['output'];
  /** Digitization */
  isDigitalStuff: Scalars['Boolean']['output'];
  /** Was this company created through a transfer? */
  isTransferred?: Maybe<Scalars['Boolean']['output']>;
  /** Identifier of the country the user is working with (market) */
  marketId?: Maybe<Scalars['Int']['output']>;
  /** Company members */
  members: CompanyOpeningMemberListType;
  /** Name */
  name: Scalars['String']['output'];
  /** Some Dutch field */
  obNummer?: Maybe<Scalars['String']['output']>;
  /** Contact person deadline */
  officeDeadlineDate?: Maybe<Scalars['String']['output']>;
  /** Information about incorporation payment */
  payment?: Maybe<PaymentType>;
  paymentsConnectionStatus?: Maybe<Scalars['String']['output']>;
  payrollTaxNumber?: Maybe<Scalars['String']['output']>;
  /** Phone number */
  phone?: Maybe<Scalars['String']['output']>;
  politicallyExposedPerson?: Maybe<Scalars['Boolean']['output']>;
  /** Company name before the last rename. Only for the accountant cabinet (Manager/Accountant); null for the client */
  previousName?: Maybe<Scalars['String']['output']>;
  /** Current company processing stage */
  processStep: CompanyOpeningProcessStepEnum;
  /** Payment number for RIK */
  referenceNumber: Scalars['String']['output'];
  /** Company registry address */
  registryAddress?: Maybe<Scalars['String']['output']>;
  /** Company registration card */
  registryCard?: Maybe<Scalars['String']['output']>;
  /** Company registry code */
  registryCode?: Maybe<Scalars['String']['output']>;
  /** Comment on the registered company */
  registryComment?: Maybe<Scalars['String']['output']>;
  /** Company registry date */
  registryDate?: Maybe<Scalars['DateTimeType']['output']>;
  resultSumSub?: Maybe<CompanyComplianceStatusEnum>;
  /** Final application number in RIK */
  rikResultId: Scalars['String']['output'];
  /** Netherlands RSIN number */
  rsin?: Maybe<Scalars['String']['output']>;
  /** Saltedge customer ID */
  saltedgeCustomerId?: Maybe<Scalars['String']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  /** Share capital in euros */
  shareCapital?: Maybe<Scalars['Float']['output']>;
  /** Company shareholders list */
  shareholdersList?: Maybe<Scalars['String']['output']>;
  sumSubStarted?: Maybe<Scalars['Boolean']['output']>;
  totalFilesQty?: Maybe<Scalars['Float']['output']>;
  unreadFilesQty?: Maybe<Scalars['Float']['output']>;
  /** Unread messages count */
  unreadMessagesCount?: Maybe<Scalars['Int']['output']>;
  /** Last edit date */
  updatedAt: Scalars['DateTimeType']['output'];
  user: UserType;
  userCompanies: Array<UserCompanyType>;
  userFirmCompanies?: Maybe<Array<UserFirmCompanyType>>;
  /** User ID */
  userId?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatStatus?: Maybe<CompanyVatStatus>;
  /** Website */
  website?: Maybe<Scalars['String']['output']>;
  /** Confirmed Digital Id */
  withDigitalId: Scalars['Boolean']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};


/** Company */
export type CompanyOpeningTypeMembersArgs = {
  pagination?: InputMaybe<PaginationInputType>;
  sort?: InputMaybe<SortInputType>;
};

/** Company accounting period */
export type CompanyPeriodType = {
  __typename?: 'CompanyPeriodType';
  /** Accounting period type (monthly/quarterly/yearly) */
  accountingType: AccountingReportPeriodEnum;
  /** Report month (monthly accounting) */
  month?: Maybe<Scalars['Int']['output']>;
  /** a_periods_folder.id — target for "Go to period" / change period */
  periodFolderId: Scalars['String']['output'];
  /** Report quarter (quarterly accounting) */
  quarter?: Maybe<Scalars['Int']['output']>;
  /** Report year */
  year: Scalars['Int']['output'];
};

export type CompanyQuery = {
  __typename?: 'CompanyQuery';
  /** Company docs */
  companyDocumentList: CompanyOpeningDocumentListType;
  companyExistsInDb?: Maybe<ExistCompany>;
  companyMembersList: Array<CompanyOpeningMemberType>;
  /** Company payments */
  companyPaymentList: PaymentListType;
  /** Company docs */
  companyProcessHistoryList: CompanyOpeningProcessHistoryListType;
  digitalIdManagerSignList: Array<DigitalIdManagerAction>;
  digitalIdPaymentsList: DigitalIdPaymentList;
  eidEasyData: EidEasyData;
  estoniaCompany?: Maybe<EstoniaCompanyOpeningType>;
  estoniaCompanyList: EstoniaCompanyOpeningListType;
  /** Generate 5 logos */
  generateCompanyLogos: Array<Scalars['String']['output']>;
  /** Company debt */
  getCompanyDebt?: Maybe<CompanyDebtType>;
  /** Get logo fileId */
  getCompanyLogo?: Maybe<Scalars['String']['output']>;
  /** Suggest company name */
  getCompanyNameSuggestions?: Maybe<Array<CompanyNameSiggestionsListType>>;
  /** Generate token for SumSub */
  getSumSubToken: Scalars['String']['output'];
  meet: IncorporationMeetType;
  membersComplianceList: MemberComplianceDto;
  /** Rate company name */
  rateCompanyName?: Maybe<Array<CompanyNameRateType>>;
  searchCompanyInRikByNameOrRegistryCode: CompanyTransferSearchType;
  /** Find company for counterparty */
  searchCustomerCompany?: Maybe<SearchInvoicesCustomerItem>;
};


export type CompanyQueryCompanyDocumentListArgs = {
  filter?: InputMaybe<IncorporationCompanyDocumentListQueryFilterInputType>;
  pagination?: InputMaybe<PaginationInputType>;
  sort?: InputMaybe<SortInputType>;
};


export type CompanyQueryCompanyExistsInDbArgs = {
  registryCode: Scalars['String']['input'];
};


export type CompanyQueryCompanyPaymentListArgs = {
  filter?: InputMaybe<IncorporationCompanyPaymentListQueryFilterInputType>;
  pagination?: InputMaybe<PaginationInputType>;
  sort?: InputMaybe<SortInputType>;
};


export type CompanyQueryCompanyProcessHistoryListArgs = {
  filter?: InputMaybe<IncorporationCompanyProcessHistoryListQueryFilterInputType>;
  pagination?: InputMaybe<PaginationInputType>;
  sort?: InputMaybe<SortInputType>;
};


export type CompanyQueryDigitalIdManagerSignListArgs = {
  isSent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyQueryDigitalIdPaymentsListArgs = {
  pagination?: InputMaybe<PaginationInputType>;
  sort?: InputMaybe<SortInputType>;
};


export type CompanyQueryEstoniaCompanyArgs = {
  filter: IncorporationEstoniaCompanyQueryFilterInputType;
};


export type CompanyQueryEstoniaCompanyListArgs = {
  filter: IncorporationEstoniaCompanyListQueryFilterInputType;
  pagination?: InputMaybe<PaginationInputType>;
  sort?: InputMaybe<SortInputType>;
};


export type CompanyQueryGenerateCompanyLogosArgs = {
  companyLogoGenerateInput: CompanyLogoGenerateInputType;
};


export type CompanyQueryGetCompanyNameSuggestionsArgs = {
  companyNameSiggestions: CompanyNameSiggestionsInputType;
};


export type CompanyQueryMeetArgs = {
  filter: IncorporationMeetQueryFilterInputType;
};


export type CompanyQueryMembersComplianceListArgs = {
  filter?: InputMaybe<MemberComplianceFilterInput>;
  pagination?: InputMaybe<PaginationInputType>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
};


export type CompanyQuerySearchCompanyInRikByNameOrRegistryCodeArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  isInvoicingSearch?: Scalars['Boolean']['input'];
  registryCodeOrName: Scalars['String']['input'];
};


export type CompanyQuerySearchCustomerCompanyArgs = {
  countryCode: Scalars['String']['input'];
  registryCode: Scalars['String']['input'];
};

export type CompanyReadinessMetricDetailType = {
  __typename?: 'CompanyReadinessMetricDetailType';
  /** Description of the metric */
  description?: Maybe<Scalars['String']['output']>;
  /** Metric value in percentage (0-100) */
  percentage: Scalars['Float']['output'];
};

export type CompanyReadinessMetricType = {
  __typename?: 'CompanyReadinessMetricType';
  /** Bank accounts with statements metric (max 30% or 15% for e-commerce) */
  bankAccountsWithStatements: CompanyReadinessMetricDetailType;
  /** Documents to transactions ratio metric (max 50%) */
  documentsToTransactions: CompanyReadinessMetricDetailType;
  /** E-commerce platforms access metric (15% for e-commerce only) */
  ecommercePlatformsAccess: CompanyReadinessMetricDetailType;
  /** Total readiness metric in percentage (0-100) */
  totalPercentage: Scalars['Float']['output'];
  /** Transaction-document reconciliation metric (max 20%) */
  transactionDocumentReconciliation: CompanyReadinessMetricDetailType;
};

/** Transfer search result */
export type CompanyTransferSearchType = {
  __typename?: 'CompanyTransferSearchType';
  /** is available */
  available: Scalars['Boolean']['output'];
  companies?: Maybe<Array<CompanyForTransfer>>;
  /** Same names company registered count */
  count: Scalars['Int']['output'];
};

export type CompanyUnreadCount = {
  __typename?: 'CompanyUnreadCount';
  companyId: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

/** Company Vat Status */
export enum CompanyVatStatus {
  Active = 'Active',
  Expired = 'Expired'
}

export type ConnectedNumberType = {
  __typename?: 'ConnectedNumberType';
  hasConsent: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type ContractsFileType = {
  __typename?: 'ContractsFileType';
  /** Company ID */
  companyId: Scalars['UuidType']['output'];
  contractsFolder?: Maybe<ContractsFolder>;
  /** Company ID */
  contractsFolderId: Scalars['UuidType']['output'];
  /** File information creation time */
  createdAt?: Maybe<Scalars['DateTimeType']['output']>;
  /** Identifier */
  id: Scalars['UuidType']['output'];
  /** Name of the file */
  name: Scalars['String']['output'];
};

export type ContractsFolder = {
  __typename?: 'ContractsFolder';
  companyFolder?: Maybe<CompanyFolder>;
  /** ID companyFolder */
  companyFolderId: Scalars['UuidType']['output'];
  /** Company ID */
  companyId: Scalars['UuidType']['output'];
  /** File information creation time */
  createdAt?: Maybe<Scalars['DateTimeType']['output']>;
  /** Identifier */
  id: Scalars['UuidType']['output'];
  /** Folder name */
  name: Scalars['String']['output'];
};

export type ConversionSubscriptionResultDto = {
  __typename?: 'ConversionSubscriptionResultDto';
  averageTimeToEnd: Scalars['Float']['output'];
  companyId: Scalars['String']['output'];
};

export type CopyLinkDto = {
  __typename?: 'CopyLinkDto';
  companyName?: Maybe<Scalars['String']['output']>;
  docName: Scalars['String']['output'];
  regCode?: Maybe<Scalars['String']['output']>;
};

export type CountDocsAndTransactions = {
  __typename?: 'CountDocsAndTransactions';
  /** Quantity of docs declined by accountant */
  documentsAccountantDeclinedQty: Scalars['Float']['output'];
  /** Quantity of docs for a such period */
  documentsQty: Scalars['Float']['output'];
  /** Quantity of matched transactions for a such period */
  matchedTransactionsQty: Scalars['Float']['output'];
  /** Percent of transactions confirmed doc */
  transactionsConfirmedDocPercent: Scalars['Float']['output'];
  /** Quantity of transactions confirmed doc */
  transactionsConfirmedDocQty: Scalars['Float']['output'];
  /** Quantity of transactions denied doc */
  transactionsDeniedDocQty: Scalars['Float']['output'];
  /** Percent of transactions missing and denied doc */
  transactionsMissingAndDeniedDocPercent: Scalars['Float']['output'];
  /** Count of transactions missing and denied doc */
  transactionsMissingAndDeniedDocQty: Scalars['Float']['output'];
  /** Quantity of transactions missing doc */
  transactionsMissingDocQty: Scalars['Float']['output'];
  /** Count of transactions without doc needed and confirmed */
  transactionsNotNeedDocAndConfirmedQty: Scalars['Float']['output'];
  /** Percent of transactions missing and denied doc */
  transactionsNotNeedDocPercent: Scalars['Float']['output'];
  /** Quantity of transactions without doc needed */
  transactionsNotNeedDocQty: Scalars['Float']['output'];
  /** Quantity of transactions processing doc */
  transactionsProcessingDocQty: Scalars['Float']['output'];
  /** Quantity of transactions for a such period which need doc */
  transactionsQty: Scalars['Float']['output'];
  /** Quantity of transactions in period */
  transactionsTotalInPeriodQty: Scalars['Float']['output'];
};

export type CountInvoicesCurrmonthResponseDto = {
  __typename?: 'CountInvoicesCurrmonthResponseDto';
  /** Count of issued invoices for the current month */
  count?: Maybe<Scalars['Int']['output']>;
};

export type CountIssuedInvoicesTotalResponseDto = {
  __typename?: 'CountIssuedInvoicesTotalResponseDto';
  /** Count of issued invoices since joining Enty */
  count?: Maybe<Scalars['Int']['output']>;
};

export type CounterpartyAddressDto = {
  /** Type of address */
  addrType: CounterpartyAddressType;
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  useAsShippingAddr?: InputMaybe<Scalars['Boolean']['input']>;
  zip: Scalars['String']['input'];
};

export type CounterpartyAddressEntity = {
  __typename?: 'CounterpartyAddressEntity';
  /** Address type */
  addrType: CounterpartyAddressType;
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  client: CounterpartyEntity;
  country: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  useAsShippingAddr?: Maybe<Scalars['Boolean']['output']>;
  zip: Scalars['String']['output'];
};

export type CounterpartyAddressInputType = {
  /** Address type */
  addrType: CounterpartyAddressType;
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  client: CounterpartyInputType;
  country: Scalars['String']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  phone: Scalars['String']['input'];
  useAsShippingAddr?: InputMaybe<Scalars['Boolean']['input']>;
  zip: Scalars['String']['input'];
};

/** Address type */
export enum CounterpartyAddressType {
  Billing = 'Billing',
  Shipping = 'Shipping'
}

/** Value isClient or isProvider */
export enum CounterpartyCategoryInput {
  Client = 'Client',
  Provider = 'Provider'
}

export type CounterpartyEntity = {
  __typename?: 'CounterpartyEntity';
  addresses: Array<CounterpartyAddressEntity>;
  birthday?: Maybe<Scalars['DateType']['output']>;
  clientId: Scalars['String']['output'];
  cm_documents?: Maybe<Array<CmDoc>>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deals?: Maybe<Array<Deal>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documents: Array<InvoicingDocumentEntity>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  idNumber?: Maybe<Scalars['String']['output']>;
  idType?: Maybe<Scalars['String']['output']>;
  invoiceAmount?: Maybe<Scalars['Float']['output']>;
  isClient?: Maybe<Scalars['Boolean']['output']>;
  isProvider?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  legalStatus: LegalStatusEnum;
  meritCustomerId?: Maybe<Scalars['String']['output']>;
  meritItemId?: Maybe<Scalars['String']['output']>;
  meritTaxId?: Maybe<Scalars['String']['output']>;
  meritVendorId?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  /** Full name */
  name?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  representativeName?: Maybe<Scalars['String']['output']>;
  spaceInvoiceClientId?: Maybe<Scalars['String']['output']>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  taxNumberValidDate?: Maybe<Scalars['DateTime']['output']>;
  taxStatus: Scalars['String']['output'];
  totalCounterpartyDocs?: Maybe<Scalars['Int']['output']>;
  totalCounterpartyInvoices?: Maybe<Scalars['Int']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CounterpartyInputType = {
  addresses: Array<CounterpartyAddressInputType>;
  birthday?: InputMaybe<Scalars['DateType']['input']>;
  clientId: Scalars['String']['input'];
  cm_documents?: InputMaybe<Array<CmDocInputType>>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  companyNumber?: InputMaybe<Scalars['String']['input']>;
  deals?: InputMaybe<Array<DealInputType>>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  documents: Array<InvoicingDocumentEntityInputType>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  idNumber?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<Scalars['String']['input']>;
  invoiceAmount?: InputMaybe<Scalars['Float']['input']>;
  isClient?: InputMaybe<Scalars['Boolean']['input']>;
  isProvider?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalStatus: LegalStatusEnum;
  meritCustomerId?: InputMaybe<Scalars['String']['input']>;
  meritItemId?: InputMaybe<Scalars['String']['input']>;
  meritTaxId?: InputMaybe<Scalars['String']['input']>;
  meritVendorId?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  representativeName?: InputMaybe<Scalars['String']['input']>;
  spaceInvoiceClientId?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  taxNumberValidDate?: InputMaybe<Scalars['DateTime']['input']>;
  taxStatus: Scalars['String']['input'];
  totalCounterpartyDocs?: InputMaybe<Scalars['Int']['input']>;
  totalCounterpartyInvoices?: InputMaybe<Scalars['Int']['input']>;
  totalDocs?: InputMaybe<Scalars['Int']['input']>;
};

export type CounterpartyInvoiceConnectionDto = {
  __typename?: 'CounterpartyInvoiceConnectionDto';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
};

export type CountryEntity = {
  __typename?: 'CountryEntity';
  dialCode: Scalars['String']['output'];
  flag: Scalars['String']['output'];
  isoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CountryFilterInputDto = {
  isoCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CountryQuery = {
  __typename?: 'CountryQuery';
  bankingCountries: Array<CountryEntity>;
  countriesList: Array<CountryEntity>;
  country: CountryEntity;
  getCurrenciesList: Array<CurrencyEntity>;
};


export type CountryQueryCountryArgs = {
  filter?: InputMaybe<CountryFilterInputDto>;
};

/** Court ruling results for company opening */
export enum CourtRulingStatusEnum {
  Failed = 'Failed',
  InProgress = 'InProgress',
  NotSent = 'NotSent',
  Success = 'Success'
}

/** Addon for inclusion in the chargebee subscription */
export type CreateCheckoutAddonInputType = {
  /** One-time charge */
  chargeOnce: Scalars['Boolean']['input'];
  /** Subscription addon identifier */
  id: Scalars['String']['input'];
  /** Number of items */
  quantity: Scalars['Int']['input'];
};

export type CreateMessageInputDto = {
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  msgText?: InputMaybe<Scalars['String']['input']>;
  periodIds?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateTaskInputDto = {
  companyId: Scalars['String']['input'];
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  periodIds?: InputMaybe<Array<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
  transactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreditNoteDto = {
  __typename?: 'CreditNoteDto';
  fileId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type CurrencyEntity = {
  __typename?: 'CurrencyEntity';
  decimalDigits: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isoName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  namePlural?: Maybe<Scalars['String']['output']>;
  spaceInvoicesIsoName?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  symbolNative?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/** Current period with aggregated data */
export type CurrentPeriodType = {
  __typename?: 'CurrentPeriodType';
  /** Current deadline date */
  currentDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** Days left until current deadline */
  currentDeadlineDaysLeft?: Maybe<Scalars['Int']['output']>;
  /** Current deadline type */
  currentDeadlineType?: Maybe<DeadlineType>;
  /** Formatted display name (e.g., "June", "Q3", "2025") */
  displayName: Scalars['String']['output'];
  /** Period folder ID */
  id: Scalars['String']['output'];
  /** Issues for the selected period */
  issues: PeriodIssuesType;
  /** Period type (upcoming, collecting_docs, processing_docs, etc.) */
  periodType?: Maybe<AccountingReportPeriodTypeEnum>;
  /** Overall readiness metric value (0-100) without breakdown */
  readinessMetric: Scalars['Float']['output'];
  /** Accountant feedback status for the period */
  status: AccountantFeedbackStatus;
  /** Accounting type (monthly, quarterly, yearly) */
  type: AccountingReportPeriodEnum;
};

/** Email data */
export type CustomEmailInputType = {
  attachmentName?: InputMaybe<Scalars['String']['input']>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  copy?: InputMaybe<Scalars['String']['input']>;
  mainText: Scalars['String']['input'];
  replyTo?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  template?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};

/** Email data with template id in email_template */
export type CustomEmailWithTemplateIdAndDocIdInputType = {
  attachmentName?: InputMaybe<Scalars['String']['input']>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  copy?: InputMaybe<Scalars['String']['input']>;
  /** Entity id from the table it belongs to: esign_docs/invoicing_document etc */
  docId?: InputMaybe<Scalars['String']['input']>;
  /** Template id from email_template */
  emailTemplateId?: InputMaybe<Scalars['String']['input']>;
  mainText: Scalars['String']['input'];
  replyTo?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  template?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};

export type CustomPromptsInput = {
  /** Custom prompt for step 1 of document generation */
  step1?: InputMaybe<Scalars['String']['input']>;
  /** Custom prompt for step 2 of document generation */
  step2?: InputMaybe<Scalars['String']['input']>;
};

/** Customer origin */
export enum CustomerOriginEnum {
  Estonia = 'Estonia',
  NotApplicable = 'NotApplicable',
  NotEu = 'NotEU',
  NotEstoniaEu = 'NotEstoniaEU'
}

export type DateFilterDto = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Current deadline type for a period */
export enum DeadlineType {
  CollectingDocs = 'CollectingDocs',
  ProcessingDocs = 'ProcessingDocs',
  ReportNotSubmitted = 'ReportNotSubmitted',
  ReportSubmitted = 'ReportSubmitted',
  Upcoming = 'Upcoming'
}

export type Deal = {
  __typename?: 'Deal';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  attachments?: Maybe<Array<DealEntity>>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Counterparty id */
  clientId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  counterparty?: Maybe<CounterpartyEntity>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdContracts?: Maybe<Array<CmDoc>>;
  createdInvoices?: Maybe<Array<InvoicingDocumentEntity>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Contracts ids to ignore in suggestions of what can be attached to the deal */
  dontSuggestContracts?: Maybe<Array<Scalars['String']['output']>>;
  /** Invoices ids to ignore in suggestions of what can be attached to the deal */
  dontSuggestInvoices?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Deal status */
  status: DealStatusEnum;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DealAmountsStats = {
  __typename?: 'DealAmountsStats';
  expectedAmount: Scalars['Float']['output'];
  receivedAmount: Scalars['Float']['output'];
};

export type DealAttachmentInput = {
  dealId: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
};

export type DealAttachmentInputType = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  deal?: InputMaybe<DealInputType>;
  dealId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileId: Scalars['String']['input'];
  fileMimeType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['String']['input']>;
};

export type DealCreateDto = {
  /** Counterparty ID */
  clientId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DealEntity = {
  __typename?: 'DealEntity';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deal?: Maybe<Deal>;
  dealId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fileId: Scalars['String']['output'];
  fileMimeType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedByUserId?: Maybe<Scalars['String']['output']>;
};

/** Deal with extended data: income/expense statistics etc */
export type DealExtended = {
  __typename?: 'DealExtended';
  deal: Deal;
  invoicesStats: DealInvoicesStats;
};

export type DealInputType = {
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<Array<DealAttachmentInputType>>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Counterparty id */
  clientId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  counterparty?: InputMaybe<CounterpartyInputType>;
  createdContracts?: InputMaybe<Array<CmDocInputType>>;
  createdInvoices?: InputMaybe<Array<InvoicingDocumentEntityInputType>>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Contracts ids to ignore in suggestions of what can be attached to the deal */
  dontSuggestContracts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Invoices ids to ignore in suggestions of what can be attached to the deal */
  dontSuggestInvoices?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Deal status */
  status: DealStatusEnum;
};

/** Deal financial statistics by attached invoices */
export type DealInvoicesStats = {
  __typename?: 'DealInvoicesStats';
  currencyIsoCode: Scalars['String']['output'];
  invoicesPaidAmount: Scalars['Float']['output'];
  invoicesPaidCount: Scalars['Int']['output'];
  invoicesUnpaidAmount: Scalars['Float']['output'];
  invoicesUnpaidCount: Scalars['Int']['output'];
};

export type DealListingItem = {
  __typename?: 'DealListingItem';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  attachments?: Maybe<Array<DealEntity>>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Counterparty id */
  clientId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  counterparty?: Maybe<CounterpartyEntity>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdContracts?: Maybe<Array<CmDoc>>;
  createdInvoices?: Maybe<Array<InvoicingDocumentEntity>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Contracts ids to ignore in suggestions of what can be attached to the deal */
  dontSuggestContracts?: Maybe<Array<Scalars['String']['output']>>;
  /** Invoices ids to ignore in suggestions of what can be attached to the deal */
  dontSuggestInvoices?: Maybe<Array<Scalars['String']['output']>>;
  expectedAmount: Scalars['Float']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  receivedAmount: Scalars['Float']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Deal status */
  status: DealStatusEnum;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Deal columns available for sorting */
export enum DealSortableFields {
  ArchivedAt = 'archivedAt',
  CancelledAt = 'cancelledAt',
  ClientId = 'clientId',
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  Name = 'name',
  StartedAt = 'startedAt',
  Status = 'status'
}

/** Computed status of the deal */
export enum DealStatusEnum {
  Archived = 'Archived',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Draft = 'Draft',
  InProgress = 'InProgress'
}

/** Lists of suggested documents that can be attached to deal */
export type DealSuggestionsDto = {
  __typename?: 'DealSuggestionsDto';
  /** List of potentially suitable contracts */
  contracts: Array<CmDoc>;
  /** List of potentially suitable invoices */
  invoices: Array<InvoicingDocumentEntity>;
};

export type DealUpdateDto = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** It is better to send a date with current time, not just the date alone */
  startedAt?: InputMaybe<Scalars['String']['input']>;
};

/** Deals list */
export type DealsListType = {
  __typename?: 'DealsListType';
  /** List */
  list?: Maybe<Array<Deal>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
  total: Scalars['Int']['output'];
};

export type DealsListingFilterDto = {
  counterparties?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  startedTo?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<DealStatusEnum>>;
};

export type DealsListingResponse = {
  __typename?: 'DealsListingResponse';
  items: Array<DealListingItem>;
  total: Scalars['Float']['output'];
};

export type DealsListingSortInputTypeDto = {
  /** Sorting field */
  field?: InputMaybe<DealSortableFields>;
  /** Sorting order */
  type?: InputMaybe<SortTypeEnum>;
};

export type DealsMutation = {
  __typename?: 'DealsMutation';
  /** Ignore document in deal recommended documents */
  addDocToIgnoreList: Deal;
  /** Attach/detach contract to deal */
  attachContracts: Scalars['Boolean']['output'];
  /** Attach a file to a deal */
  attachFileToDeal: DealEntity;
  /** Attach/detach invoice to deal */
  attachInvoices: Scalars['Boolean']['output'];
  /** Cancel deal and related docs */
  cancelDeal: Deal;
  /** Complete deal */
  completeDeal: Deal;
  /** Create new deal */
  createDeal: Deal;
  /** Delete deal */
  deleteDeal: Scalars['Boolean']['output'];
  /** Detach docs (contracts, invoices) from deals */
  detachDocs: Scalars['Boolean']['output'];
  /** Remove the attachment from a deal */
  removeDealAttachment: Scalars['Boolean']['output'];
  /** Edit deal */
  updateDeal: Deal;
};


export type DealsMutationAddDocToIgnoreListArgs = {
  dealId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
};


export type DealsMutationAttachContractsArgs = {
  contractIds: Array<Scalars['String']['input']>;
  dealId?: InputMaybe<Scalars['String']['input']>;
};


export type DealsMutationAttachFileToDealArgs = {
  input: DealAttachmentInput;
};


export type DealsMutationAttachInvoicesArgs = {
  dealId?: InputMaybe<Scalars['String']['input']>;
  invoiceIds: Array<Scalars['String']['input']>;
};


export type DealsMutationCancelDealArgs = {
  dealId: Scalars['String']['input'];
};


export type DealsMutationCompleteDealArgs = {
  dealId: Scalars['String']['input'];
};


export type DealsMutationCreateDealArgs = {
  deal: DealCreateDto;
};


export type DealsMutationDeleteDealArgs = {
  dealId: Scalars['String']['input'];
};


export type DealsMutationDetachDocsArgs = {
  dealId?: InputMaybe<Scalars['String']['input']>;
};


export type DealsMutationRemoveDealAttachmentArgs = {
  attachmentId: Scalars['String']['input'];
};


export type DealsMutationUpdateDealArgs = {
  deal: DealUpdateDto;
};

export type DealsQuery = {
  __typename?: 'DealsQuery';
  /** List of all counterparties by company */
  getCounterparties: Array<CounterpartyEntity>;
  /** List of all counterparties having deals */
  getCounterpartiesHavingDeals: Array<CounterpartyEntity>;
  /** One deal by id */
  getDealById: DealExtended;
  /** Statistics with deals income/expense amounts */
  getDealStats: DealAmountsStats;
  /** List all documents that can be attached to deal */
  getSuggestionsDocs: DealSuggestionsDto;
  /**
   * All deals by company
   * @deprecated Use listDealsFiltered
   */
  listDeals: DealsListType;
  /** All deals by company with filters applied */
  listDealsFiltered: DealsListingResponse;
};


export type DealsQueryGetDealByIdArgs = {
  dealId: Scalars['String']['input'];
};


export type DealsQueryGetDealStatsArgs = {
  filter?: InputMaybe<DealsListingFilterDto>;
};


export type DealsQueryGetSuggestionsDocsArgs = {
  dealId: Scalars['String']['input'];
};


export type DealsQueryListDealsArgs = {
  pagination: PaginationInputType;
  sort?: InputMaybe<DealsListingSortInputTypeDto>;
};


export type DealsQueryListDealsFilteredArgs = {
  filter?: InputMaybe<DealsListingFilterDto>;
  pagination: PaginationInputType;
  sort?: InputMaybe<Array<DealsListingSortInputTypeDto>>;
};

export type DigitalIdCreateResType = {
  __typename?: 'DigitalIdCreateResType';
  /** ClientID in EidEasy */
  clientId: Scalars['String']['output'];
  /** DocID for sign */
  docId: Scalars['String']['output'];
  /** Identifier of the application in Rik */
  rikId: Scalars['String']['output'];
  /** Address for eidEasy */
  url: Scalars['String']['output'];
};

export type DigitalIdManagerAction = {
  __typename?: 'DigitalIdManagerAction';
  /** Company */
  company: CompanyOpeningType;
  /** Generated date */
  createdAt: Scalars['DateTimeType']['output'];
  /** ID */
  id: Scalars['String']['output'];
  /** Sent to RIK? */
  isSent: Scalars['Boolean']['output'];
  /** Manager sign date */
  managerSignedAt?: Maybe<Scalars['DateTimeType']['output']>;
  /** Manager signed fileID */
  managerSignedFileId?: Maybe<Scalars['String']['output']>;
  /** Send to RIK date */
  sentAt?: Maybe<Scalars['DateTimeType']['output']>;
  /** User signed fileID */
  userSignedFileId: Scalars['String']['output'];
};

export type DigitalIdPayment = {
  __typename?: 'DigitalIdPayment';
  /** Comment */
  comment?: Maybe<Scalars['String']['output']>;
  /** Link to the user company */
  companyId?: Maybe<Scalars['String']['output']>;
  /** Generated date */
  createdAt: Scalars['DateTimeType']['output'];
  /** ID */
  id: Scalars['String']['output'];
  /** Payment date */
  payDate?: Maybe<Scalars['DateTimeType']['output']>;
  /** Payment code RIK */
  refCode: Scalars['String']['output'];
  /** User assigned to the payment */
  user?: Maybe<UserType>;
  /** Date of binding to user */
  userBindedAt?: Maybe<Scalars['DateTimeType']['output']>;
  /** Who received the payment */
  userId?: Maybe<Scalars['String']['output']>;
};

export type DigitalIdPaymentList = {
  __typename?: 'DigitalIdPaymentList';
  /** List */
  list?: Maybe<Array<DigitalIdPayment>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export enum DigitalIdStatusEnum {
  Multiple = 'Multiple',
  Single = 'Single',
  Without = 'Without'
}

/** Document AI processing entity */
export type DocAi = {
  __typename?: 'DocAi';
  /** AI template */
  aiTemplate?: Maybe<Scalars['String']['output']>;
  /** AI answers */
  answers?: Maybe<Scalars['JSON']['output']>;
  /** Related CM document ID */
  cmDocId?: Maybe<Scalars['String']['output']>;
  /** Company ID */
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Custom Step 1 Prompt */
  customStep1Prompt?: Maybe<Scalars['String']['output']>;
  /** Custom Step 2 Prompt */
  customStep2Prompt?: Maybe<Scalars['String']['output']>;
  /** Generated text content */
  generatedText?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** AI prompt */
  prompt?: Maybe<Scalars['String']['output']>;
  /** Questions for AI */
  questions?: Maybe<Scalars['JSON']['output']>;
  /** Document Title (autogenerated) */
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DocAiAnswersInput = {
  answers: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
};

export type DocAiPrompts = {
  __typename?: 'DocAiPrompts';
  /** First step prompt */
  step1Prompt: Scalars['String']['output'];
  /** Second step prompt */
  step2Prompt: Scalars['String']['output'];
};

export type DocsByClientQueryFilterInputType = {
  /** Client Identifier */
  counterpartyId: Scalars['String']['input'];
  /** Status */
  status?: InputMaybe<CmDocStatusEnum>;
};

export type DocsDataFiltersDto = {
  __typename?: 'DocsDataFiltersDto';
  contractType: Array<FiltersItem>;
  counterparty: Array<FiltersItem>;
  status: Array<FiltersItem>;
};

export type DocsFilterDto = {
  __typename?: 'DocsFilterDto';
  counterparty: FilterDef;
};

export type DocsInfoResponseDto = {
  __typename?: 'DocsInfoResponseDto';
  amount?: Maybe<Scalars['Float']['output']>;
  counterpartyName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  fieldsRecognition?: Maybe<Scalars['Boolean']['output']>;
  fileId: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  transactionConnections?: Maybe<Scalars['String']['output']>;
};

export type DocsInfoResponseListType = {
  __typename?: 'DocsInfoResponseListType';
  /** List */
  list?: Maybe<Array<DocsInfoResponseDto>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export type DocsMutation = {
  __typename?: 'DocsMutation';
  /** Delete a transaction and document link */
  removeRelationInTransactionDocConnection: Scalars['Boolean']['output'];
  /** Replace an existing document connection with a new one for a transaction */
  replaceTransactionDocumentConnection: Scalars['Boolean']['output'];
  /** Establish a connection between a transaction and a document */
  setRelationInTransactionDocConnection: Scalars['Boolean']['output'];
};


export type DocsMutationRemoveRelationInTransactionDocConnectionArgs = {
  relationIds: Array<RelationTransactionsDocInputDto>;
};


export type DocsMutationReplaceTransactionDocumentConnectionArgs = {
  newFileId: Scalars['String']['input'];
  oldFileId: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};


export type DocsMutationSetRelationInTransactionDocConnectionArgs = {
  relationIds: Array<RelationTransactionsDocInputDto>;
};

export type DocsQuery = {
  __typename?: 'DocsQuery';
  /** Can the user still generate documents? */
  canIGenerateDoc: Scalars['Boolean']['output'];
  /** Export bank statement and documents */
  exportDocuments: ExportDocumentsReponseDto;
  /** Get list of active filters for getAllDocsInfoByCompany */
  filterDataGetAllDocsInfoByCompany: DocsFilterDto;
  /** get all the information on company files */
  getAllDocsInfoByCompany: DocsInfoResponseListType;
  /** get transaction available for linking or already linked with invoice */
  getAvailableTransactionsForInvoice: Array<TransactionForInvoiceDto>;
  /** Request to receive a list of transactions of all bank accounts and documents for this period */
  getTransactionsPeriodWithDocs: TransactionsPeriodWithDocsResponseListType;
};


export type DocsQueryExportDocumentsArgs = {
  accountIds: Array<Scalars['String']['input']>;
  bankStatement?: InputMaybe<Scalars['Boolean']['input']>;
  dateEnd: Scalars['String']['input'];
  dateStart: Scalars['String']['input'];
  documentStatement?: InputMaybe<Scalars['Boolean']['input']>;
  documents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DocsQueryGetAllDocsInfoByCompanyArgs = {
  amount?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['UuidType']['input'];
  counterpartyName?: InputMaybe<Scalars['String']['input']>;
  dateEnd?: InputMaybe<Scalars['String']['input']>;
  dateStart?: InputMaybe<Scalars['String']['input']>;
  onlyWithoutConnections?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInputType>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DocsQueryGetAvailableTransactionsForInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
};


export type DocsQueryGetTransactionsPeriodWithDocsArgs = {
  companyId: Scalars['UuidType']['input'];
  filter?: InputMaybe<TransactionsPeriodWithDocsInputDto>;
  pagination?: InputMaybe<PaginationInputType>;
  sort?: InputMaybe<SortInputType>;
};

export enum DocumentClientEmailTypeEnum {
  CreditNote = 'CreditNote',
  Notify = 'Notify',
  PaymentLinkNotify = 'PaymentLinkNotify',
  PaymentLinkRemind = 'PaymentLinkRemind',
  Remind = 'Remind'
}

export type DocumentInfoDto = {
  __typename?: 'DocumentInfoDto';
  docId?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export enum DocumentStatusEnum {
  Cancelled = 'Cancelled',
  Draft = 'Draft',
  Outstanding = 'Outstanding',
  Overdue = 'Overdue',
  Paid = 'Paid'
}

export type DocumentTransactionLinkDto = {
  __typename?: 'DocumentTransactionLinkDto';
  bankingTransactionId: Scalars['String']['output'];
  docInfoId: Scalars['String']['output'];
};

/** List of documents by counterparty */
export type DocumentsByClientListType = {
  __typename?: 'DocumentsByClientListType';
  allCount: Scalars['Int']['output'];
  cancelledCount: Scalars['Int']['output'];
  draftsCount: Scalars['Int']['output'];
  /** List */
  list?: Maybe<Array<InvoicingDocumentEntity>>;
  outstandingCount: Scalars['Int']['output'];
  overdueCount: Scalars['Int']['output'];
  /** Pagination */
  pagination?: Maybe<PaginationType>;
  paidCount: Scalars['Int']['output'];
};

export type DocumentsListFilterInputDto = {
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  drafts?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  outstanding?: InputMaybe<Scalars['Boolean']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

/** Invoices list */
export type DocumentsOfOrganizationListType = {
  __typename?: 'DocumentsOfOrganizationListType';
  allCount: Scalars['Int']['output'];
  cancelledCount: Scalars['Int']['output'];
  draftsCount: Scalars['Int']['output'];
  /** List */
  list?: Maybe<Array<InvoicingDocumentEntity>>;
  outstandingCount: Scalars['Int']['output'];
  overdueCount: Scalars['Int']['output'];
  /** Pagination */
  pagination?: Maybe<PaginationType>;
  paidCount: Scalars['Int']['output'];
};

export type DocumentsQueryFilterInputType = {
  contractType?: InputMaybe<Array<FiltersItemInput>>;
  counterparty?: InputMaybe<Array<FiltersItemInput>>;
  dateFilter?: InputMaybe<DateFilterDto>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Status */
  status?: InputMaybe<Array<FiltersItemInput>>;
  worker?: InputMaybe<Array<FiltersItemInput>>;
};

export type DuplicateFileType = {
  __typename?: 'DuplicateFileType';
  /** Period type of the existing document */
  accountingType?: Maybe<AccountingReportPeriodEnum>;
  /** ID of the already uploaded document */
  existingFileId: Scalars['UuidType']['output'];
  /** Name of the already uploaded document */
  existingFileName: Scalars['String']['output'];
  /** True when the existing document has a document_info row. The attach modal lists documents from document_info, so a false here means it cannot be offered from storage at any filter */
  isInDocumentStorage: Scalars['Boolean']['output'];
  /** True when the match sits in the period being uploaded to. Informational — any match in the company blocks the upload. Always false when targetPeriodsFolderId is not passed */
  isSamePeriod: Scalars['Boolean']['output'];
  month?: Maybe<Scalars['Int']['output']>;
  /** a_periods_folder.id the existing document sits in */
  periodsFolderId?: Maybe<Scalars['UuidType']['output']>;
  quarter?: Maybe<Scalars['Int']['output']>;
  /** Hash from the request that matched */
  sha256: Scalars['String']['output'];
  /** When the existing document was uploaded */
  uploadedAt: Scalars['DateTimeType']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type EcomShopAccessCreatedDto = {
  __typename?: 'EcomShopAccessCreatedDto';
  /** E-commerce shop access ID */
  id: Scalars['UuidType']['output'];
  /** Shop name on the platform */
  shopName: Scalars['String']['output'];
};

export type EcomShopAccessEntity = {
  __typename?: 'EcomShopAccessEntity';
  /** Access owner */
  accessOwner?: Maybe<AccessOwner>;
  /** Shop name override set by an accountant/manager; falls back to shopName when empty */
  accountantShopName?: Maybe<Scalars['String']['output']>;
  /** Company ID */
  companyId: Scalars['UuidType']['output'];
  /** Creation date */
  createdAt: Scalars['DateTimeType']['output'];
  /** Resolved shop name to display: accountantShopName when set, otherwise shopName */
  displayName?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['UuidType']['output'];
  /** Access submitted */
  isAccessSubmitted?: Maybe<Scalars['Boolean']['output']>;
  /** Has full access */
  isFullAccess: Scalars['Boolean']['output'];
  /** MeritBank ID */
  meritBankId?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<EcomShopEntity>;
  /** Platform ID */
  platformId: Scalars['UuidType']['output'];
  /** Shop name on the platform (set by the user) */
  shopName: Scalars['String']['output'];
  /** Stripe API Key */
  stripeApiKey?: Maybe<Scalars['String']['output']>;
  /** Last updated date */
  updatedAt?: Maybe<Scalars['DateTimeType']['output']>;
  /** Waiting for manual check */
  waitForCheck: Scalars['Boolean']['output'];
};

export type EcomShopAccessInfoDto = {
  __typename?: 'EcomShopAccessInfoDto';
  displayName?: Maybe<Scalars['String']['output']>;
  platformName?: Maybe<Scalars['String']['output']>;
  shopName?: Maybe<Scalars['String']['output']>;
};

export type EcomShopEntity = {
  __typename?: 'EcomShopEntity';
  /** Creation date */
  createdAt: Scalars['DateTimeType']['output'];
  /** Soft deletion date */
  deletedAt?: Maybe<Scalars['DateTimeType']['output']>;
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Checks if there is at least one Sales Report for the specified period */
  hasSalesReport?: Maybe<Scalars['Boolean']['output']>;
  /** ID */
  id: Scalars['UuidType']['output'];
  /** Is platform technically supported */
  isAccessAllowed: Scalars['Boolean']['output'];
  /** Custom (added by user) shop */
  isCustom: Scalars['Boolean']['output'];
  /** Logo key */
  logo?: Maybe<Scalars['String']['output']>;
  /** E-commerce platform name */
  name: Scalars['String']['output'];
  /** URL to the platform */
  url: Scalars['String']['output'];
};

export type EidEasyAuthInitInput = {
  /** ISO-2 country code (e.g. EE, LT, LV) */
  country?: InputMaybe<Scalars['String']['input']>;
  /** UI language for the eIDEasy page */
  lang?: InputMaybe<Scalars['String']['input']>;
  /** Authentication method to pre-select. Omit it to send the user to the eIDEasy method-chooser page with all enabled methods (used by REGISTER sign-up). */
  method?: InputMaybe<EidEasyAuthMethod>;
  /** LOGIN to sign in as existing user; REGISTER to create a new account; LINK to bind eID to current user */
  purpose: EidEasyAuthPurpose;
};

export type EidEasyAuthInitPayload = {
  __typename?: 'EidEasyAuthInitPayload';
  /** URL the frontend should redirect the browser to */
  authUrl: Scalars['String']['output'];
  /** Opaque one-time state token; backend validates it on auth completion. The frontend may echo it through the eIDEasy redirect for an extra check. */
  state: Scalars['String']['output'];
};

/** eIDEasy authentication method used for login/linking */
export enum EidEasyAuthMethod {
  IdCard = 'ID_CARD',
  MobileId = 'MOBILE_ID',
  SmartId = 'SMART_ID'
}

/** Purpose of the eIDEasy auth flow: LOGIN as an existing user, LINK to the current user, or REGISTER a brand-new account */
export enum EidEasyAuthPurpose {
  Link = 'LINK',
  Login = 'LOGIN',
  Register = 'REGISTER'
}

/** EidEasy data */
export type EidEasyData = {
  __typename?: 'EidEasyData';
  /** ClientId for eideasy */
  clientId: Scalars['String']['output'];
  /** Url for eidEasy */
  url: Scalars['String']['output'];
};

export type EidEasySetEmailPayload = {
  __typename?: 'EidEasySetEmailPayload';
  /** True when the real email was accepted and a confirmation email was sent */
  status: Scalars['Boolean']['output'];
};

export type EmailExistsInputType = {
  /** Email address */
  email: Scalars['EmailType']['input'];
};

/** Log in history */
export type EmailExistsPayload = {
  __typename?: 'EmailExistsPayload';
  /** Is active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** User id */
  userId?: Maybe<Scalars['String']['output']>;
};

export type EmailMutation = {
  __typename?: 'EmailMutation';
  /** Select email template for user-triggered email sending */
  selectEmailTemplateForType: Scalars['String']['output'];
};


export type EmailMutationSelectEmailTemplateForTypeArgs = {
  emailType: EmailTemplatesTypesEnum;
  templateId: Scalars['String']['input'];
};

export type EmailTemplate = {
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  /** Used for marking templates as implementing a single feature */
  templateType?: InputMaybe<EmailTemplatesTypesEnum>;
  text: Scalars['String']['input'];
  transactionalStatus?: InputMaybe<Scalars['JSON']['input']>;
  /** Template name visible at UI side */
  visibleName?: InputMaybe<Scalars['String']['input']>;
};

export type EmailTemplateInputType = {
  /** cm_doc ID */
  cmDocId?: InputMaybe<Scalars['String']['input']>;
  /** Template ID from km */
  cmDocTemplateId?: InputMaybe<Scalars['String']['input']>;
  /** Counterparty ID */
  counterpartyId?: InputMaybe<Scalars['String']['input']>;
  /** Template ID */
  id: Scalars['String']['input'];
  /** Invoice ID */
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  /** Worker ID */
  workerId?: InputMaybe<Scalars['String']['input']>;
};

export type EmailTemplateType = {
  __typename?: 'EmailTemplateType';
  buttonLink?: Maybe<Scalars['String']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  /** Used for marking templates as implementing a single feature */
  templateType?: Maybe<EmailTemplatesTypesEnum>;
  text: Scalars['String']['output'];
  transactionalStatus?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Template name visible at UI side */
  visibleName?: Maybe<Scalars['String']['output']>;
};

export enum EmailTemplatesTypesEnum {
  InvoiceCreditNote = 'InvoiceCreditNote',
  InvoiceRemind = 'InvoiceRemind',
  InvoiceSend = 'InvoiceSend'
}

export type EsignDocsEntity = {
  __typename?: 'EsignDocsEntity';
  companyId: Scalars['String']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fileId: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  serviceName: Scalars['String']['output'];
  signature1Date?: Maybe<Scalars['DateTime']['output']>;
  signature2Date?: Maybe<Scalars['DateTime']['output']>;
  signed1FileId?: Maybe<Scalars['String']['output']>;
  signed1FileType?: Maybe<Scalars['String']['output']>;
  signed2FileId?: Maybe<Scalars['String']['output']>;
  signed2FileType?: Maybe<Scalars['String']['output']>;
  signer1DocId?: Maybe<Scalars['String']['output']>;
  signer1Email?: Maybe<Scalars['String']['output']>;
  signer1FirstName?: Maybe<Scalars['String']['output']>;
  signer1LastName?: Maybe<Scalars['String']['output']>;
  signer2DocId?: Maybe<Scalars['String']['output']>;
  signer2Email?: Maybe<Scalars['String']['output']>;
  signer2FirstName?: Maybe<Scalars['String']['output']>;
  signer2LastName?: Maybe<Scalars['String']['output']>;
  signing1Method?: Maybe<Scalars['String']['output']>;
  signing2Method?: Maybe<Scalars['String']['output']>;
  status: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EsignDocsInputType = {
  companyId: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileId: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  serviceName: Scalars['String']['input'];
  signature1Date?: InputMaybe<Scalars['DateTime']['input']>;
  signature2Date?: InputMaybe<Scalars['DateTime']['input']>;
  signed1FileId?: InputMaybe<Scalars['String']['input']>;
  signed1FileType?: InputMaybe<Scalars['String']['input']>;
  signed2FileId?: InputMaybe<Scalars['String']['input']>;
  signed2FileType?: InputMaybe<Scalars['String']['input']>;
  signer1DocId?: InputMaybe<Scalars['String']['input']>;
  signer1Email?: InputMaybe<Scalars['String']['input']>;
  signer1FirstName?: InputMaybe<Scalars['String']['input']>;
  signer1LastName?: InputMaybe<Scalars['String']['input']>;
  signer2DocId?: InputMaybe<Scalars['String']['input']>;
  signer2Email?: InputMaybe<Scalars['String']['input']>;
  signer2FirstName?: InputMaybe<Scalars['String']['input']>;
  signer2LastName?: InputMaybe<Scalars['String']['input']>;
  signing1Method?: InputMaybe<Scalars['String']['input']>;
  signing2Method?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['Float']['input'];
  updatedAt: Scalars['DateTime']['input'];
};

export type Estimate = {
  __typename?: 'Estimate';
  /** Credits remaining for the next payment */
  amountLeftForNextPayment: Scalars['Float']['output'];
  /** Credits applied to the current invoice */
  creditsApplied: Scalars['Float']['output'];
  /**
   * Credits applied to the current invoice
   * @deprecated Misleading name, maps to credits applied to the current invoice. Use creditsApplied instead.
   */
  creditsFromCurrentPlan: Scalars['Float']['output'];
  /** Date when next payment is due */
  nextBillingDate?: Maybe<Scalars['DateTimeType']['output']>;
  /** Subtotal without tax */
  subtotal: Scalars['Float']['output'];
  /** Tax (VAT) amount */
  tax: Scalars['Float']['output'];
  /** Total amount including tax (subtotal + tax) */
  total: Scalars['Float']['output'];
  /** Total amount to be paid now */
  totalToPayNow: Scalars['Float']['output'];
};

export type EstoniaCompanyOpeningDocsType = {
  __typename?: 'EstoniaCompanyOpeningDocsType';
  /** ID Article of association */
  articlesOfAssociation?: Maybe<Scalars['String']['output']>;
  articlesOfAssociationGoogle?: Maybe<Scalars['String']['output']>;
};

/** Estonian company */
export type EstoniaCompanyOpeningInputType = {
  /** Company employees */
  company: CompanyOpeningInputType;
  /** Available for contributions */
  isContribute?: InputMaybe<Scalars['Boolean']['input']>;
  /** Availability of e-residency */
  useEResidentCard?: InputMaybe<EstoniaCompanyOpeningUseEResidentCardEnum>;
  /** Is e-residency needed */
  wantGetEResidency?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is a virtual office required */
  withVirtualOffice?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Estonian companies */
export type EstoniaCompanyOpeningListType = {
  __typename?: 'EstoniaCompanyOpeningListType';
  /** List */
  list?: Maybe<Array<EstoniaCompanyOpeningType>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export type EstoniaCompanyOpeningType = {
  __typename?: 'EstoniaCompanyOpeningType';
  company: CompanyOpeningType;
  /** Docs */
  docs: EstoniaCompanyOpeningDocsType;
  /** ID of the document uploaded to EidEasy */
  eidDocId?: Maybe<Scalars['String']['output']>;
  /** Available for contributions */
  isContribute: Scalars['Boolean']['output'];
  /** ID of the initial document file for signing from RIK */
  rikDocForSignFileId?: Maybe<Scalars['String']['output']>;
  /** Initial application number received from RIK */
  rikId?: Maybe<Scalars['String']['output']>;
  /** Final application number from Rik. Issued after the last submission of signed documents to Rik. */
  rikResultId?: Maybe<Scalars['String']['output']>;
  /** Availability of e-residency */
  useEResidentCard: EstoniaCompanyOpeningUseEResidentCardEnum;
  /** Is e-residency needed */
  wantGetEResidency: Scalars['Boolean']['output'];
  /** Is a virtual office needed */
  withVirtualOffice: Scalars['Boolean']['output'];
};

/** Presence of e-residency */
export enum EstoniaCompanyOpeningUseEResidentCardEnum {
  /** E-residency is present */
  Already = 'Already',
  /** E-residency is absent */
  Not = 'Not'
}

/** Data of existing company */
export type ExistCompany = {
  __typename?: 'ExistCompany';
  email: Scalars['String']['output'];
  existCompanyName: Scalars['String']['output'];
};

/** Expected income details */
export type ExpectedIncomeDetails = {
  __typename?: 'ExpectedIncomeDetails';
  /** Total count of all invoices */
  count?: Maybe<Scalars['Float']['output']>;
  /** List of invoices */
  invoices?: Maybe<Array<InvoicingDocumentEntity>>;
};

export type ExportDocumentsReponseDto = {
  __typename?: 'ExportDocumentsReponseDto';
  fileId?: Maybe<Scalars['String']['output']>;
};

/** Extended file with path */
export type ExtendedFile = {
  __typename?: 'ExtendedFile';
  /** ID of company folder */
  companyFolderId?: Maybe<Scalars['String']['output']>;
  /** Company ID */
  companyId: Scalars['UuidType']['output'];
  /** Time when file information was created */
  createdAt?: Maybe<Scalars['DateTimeType']['output']>;
  /** File ID */
  id: Scalars['UuidType']['output'];
  /** File name */
  name: Scalars['String']['output'];
  /** ID of periods folder */
  periodsFolderId?: Maybe<Scalars['String']['output']>;
  /** ID of the section to which the file belongs */
  periodsSubfolderId?: Maybe<Scalars['String']['output']>;
  /** ID of year folder */
  yearFolderId?: Maybe<Scalars['String']['output']>;
};

/** Accounting status of the file */
export enum FileAccStatus {
  Confirmed = 'Confirmed',
  Denied = 'Denied',
  Processing = 'Processing'
}

export type FileData = {
  __typename?: 'FileData';
  created_at?: Maybe<Scalars['String']['output']>;
  file_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FileDownloadDto = {
  __typename?: 'FileDownloadDto';
  fileId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type FileDto = {
  __typename?: 'FileDto';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  sourceType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FileInContractsFolderInput = {
  /** Contracts folder ID */
  contractsFolderId: Scalars['String']['input'];
  /** Uploaded file ID */
  fileId: Scalars['String']['input'];
  /** Name of the uploaded file */
  name: Scalars['String']['input'];
};

export type FileInSubfolderIdInput = {
  /** Comment on the uploaded file */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Uploaded file ID */
  fileId: Scalars['String']['input'];
  /** Name of the uploaded file */
  name: Scalars['String']['input'];
  /** Subfolder ID */
  periodsSubfolderId: Scalars['String']['input'];
};

/** Rejection reason of the file */
export enum FileRejectionReason {
  MissingDetails = 'MissingDetails',
  Other = 'Other',
  UnrelatedToAccounting = 'UnrelatedToAccounting'
}

/** Upload document sources */
export enum FileSource {
  Accountant = 'Accountant',
  Banking = 'Banking',
  Chargebee = 'Chargebee',
  Chazy = 'Chazy',
  Invoice = 'Invoice',
  Invoicing = 'Invoicing',
  Mail = 'Mail',
  Manual = 'Manual'
}

/** Upload document types */
export enum FileType {
  AccountPayablesReceivables = 'AccountPayablesReceivables',
  Bs = 'Bs',
  FixedAssets = 'FixedAssets',
  Gl = 'Gl',
  Hr = 'Hr',
  Incoming = 'Incoming',
  Internal = 'Internal',
  InvoiceFromEnty = 'InvoiceFromEnty',
  Outcoming = 'Outcoming',
  PlStatement = 'PlStatement',
  Report = 'Report',
  SalesReport = 'SalesReport',
  Statement = 'Statement'
}

export type FilesReceivedByMailListQueryFilterInputType = {
  /** File name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Sender`s email */
  sender?: InputMaybe<Scalars['String']['input']>;
};

export type FilterDef = {
  __typename?: 'FilterDef';
  filterName: Scalars['String']['output'];
  localeKey: Scalars['String']['output'];
  values: Array<FiltersItem2>;
};

export type FiltersItem = {
  __typename?: 'FiltersItem';
  title: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FiltersItem2 = {
  __typename?: 'FiltersItem2';
  localeKey?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FiltersItemInput = {
  title: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FinancesSettings = {
  __typename?: 'FinancesSettings';
  alertOn?: Maybe<Scalars['Boolean']['output']>;
  categorySetupStep: CategorySetupStep;
  companyId: Scalars['String']['output'];
  defaultCurrency?: Maybe<Scalars['String']['output']>;
  thresholdAmount?: Maybe<Scalars['Float']['output']>;
};

export type Firm = {
  __typename?: 'Firm';
  createdAt: Scalars['DateTime']['output'];
  firmCompanies?: Maybe<Array<FirmCompany>>;
  id: Scalars['String']['output'];
  markets: Array<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userFirms?: Maybe<Array<UserFirmType>>;
};

export type FirmCompany = {
  __typename?: 'FirmCompany';
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  firmId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type FirmCompanyType = {
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  firmId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type FirmType = {
  createdAt: Scalars['DateTime']['input'];
  firmCompanies?: InputMaybe<Array<FirmCompanyType>>;
  id: Scalars['String']['input'];
  markets: Array<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
  userFirms?: InputMaybe<Array<UserFirm>>;
};

export type FreshworksMutation = {
  __typename?: 'FreshworksMutation';
  freshworksUpdateContactUTM: Scalars['Boolean']['output'];
  freshworksUpdateDigitalID: Scalars['Boolean']['output'];
  freshworksUpdateLeadStatus: Scalars['Boolean']['output'];
  freshworksUpdateProcessStage: Scalars['Boolean']['output'];
  incRequested: Scalars['Boolean']['output'];
};


export type FreshworksMutationFreshworksUpdateContactUtmArgs = {
  utmData: Scalars['String']['input'];
};


export type FreshworksMutationFreshworksUpdateDigitalIdArgs = {
  digitalIdStatus: DigitalIdStatusEnum;
};


export type FreshworksMutationFreshworksUpdateLeadStatusArgs = {
  leadStatus: LeadStatusEnum;
};


export type FreshworksMutationFreshworksUpdateProcessStageArgs = {
  processStage: ProcessStageEnum;
};

export type FromChargebeeInput = {
  /** Comment on the uploaded file */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Uploaded file ID */
  fileId: Scalars['String']['input'];
  /** Name of the uploaded file */
  name: Scalars['String']['input'];
};

export type GenerateCategoriesFromDescriptionInput = {
  q1?: InputMaybe<Scalars['String']['input']>;
  q2?: InputMaybe<Scalars['String']['input']>;
  q3?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateFakeCategoriesForCompaniesResult = {
  __typename?: 'GenerateFakeCategoriesForCompaniesResult';
  errors: Scalars['Float']['output'];
  processed: Scalars['Float']['output'];
  results: Array<CompanyCategoryGenerationResult>;
  skipped: Scalars['Float']['output'];
};

export type GeneratePdfDocumentDto = {
  __typename?: 'GeneratePdfDocumentDto';
  fileId: Scalars['String']['output'];
};

export type GetCompanyPeriodSubFolderSortFieldDtoInputType = {
  /** Direction */
  direction: SortTypeEnum;
  /** Sort field */
  field: GetCompanyPeriodSubFolderSortFieldEnum;
};

/** Sort field name */
export enum GetCompanyPeriodSubFolderSortFieldEnum {
  CreatedAt = 'CreatedAt',
  IsRead = 'IsRead',
  Name = 'Name'
}

export type GetDocLocation = {
  __typename?: 'GetDocLocation';
  /** ID of company folder */
  companyFolderId?: Maybe<Scalars['String']['output']>;
  /** ID of company */
  companyId: Scalars['String']['output'];
  /** ID of period subfolder */
  contractsFolderId?: Maybe<Scalars['String']['output']>;
  /** ID of period folder */
  periodFolderId?: Maybe<Scalars['String']['output']>;
  /** ID of period subfolder */
  periodSubfolderId?: Maybe<Scalars['String']['output']>;
  /** ID of year folder */
  yearFolderId?: Maybe<Scalars['String']['output']>;
};

export type GetManagerActionsFilterInput = {
  /** Filter by action (partial match) */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Filter from date */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter to date */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by manager user ID */
  managerUserId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by affected user ID */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetManagerActionsResponse = {
  __typename?: 'GetManagerActionsResponse';
  /** List of manager actions */
  list: Array<ManagerActionLog>;
  /** Pagination info */
  pagination: PaginationResponse;
};

export type GetMessagesDto = {
  __typename?: 'GetMessagesDto';
  messages: Array<MessageDto>;
  total: Scalars['Float']['output'];
};

export type GetTasksDto = {
  __typename?: 'GetTasksDto';
  tasks: Array<TaskDto>;
  total: Scalars['Float']['output'];
};

export type GetTasksInput = {
  chatFileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  chatIds?: InputMaybe<Array<Scalars['String']['input']>>;
  chatPeriodIds?: InputMaybe<Array<Scalars['String']['input']>>;
  chatTransactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  messageFileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  messagePeriodIds?: InputMaybe<Array<Scalars['String']['input']>>;
  messageTransactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<ChatStatusEnum>>;
};

/** Group type of the file */
export enum GroupTypeEnum {
  Accounting = 'Accounting',
  Transfer = 'Transfer'
}

export type HrDocEntity = {
  __typename?: 'HRDocEntity';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  docName: Scalars['String']['output'];
  docNumber: Scalars['String']['output'];
  docType: HrDocTypeEnum;
  esignDoc?: Maybe<EsignDocsEntity>;
  /** Record id in esign_docs */
  esignDocId?: Maybe<Scalars['String']['output']>;
  esignedFileId?: Maybe<Scalars['String']['output']>;
  fileId: Scalars['String']['output'];
  fileIdDocx?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  manuallySignedFileId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workerId: Scalars['String']['output'];
};

export enum HrDocTypeEnum {
  Agreement = 'Agreement',
  SignedAgreement = 'SignedAgreement',
  TaxFreeIncomeApplication = 'TaxFreeIncomeApplication',
  TaxFreeIncomeApplicationSigned = 'TaxFreeIncomeApplicationSigned',
  Unknown = 'Unknown'
}

export enum HrEmploymentTypeEnum {
  Permanent = 'Permanent',
  Temporary = 'Temporary'
}

export type HrMutation = {
  __typename?: 'HRMutation';
  /** Generate document for employee */
  addHRDoc: Scalars['Int']['output'];
  createAllFolders: Scalars['Boolean']['output'];
  /** Generate agreement for employee */
  createHRServiceAgreement: Scalars['Boolean']['output'];
  /** Create team */
  createHRTeam: Scalars['Boolean']['output'];
  createPaymentPeriod: Scalars['String']['output'];
  /** Delete document by employee */
  deleteHRDoc: Scalars['Boolean']['output'];
  /** Delete employee */
  deleteHRWorker: HrWorkerEntity;
  /** Delete record in hr_payment */
  deleteHrPayment: HrPaymentEntity;
  /** Save payment settings for employee */
  saveHRPaymentSetting: HrPaymentSettingEntity;
  /** Create new employee */
  saveHRWorker: HrWorkerEntity;
  /** Send generated document by email */
  sendAgreementViaEmail: Scalars['Boolean']['output'];
  transferDocType2toAgreement: Scalars['Boolean']['output'];
  /** Update record in hr_payment */
  updateHrPayment: HrPaymentEntity;
  /** Update current period step */
  updatePaymentPeriodStep: HrPaymentPeriodType;
};


export type HrMutationAddHrDocArgs = {
  docName: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
  signedDoc: Scalars['Boolean']['input'];
  workerId: Scalars['String']['input'];
};


export type HrMutationCreateAllFoldersArgs = {
  password: Scalars['String']['input'];
};


export type HrMutationCreateHrServiceAgreementArgs = {
  docType: HrDocTypeEnum;
  workerId: Scalars['String']['input'];
};


export type HrMutationCreateHrTeamArgs = {
  name: Scalars['String']['input'];
};


export type HrMutationCreatePaymentPeriodArgs = {
  companyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type HrMutationDeleteHrDocArgs = {
  docId: Scalars['Float']['input'];
  signed?: Scalars['Boolean']['input'];
  workerId: Scalars['String']['input'];
};


export type HrMutationDeleteHrWorkerArgs = {
  workerId: Scalars['String']['input'];
};


export type HrMutationDeleteHrPaymentArgs = {
  id: Scalars['String']['input'];
};


export type HrMutationSaveHrPaymentSettingArgs = {
  paymentSetting: HrPaymentSettingDto;
};


export type HrMutationSaveHrWorkerArgs = {
  worker: HrWorkerDto;
};


export type HrMutationSendAgreementViaEmailArgs = {
  fileId: Scalars['String']['input'];
  workerId: Scalars['String']['input'];
};


export type HrMutationTransferDocType2toAgreementArgs = {
  password: Scalars['String']['input'];
};


export type HrMutationUpdateHrPaymentArgs = {
  hrPayment: HrPaymentInputType;
};


export type HrMutationUpdatePaymentPeriodStepArgs = {
  newStepId: Scalars['Float']['input'];
  periodId: Scalars['String']['input'];
};

export type HrPaymentEntity = {
  __typename?: 'HRPaymentEntity';
  /** Bonus amount for current period */
  bonus: Scalars['Float']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  grossHourPay?: Maybe<Scalars['Float']['output']>;
  /** Hours per week */
  hoursPerWeek?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Used sick leave days */
  medicalLeaveDays: Scalars['Float']['output'];
  /** Net salary from accounting department */
  netPay?: Maybe<Scalars['Float']['output']>;
  /** Fact overtime hours for current period */
  overtimeHours: Scalars['Float']['output'];
  /** Overtime hourly rate */
  overtimeRate: Scalars['Float']['output'];
  paymentPeriod: HrPaymentPeriodType;
  /** Period id */
  paymentPeriodId: Scalars['UuidType']['output'];
  /** Payslip file id */
  payslipFileId?: Maybe<Scalars['String']['output']>;
  /** Monthly or hourly rate */
  rate?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Used vacation days */
  vacationDays: Scalars['Float']['output'];
  worker?: Maybe<HrWorkerEntity>;
  workerId: Scalars['String']['output'];
};

export type HrPaymentEntityInput = {
  /** Bonus amount for current period */
  bonus?: Scalars['Float']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  grossHourPay?: InputMaybe<Scalars['Float']['input']>;
  /** Hours per week */
  hoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  /** Used sick leave days */
  medicalLeaveDays?: Scalars['Float']['input'];
  /** Net salary from accounting department */
  netPay?: InputMaybe<Scalars['Float']['input']>;
  /** Fact overtime hours for current period */
  overtimeHours?: Scalars['Float']['input'];
  /** Overtime hourly rate */
  overtimeRate?: Scalars['Float']['input'];
  paymentPeriod: HrPaymentPeriodEntity;
  /** Period id */
  paymentPeriodId: Scalars['UuidType']['input'];
  /** Payslip file id */
  payslipFileId?: InputMaybe<Scalars['String']['input']>;
  /** Monthly or hourly rate */
  rate?: InputMaybe<Scalars['Float']['input']>;
  /** Used vacation days */
  vacationDays?: Scalars['Float']['input'];
  worker?: InputMaybe<HrWorkerInputType>;
  workerId: Scalars['String']['input'];
};

export type HrPaymentSettingDto = {
  bankName: Scalars['String']['input'];
  bicOrSwift: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  endDateOfEmployment?: InputMaybe<Scalars['DateTime']['input']>;
  /** End of the agreement date */
  endOfAgreement?: InputMaybe<Scalars['DateTime']['input']>;
  grossHourPay: Scalars['Float']['input'];
  holidayAllowance?: InputMaybe<Scalars['Int']['input']>;
  hoursPerWeek: Scalars['Int']['input'];
  iban: Scalars['String']['input'];
  isPaymentSettingsComplete: Scalars['Boolean']['input'];
  locationOfWork?: InputMaybe<Scalars['String']['input']>;
  paymentDay: Scalars['Int']['input'];
  paymentDetails?: InputMaybe<Scalars['String']['input']>;
  rate: HrPaymentTypeEnum;
  service: Scalars['String']['input'];
  startDateOfEmployment?: InputMaybe<Scalars['DateTime']['input']>;
  taxFreeIncome?: InputMaybe<Scalars['Float']['input']>;
  trialPeriod?: InputMaybe<Scalars['Int']['input']>;
  typeTrialPeriod?: InputMaybe<HrTrialPeriodTypeEnum>;
  typeWorkingHours?: InputMaybe<HrWorkingHoursTypeEnum>;
  vacationDays?: InputMaybe<Scalars['Int']['input']>;
  /** 2 values. Can be stored as 00:00 (first input) - 00:00 (second input) */
  workSchedule?: InputMaybe<Scalars['String']['input']>;
  workerId: Scalars['String']['input'];
  workingHours?: InputMaybe<Scalars['Int']['input']>;
};

export type HrPaymentSettingEntity = {
  __typename?: 'HRPaymentSettingEntity';
  bankName: Scalars['String']['output'];
  bicOrSwift: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDateOfEmployment?: Maybe<Scalars['DateTime']['output']>;
  /** End of the agreement date */
  endOfAgreement?: Maybe<Scalars['DateTime']['output']>;
  grossHourPay: Scalars['Float']['output'];
  holidayAllowance?: Maybe<Scalars['Int']['output']>;
  hoursPerWeek: Scalars['Int']['output'];
  iban: Scalars['String']['output'];
  isPaymentSettingsComplete: Scalars['Boolean']['output'];
  locationOfWork?: Maybe<Scalars['String']['output']>;
  paymentDay: Scalars['Int']['output'];
  /** Salary data from opnforms */
  paymentDetails?: Maybe<Scalars['String']['output']>;
  rate: HrPaymentTypeEnum;
  service: Scalars['String']['output'];
  startDateOfEmployment?: Maybe<Scalars['DateTime']['output']>;
  taxFreeIncome?: Maybe<Scalars['Float']['output']>;
  trialPeriod?: Maybe<Scalars['Int']['output']>;
  typeTrialPeriod?: Maybe<HrTrialPeriodTypeEnum>;
  typeWorkingHours?: Maybe<HrWorkingHoursTypeEnum>;
  vacationDays?: Maybe<Scalars['Int']['output']>;
  /** Two hh:mm values e.g 00:00 - 00:00 */
  workSchedule?: Maybe<Scalars['String']['output']>;
  workerId: Scalars['String']['output'];
  workingHours?: Maybe<Scalars['Int']['output']>;
};

export enum HrPaymentTypeEnum {
  Hourly = 'Hourly',
  Monthly = 'Monthly'
}

export type HrQuery = {
  __typename?: 'HRQuery';
  /** Get active payment period */
  getActivePaymentPeriod?: Maybe<HrPaymentPeriodType>;
  /** Get archived payment periods */
  getInactivePaymentPeriod: Array<HrPaymentPeriodType>;
  /** For control panel cards: hired employees count */
  hiredWorkersCount: Scalars['Int']['output'];
  /** Get list of documents by employee id */
  hrDocuments: Array<HrDocEntity>;
  /** Get employee by id */
  hrWorker: HrWorkerEntity;
  /** Get payment settings by employee id */
  hrWorkerPaymentSetting?: Maybe<HrPaymentSettingEntity>;
  /** Get company employees list */
  hrWorkersList: HrWorkerEntityListType;
  /** For control panel cards: employees list */
  lastHiredWorkers?: Maybe<Array<HrWorkerEntity>>;
  /** Send payslip by email */
  sendPayslipToEmail: Scalars['Boolean']['output'];
  /** Get list of employees with payments data for current petiod */
  tableDataForHrPayment: HrPaymentWithWorkerListType;
  /** Get company teams list */
  teamsList: Array<HrTeam>;
  /** Total wages for hired employees */
  totalWageFund: Scalars['Int']['output'];
  /** For control panel cards: employees count */
  workersCount: Scalars['Int']['output'];
};


export type HrQueryHrDocumentsArgs = {
  workerId: Scalars['String']['input'];
};


export type HrQueryHrWorkerArgs = {
  workerId: Scalars['String']['input'];
};


export type HrQueryHrWorkerPaymentSettingArgs = {
  workerId: Scalars['String']['input'];
};


export type HrQueryHrWorkersListArgs = {
  filter?: InputMaybe<HrWorkerListFilterInputDto>;
  pagination: PaginationInputType;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
};


export type HrQuerySendPayslipToEmailArgs = {
  payslipFileId: Scalars['String']['input'];
  workerId: Scalars['String']['input'];
};


export type HrQueryTableDataForHrPaymentArgs = {
  filter?: InputMaybe<HrPaymentFilterInputType>;
  pagination: PaginationInputType;
  periodId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
};

export type HrTeam = {
  __typename?: 'HRTeam';
  companyId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum HrTrialPeriodTypeEnum {
  Days = 'Days',
  Months = 'Months'
}

export type HrWorkerDto = {
  address: Scalars['String']['input'];
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  /** BSN for Netherlands */
  bsn?: InputMaybe<Scalars['String']['input']>;
  /** Chamber of Commerce number */
  ccNumber?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  confirmInfoClicked: Scalars['Boolean']['input'];
  country: Scalars['String']['input'];
  /** Language for document generation */
  docLang?: InputMaybe<Scalars['String']['input']>;
  duties: Scalars['String']['input'];
  email: Scalars['String']['input'];
  /** Type of Employment */
  employmentType?: InputMaybe<HrEmploymentTypeEnum>;
  /** Worker document ID (passport) */
  fileId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idNumber: Scalars['String']['input'];
  /** Field for document upload */
  idScan?: InputMaybe<Scalars['String']['input']>;
  isGeneralInfoComplete: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  position: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
  typeOfId: Scalars['String']['input'];
  workerType: HrWorkerTypeEnum;
  /** Name of sole proprietorship (zzp) */
  zzp?: InputMaybe<Scalars['String']['input']>;
};

export type HrWorkerEntity = {
  __typename?: 'HRWorkerEntity';
  address: Scalars['String']['output'];
  birthday?: Maybe<Scalars['DateTime']['output']>;
  /** BSN for the Netherlands */
  bsn?: Maybe<Scalars['String']['output']>;
  /** Chamber of Commerce number */
  ccNumber?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  cm_documents?: Maybe<Array<CmDoc>>;
  confirmInfoClicked: Scalars['Boolean']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document language */
  docLang?: Maybe<Scalars['String']['output']>;
  duties: Scalars['String']['output'];
  email: Scalars['String']['output'];
  /** Type of Employment */
  employmentType?: Maybe<HrEmploymentTypeEnum>;
  /** File id for employee identification document */
  fileId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  grossMonthlyWage?: Maybe<Scalars['Float']['output']>;
  /** Check if employee has a signed agreement */
  haveSignedAgreement: Scalars['Boolean']['output'];
  hiredAt?: Maybe<Scalars['DateTime']['output']>;
  /** 1 - hired, and 0 - not hired */
  hiredWorker: Scalars['Int']['output'];
  id?: Maybe<Scalars['String']['output']>;
  idNumber: Scalars['String']['output'];
  /** Document scan file */
  idScan?: Maybe<Scalars['String']['output']>;
  isGeneralInfoComplete: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  monthlyWageFund?: Maybe<Scalars['Float']['output']>;
  periodPaymentSettings?: Maybe<Array<HrPaymentEntity>>;
  phone: Scalars['String']['output'];
  position: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
  typeOfId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  workerType: HrWorkerTypeEnum;
  /** Name of sole proprietorship (zzp) */
  zzp?: Maybe<Scalars['String']['output']>;
};

/** List of workers */
export type HrWorkerEntityListType = {
  __typename?: 'HRWorkerEntityListType';
  /** List */
  list?: Maybe<Array<HrWorkerEntity>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export type HrWorkerInputType = {
  address: Scalars['String']['input'];
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  /** BSN for the Netherlands */
  bsn?: InputMaybe<Scalars['String']['input']>;
  /** Chamber of Commerce number */
  ccNumber?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  cm_documents?: InputMaybe<Array<CmDocInputType>>;
  confirmInfoClicked: Scalars['Boolean']['input'];
  country: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Document language */
  docLang?: InputMaybe<Scalars['String']['input']>;
  duties: Scalars['String']['input'];
  email: Scalars['String']['input'];
  /** Type of Employment */
  employmentType?: InputMaybe<HrEmploymentTypeEnum>;
  /** File id for employee identification document */
  fileId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  grossMonthlyWage?: InputMaybe<Scalars['Float']['input']>;
  hiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** 1 - hired, and 0 - not hired */
  hiredWorker: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idNumber: Scalars['String']['input'];
  /** Document scan file */
  idScan?: InputMaybe<Scalars['String']['input']>;
  isGeneralInfoComplete: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  monthlyWageFund?: InputMaybe<Scalars['Float']['input']>;
  periodPaymentSettings?: InputMaybe<Array<HrPaymentEntityInput>>;
  phone: Scalars['String']['input'];
  position: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
  typeOfId: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  workerType: HrWorkerTypeEnum;
  /** Name of sole proprietorship (zzp) */
  zzp?: InputMaybe<Scalars['String']['input']>;
};

export enum HrWorkerTypeEnum {
  Contractor = 'Contractor',
  Employee = 'Employee',
  Member = 'Member'
}

export enum HrWorkingHoursTypeEnum {
  Day = 'Day',
  Week = 'Week'
}

/** A bank account the accountant creates for a statement import */
export type HiddenBankAccountInput = {
  /** Account name */
  accountName: Scalars['String']['input'];
  bankName?: InputMaybe<Scalars['String']['input']>;
  /** Company of the account */
  companyId: Scalars['String']['input'];
  /** Account currency, 3-letter ISO code */
  currency: Scalars['String']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
};

export type HiredAtType = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HrDocumentSaveBodyDto = {
  __typename?: 'HrDocumentSaveBodyDto';
  docId?: Maybe<Scalars['Int']['output']>;
  docName: Scalars['String']['output'];
  docType: Scalars['Float']['output'];
  fileId: Scalars['String']['output'];
  workerId: Scalars['String']['output'];
};

export type HrPaymentFilterInputType = {
  /** Worker type */
  workerType?: InputMaybe<HrWorkerTypeEnum>;
};

export type HrPaymentInputType = {
  /** what is the amount of the bonus/bonus to the employee for the period */
  bonus?: Scalars['Float']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  grossHourPay?: InputMaybe<Scalars['Float']['input']>;
  /** How salary is calculated */
  hoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  /** how many days the user was on sick leave during this period */
  medicalLeaveDays?: Scalars['Float']['input'];
  /** Net salary calculated by the accountant */
  netPay?: InputMaybe<Scalars['Float']['input']>;
  /** how many hours the employee worked overtime during the period. */
  overtimeHours?: Scalars['Float']['input'];
  /** How much an hour of employee overtime costs. */
  overtimeRate?: Scalars['Float']['input'];
  /** link to the document ID Payslip */
  payslipFileId?: InputMaybe<Scalars['String']['input']>;
  periodPaymentSettingId?: InputMaybe<Scalars['String']['input']>;
  /** how it is calculated: per hour or per month */
  rate?: InputMaybe<Scalars['Float']['input']>;
  /** how many days the user was on vacation during this period. */
  vacationDays?: Scalars['Float']['input'];
};

export type HrPaymentPeriodEntity = {
  /** Archive id with all period payslips */
  allPayslipFileId?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Company>;
  companyId: Scalars['String']['input'];
  /** Period end date */
  periodEndDate: Scalars['DateTime']['input'];
  /** Period start date */
  periodStartDate: Scalars['DateTime']['input'];
  /** Current period status */
  periodStatus: Scalars['Float']['input'];
  /** Current period step */
  periodStep?: Scalars['Float']['input'];
  prevPeriodId?: InputMaybe<Scalars['String']['input']>;
  /** Sum for netPay for all employees in current period */
  totalNetPay?: InputMaybe<Scalars['Float']['input']>;
};

/** Object of the salary payment period */
export type HrPaymentPeriodType = {
  __typename?: 'HrPaymentPeriodType';
  /** Archive id with all period payslips */
  allPayslipFileId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyOpeningType>;
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Period end date */
  periodEndDate: Scalars['DateTime']['output'];
  /** Period start date */
  periodStartDate: Scalars['DateTime']['output'];
  /** Current period status */
  periodStatus: Scalars['Float']['output'];
  /** Current period step */
  periodStep: Scalars['Float']['output'];
  prevPeriodId?: Maybe<Scalars['String']['output']>;
  /** Sum for netPay for all employees in current period */
  totalNetPay?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HrPaymentWithWorkerListType = {
  __typename?: 'HrPaymentWithWorkerListType';
  /** List */
  list?: Maybe<Array<HrPaymentWithWorkerType>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export type HrPaymentWithWorkerType = {
  __typename?: 'HrPaymentWithWorkerType';
  bonus?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  grossHourPay?: Maybe<Scalars['Float']['output']>;
  hoursPerWeek?: Maybe<Scalars['Float']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  medicalLeaveDays?: Maybe<Scalars['Float']['output']>;
  netPay?: Maybe<Scalars['Float']['output']>;
  overtimeHours?: Maybe<Scalars['Float']['output']>;
  overtimeRate?: Maybe<Scalars['Float']['output']>;
  payslipFileId?: Maybe<Scalars['String']['output']>;
  periodPaymentSettingId?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  vacationDays?: Maybe<Scalars['Float']['output']>;
  workerEmail?: Maybe<Scalars['String']['output']>;
  workerId: Scalars['String']['output'];
  workerType: Scalars['Float']['output'];
};

export type HrWorkerListFilterInputDto = {
  department?: InputMaybe<Scalars['String']['input']>;
  hiredAt?: InputMaybe<HiredAtType>;
  name?: InputMaybe<Scalars['String']['input']>;
  workerType?: InputMaybe<Scalars['Float']['input']>;
};

export type ImportedContactDto = {
  __typename?: 'ImportedContactDto';
  clientId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
};

export type ImportedProductDto = {
  __typename?: 'ImportedProductDto';
  currency?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type IncorporationCompanyDocumentListQueryFilterInputType = {
  /** CompanyID */
  companyId: Scalars['String']['input'];
};

export type IncorporationCompanyPaymentListQueryFilterInputType = {
  /** CompanyID */
  companyId: Scalars['String']['input'];
};

export type IncorporationCompanyProcessHistoryListQueryFilterInputType = {
  /** CompanyID */
  companyId: Scalars['String']['input'];
};

export type IncorporationEstoniaCompanyListQueryFilterInputType = {
  /** Search pattern */
  search?: InputMaybe<Scalars['String']['input']>;
  /** userID */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type IncorporationEstoniaCompanyQueryFilterInputType = {
  /** CompanyID */
  id: Scalars['UuidType']['input'];
};

/** Lead creation */
export type IncorporationLeadCreateInputType = {
  email: Scalars['EmailType']['input'];
};

export type IncorporationLeadCreatePayload = {
  __typename?: 'IncorporationLeadCreatePayload';
  /** Created lead */
  lead: IncorporationLeadType;
};

export type IncorporationLeadType = {
  __typename?: 'IncorporationLeadType';
  /** Created date */
  createdAt: Scalars['DateTimeType']['output'];
  /** Email address */
  email: Scalars['EmailType']['output'];
  /** ID */
  id: Scalars['UuidType']['output'];
};

export type IncorporationMeetCreateInputType = {
  /** Contact email address */
  email: Scalars['EmailType']['input'];
  /** Contact email address */
  manager: IncorporationMeetManagerEnum;
  /** Example field (placeholder) */
  source: IncorporationMeetSourceEnum;
  /** Contact email address */
  type: Scalars['String']['input'];
};

/** Manager ID */
export enum IncorporationMeetManagerEnum {
  Alina = 'ALINA',
  Arina = 'ARINA',
  Arina2 = 'ARINA2',
  Gulshan = 'GULSHAN'
}

export type IncorporationMeetQueryFilterInputType = {
  /** MeetID */
  id: Scalars['UuidType']['input'];
};

/** Source of application */
export enum IncorporationMeetSourceEnum {
  AccountantConsultation = 'AccountantConsultation',
  Accounting = 'Accounting',
  BankQuiz = 'BankQuiz',
  Banking = 'Banking',
  CompanyDocuments = 'CompanyDocuments',
  ControlPanel = 'ControlPanel',
  Cyprus = 'Cyprus',
  Estonia = 'Estonia',
  Europe = 'Europe',
  Invoicing = 'Invoicing',
  KnowledgeBase = 'KnowledgeBase',
  Main = 'Main',
  PlanChange = 'PlanChange',
  Pricing = 'Pricing',
  PricingTransfer = 'PricingTransfer',
  Profile = 'Profile',
  ProfileHotAction = 'ProfileHotAction',
  Vat = 'Vat'
}

export type IncorporationMeetType = {
  __typename?: 'IncorporationMeetType';
  createdAt: Scalars['DateTime']['output'];
  /** Contact email address */
  email: Scalars['String']['output'];
  /** ID */
  id: Scalars['String']['output'];
  inviteeAt?: Maybe<Scalars['DateTimeType']['output']>;
  /** Locale */
  locale: Scalars['String']['output'];
  manager?: Maybe<IncorporationMeetManagerEnum>;
  meetEndAt?: Maybe<Scalars['DateTimeType']['output']>;
  meetStartAt?: Maybe<Scalars['DateTimeType']['output']>;
  meetUrl: Scalars['String']['output'];
  source: IncorporationMeetSourceEnum;
  timezone: Scalars['String']['output'];
  /** Type of meeting */
  type: IncorporationMeetTypeEnum;
  /** ID of visit */
  visitorId: Scalars['String']['output'];
};

/** Meet type */
export enum IncorporationMeetTypeEnum {
  CompanyOpening = 'CompanyOpening',
  Landing = 'Landing',
  PersonalArea = 'PersonalArea'
}

export type IncorporationQuestionInputType = {
  /** Contact email address */
  email: Scalars['EmailType']['input'];
  /** Question text */
  question: Scalars['String']['input'];
  /** Request source */
  source: IncorporationMeetSourceEnum;
  /** Question type */
  type?: InputMaybe<IncorporationQuestionTypeEnum>;
};

/** Type of request */
export enum IncorporationQuestionTypeEnum {
  Cooperation = 'Cooperation',
  GetStarted = 'GetStarted',
  Incorporation = 'Incorporation',
  Marketing = 'Marketing',
  NewsletterSubscription = 'NewsletterSubscription',
  ProductRelated = 'ProductRelated'
}

/** A transaction on another account of the company that can be linked as the other leg of an internal transfer */
export type InternalTransferCandidate = {
  __typename?: 'InternalTransferCandidate';
  /** Banking account of the transaction */
  accountId: Scalars['String']['output'];
  /** Signed amount in the transaction currency */
  amount: Scalars['String']['output'];
  /** Account name to display: the Merit bank name if linked, otherwise the account name */
  bankAccount?: Maybe<Scalars['String']['output']>;
  /** Category name */
  category?: Maybe<Scalars['String']['output']>;
  /** Counterparty name */
  counterparty?: Maybe<Scalars['String']['output']>;
  /** Transaction currency */
  currency: Scalars['String']['output'];
  /** Transaction date */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Same currency and the same absolute amount as the transaction being paired */
  isAmountMatch: Scalars['Boolean']['output'];
  /** Whether the transaction is already categorized as an internal transfer */
  isInternalTransfer: Scalars['Boolean']['output'];
  /** Already sent to Merit as a payment: it cannot be linked until that payment is deleted in Merit */
  isSentToMerit: Scalars['Boolean']['output'];
  /** Description of the transaction from the bank */
  note?: Maybe<Scalars['String']['output']>;
  /** Transaction ID */
  transactionId: Scalars['String']['output'];
};

export type InvoicesListQueryFilterInputType = {
  /** Client identifier */
  clientId: Scalars['UuidType']['input'];
  /** Invoice status */
  status?: InputMaybe<DocumentStatusEnum>;
};

export type InvoicingCreateClientDtoType = {
  addresses: Array<CounterpartyAddressDto>;
  birthday?: InputMaybe<Scalars['DateType']['input']>;
  companyNumber?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  idNumber?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<Scalars['String']['input']>;
  isClient?: InputMaybe<Scalars['Boolean']['input']>;
  isProvider?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalStatus: LegalStatusEnum;
  middleName?: InputMaybe<Scalars['String']['input']>;
  representativeName?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  taxStatus: TaxStatusEnum;
};

export type InvoicingCreateItemDtoType = {
  currency: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicingCreditNoteEntity = {
  __typename?: 'InvoicingCreditNoteEntity';
  additionalComment?: Maybe<Scalars['String']['output']>;
  bankingAccountId?: Maybe<Scalars['String']['output']>;
  client?: Maybe<CounterpartyEntity>;
  createdAt: Scalars['DateTime']['output'];
  creditNoteDate: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  currencySymbol?: Maybe<Scalars['String']['output']>;
  docFileId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoicingDocument?: Maybe<InvoicingDocumentEntity>;
  invoicingDocumentId: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  numberNumber: Scalars['String']['output'];
  numberYear: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  status?: Maybe<DocumentStatusEnum>;
  total?: Maybe<Scalars['Float']['output']>;
  totalWithTax?: Maybe<Scalars['Float']['output']>;
};

export type InvoicingCreditNoteEntityInputType = {
  additionalComment?: InputMaybe<Scalars['String']['input']>;
  bankingAccountId?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<CounterpartyInputType>;
  createdAt: Scalars['DateTime']['input'];
  creditNoteDate: Scalars['DateTime']['input'];
  currency?: Scalars['String']['input'];
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  docFileId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  invoicingDocument?: InputMaybe<InvoicingDocumentEntityInputType>;
  invoicingDocumentId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  numberNumber: Scalars['String']['input'];
  numberYear: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  status?: InputMaybe<DocumentStatusEnum>;
  total?: InputMaybe<Scalars['Float']['input']>;
  totalWithTax?: InputMaybe<Scalars['Float']['input']>;
};

export type InvoicingCurMonthReportResponseDto = {
  __typename?: 'InvoicingCurMonthReportResponseDto';
  /** Outstanding + Overdue count */
  ooCount?: Maybe<Scalars['Float']['output']>;
  /** Outstanding + Overdue + Paid count */
  oopCount?: Maybe<Scalars['Float']['output']>;
  /** Outstanding + Overdue + Paid sum */
  oopSum?: Maybe<Scalars['Float']['output']>;
  /** Paid sum */
  pSum?: Maybe<Scalars['Float']['output']>;
};

export type InvoicingCustomizeEntity = {
  __typename?: 'InvoicingCustomizeEntity';
  colorMain?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  logoAdded?: Maybe<Scalars['Boolean']['output']>;
  logoFileId?: Maybe<Scalars['String']['output']>;
  paymentReminderOn?: Maybe<Scalars['Boolean']['output']>;
  pdfTemplate?: Maybe<Scalars['String']['output']>;
  showPaymentsModal?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userLinkAdded?: Maybe<Scalars['Boolean']['output']>;
};

export type InvoicingDocumentEntity = {
  __typename?: 'InvoicingDocumentEntity';
  additionalComment?: Maybe<Scalars['String']['output']>;
  /** Indicates if transaction automatically linked to invoice */
  autoMatched?: Maybe<Scalars['Boolean']['output']>;
  bankingAccountId?: Maybe<Scalars['String']['output']>;
  cancelled: Scalars['Boolean']['output'];
  client?: Maybe<CounterpartyEntity>;
  /** Company that owns the document */
  company?: Maybe<CompanyOpeningType>;
  /** ID of the company that owns the document */
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  creditNote?: Maybe<Array<InvoicingCreditNoteEntity>>;
  currency: Scalars['String']['output'];
  currencySymbol?: Maybe<Scalars['String']['output']>;
  dateDue: Scalars['DateTime']['output'];
  datePaid?: Maybe<Scalars['DateTime']['output']>;
  deal?: Maybe<Deal>;
  dealId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  directPaymentLinkAdded: Scalars['Boolean']['output'];
  docFileId?: Maybe<Scalars['String']['output']>;
  draft: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  itemsInDoc?: Maybe<Array<InvoicingItemInDocumentEntity>>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  numberNumber: Scalars['String']['output'];
  numberYear: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  overdueReminderSentAt?: Maybe<Scalars['DateTime']['output']>;
  paidInFull: Scalars['Boolean']['output'];
  paidOnline: Scalars['Boolean']['output'];
  paymentLink?: Maybe<MonitePaymentLinkEntity>;
  payoutSettled: Scalars['Boolean']['output'];
  recurrent?: Maybe<InvoicingRecurrentEntity>;
  recurrentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DocumentStatusEnum>;
  total?: Maybe<Scalars['Float']['output']>;
  totalConverted?: Maybe<Scalars['Float']['output']>;
  totalWithTax?: Maybe<Scalars['Float']['output']>;
  totalWithTaxConverted?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoicingDocumentEntityInputType = {
  additionalComment?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if transaction automatically linked to invoice */
  autoMatched?: InputMaybe<Scalars['Boolean']['input']>;
  bankingAccountId?: InputMaybe<Scalars['String']['input']>;
  cancelled: Scalars['Boolean']['input'];
  client?: InputMaybe<CounterpartyInputType>;
  /** Company that owns the document */
  company?: InputMaybe<Company>;
  /** ID of the company that owns the document */
  companyId: Scalars['ID']['input'];
  createdAt: Scalars['DateTime']['input'];
  creditNote?: InputMaybe<Array<InvoicingCreditNoteEntityInputType>>;
  currency?: Scalars['String']['input'];
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  dateDue: Scalars['DateTime']['input'];
  datePaid?: InputMaybe<Scalars['DateTime']['input']>;
  deal?: InputMaybe<DealInputType>;
  dealId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  directPaymentLinkAdded: Scalars['Boolean']['input'];
  docFileId?: InputMaybe<Scalars['String']['input']>;
  draft: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  invoiceDate: Scalars['DateTime']['input'];
  itemsInDoc?: InputMaybe<Array<InvoicingItemInDocumentEntityInputType>>;
  note?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  numberNumber: Scalars['String']['input'];
  numberYear: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  overdueReminderSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  paidInFull: Scalars['Boolean']['input'];
  paidOnline: Scalars['Boolean']['input'];
  paymentLink?: InputMaybe<MonitePaymentLinkEntityInputType>;
  payoutSettled: Scalars['Boolean']['input'];
  recurrent?: InputMaybe<InvoicingRecurrentType>;
  recurrentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentStatusEnum>;
  total?: InputMaybe<Scalars['Float']['input']>;
  totalConverted?: InputMaybe<Scalars['Float']['input']>;
  totalWithTax?: InputMaybe<Scalars['Float']['input']>;
  totalWithTaxConverted?: InputMaybe<Scalars['Float']['input']>;
  updatedAt: Scalars['DateTime']['input'];
};

export type InvoicingItemEntity = {
  __typename?: 'InvoicingItemEntity';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  itemsInCmDoc?: Maybe<Array<ProductInCmDoc>>;
  itemsInDoc?: Maybe<Array<InvoicingItemInDocumentEntity>>;
  itemsInDocs?: Maybe<InvoicingItemInDocumentEntity>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  spaceInvoiceItemId?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<InvoicingItemUnitEnum>;
  unitEntity?: Maybe<InvoicingItemUnitEntity>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoicingItemEntityInputType = {
  createdAt: Scalars['DateTime']['input'];
  currency: Scalars['String']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  itemsInCmDoc?: InputMaybe<Array<ProductInCmDocInputType>>;
  itemsInDoc?: InputMaybe<Array<InvoicingItemInDocumentEntityInputType>>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  spaceInvoiceItemId?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<InvoicingItemUnitEnum>;
  unitEntity?: InputMaybe<InvoicingItemUnitEntityInputType>;
  updatedAt: Scalars['DateTime']['input'];
};

export type InvoicingItemInDocumentEntity = {
  __typename?: 'InvoicingItemInDocumentEntity';
  discount?: Maybe<Scalars['Float']['output']>;
  discountIsAmount?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceId: Scalars['String']['output'];
  item?: Maybe<InvoicingItemEntity>;
  itemId?: Maybe<Scalars['String']['output']>;
  meritItem?: Maybe<MeritItemEntity>;
  meritItemId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<InvoicingItemUnitEnum>;
  unitEntity?: Maybe<InvoicingItemUnitEntity>;
};

export type InvoicingItemInDocumentEntityInputType = {
  discount?: InputMaybe<Scalars['Float']['input']>;
  discountIsAmount?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  item?: InputMaybe<InvoicingItemEntityInputType>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  meritItem?: InputMaybe<MeritItemEntityInputType>;
  meritItemId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  tax?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<InvoicingItemUnitEnum>;
  unitEntity?: InputMaybe<InvoicingItemUnitEntityInputType>;
};

export type InvoicingItemUnitEntity = {
  __typename?: 'InvoicingItemUnitEntity';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  items?: Maybe<Array<InvoicingItemEntity>>;
  itemsInDoc?: Maybe<Array<InvoicingItemInDocumentEntity>>;
  name: InvoicingItemUnitEnum;
  popularity?: Maybe<Scalars['Float']['output']>;
  shortName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoicingItemUnitEntityInputType = {
  createdAt: Scalars['DateTime']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  items?: InputMaybe<Array<InvoicingItemEntityInputType>>;
  itemsInDoc?: InputMaybe<Array<InvoicingItemInDocumentEntityInputType>>;
  name: InvoicingItemUnitEnum;
  popularity?: InputMaybe<Scalars['Float']['input']>;
  shortName: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
};

export enum InvoicingItemUnitEnum {
  Centiliter = 'Centiliter',
  Centimeter = 'Centimeter',
  Day = 'Day',
  Foot = 'Foot',
  Gallon = 'Gallon',
  Gram = 'Gram',
  Hour = 'Hour',
  Inch = 'Inch',
  Item = 'Item',
  Kilogram = 'Kilogram',
  Kiloliter = 'Kiloliter',
  Kilometer = 'Kilometer',
  Liter = 'Liter',
  Meter = 'Meter',
  Mile = 'Mile',
  Milligram = 'Milligram',
  Milliliter = 'Milliliter',
  Millimeter = 'Millimeter',
  Minute = 'Minute',
  Month = 'Month',
  Piece = 'Piece',
  Pint = 'Pint',
  Pound = 'Pound',
  Ton = 'Ton',
  Week = 'Week',
  Yard = 'Yard',
  Year = 'Year'
}

export type InvoicingMutation = {
  __typename?: 'InvoicingMutation';
  activateSpaceInvoiceOrganization: Scalars['Boolean']['output'];
  addOrUpdateItemInDocument: InvoicingItemInDocumentEntity;
  addOrUpdateItemsInDocument: Scalars['Boolean']['output'];
  createClientAtCompany: CounterpartyEntity;
  /** @deprecated Use createClientAtCompany instead */
  createClientAtOrganization: Scalars['Boolean']['output'];
  createCopyDocumentAtOrganization: Scalars['Boolean']['output'];
  /** Create credit note for cancelled invoice */
  createCreditNote: CreditNoteDto;
  createDocumentAtOrganization: InvoicingDocumentEntity;
  createFakeInvoicingData: Scalars['Boolean']['output'];
  /** Create invoice in Merit */
  createInvoiceInMerit: Scalars['Boolean']['output'];
  /** Create invoice in Merit */
  createInvoiceInMeritByAFileId: Scalars['Boolean']['output'];
  /** Save product to be listed in invoices */
  createItemAtOrganization: InvoicingItemEntity;
  /** Create vendor in Merit for counterparty */
  createMeritVendorForCounterparty: CounterpartyEntity;
  deactivateSpaceInvoiceOrganization: Scalars['Boolean']['output'];
  deleteClientsAtOrganization: Scalars['Boolean']['output'];
  deleteDocumentsAtOrganization: Scalars['Boolean']['output'];
  deleteItemInDocument: Scalars['Boolean']['output'];
  deleteItemsAtOrganization: Scalars['Boolean']['output'];
  /** Delete invoice in Merit and unlink from a_file */
  deleteMeritInvoice: Scalars['Boolean']['output'];
  exportCatalogueCsv: Scalars['Boolean']['output'];
  /** Generate invoice PDF in Space Invoice */
  generateDocumentPdf: GeneratePdfDocumentDto;
  /** Link merit items */
  linkMeritItems: Scalars['Boolean']['output'];
  markAsPaidDocumentsAtOrganization: AccountingPeriodDto;
  /** Make a paid invoice unpaid */
  markAsUnpaidDocumentsAtOrganization: Scalars['Boolean']['output'];
  migrateOcrCounterpartiesJanuary2026: Scalars['Boolean']['output'];
  processDebitorReminders: Scalars['Boolean']['output'];
  /** Remove Merit item from counterparty */
  removeCounterpartyMeritItemId: Scalars['Boolean']['output'];
  /** Remove Merit tax from counterparty */
  removeCounterpartyMeritTaxId: Scalars['Boolean']['output'];
  sendMailToDocumentClient: Scalars['Boolean']['output'];
  setCounterpartyCategory: Scalars['Boolean']['output'];
  /** Set Merit item for counterparty */
  setCounterpartyMeritItemId: Scalars['Boolean']['output'];
  /** Set Merit tax for counterparty */
  setCounterpartyMeritTaxId: Scalars['Boolean']['output'];
  setLogoToInvoice?: Maybe<InvoicingCustomizeEntity>;
  setOverdueReminder: Scalars['Boolean']['output'];
  syncSpaceInvoiceTemplates: Scalars['Boolean']['output'];
  syncWithSpaceInvoiceByCurrentUser: Scalars['Boolean']['output'];
  test: Scalars['Boolean']['output'];
  /** Test create customer in Merit */
  testCreateMeritCustomer: Scalars['String']['output'];
  updateClientAtOrganization: Scalars['Boolean']['output'];
  updateCurrenciesList: Scalars['Boolean']['output'];
  updateDocumentAtOrganization: Scalars['Boolean']['output'];
  updateItemAtOrganization: Scalars['Boolean']['output'];
  updateOrganizationsLocale: Scalars['Boolean']['output'];
  updateOrganizationsPayments: Scalars['Boolean']['output'];
  updateOrganizationsTemplate: InvoicingCustomizeEntity;
  writeNameAndUnitInInvoiceItemRows: Scalars['Boolean']['output'];
};


export type InvoicingMutationAddOrUpdateItemInDocumentArgs = {
  itemInDoc: InvoicingItemInDocumentEntityInputType;
};


export type InvoicingMutationAddOrUpdateItemsInDocumentArgs = {
  itemsInDoc: Array<ItemsInDocumentRequestDto>;
};


export type InvoicingMutationCreateClientAtCompanyArgs = {
  client: InvoicingCreateClientDtoType;
};


export type InvoicingMutationCreateClientAtOrganizationArgs = {
  client: InvoicingCreateClientDtoType;
};


export type InvoicingMutationCreateCopyDocumentAtOrganizationArgs = {
  id: Scalars['String']['input'];
};


export type InvoicingMutationCreateCreditNoteArgs = {
  invoiceId: Scalars['String']['input'];
};


export type InvoicingMutationCreateFakeInvoicingDataArgs = {
  password: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type InvoicingMutationCreateInvoiceInMeritArgs = {
  companyId: Scalars['String']['input'];
  customVatNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  skipChecks?: InputMaybe<Scalars['Boolean']['input']>;
};


export type InvoicingMutationCreateInvoiceInMeritByAFileIdArgs = {
  aFileId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  customVatNumber?: InputMaybe<Scalars['String']['input']>;
  skipChecks?: InputMaybe<Scalars['Boolean']['input']>;
};


export type InvoicingMutationCreateItemAtOrganizationArgs = {
  item: InvoicingCreateItemDtoType;
};


export type InvoicingMutationCreateMeritVendorForCounterpartyArgs = {
  clientId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};


export type InvoicingMutationDeleteClientsAtOrganizationArgs = {
  clientIds: Array<Scalars['String']['input']>;
};


export type InvoicingMutationDeleteDocumentsAtOrganizationArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type InvoicingMutationDeleteItemInDocumentArgs = {
  id: Scalars['String']['input'];
};


export type InvoicingMutationDeleteItemsAtOrganizationArgs = {
  itemIds: Array<Scalars['String']['input']>;
};


export type InvoicingMutationDeleteMeritInvoiceArgs = {
  fileId: Scalars['String']['input'];
};


export type InvoicingMutationExportCatalogueCsvArgs = {
  tableName: Scalars['String']['input'];
};


export type InvoicingMutationGenerateDocumentPdfArgs = {
  directPaymentLinkAdded?: InputMaybe<Scalars['Boolean']['input']>;
  draft: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};


export type InvoicingMutationLinkMeritItemsArgs = {
  companyId: Scalars['String']['input'];
  meritItemsLinks: Array<MeritItemLinkInput>;
};


export type InvoicingMutationMarkAsPaidDocumentsAtOrganizationArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  paymentDate?: InputMaybe<Scalars['String']['input']>;
};


export type InvoicingMutationMarkAsUnpaidDocumentsAtOrganizationArgs = {
  id: Scalars['String']['input'];
};


export type InvoicingMutationMigrateOcrCounterpartiesJanuary2026Args = {
  password: Scalars['String']['input'];
};


export type InvoicingMutationRemoveCounterpartyMeritItemIdArgs = {
  clientId: Scalars['String']['input'];
};


export type InvoicingMutationRemoveCounterpartyMeritTaxIdArgs = {
  clientId: Scalars['String']['input'];
};


export type InvoicingMutationSendMailToDocumentClientArgs = {
  id: Scalars['String']['input'];
  type: DocumentClientEmailTypeEnum;
};


export type InvoicingMutationSetCounterpartyCategoryArgs = {
  category: CounterpartyCategoryInput;
  categoryValue: Scalars['Boolean']['input'];
  clientId: Scalars['String']['input'];
};


export type InvoicingMutationSetCounterpartyMeritItemIdArgs = {
  clientId: Scalars['String']['input'];
  meritItemId: Scalars['String']['input'];
};


export type InvoicingMutationSetCounterpartyMeritTaxIdArgs = {
  clientId: Scalars['String']['input'];
  meritTaxId: Scalars['String']['input'];
};


export type InvoicingMutationSetLogoToInvoiceArgs = {
  fileId?: InputMaybe<Scalars['String']['input']>;
  logoAdded: Scalars['Boolean']['input'];
};


export type InvoicingMutationSetOverdueReminderArgs = {
  value: Scalars['Boolean']['input'];
};


export type InvoicingMutationSyncSpaceInvoiceTemplatesArgs = {
  password: Scalars['String']['input'];
};


export type InvoicingMutationTestCreateMeritCustomerArgs = {
  counterpartyId: Scalars['String']['input'];
};


export type InvoicingMutationUpdateClientAtOrganizationArgs = {
  client: InvoicingUpdateClientDto;
  clientId: Scalars['String']['input'];
};


export type InvoicingMutationUpdateDocumentAtOrganizationArgs = {
  document: InvoicingUpdateDocumentDto;
  id: Scalars['String']['input'];
};


export type InvoicingMutationUpdateItemAtOrganizationArgs = {
  item: InvoicingCreateItemDtoType;
  itemId: Scalars['String']['input'];
};


export type InvoicingMutationUpdateOrganizationsLocaleArgs = {
  locale: Scalars['String']['input'];
};


export type InvoicingMutationUpdateOrganizationsPaymentsArgs = {
  showPaymentsModal?: InputMaybe<Scalars['Boolean']['input']>;
  userLinkAdded?: InputMaybe<Scalars['Boolean']['input']>;
};


export type InvoicingMutationUpdateOrganizationsTemplateArgs = {
  colorMain?: InputMaybe<Scalars['String']['input']>;
  pdfTemplate?: InputMaybe<Scalars['String']['input']>;
};


export type InvoicingMutationWriteNameAndUnitInInvoiceItemRowsArgs = {
  password: Scalars['String']['input'];
};

/** Company products list */
export type InvoicingQueriesListType = {
  __typename?: 'InvoicingQueriesListType';
  allCount: Scalars['Int']['output'];
  /** List */
  list?: Maybe<Array<InvoicingItemEntity>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export type InvoicingQuery = {
  __typename?: 'InvoicingQuery';
  clientsOfOrganizationList: ClientsOfOrganizationListType;
  /** Convert all invoices amounts into EUR */
  conversionInvoiceCurrencyIntoEuro?: Maybe<Scalars['Boolean']['output']>;
  counterpartyCount: Scalars['Int']['output'];
  document: InvoicingDocumentEntity;
  documentsOfOrganizationList: DocumentsOfOrganizationListType;
  /** Get invoices by company with filters, search query matching document number or counterparty */
  documentsOfOrganizationListWithFlexibleFilters: DocumentsOfOrganizationListType;
  /** Count of issued invoices for the current month */
  getCountIssuedInvoicesCurrentMonth?: Maybe<CountInvoicesCurrmonthResponseDto>;
  /** Count of issued invoices since joining Enty */
  getCountIssuedInvoicesTotal?: Maybe<CountIssuedInvoicesTotalResponseDto>;
  /** Counterparties for Merit item/tax links */
  getCounterpartiesForMeritLinks: Array<CounterpartyEntity>;
  getCounterpartyById: CounterpartyEntity;
  /** Country with tax rate */
  getCountryWithTaxRate?: Maybe<ItemCountryTaxRateDto>;
  getCurrenciesList: Array<CurrencyEntity>;
  getInvoiceItemRows: Array<RowItemDocumentResponseDto>;
  /** Get all unit item types */
  getItemUnits?: Maybe<Array<ItemUnitResponseDto>>;
  /** Merit items for company */
  getMeritItemsFromEnty: Array<MeritItemEntity>;
  /** Merit items for company with usage = 2 */
  getMeritItemsFromMeritUsageTwo: Array<MeritItemResponse>;
  /** Merit items for company from Merit api with taxes */
  getMeritItemsFromMeritWithTaxes: Array<MeritItemResponse>;
  /** Merit items links */
  getMeritItemsLinks: Array<MeritItemLink>;
  /** Merit taxes for company */
  getMeritTaxes: Array<MeritTaxResponse>;
  getOrganizationCustomize: InvoicingCustomizeEntity;
  /** All invoices by counterparty */
  invoicesListByClient?: Maybe<DocumentsByClientListType>;
  /** Invoicing report for current month */
  invoicingCurMonthReport?: Maybe<InvoicingCurMonthReportResponseDto>;
  itemsOfOrganizationList: InvoicingQueriesListType;
  lastDocument?: Maybe<InvoicingDocumentEntity>;
  /** Search invoice counterparty company */
  searchInvoicesCustomer?: Maybe<SearchInvoicesCustomerItem>;
  /** Statistics for invoicing main page */
  statisticsForMasterInvoicing?: Maybe<InvoicingstatisticsResponseDto>;
  taxByClient: TaxByClientResponseDto;
  topCounterparties: Array<CounterpartyEntity>;
};


export type InvoicingQueryClientsOfOrganizationListArgs = {
  filter?: InputMaybe<ClientsListFilterInputDto>;
  pagination: PaginationInputType;
  sort?: InputMaybe<SortInputType>;
};


export type InvoicingQueryDocumentArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type InvoicingQueryDocumentsOfOrganizationListArgs = {
  filter?: InputMaybe<DocumentsListFilterInputDto>;
  pagination: PaginationInputType;
  sort?: InputMaybe<SortInputType>;
};


export type InvoicingQueryDocumentsOfOrganizationListWithFlexibleFiltersArgs = {
  filter?: InputMaybe<DocumentsListFilterInputDto>;
  pagination: PaginationInputType;
  sort?: InputMaybe<SortInputType>;
};


export type InvoicingQueryGetCounterpartiesForMeritLinksArgs = {
  companyId: Scalars['String']['input'];
  excludeSystemCounterparties?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type InvoicingQueryGetCounterpartyByIdArgs = {
  clientId: Scalars['String']['input'];
};


export type InvoicingQueryGetInvoiceItemRowsArgs = {
  invoiceId: Scalars['String']['input'];
};


export type InvoicingQueryGetMeritItemsFromEntyArgs = {
  companyId: Scalars['String']['input'];
  type?: InputMaybe<ItemTypeEnum>;
};


export type InvoicingQueryGetMeritItemsFromMeritUsageTwoArgs = {
  companyId: Scalars['String']['input'];
};


export type InvoicingQueryGetMeritItemsFromMeritWithTaxesArgs = {
  companyId: Scalars['String']['input'];
};


export type InvoicingQueryGetMeritItemsLinksArgs = {
  companyId: Scalars['String']['input'];
};


export type InvoicingQueryGetMeritTaxesArgs = {
  companyId: Scalars['String']['input'];
};


export type InvoicingQueryInvoicesListByClientArgs = {
  filter?: InputMaybe<InvoicesListQueryFilterInputType>;
  pagination?: InputMaybe<PaginationInputType>;
  sort?: InputMaybe<SortInputType>;
};


export type InvoicingQueryItemsOfOrganizationListArgs = {
  filter?: InputMaybe<ItemsListFilterInputDto>;
  pagination: PaginationInputType;
  sort?: InputMaybe<SortInputType>;
};


export type InvoicingQuerySearchInvoicesCustomerArgs = {
  registryCode: Scalars['String']['input'];
};


export type InvoicingQueryStatisticsForMasterInvoicingArgs = {
  period?: InputMaybe<Scalars['String']['input']>;
};


export type InvoicingQueryTaxByClientArgs = {
  clientId: Scalars['String']['input'];
};

export type InvoicingRecurrentEntity = {
  __typename?: 'InvoicingRecurrentEntity';
  /** Email or list of emails to notify when recurrent invoices is generated */
  autoSendTo?: Maybe<Scalars['String']['output']>;
  company: CompanyOpeningType;
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdInvoices?: Maybe<Array<InvoicingDocumentEntity>>;
  id: Scalars['String']['output'];
  invoice: InvoicingDocumentEntity;
  invoiceId: Scalars['String']['output'];
  isProcessing: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nextDate?: Maybe<Scalars['DateTime']['output']>;
  notify: Scalars['Boolean']['output'];
  numRecurrences: Scalars['Float']['output'];
  saveAsDraft: Scalars['Boolean']['output'];
  startDate: Scalars['DateTime']['output'];
  /** Recurrent type */
  type: InvoicingRecurrentTypesEnum;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InvoicingRecurrentInputType = {
  autoSendTo?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notify: Scalars['Boolean']['input'];
  numRecurrences: Scalars['Float']['input'];
  saveAsDraft: Scalars['Boolean']['input'];
  startDate: Scalars['DateTime']['input'];
  type: InvoicingRecurrentTypesEnum;
};

export type InvoicingRecurrentType = {
  /** Email or list of emails to notify when recurrent invoices is generated */
  autoSendTo?: InputMaybe<Scalars['String']['input']>;
  company: Company;
  companyId: Scalars['String']['input'];
  createdInvoices?: InputMaybe<Array<InvoicingDocumentEntityInputType>>;
  id: Scalars['String']['input'];
  invoice: InvoicingDocumentEntityInputType;
  invoiceId: Scalars['String']['input'];
  isProcessing: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  nextDate?: InputMaybe<Scalars['DateTime']['input']>;
  notify: Scalars['Boolean']['input'];
  numRecurrences: Scalars['Float']['input'];
  saveAsDraft: Scalars['Boolean']['input'];
  startDate: Scalars['DateTime']['input'];
  /** Recurrent type */
  type: InvoicingRecurrentTypesEnum;
};

export enum InvoicingRecurrentTypesEnum {
  Monthly = 'Monthly',
  Weekly = 'Weekly',
  Yearly = 'Yearly'
}

export type InvoicingRecurrentUpdateInputType = {
  autoSendTo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notify: Scalars['Boolean']['input'];
  numRecurrences: Scalars['Float']['input'];
  saveAsDraft: Scalars['Boolean']['input'];
  startDate: Scalars['DateTime']['input'];
  type: InvoicingRecurrentTypesEnum;
};

export type InvoicingUpdateClientDto = {
  addresses?: InputMaybe<Array<CounterpartyAddressDto>>;
  birthday?: InputMaybe<Scalars['DateType']['input']>;
  companyNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<Scalars['String']['input']>;
  isClient?: InputMaybe<Scalars['Boolean']['input']>;
  isProvider?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalStatus?: InputMaybe<LegalStatusEnum>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  representativeName?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<TaxStatusEnum>;
};

export type InvoicingUpdateDocumentDto = {
  additionalComment?: InputMaybe<Scalars['String']['input']>;
  bankingAccountId?: InputMaybe<Scalars['String']['input']>;
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateDue?: InputMaybe<Scalars['DateTime']['input']>;
  datePaid?: InputMaybe<Scalars['DateTime']['input']>;
  dealId?: InputMaybe<Scalars['String']['input']>;
  directPaymentLinkAdded?: InputMaybe<Scalars['Boolean']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  numberNumber?: InputMaybe<Scalars['String']['input']>;
  numberYear?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  totalWithTax?: InputMaybe<Scalars['Float']['input']>;
};

export type InvoicingstatisticsResponseDto = {
  __typename?: 'InvoicingstatisticsResponseDto';
  /** Issued invoices count */
  countIssuedInvoices?: Maybe<Scalars['Float']['output']>;
  /** Paid invoices count */
  countPaidInvoices?: Maybe<Scalars['Float']['output']>;
  /** Revenue difference compared to previous period */
  differenceAmount?: Maybe<Scalars['Float']['output']>;
  /** Revenue difference compared to previous period, % */
  differencePercentage?: Maybe<Scalars['Float']['output']>;
  /** Total amount paid online for selected period */
  payOnline?: Maybe<Scalars['Float']['output']>;
  /** Amount of payouts (having status settled) */
  payout?: Maybe<Scalars['Float']['output']>;
  /** Proportion of paid to issued invoices */
  ratioOfInvoicesPaidToIssued?: Maybe<Scalars['Float']['output']>;
  /** Revenue */
  revenue?: Maybe<Scalars['Float']['output']>;
  /** Tax amount */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Total amount of issued unpaid invoices */
  unpaid?: Maybe<Scalars['Float']['output']>;
};

/** Issuer VAT status */
export enum IssuerVatStatusEnum {
  HasVatNumber = 'HasVatNumber',
  NoVatNumber = 'NoVatNumber'
}

export type ItemCountryTaxRateDto = {
  __typename?: 'ItemCountryTaxRateDto';
  country: Scalars['String']['output'];
  taxRate?: Maybe<Scalars['Float']['output']>;
};

/** Item type */
export enum ItemTypeEnum {
  Expenses = 'Expenses',
  Sales = 'Sales'
}

export type ItemUnitResponseDto = {
  __typename?: 'ItemUnitResponseDto';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  popularity: Scalars['Int']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
};

export type ItemsInDocumentRequestDto = {
  currency?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discountIsAmount?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  saveItem?: Scalars['Boolean']['input'];
  tax?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<InvoicingItemUnitEnum>;
  unitId?: InputMaybe<Scalars['String']['input']>;
};

export type ItemsListFilterInputDto = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type JohnPhraseEntity = {
  __typename?: 'JohnPhraseEntity';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** For night mode shown */
  isForNightMode: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type JohnQuery = {
  __typename?: 'JohnQuery';
  randomPhrases: Array<JohnPhraseEntity>;
};


export type JohnQueryRandomPhrasesArgs = {
  isNightMode: Scalars['Boolean']['input'];
};

export type KbMutation = {
  __typename?: 'KBMutation';
  /** Create article for learn_explore block */
  createOrUpdateLearnExploreArticle: LearnExplore;
  /** Delete article from admin panel */
  deleteArticle: Scalars['Boolean']['output'];
  /** Hard delete article in learn_explore block */
  deleteLearnExploreArticle: Scalars['Boolean']['output'];
  /** Mark unread articles as read */
  markAllAsSeen: Scalars['Boolean']['output'];
  /** Create article from admin panel */
  saveArticle: Scalars['Boolean']['output'];
};


export type KbMutationCreateOrUpdateLearnExploreArticleArgs = {
  article: LearnExploreInputType;
};


export type KbMutationDeleteArticleArgs = {
  id: Scalars['String']['input'];
};


export type KbMutationDeleteLearnExploreArticleArgs = {
  id: Scalars['String']['input'];
};


export type KbMutationSaveArticleArgs = {
  article: KnowledgeBaseInputType;
};

export type KbQuery = {
  __typename?: 'KBQuery';
  /** One article by id */
  article: KnowledgeBase;
  /** Get all articles */
  articles: Array<KnowledgeBase>;
  /** Get one article by id for new Knowledge Base */
  getLearnExploreArticle: LearnExplore;
  /** Get all articles for Learn & Explore */
  getLearnExploreArticles: Array<LearnExplore>;
  /** Get count of new articles for user */
  newArticlesCount: Scalars['Int']['output'];
  /** Get list of all tags */
  tags: Array<ArticleTag>;
};


export type KbQueryArticleArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type KbQueryArticlesArgs = {
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type KbQueryGetLearnExploreArticleArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Knowledge base entity id */
export type KnowledgeBase = {
  __typename?: 'KnowledgeBase';
  /** Guide action */
  action: Scalars['String']['output'];
  /** Creation date */
  createdAt: Scalars['DateTimeType']['output'];
  /** Hide in listing? */
  deleted: Scalars['Boolean']['output'];
  /** Background image url for desktop */
  desktopBackgroundId?: Maybe<Scalars['String']['output']>;
  /** Is content free? */
  free: Scalars['Boolean']['output'];
  /** Guide file url */
  guideFileId?: Maybe<Scalars['String']['output']>;
  /** Guide page url */
  guideLink: Scalars['String']['output'];
  /** Title */
  guideName: Scalars['String']['output'];
  /** id */
  id: Scalars['String']['output'];
  /** Background image url for mobile */
  mobileBackgroundId?: Maybe<Scalars['String']['output']>;
  /** Order number */
  order: Scalars['Int']['output'];
  /** Preview image url */
  previewImageId?: Maybe<Scalars['String']['output']>;
  /** Preview text */
  previewText: Scalars['String']['output'];
  /** Tags, space separated */
  tags: Scalars['String']['output'];
  /** Update date */
  updatedAt: Scalars['DateTimeType']['output'];
  /** Article author */
  userId: Scalars['String']['output'];
};

export type KnowledgeBaseInputType = {
  /** Guide action */
  action: Scalars['String']['input'];
  /** Creation date */
  createdAt: Scalars['DateTimeType']['input'];
  /** Hide in listing? */
  deleted: Scalars['Boolean']['input'];
  /** Background image url for desktop */
  desktopBackgroundId?: InputMaybe<Scalars['String']['input']>;
  /** Is content free? */
  free: Scalars['Boolean']['input'];
  /** Guide file url */
  guideFileId?: InputMaybe<Scalars['String']['input']>;
  /** Guide page url */
  guideLink: Scalars['String']['input'];
  /** Title */
  guideName: Scalars['String']['input'];
  /** id */
  id: Scalars['String']['input'];
  /** Background image url for mobile */
  mobileBackgroundId?: InputMaybe<Scalars['String']['input']>;
  /** Order number */
  order: Scalars['Int']['input'];
  /** Preview image url */
  previewImageId?: InputMaybe<Scalars['String']['input']>;
  /** Preview text */
  previewText: Scalars['String']['input'];
  /** Tags, space separated */
  tags: Scalars['String']['input'];
  /** Update date */
  updatedAt: Scalars['DateTimeType']['input'];
  /** Article author */
  userId: Scalars['String']['input'];
};

export type LabelSummary = {
  __typename?: 'LabelSummary';
  confidence?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export enum LeadStatusEnum {
  Incorporation = 'Incorporation',
  Transfer = 'Transfer'
}

export type LearnExplore = {
  __typename?: 'LearnExplore';
  /** Is active t/f */
  active: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** fileId in filestorage */
  imageFileId: Scalars['String']['output'];
  /** Article language iso */
  lang: Scalars['String']['output'];
  /** Article page url */
  link: Scalars['String']['output'];
  /** marketId/ids, comma separated */
  market: Scalars['String']['output'];
  /** Order number */
  order: Scalars['Float']['output'];
  /** Reading time, minutes */
  readingTime?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LearnExploreInputType = {
  /** Is active t/f */
  active: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  /** fileId in filestorage */
  imageFileId: Scalars['String']['input'];
  /** Article language iso */
  lang: Scalars['String']['input'];
  /** Article page url */
  link: Scalars['String']['input'];
  /** marketId/ids, comma separated */
  market: Scalars['String']['input'];
  /** Order number */
  order: Scalars['Float']['input'];
  /** Reading time, minutes */
  readingTime?: InputMaybe<Scalars['Float']['input']>;
  text: Scalars['String']['input'];
};

export enum LegalStatusEnum {
  Individual = 'Individual',
  LegalEntity = 'LegalEntity'
}

export type LogDataDto = {
  __typename?: 'LogDataDto';
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  params?: Maybe<Scalars['String']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type LogListDto = {
  __typename?: 'LogListDto';
  /** List */
  list?: Maybe<Array<LogDataDto>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export type LogMutation = {
  __typename?: 'LogMutation';
  /** Delete log with error */
  deleteErrorLog: Scalars['Boolean']['output'];
  /** Delete log with info */
  deleteInfoLog: Scalars['Boolean']['output'];
};


export type LogMutationDeleteErrorLogArgs = {
  logId: Scalars['String']['input'];
};


export type LogMutationDeleteInfoLogArgs = {
  logId: Scalars['String']['input'];
};

export type LogQuery = {
  __typename?: 'LogQuery';
  /** Get logs list with errors type */
  errorsList: LogListDto;
  /** Get logs list with info type */
  infoList: LogListDto;
};


export type LogQueryErrorsListArgs = {
  filter: LogsFilterDto;
  pagination: PaginationInputType;
};


export type LogQueryInfoListArgs = {
  filter: LogsFilterDto;
  pagination: PaginationInputType;
};

export type LogsFilterDto = {
  email?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type MailInvoiceFilterInputType = {
  /** Sort-status filter; omit (or null) to show all documents */
  status?: InputMaybe<MailInvoiceStatusEnum>;
};

/** List of documents received by mail */
export type MailInvoiceListType = {
  __typename?: 'MailInvoiceListType';
  /** List */
  list?: Maybe<Array<MailInvoiceType>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

/** Sortable columns of the mailbox list */
export enum MailInvoiceSortField {
  FileName = 'FileName',
  Received = 'Received',
  SenderEmail = 'SenderEmail'
}

export type MailInvoiceSortInput = {
  /** Column to sort by; defaults to receipt date */
  field?: InputMaybe<MailInvoiceSortField>;
  /** Sort order; defaults to descending (newest first) */
  type?: InputMaybe<SortTypeEnum>;
};

/** Filter mailbox documents by whether they are attached to a period */
export enum MailInvoiceStatusEnum {
  NotSorted = 'NotSorted',
  Sorted = 'Sorted'
}

/** Document received by mail */
export type MailInvoiceType = {
  __typename?: 'MailInvoiceType';
  /** accountingFileId — used for view / download / change period */
  fileId?: Maybe<Scalars['String']['output']>;
  /** File name */
  fileName?: Maybe<Scalars['String']['output']>;
  /** monite_invoice.id — used for delete */
  id: Scalars['String']['output'];
  /** True when the period was assigned automatically (OCR), not manually */
  isPeriodAutoAssigned: Scalars['Boolean']['output'];
  /** True when the document is sorted into a period */
  isSorted: Scalars['Boolean']['output'];
  /** Period the document is sorted into; null when not sorted */
  period?: Maybe<CompanyPeriodType>;
  /** Date the document was received */
  received: Scalars['DateTime']['output'];
  /** Sender's email */
  senderEmail?: Maybe<Scalars['String']['output']>;
};

export type ManagerActionLog = {
  __typename?: 'ManagerActionLog';
  /** Action performed by the manager */
  action: Scalars['String']['output'];
  /** When the action was performed */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  /** Manager who performed the action */
  manager?: Maybe<UserType>;
  /** ID of the manager who performed the action */
  managerUserId: Scalars['String']['output'];
  /** User affected by the action */
  user?: Maybe<UserType>;
  /** ID of the user affected by the action */
  userId: Scalars['String']['output'];
};

export type MarkNotificationsReadInput = {
  /** true - mark as read, false - mark as unread */
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID уведомлений для отметки. Если не указано, будут отмечены все уведомления компании */
  notificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Market = {
  __typename?: 'Market';
  /** Additional names for search, string separated by space + comma */
  alternativeNames?: Maybe<Scalars['String']['output']>;
  /** Currency name */
  currency: Scalars['String']['output'];
  /** Currency code 3 letters */
  currencyIso3code: Scalars['String']['output'];
  /** Currency symbol */
  currencySign: Scalars['String']['output'];
  /** Identifier */
  id: Scalars['Int']['output'];
  /** Country code 2 letters */
  iso2code: Scalars['String']['output'];
  /** Country code 3 letters */
  iso3code: Scalars['String']['output'];
  /** Regional code */
  marketLocale: Scalars['String']['output'];
  /** Name */
  name: Scalars['String']['output'];
  taxRate?: Maybe<Scalars['Float']['output']>;
};

export type MarketInputType = {
  /** Additional names for search, string separated by space + comma */
  alternativeNames?: InputMaybe<Scalars['String']['input']>;
  /** Currency name */
  currency: Scalars['String']['input'];
  /** Currency code 3 letters */
  currencyIso3code: Scalars['String']['input'];
  /** Currency symbol */
  currencySign: Scalars['String']['input'];
  /** Identifier */
  id: Scalars['Int']['input'];
  /** Country code 2 letters */
  iso2code: Scalars['String']['input'];
  /** Country code 3 letters */
  iso3code: Scalars['String']['input'];
  /** Regional code */
  marketLocale: Scalars['String']['input'];
  /** Name */
  name: Scalars['String']['input'];
  taxRate?: InputMaybe<Scalars['Float']['input']>;
};

export type MemberComplianceDto = {
  __typename?: 'MemberComplianceDto';
  /** List */
  list?: Maybe<Array<MemberComplianceItem>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export type MemberComplianceFilterInput = {
  sumSubStep?: InputMaybe<CompanyMemberSumSubStepEnum>;
};

export type MemberComplianceItem = {
  __typename?: 'MemberComplianceItem';
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  isTransferred?: Maybe<Scalars['Boolean']['output']>;
  memberCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  memberEmail?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  memberLegalType?: Maybe<Scalars['String']['output']>;
  memberLevelName?: Maybe<Scalars['String']['output']>;
  memberName?: Maybe<Scalars['String']['output']>;
  memberRiskLabels?: Maybe<Scalars['String']['output']>;
  memberRole?: Maybe<Scalars['String']['output']>;
  memberSumSubResult?: Maybe<Scalars['String']['output']>;
  memberSumSubStep?: Maybe<CompanyMemberSumSubStepEnum>;
  processStep?: Maybe<Scalars['String']['output']>;
  sumSubApplicantLink?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** Merit account response */
export type MeritAccountDto = {
  __typename?: 'MeritAccountDto';
  /** Merit account ID */
  AccountID?: Maybe<Scalars['String']['output']>;
  /** Cashflow name */
  CashflowName?: Maybe<Scalars['String']['output']>;
  /** Cashflow name in English */
  CashflowNameEN?: Maybe<Scalars['String']['output']>;
  /** Account code */
  Code?: Maybe<Scalars['String']['output']>;
  /** Account type from Merit: "Koondkonto" (parent/summary) or "Detailne" (detail/leaf) */
  IsParent?: Maybe<Scalars['String']['output']>;
  /** Linked vendor name */
  LinkedVendorName?: Maybe<Scalars['String']['output']>;
  /** Account name */
  Name?: Maybe<Scalars['String']['output']>;
  /** Account name in English */
  NameEN?: Maybe<Scalars['String']['output']>;
  /** Account name in Russian */
  NameRU?: Maybe<Scalars['String']['output']>;
  /** Is account active flag */
  NoActive?: Maybe<Scalars['Float']['output']>;
  /** Report descriptor name */
  ReportdescName?: Maybe<Scalars['String']['output']>;
  /** Report descriptor name in English */
  ReportdescNameEN?: Maybe<Scalars['String']['output']>;
  /** Tax name */
  TaxName?: Maybe<Scalars['String']['output']>;
  /** Tax name in English */
  TaxNameEN?: Maybe<Scalars['String']['output']>;
  /** Tax name in Russian */
  TaxNameRU?: Maybe<Scalars['String']['output']>;
};

export type MeritBankAccountDto = {
  __typename?: 'MeritBankAccountDto';
  bankingAccount?: Maybe<BankingAccountInfoDto>;
  bankingAccountId?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  isIntermediary: Scalars['Boolean']['output'];
  meritBankAccountId: Scalars['String']['output'];
  meritBankId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MeritEcomShopDto = {
  __typename?: 'MeritEcomShopDto';
  accountCode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  ecomShopAccess?: Maybe<EcomShopAccessInfoDto>;
  ecomShopsAccessId?: Maybe<Scalars['String']['output']>;
  meritBankId: Scalars['String']['output'];
  meritEcomShopId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  platformCandidateIds: Array<Scalars['String']['output']>;
  suggestedEcomShopsAccessId?: Maybe<Scalars['String']['output']>;
};

/** Result of invoice shipment to Merit */
export enum MeritInvoiceShipmentResult {
  Error = 'ERROR',
  NotSent = 'NOT_SENT',
  Ok = 'OK'
}

export type MeritItemEntity = {
  __typename?: 'MeritItemEntity';
  combinationId: Scalars['Float']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerOrigin: CustomerOriginEnum;
  id: Scalars['String']['output'];
  issuerVatStatus: IssuerVatStatusEnum;
  meritItemCode?: Maybe<Scalars['String']['output']>;
  meritTaxId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productType: ProductTypeEnum;
  taxPct?: Maybe<Scalars['Float']['output']>;
  type: ItemTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
  vatStatus: VatStatusEnum;
};

export type MeritItemEntityInputType = {
  combinationId: Scalars['Float']['input'];
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  customerOrigin: CustomerOriginEnum;
  id: Scalars['String']['input'];
  issuerVatStatus: IssuerVatStatusEnum;
  meritItemCode?: InputMaybe<Scalars['String']['input']>;
  meritTaxId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productType: ProductTypeEnum;
  taxPct?: InputMaybe<Scalars['Float']['input']>;
  type: ItemTypeEnum;
  updatedAt: Scalars['DateTime']['input'];
  vatStatus: VatStatusEnum;
};

export type MeritItemLink = {
  __typename?: 'MeritItemLink';
  /** Merit item ID from Merit */
  itemCodeFromMerit?: Maybe<Scalars['String']['output']>;
  /** Merit item ID from Enty */
  itemIdFromEnty: Scalars['String']['output'];
  /** Merit item tax ID */
  meritTaxId?: Maybe<Scalars['String']['output']>;
  /** Merit item tax percentage */
  meritTaxPct?: Maybe<Scalars['Float']['output']>;
};

export type MeritItemLinkInput = {
  /** Merit item ID from Merit */
  itemCodeFromMerit?: InputMaybe<Scalars['String']['input']>;
  /** Merit item ID from Enty */
  itemIdFromEnty: Scalars['String']['input'];
  /** Merit item tax ID */
  meritTaxId?: InputMaybe<Scalars['String']['input']>;
  /** Merit item tax percentage */
  meritTaxPct?: InputMaybe<Scalars['Float']['input']>;
};

/** Merit item response */
export type MeritItemResponse = {
  __typename?: 'MeritItemResponse';
  /** Merit item code */
  Code: Scalars['String']['output'];
  /** Merit item default location name */
  DefLoc_Name?: Maybe<Scalars['String']['output']>;
  /** Merit item discount percentage */
  DiscountPct?: Maybe<Scalars['Float']['output']>;
  /** Merit item EAN code */
  EANCode?: Maybe<Scalars['String']['output']>;
  /** Merit item GTU codes */
  GTUCodes?: Maybe<Scalars['String']['output']>;
  /** Merit item inventory account code */
  InventoryAccountCode?: Maybe<Scalars['String']['output']>;
  /** Merit item inventory cost */
  InventoryCost?: Maybe<Scalars['Float']['output']>;
  /** Merit item inventory quantity */
  InventoryQty?: Maybe<Scalars['Float']['output']>;
  /** Merit item item cost account code */
  ItemCostAccountCode?: Maybe<Scalars['String']['output']>;
  /** Merit item item group name */
  ItemGroupName?: Maybe<Scalars['String']['output']>;
  /** Merit item ID */
  ItemId: Scalars['String']['output'];
  /** Merit item item unit cost */
  ItemUnitCost?: Maybe<Scalars['Float']['output']>;
  /** Merit item last purchase price */
  LastPurchasePrice?: Maybe<Scalars['Float']['output']>;
  /** Merit item tax ID */
  MeritTaxId?: Maybe<Scalars['String']['output']>;
  /** Merit item tax name */
  MeritTaxName?: Maybe<Scalars['String']['output']>;
  /** Merit item tax percentage */
  MeritTaxPct?: Maybe<Scalars['Float']['output']>;
  /** Merit item name */
  Name: Scalars['String']['output'];
  /** Merit item name in English */
  NameEN?: Maybe<Scalars['String']['output']>;
  /** Merit item name in Finnish */
  NameFI?: Maybe<Scalars['String']['output']>;
  /** Merit item name in Russian */
  NameRU?: Maybe<Scalars['String']['output']>;
  /** Merit item purchase account code */
  PurchaseAccountCode?: Maybe<Scalars['String']['output']>;
  /** Merit item reserved quantity */
  ReservedQty?: Maybe<Scalars['Float']['output']>;
  /** Merit item sales account code */
  SalesAccountCode?: Maybe<Scalars['String']['output']>;
  /** Merit item sales price */
  SalesPrice?: Maybe<Scalars['Float']['output']>;
  /** Merit item type */
  Type?: Maybe<Scalars['String']['output']>;
  /** Merit item type 0 */
  Type0?: Maybe<Scalars['Float']['output']>;
  /** Merit item unit of measure name */
  UnitofMeasureName?: Maybe<Scalars['String']['output']>;
  /** Merit item usage */
  Usage?: Maybe<Scalars['String']['output']>;
  /** Merit item usage 0 */
  Usage0?: Maybe<Scalars['Float']['output']>;
  /** Merit item VAT tax name */
  VatTaxName?: Maybe<Scalars['String']['output']>;
};

/** Merit tax response */
export type MeritTaxResponse = {
  __typename?: 'MeritTaxResponse';
  /** Merit tax code */
  Code: Scalars['String']['output'];
  /** Merit tax ID */
  Id: Scalars['String']['output'];
  /** Merit tax name */
  Name: Scalars['String']['output'];
  /** Merit tax percentage */
  TaxPct: Scalars['Float']['output'];
};

export type MessageDto = {
  __typename?: 'MessageDto';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  messageText?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<MessagePayloadDto>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  taskId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userSender: MessageSender;
  userSenderId: Scalars['String']['output'];
};

export type MessagePayloadDto = {
  __typename?: 'MessagePayloadDto';
  files?: Maybe<Array<FileDto>>;
  periods?: Maybe<Array<AccountingReportType>>;
  transactions?: Maybe<Array<BankingTransactionEntity>>;
};

export type MessageSender = {
  __typename?: 'MessageSender';
  avatarFileId?: Maybe<Scalars['String']['output']>;
  currentLanguage: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isCompany: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
  surname: Scalars['String']['output'];
};

/** Second-factor method */
export enum MfaMethod {
  Totp = 'Totp'
}

export type MfaRecoveryCodesPayload = {
  __typename?: 'MfaRecoveryCodesPayload';
  /** The fresh set of single-use recovery codes; every earlier code is now void */
  recoveryCodes: Array<Scalars['String']['output']>;
};

export type MfaSetupConfirmPayload = {
  __typename?: 'MfaSetupConfirmPayload';
  /** Whether a confirmed second factor is enforced at login */
  enabled: Scalars['Boolean']['output'];
  /** Confirmed methods */
  methods: Array<MfaMethod>;
  /** Single-use recovery codes, shown exactly once */
  recoveryCodes: Array<Scalars['String']['output']>;
  /** Unspent recovery codes; null while 2FA is off */
  recoveryCodesLeft?: Maybe<Scalars['Int']['output']>;
};

export type MfaSetupPayload = {
  __typename?: 'MfaSetupPayload';
  /** otpauth:// URI to render as a QR code */
  otpauthUrl: Scalars['String']['output'];
  /** Base32 TOTP secret, for manual entry into the app */
  secret: Scalars['String']['output'];
};

export type MfaStatusPayload = {
  __typename?: 'MfaStatusPayload';
  /** Whether a confirmed second factor is enforced at login */
  enabled: Scalars['Boolean']['output'];
  /** Confirmed methods */
  methods: Array<MfaMethod>;
  /** Unspent recovery codes; null while 2FA is off */
  recoveryCodesLeft?: Maybe<Scalars['Int']['output']>;
};

/** Module onboarding statuses */
export enum ModuleOnboardingStatus {
  Completed = 'Completed',
  Default = 'Default',
  InProgress = 'InProgress'
}

/** Types of Monite currencies */
export enum MoniteCurrencyTypeEnum {
  Aud = 'AUD',
  Brl = 'BRL',
  Cad = 'CAD',
  Chf = 'CHF',
  Cny = 'CNY',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Inr = 'INR',
  Jpy = 'JPY',
  Krw = 'KRW',
  Mxn = 'MXN',
  Nok = 'NOK',
  Nzd = 'NZD',
  Rub = 'RUB',
  Sek = 'SEK',
  Sgd = 'SGD',
  Try = 'TRY',
  Usd = 'USD',
  Zar = 'ZAR'
}

export type MoniteEntity = {
  __typename?: 'MoniteEntity';
  company?: Maybe<CompanyOpeningType>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  moniteEntityId: Scalars['String']['output'];
  moniteUsers?: Maybe<Array<MoniteUserEntity>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UserType>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MoniteInvoiceEntity = {
  __typename?: 'MoniteInvoiceEntity';
  accountingFile?: Maybe<AccountingFileType>;
  accountingFileId?: Maybe<Scalars['String']['output']>;
  aiComplianceReason?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  complianceRank?: Maybe<Scalars['String']['output']>;
  counterpartAddress?: Maybe<Scalars['String']['output']>;
  counterpartAddressCity?: Maybe<Scalars['String']['output']>;
  counterpartCountry?: Maybe<Scalars['String']['output']>;
  counterpartCountryCode?: Maybe<Scalars['String']['output']>;
  counterpartVatNumber?: Maybe<Scalars['String']['output']>;
  counterpart_name?: Maybe<Scalars['String']['output']>;
  counterpartyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  currency_exchange?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  extractedCounterpartAccount?: Maybe<Scalars['String']['output']>;
  file?: Maybe<FileData>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  issued_at?: Maybe<Scalars['DateTime']['output']>;
  issuerAddress?: Maybe<Scalars['String']['output']>;
  issuerAddressCity?: Maybe<Scalars['String']['output']>;
  issuerCountry?: Maybe<Scalars['String']['output']>;
  issuerCountryCode?: Maybe<Scalars['String']['output']>;
  issuerName?: Maybe<Scalars['String']['output']>;
  issuerVatNumber?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['JSON']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  other_extracted_data?: Maybe<OtherExtractedData>;
  payable_origin?: Maybe<Scalars['String']['output']>;
  payment_details?: Maybe<Scalars['JSON']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['String']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  total_amount_eur?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vatNumberValidDate?: Maybe<Scalars['DateTime']['output']>;
};

/** List of incoming invoices */
export type MoniteInvoiceEntityListType = {
  __typename?: 'MoniteInvoiceEntityListType';
  /** List */
  data?: Maybe<Array<MoniteInvoiceEntity>>;
  next_pagination_token?: Maybe<Scalars['Int']['output']>;
  prev_pagination_token?: Maybe<Scalars['Int']['output']>;
};

export type MoniteMailInvoice = {
  __typename?: 'MoniteMailInvoice';
  action?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  entity?: Maybe<MoniteEntity>;
  entityId?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  object_id?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** List of documents */
export type MoniteMailInvoiceListType = {
  __typename?: 'MoniteMailInvoiceListType';
  /** List */
  list?: Maybe<Array<MoniteMailInvoice>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export type MoniteMailObjectType = {
  __typename?: 'MoniteMailObjectType';
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entity?: Maybe<MoniteEntity>;
  entityId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mailId?: Maybe<Scalars['String']['output']>;
  mailbox_domain_id?: Maybe<Scalars['String']['output']>;
  mailbox_full_address?: Maybe<Scalars['String']['output']>;
  mailbox_name?: Maybe<Scalars['String']['output']>;
  /** Total file count from email that could not be assigned to a period */
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MonitePaymentLinkEntity = {
  __typename?: 'MonitePaymentLinkEntity';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  document?: Maybe<InvoicingDocumentEntity>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoicingDocumentId?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  paymentIntentStatus?: Maybe<Scalars['String']['output']>;
  paymentLinkId?: Maybe<Scalars['String']['output']>;
  paymentLinkStatus?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  urlEnty?: Maybe<Scalars['String']['output']>;
  urlMonite?: Maybe<Scalars['String']['output']>;
};

export type MonitePaymentLinkEntityInputType = {
  document?: InputMaybe<InvoicingDocumentEntityInputType>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  invoicingDocumentId?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentIntentStatus?: InputMaybe<Scalars['String']['input']>;
  paymentLinkId?: InputMaybe<Scalars['String']['input']>;
  paymentLinkStatus?: InputMaybe<Scalars['String']['input']>;
  urlEnty?: InputMaybe<Scalars['String']['input']>;
  urlMonite?: InputMaybe<Scalars['String']['input']>;
};

export type MoniteUserEntity = {
  __typename?: 'MoniteUserEntity';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entity?: Maybe<MoniteEntity>;
  entityId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  moniteUserId?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MoniteWebComponentConfigsDto = {
  __typename?: 'MoniteWebComponentConfigsDto';
  entityId: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type MsgNotifPayloadDto = {
  __typename?: 'MsgNotifPayloadDto';
  chatId: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  msgId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  accounting: AccountingMutation;
  admin: AdminMutation;
  amplitude: AmplitudeMutation;
  /** Starts the approval process once the uploaded payable is validated */
  approve: MoniteInvoiceEntity;
  /** Generate an archive and get a link to it */
  archive: Scalars['String']['output'];
  banking: BankingMutation;
  bankingCategorization: BankingCategorizationMutation;
  /** Cancel draft. Kind of delete */
  cancelDraft: MoniteInvoiceEntity;
  changeTaskStatus?: Maybe<Scalars['Boolean']['output']>;
  chargebee: ChargebeeMutation;
  cm: CmMuation;
  comingServices: ComingServicesMutation;
  /** Create a payment link release notification. */
  createAPaymentLinkReleaseNotification: Scalars['Boolean']['output'];
  /** Save answers for DocAi and generate doc */
  createCmDocFromAi: DocAi;
  /** Create DocAi with prompt */
  createDocAiWithPrompt: DocAi;
  createInvoiceRecurrent: InvoicingRecurrentEntity;
  /** Creating a link for onboarding */
  createStripeOnboardingLink: Scalars['String']['output'];
  createTask?: Maybe<Scalars['String']['output']>;
  csService: CsServiceMutation;
  deals: DealsMutation;
  /** Deleting a file that came from the mail */
  deleteDocument: Scalars['Boolean']['output'];
  deleteInvoiceRecurrent: Scalars['Boolean']['output'];
  /** AL-2737: soft-delete a mailbox document (removes only the monite_invoice row) */
  deleteMailInvoice: Scalars['Boolean']['output'];
  deleteMessage?: Maybe<Scalars['Boolean']['output']>;
  deleteTask?: Maybe<Scalars['Boolean']['output']>;
  docs: DocsMutation;
  email: EmailMutation;
  freshworks: FreshworksMutation;
  /** Generate recurrent invoices that are due */
  generateRecurrentInvoices: Scalars['Int']['output'];
  /** Create or receive mail address */
  getOrCreateMail: MoniteMailObjectType;
  hr: HrMutation;
  incorporation: CompanyMutation;
  /** Init monite setting. */
  initSettings: Scalars['Boolean']['output'];
  invoicing: InvoicingMutation;
  kb: KbMutation;
  log: LogMutation;
  /** Mark as paid */
  markAsPay: MoniteInvoiceEntity;
  notif: NotificationsMutation;
  notifications: NotificationsMutation2;
  oauth: OAuthMutation;
  /** Prepare file for esign signature */
  prepareFilesForSigning?: Maybe<EsignDocsEntity>;
  /** Prepare file for signature by the second signer, available only to admins */
  prepareSignForSecondSigned: Scalars['Boolean']['output'];
  /** Prepare file for signature by the second signer */
  prepareSignForSecondSignedAndAddSigner: Scalars['Boolean']['output'];
  /** Save answers for DocAi and generate doc */
  processDocAiAnswers: DocAi;
  readMessages?: Maybe<Scalars['Boolean']['output']>;
  search: SearchMutation;
  sendMessage?: Maybe<Scalars['Boolean']['output']>;
  /** AL-2737: assign or change the period of a mailbox document */
  setMailInvoicePeriod: Scalars['Boolean']['output'];
  settings: SettingsMutation;
  stopInvoiceRecurrent: Scalars['Boolean']['output'];
  sumsub: SumsubMutation;
  /** Send for payment */
  toPay: MoniteInvoiceEntity;
  transactionRules: TransactionRulesMutation;
  /** Make adjustments to the draft */
  updateDraft: MoniteInvoiceEntity;
  updateInvoiceRecurrent: InvoicingRecurrentEntity;
  updateMessage?: Maybe<Scalars['Boolean']['output']>;
  updateOnboardingStatus: Scalars['Boolean']['output'];
  updateTask?: Maybe<Scalars['Boolean']['output']>;
  user: UserMutation;
  /** Verification of a document received from the mail */
  verifyDocument: Scalars['Boolean']['output'];
};


export type MutationApproveArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveArgs = {
  fileIds: Array<Scalars['String']['input']>;
};


export type MutationCancelDraftArgs = {
  id: Scalars['String']['input'];
};


export type MutationChangeTaskStatusArgs = {
  status: ChatStatusEnum;
  taskId: Scalars['String']['input'];
};


export type MutationCreateAPaymentLinkReleaseNotificationArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCmDocFromAiArgs = {
  id: Scalars['String']['input'];
};


export type MutationCreateDocAiWithPromptArgs = {
  customPrompts?: InputMaybe<CustomPromptsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
};


export type MutationCreateInvoiceRecurrentArgs = {
  input: InvoicingRecurrentInputType;
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInputDto;
};


export type MutationDeleteDocumentArgs = {
  object_id: Scalars['String']['input'];
};


export type MutationDeleteInvoiceRecurrentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMailInvoiceArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMessageArgs = {
  chatId: Scalars['String']['input'];
  msgId: Scalars['String']['input'];
};


export type MutationDeleteTaskArgs = {
  taskId: Scalars['String']['input'];
};


export type MutationMarkAsPayArgs = {
  id: Scalars['String']['input'];
};


export type MutationPrepareFilesForSigningArgs = {
  id: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
};


export type MutationPrepareSignForSecondSignedArgs = {
  esignDocid: Scalars['String']['input'];
};


export type MutationPrepareSignForSecondSignedAndAddSignerArgs = {
  esignDocId: Scalars['String']['input'];
  signerId: Scalars['String']['input'];
};


export type MutationProcessDocAiAnswersArgs = {
  input: DocAiAnswersInput;
};


export type MutationReadMessagesArgs = {
  chatId: Scalars['String']['input'];
  msgIds: Array<Scalars['String']['input']>;
};


export type MutationSendMessageArgs = {
  chatId: Scalars['String']['input'];
  msg: CreateMessageInputDto;
};


export type MutationSetMailInvoicePeriodArgs = {
  fileId: Scalars['String']['input'];
  periodFolderId: Scalars['String']['input'];
};


export type MutationStopInvoiceRecurrentArgs = {
  id: Scalars['String']['input'];
};


export type MutationToPayArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateDraftArgs = {
  details: UpdateMonitePayableInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateInvoiceRecurrentArgs = {
  id: Scalars['String']['input'];
  input: InvoicingRecurrentUpdateInputType;
};


export type MutationUpdateMessageArgs = {
  chatId: Scalars['String']['input'];
  msg: CreateMessageInputDto;
  msgId: Scalars['String']['input'];
};


export type MutationUpdateOnboardingStatusArgs = {
  isCompleted: Scalars['Boolean']['input'];
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationVerifyDocumentArgs = {
  object_id: Scalars['String']['input'];
  period: AccountingPeriod;
};

export type Notification = {
  __typename?: 'Notification';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  code?: Maybe<NotificationCode>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  link1?: Maybe<Scalars['String']['output']>;
  link1Text?: Maybe<Scalars['String']['output']>;
  link2?: Maybe<Scalars['String']['output']>;
  link2Text?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  priority: NotificationPriority;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /** Start date for showing */
  showFrom: Scalars['DateTime']['output'];
  source?: Maybe<Scalars['String']['output']>;
  template?: Maybe<NotificationTemplate>;
  templateId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
  withToast?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationByAdminInputType = {
  /** First link */
  link1?: InputMaybe<Scalars['String']['input']>;
  /** First link button text */
  link1Text?: InputMaybe<Scalars['String']['input']>;
  /** Second link */
  link2?: InputMaybe<Scalars['String']['input']>;
  /** Second link button text */
  link2Text?: InputMaybe<Scalars['String']['input']>;
  /** Notification message */
  message: Scalars['String']['input'];
  /** Send to all users */
  sendAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notification title */
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
  /** List of user IDs separated by comma and space */
  userIds: Scalars['String']['input'];
};

/** Available notification codes */
export enum NotificationCode {
  AccountingAcc_1 = 'ACCOUNTING_ACC_1',
  AccountingAcc_2 = 'ACCOUNTING_ACC_2',
  AccountingDeniedDocuments = 'ACCOUNTING_DENIED_DOCUMENTS',
  AccountingExtraDocs = 'ACCOUNTING_EXTRA_DOCS',
  AccountingMissingDocuments = 'ACCOUNTING_MISSING_DOCUMENTS',
  AccountingNewMassageInQuestions = 'ACCOUNTING_NEW_MASSAGE_IN_QUESTIONS',
  AccountingNoDocuments = 'ACCOUNTING_NO_DOCUMENTS',
  AccountingOnboardingNeedsAttention = 'ACCOUNTING_ONBOARDING_NEEDS_ATTENTION',
  AccountingOnboardingNotStarted = 'ACCOUNTING_ONBOARDING_NOT_STARTED',
  AccountingTsdPayment = 'ACCOUNTING_TSD_PAYMENT',
  AccountingVat = 'ACCOUNTING_VAT',
  AccountingVatPayment = 'ACCOUNTING_VAT_PAYMENT',
  AccountingVatUpgrade = 'ACCOUNTING_VAT_UPGRADE',
  BankingAlertBankingAlert_1 = 'BANKING_ALERT_BANKING_ALERT_1',
  BankingBankEx = 'BANKING_BANK_EX',
  CmCm_1 = 'CM_CM_1',
  CmCm_2 = 'CM_CM_2',
  CmEsignCm = 'CM_ESIGN_CM',
  CompanyInc_1 = 'COMPANY_INC_1',
  CompanyInc_2 = 'COMPANY_INC_2',
  CompanyInc_3 = 'COMPANY_INC_3',
  CompanyOne = 'COMPANY_ONE',
  HrEsignHr = 'HR_ESIGN_HR',
  HrPayroll_1 = 'HR_PAYROLL_1',
  HrPayroll_3 = 'HR_PAYROLL_3',
  InvoicingDocsNeeded = 'INVOICING_DOCS_NEEDED',
  InvoicingPl_1 = 'INVOICING_PL_1',
  InvoicingPl_3 = 'INVOICING_PL_3',
  InvoicingPl_4 = 'INVOICING_PL_4',
  InvoicingPl_5 = 'INVOICING_PL_5',
  TestNotification = 'TEST_NOTIFICATION'
}

export type NotificationListDto = {
  __typename?: 'NotificationListDto';
  /** List */
  list?: Maybe<Array<Notification>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

/** Notification priority */
export enum NotificationPriority {
  High = 'HIGH',
  Info = 'INFO',
  Urgent = 'URGENT'
}

export type NotificationTemplate = {
  __typename?: 'NotificationTemplate';
  code?: Maybe<NotificationCode>;
  id: Scalars['String']['output'];
  link1?: Maybe<Scalars['String']['output']>;
  link1Text?: Maybe<Scalars['String']['output']>;
  link2?: Maybe<Scalars['String']['output']>;
  link2Text?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  priority: NotificationPriority;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  withToast: Scalars['Boolean']['output'];
};

export type NotificationsMutation = {
  __typename?: 'NotificationsMutation';
  /** Change WhatsApp notification mode (on/off) */
  changeWhatsapMode: Scalars['Boolean']['output'];
  /** Verify otp and connect or update a WhatsApp phone number for the company */
  connectPhoneNumber: UserWhatsappNumbers;
  /** Connect or update a WhatsApp phone number attempt */
  connectPhoneNumberAttempt: Scalars['Boolean']['output'];
  /** Create notification using template */
  create: Notification;
  /** Create notifications for users by ids from admin panel */
  createNotificationsByAdmin: Scalars['Boolean']['output'];
  /** Delete notification */
  delete: Notification;
  /** Delete connected WhatsApp phone number */
  deletePhoneNumber: Scalars['Boolean']['output'];
  /** Mark as read */
  markAsRead: Scalars['Boolean']['output'];
  sendTestNotification: Scalars['Boolean']['output'];
};


export type NotificationsMutationChangeWhatsapModeArgs = {
  value: Scalars['Boolean']['input'];
};


export type NotificationsMutationConnectPhoneNumberArgs = {
  otpCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  phoneNumberId?: InputMaybe<Scalars['String']['input']>;
};


export type NotificationsMutationConnectPhoneNumberAttemptArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type NotificationsMutationCreateArgs = {
  templateId: TemplatesEnum;
};


export type NotificationsMutationCreateNotificationsByAdminArgs = {
  notificationData: NotificationByAdminInputType;
};


export type NotificationsMutationDeleteArgs = {
  id: Scalars['String']['input'];
};


export type NotificationsMutationDeletePhoneNumberArgs = {
  phoneNumberId: Scalars['String']['input'];
};


export type NotificationsMutationMarkAsReadArgs = {
  id: Scalars['String']['input'];
};


export type NotificationsMutationSendTestNotificationArgs = {
  input: SendTestNotificationInput;
};

export type NotificationsMutation2 = {
  __typename?: 'NotificationsMutation2';
  /** Archive/unarchive notifications. Returns count of updated records */
  archiveToastNotifications: Scalars['Int']['output'];
  /** Mark notifications as closed (dismissed by the user). Returns count of updated records */
  closeToastNotifications: Scalars['Int']['output'];
  /** Mark notifications as read/unread. Returns count of updated records */
  markToastNotificationsRead: Scalars['Int']['output'];
};


export type NotificationsMutation2ArchiveToastNotificationsArgs = {
  input: ArchiveNotificationsInput;
};


export type NotificationsMutation2CloseToastNotificationsArgs = {
  input: CloseNotificationsInput;
};


export type NotificationsMutation2MarkToastNotificationsReadArgs = {
  input: MarkNotificationsReadInput;
};

export type NotificationsQuery = {
  __typename?: 'NotificationsQuery';
  /** Get list of all notifications sent from admin panel */
  allNofitByAdmin: NotificationListDto;
  /** Get list of all notifications sent to user */
  list: Array<Notification>;
  /** Unread notifications count */
  unreadCount: Scalars['Int']['output'];
};


export type NotificationsQueryAllNofitByAdminArgs = {
  pagination?: InputMaybe<PaginationInputType>;
};


export type NotificationsQueryListArgs = {
  onlyUnread?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationsQuery2 = {
  __typename?: 'NotificationsQuery2';
  /** Get all notification settings for the company */
  getNotificationSettings: CompanyNotificationsSettingsType;
  toastNotifications: ToastNotificationsListResponse;
  toastNotificationsCount: ToastNotificationsCountResponse;
};


export type NotificationsQuery2ToastNotificationsArgs = {
  input: ToastNotificationsListInput;
};

export type OAuthAuthorizationRequestPayload = {
  __typename?: 'OAuthAuthorizationRequestPayload';
  clientName: Scalars['String']['output'];
  clientUri?: Maybe<Scalars['String']['output']>;
  /** Companies the user may grant access to */
  companies: Array<OAuthConsentCompany>;
  expiresAt: Scalars['DateTime']['output'];
  logoUri?: Maybe<Scalars['String']['output']>;
  /** Host the browser returns to after the decision */
  redirectHost: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
  scopes: Array<Scalars['String']['output']>;
};

export type OAuthConsentCompany = {
  __typename?: 'OAuthConsentCompany';
  /** The access the token will inherit: reader or editor */
  access: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OAuthDecisionPayload = {
  __typename?: 'OAuthDecisionPayload';
  /** Where the consent page must send the browser */
  redirectUrl: Scalars['String']['output'];
};

export type OAuthMutation = {
  __typename?: 'OAuthMutation';
  /** Grant the application access to one company of the user */
  approveAuthorization: OAuthDecisionPayload;
  /** Refuse the application */
  denyAuthorization: OAuthDecisionPayload;
};


export type OAuthMutationApproveAuthorizationArgs = {
  companyId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};


export type OAuthMutationDenyAuthorizationArgs = {
  requestId: Scalars['String']['input'];
};

export type OAuthQuery = {
  __typename?: 'OAuthQuery';
  /** What an application asks for, for the consent page */
  authorizationRequest: OAuthAuthorizationRequestPayload;
};


export type OAuthQueryAuthorizationRequestArgs = {
  requestId: Scalars['String']['input'];
};

export type OnboardingResponseDto = {
  __typename?: 'OnboardingResponseDto';
  completedOnboarding: Scalars['Boolean']['output'];
  services: OnboardingStatusDto;
};

export type OnboardingStatusDto = {
  __typename?: 'OnboardingStatusDto';
  accounting: ModuleOnboardingStatus;
  banking: ModuleOnboardingStatus;
  cm: ModuleOnboardingStatus;
};

export type OtherExtractedData = {
  __typename?: 'OtherExtractedData';
  /** Summary */
  summary?: Maybe<Array<Summary>>;
};

export type PaginatedGetTransactionsListDto = {
  __typename?: 'PaginatedGetTransactionsListDto';
  /** List */
  list?: Maybe<Array<BankingTransactionEntity>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

/** Rules of pagination */
export type PaginationInputType = {
  /** Number of items to select from the list */
  limit: Scalars['Int']['input'];
  /** Number of items to skip from the start of the list */
  offset: Scalars['Int']['input'];
};

/** Pagination data */
export type PaginationResponse = {
  __typename?: 'PaginationResponse';
  /** Current limit */
  limit: Scalars['Int']['output'];
  /** Current offset */
  offset: Scalars['Int']['output'];
  /** Total count */
  total: Scalars['Int']['output'];
};

/** List pagination data */
export type PaginationType = {
  __typename?: 'PaginationType';
  /** Total items count */
  total: Scalars['Int']['output'];
};

export type Payment = {
  /** Amount in euro cents */
  amount: Scalars['Int']['input'];
  /** Company ID */
  companyId: Scalars['UuidType']['input'];
  /** Creation date */
  createdAt: Scalars['DateTimeType']['input'];
  /** ID */
  id: Scalars['String']['input'];
  /** Payment service name */
  service: Scalars['String']['input'];
  /** ayment service name */
  serviceId: Scalars['String']['input'];
  /** Payment status */
  status: Scalars['String']['input'];
};

export type PaymentInfo = {
  /** Creation date */
  nextBillingDate: Scalars['DateTimeType']['input'];
  /** Subscription name */
  planName: Scalars['String']['input'];
};

/** Payment summary */
export type PaymentInfoType = {
  __typename?: 'PaymentInfoType';
  /** Creation date */
  nextBillingDate: Scalars['DateTimeType']['output'];
  /** Subscription name */
  planName: Scalars['String']['output'];
};

/** Company payments history */
export type PaymentListType = {
  __typename?: 'PaymentListType';
  /** List */
  list?: Maybe<Array<PaymentType>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export type PaymentType = {
  __typename?: 'PaymentType';
  /** Amount in euro cents */
  amount: Scalars['Int']['output'];
  /** Company ID */
  companyId: Scalars['UuidType']['output'];
  /** Creation date */
  createdAt: Scalars['DateTimeType']['output'];
  /** ID */
  id: Scalars['String']['output'];
  /** Information about incorporation payment */
  info: PaymentInfoType;
  /** Payment service name */
  service: Scalars['String']['output'];
  /** ayment service name */
  serviceId: Scalars['String']['output'];
  /** Payment status */
  status: Scalars['String']['output'];
};

/** Payment links status changed */
export type PaymentsConnectionStatusChangedEventType = {
  __typename?: 'PaymentsConnectionStatusChangedEventType';
  companyId: Scalars['String']['output'];
  paymentsConnectionStatus: Scalars['String']['output'];
};

/** Period deadlines information */
export type PeriodDeadlinesType = {
  __typename?: 'PeriodDeadlinesType';
  /** End of early submission window */
  collectingDocsDeadline: Scalars['DateTime']['output'];
  /** Current active deadline date */
  currentDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** Days left until current deadline */
  currentDeadlineDaysLeft?: Maybe<Scalars['Int']['output']>;
  /** Current deadline type */
  currentDeadlineType: DeadlineType;
  /** First reminder end date */
  firstReminderEndDate: Scalars['DateTime']['output'];
  /** First reminder start date */
  firstReminderStartDate: Scalars['DateTime']['output'];
  /** Period end date */
  periodEndDate: Scalars['DateTime']['output'];
  /** Period start date */
  periodStartDate: Scalars['DateTime']['output'];
  /** Period type (upcoming, collecting_docs, processing_docs, report_submitted, report_not_submitted) */
  periodType: AccountingReportPeriodTypeEnum;
  /** Processing docs deadline - legal deadline */
  processingDocsDeadline: Scalars['DateTime']['output'];
  /** Second reminder end date */
  secondReminderEndDate: Scalars['DateTime']['output'];
  /** Second reminder start date */
  secondReminderStartDate: Scalars['DateTime']['output'];
  /** Third reminder end date */
  thirdReminderEndDate: Scalars['DateTime']['output'];
  /** Third reminder start date */
  thirdReminderStartDate: Scalars['DateTime']['output'];
  /** Upcoming deadline - when period becomes active */
  upcomingDeadline: Scalars['DateTime']['output'];
};

/** Summary row for a document in a period (Merit export view) */
export type PeriodDocumentSummaryItem = {
  __typename?: 'PeriodDocumentSummaryItem';
  /** Amount with currency */
  amount: Scalars['String']['output'];
  /** Article (merit_item name) or Not set */
  article?: Maybe<Scalars['String']['output']>;
  /** Counterparty name and country */
  counterparty?: Maybe<Scalars['String']['output']>;
  /** Document date */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Direction: in, out, or empty for default/report subfolders */
  direction?: Maybe<Scalars['String']['output']>;
  /** Document name (a_file.name) */
  document: Scalars['String']['output'];
  /** Error from merit_invoice_shipment */
  error?: Maybe<Scalars['String']['output']>;
  /** File ID */
  fileId: Scalars['UuidType']['output'];
  /** Transactions already imported from the statement; set with statementTransactionsCount */
  importedTransactionsCount?: Maybe<Scalars['Int']['output']>;
  /** VAT validation status: true if validated recently (counterparty.taxNumberValidDate or monite_invoice.vatNumberValidDate within last month) */
  isVatValid?: Maybe<Scalars['Boolean']['output']>;
  /** True if invoice date is outside calendar period (requires resubmission) */
  mustResubmitDeclaration?: Maybe<Scalars['Boolean']['output']>;
  /** Source of file */
  source?: Maybe<FileSource>;
  /** Transactions OCR recognized in the document; set only for a bank statement uploaded or mailed by the client, whose transactions can be imported */
  statementTransactionsCount?: Maybe<Scalars['Int']['output']>;
  /** Merit shipment status: sent successfully, error on send, or never sent */
  status: Scalars['String']['output'];
  /** Tax (merit tax name) or Not set */
  tax?: Maybe<Scalars['String']['output']>;
  /** Document type: invoice, statement, or OCR documentType */
  type: Scalars['String']['output'];
  /** VAT number */
  vat?: Maybe<Scalars['String']['output']>;
};

export type PeriodIssuesType = {
  __typename?: 'PeriodIssuesType';
  /** Number of denied documents (accStatusId=4) in this period */
  deniedDocumentsCount: Scalars['Int']['output'];
  /** Number of missing transactions (docNeeded=true and reason=accountant) in this period */
  missingTransactionsCount: Scalars['Int']['output'];
  /** Number of open questions (tasks) for the company in this period */
  openQuestionsCount: Scalars['Int']['output'];
  /** Number of transactions in this period (by transactionDate) that have at least one attached denied document (accStatusId=4) */
  transactionsWithDeniedDocumentsCount: Scalars['Int']['output'];
};

/** The other leg of a linked internal transfer */
export type PeriodTransactionInternalTransferPair = {
  __typename?: 'PeriodTransactionInternalTransferPair';
  /** Amount with currency */
  amount: Scalars['String']['output'];
  /** Bank account of the other leg: the Merit bank name, otherwise the account name */
  bankAccount?: Maybe<Scalars['String']['output']>;
  /** Transaction date */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Transaction ID of the other leg */
  transactionId: Scalars['String']['output'];
};

/** Linked invoice file for period transaction summary */
export type PeriodTransactionInvoiceLink = {
  __typename?: 'PeriodTransactionInvoiceLink';
  /** File ID */
  fileId: Scalars['UuidType']['output'];
  /** File name for display */
  name: Scalars['String']['output'];
};

/** Summary row for a transaction in a period (Merit export view) */
export type PeriodTransactionSummaryItem = {
  __typename?: 'PeriodTransactionSummaryItem';
  /** Amount with currency */
  amount: Scalars['String']['output'];
  /** Article (merit_item name) or Not set */
  article?: Maybe<Scalars['String']['output']>;
  /** Bank account name from Merit */
  bankAccount?: Maybe<Scalars['String']['output']>;
  /** Category name from banking_category_items */
  category?: Maybe<Scalars['String']['output']>;
  /** Manual comment left on the transaction */
  comment?: Maybe<Scalars['String']['output']>;
  /** Counterparty name */
  counterparty?: Maybe<Scalars['String']['output']>;
  /** Transaction date */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Whether a document is needed for transaction */
  docNeeded?: Maybe<Scalars['Boolean']['output']>;
  /** Error from merit_invoice_shipment */
  error?: Maybe<Scalars['String']['output']>;
  /** The other leg of a linked internal transfer; null when not linked or when that transaction no longer exists */
  internalTransferPair?: Maybe<PeriodTransactionInternalTransferPair>;
  /** Transaction ID of the other leg when the transaction is a linked internal transfer */
  internalTransferTransactionId?: Maybe<Scalars['String']['output']>;
  /** Linked invoices (files) with ability to view */
  invoices: Array<PeriodTransactionInvoiceLink>;
  /** Whether the transaction is categorized as an internal transfer; Merit accepts it only with a linked pair */
  isInternalTransfer: Scalars['Boolean']['output'];
  /** Set on a fee row: ID of the transaction (body) the bank charged this fee for. The fee row goes right after its body row */
  parentTransactionId?: Maybe<Scalars['String']['output']>;
  /** Set on a transaction the accountant imported from a bank statement: the accounting file (a_file) of the statement. Such a transaction is not shown to the client */
  statementFileId?: Maybe<Scalars['String']['output']>;
  /** Merit shipment status: sent successfully, error on send, or never sent */
  status: Scalars['String']['output'];
  /** Tax rate/name from Merit */
  tax?: Maybe<Scalars['String']['output']>;
  /** Transaction ID */
  transactionId: Scalars['String']['output'];
};

/** Accounting report section */
export type PeriodsSubfolderType = {
  __typename?: 'PeriodsSubfolderType';
  /** Creation time */
  createdAt: Scalars['DateTimeType']['output'];
  /** Documents */
  docs: Array<AccountingFileType>;
  files?: Maybe<Array<AccountingFileType>>;
  /** Primary ID */
  id: Scalars['UuidType']['output'];
  /** Section name */
  name: Scalars['String']['output'];
  periodsFolder?: Maybe<AccountingReportType>;
  /** Report ID */
  periodsFolderId: Scalars['UuidType']['output'];
  /** Currently periodsFolderId */
  reportId: Scalars['UuidType']['output'];
  totalFilesQty?: Maybe<Scalars['Float']['output']>;
  /** Section type */
  type: AccountingReportPartTypeEnum;
  unreadFilesQty?: Maybe<Scalars['Float']['output']>;
};

export type PlanFeaturesTextEntityEntity = {
  __typename?: 'PlanFeaturesTextEntityEntity';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** List of plans that include this feature, separated by commas */
  includedPlans: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  planFeaturesTitle?: Maybe<PlanFeaturesTitleEntity>;
  planFeaturesTitleId: Scalars['String']['output'];
  /** List of plans that include this feature, separated by commas */
  showValue: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PlanFeaturesTextEntityInputType = {
  /** List of plans that include this feature, separated by commas */
  includedPlans: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  planFeaturesTitle?: InputMaybe<PlanFeaturesTitleInputType>;
  planFeaturesTitleId: Scalars['String']['input'];
  /** List of plans that include this feature, separated by commas */
  showValue: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type PlanFeaturesTitleEntity = {
  __typename?: 'PlanFeaturesTitleEntity';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** Market by ID */
  marketId?: Maybe<Scalars['Float']['output']>;
  /** Title name */
  name?: Maybe<Scalars['String']['output']>;
  /** Index to understand the order of placement */
  order?: Maybe<Scalars['Float']['output']>;
  texts?: Maybe<Array<PlanFeaturesTextEntityEntity>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PlanFeaturesTitleInputType = {
  id: Scalars['String']['input'];
  /** Market by ID */
  marketId?: InputMaybe<Scalars['Float']['input']>;
  /** Title name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Index to understand the order of placement */
  order?: InputMaybe<Scalars['Float']['input']>;
  texts?: InputMaybe<Array<PlanFeaturesTextEntityInputType>>;
};

export type PlanTypeEntity = {
  __typename?: 'PlanTypeEntity';
  /** Plan description */
  description?: Maybe<Scalars['String']['output']>;
  /** Report submission frequency */
  documentsPeriod?: Maybe<AccountingReportPeriodEnum>;
  features?: Maybe<Array<PlanTypeFeaturesEntity>>;
  /** Have tooltip */
  haveTooltip?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  /** Market by ID */
  marketId?: Maybe<Scalars['Float']['output']>;
  /** Plan name */
  name?: Maybe<Scalars['String']['output']>;
  /** Order for sorting */
  order?: Maybe<Scalars['Float']['output']>;
  /** Tooltip text */
  tooltipText?: Maybe<Scalars['String']['output']>;
};

export type PlanTypeFeaturesEntity = {
  __typename?: 'PlanTypeFeaturesEntity';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  featuresText: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  planType?: Maybe<PlanTypeEntity>;
  planTypeId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PlanTypeFeaturesInputType = {
  featuresText: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  planType?: InputMaybe<PlanTypeInputType>;
  planTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type PlanTypeInputType = {
  /** Plan description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Report submission frequency */
  documentsPeriod?: InputMaybe<AccountingReportPeriodEnum>;
  features?: InputMaybe<Array<PlanTypeFeaturesInputType>>;
  /** Have tooltip */
  haveTooltip?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  /** Market by ID */
  marketId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Order for sorting */
  order?: InputMaybe<Scalars['Float']['input']>;
  /** Tooltip text */
  tooltipText?: InputMaybe<Scalars['String']['input']>;
};

export type PortalSession = {
  __typename?: 'PortalSession';
  access_url: Scalars['String']['output'];
  created_at: Scalars['Float']['output'];
  customer_id: Scalars['String']['output'];
  expires_at: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  object: Scalars['String']['output'];
  redirect_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type PotentialTaxByRateDto = {
  __typename?: 'PotentialTaxByRateDto';
  /** Negative tax amount in EUR for this rate (incoming invoices) */
  incomingTaxAmountEur: Scalars['Float']['output'];
  /** Positive tax amount in EUR for this rate (outgoing invoices) */
  outgoingTaxAmountEur: Scalars['Float']['output'];
  /** Aggregated tax amount in EUR for this rate */
  taxAmountEur: Scalars['Float']['output'];
  /** Tax rate in percent */
  taxRate: Scalars['Float']['output'];
};

export type PotentialTaxSummaryDto = {
  __typename?: 'PotentialTaxSummaryDto';
  /** Extra tax amount (28%) in EUR for transactions with denied documents */
  deniedTaxAmountEur: Scalars['Float']['output'];
  /** Extra tax amount (28%) in EUR for transactions with extraTaxAgree = true */
  extraTaxAgreeAmountEur: Scalars['Float']['output'];
  /** Extra tax amount (28%) in EUR for missing/denied docs */
  extraTaxAmountEur: Scalars['Float']['output'];
  /** Total invoice tax amount in EUR */
  invoicesTaxAmountEur: Scalars['Float']['output'];
  /** Extra tax amount (28%) in EUR for transactions with missing documents */
  missingTaxAmountEur: Scalars['Float']['output'];
  /** Tax amounts grouped by tax rate for invoice files attached to period transactions */
  taxesByRate: Array<PotentialTaxByRateDto>;
  /** Total amount in EUR (invoice taxes + extra tax) */
  totalTaxAmountEur: Scalars['Float']['output'];
};

export type PreviousPeriodDeclarationStatusDto = {
  __typename?: 'PreviousPeriodDeclarationStatusDto';
  /** Whether declaration was submitted for previous period */
  isDeclarationSubmitted: Scalars['Boolean']['output'];
  /** ID of the previous period */
  previousPeriodId?: Maybe<Scalars['UuidType']['output']>;
  /** Name of the previous period (e.g., July 2025, Q3 2025, 2025) */
  previousPeriodName?: Maybe<Scalars['String']['output']>;
};

export type PricingByPeriod = {
  __typename?: 'PricingByPeriod';
  chargebeeId: Scalars['String']['output'];
  docs: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
};

export type PricingItem = {
  __typename?: 'PricingItem';
  description?: Maybe<Scalars['String']['output']>;
  documentsPeriod?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<PlanTypeFeaturesEntity>>;
  haveTooltip?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  monthlyPrice: Array<PricingByPeriod>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  tooltipText?: Maybe<Scalars['String']['output']>;
  yearlyPrice: Array<PricingByPeriod>;
};

export enum ProcessStageEnum {
  Incorporating = 'Incorporating',
  IncorporationPaid = 'IncorporationPaid',
  Merged = 'Merged',
  ProcessCompleted = 'ProcessCompleted',
  ProcessStarted = 'ProcessStarted',
  Registered = 'Registered',
  SubscriptionClient = 'SubscriptionClient'
}

/** Document to product relation */
export type ProductInCmDoc = {
  __typename?: 'ProductInCMDoc';
  /** Products amount */
  amount?: Maybe<Scalars['Float']['output']>;
  cmDocId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product: InvoicingItemEntity;
  productId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductInCmDocInputType = {
  /** Products amount */
  amount?: InputMaybe<Scalars['Float']['input']>;
  cmDocId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  product: InvoicingItemEntityInputType;
  productId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Product type */
export enum ProductTypeEnum {
  Product = 'Product',
  Service = 'Service'
}

export type Query = {
  __typename?: 'Query';
  accounting: AccountingQuery;
  admin: AdminQuery;
  banking: BankingQuery;
  bankingCategorization: BankingCategorizationQuery;
  chargebee: ChargebeeQuery;
  cm: CmQuery;
  comingServices: ComingServicesQuery;
  country: CountryQuery;
  csService: CsServiceQuery;
  /** Data for the large table in pricing */
  dataForPricingTable: Array<PlanFeaturesTitleEntity>;
  deals: DealsQuery;
  docs: DocsQuery;
  /** Data about one invoice */
  findInvoice: MoniteInvoiceEntity;
  findRecurrentForInvoice?: Maybe<InvoicingRecurrentEntity>;
  getAccountingOnboardingStatus: AccountingOnboardingResponseDto;
  getAccountingOnboardingStatusByAdmin: AccountingOnboardingResponseDto;
  /** Getting all active plans */
  getActivePlans: Array<PricingItem>;
  /** AL-2737: company accounting periods for the mailbox period selector */
  getCompanyPeriods: Array<CompanyPeriodType>;
  /** Get configs for payment web component. */
  getConfigsForPaymentComponent: MoniteWebComponentConfigsDto;
  /** Data for the Copy Link page */
  getCopyLinkData?: Maybe<CopyLinkDto>;
  /** Get email template by id */
  getEmailTemplateById: EmailTemplateType;
  /** Get email templates by type */
  getEmailTemplatesByType: Array<EmailTemplateType>;
  /** List of files received by mail */
  getFilesReceivedByMail: MoniteMailInvoiceListType;
  /** AL-2737: Accounting → Mailbox — list of documents received by mail */
  getMailInvoices: MailInvoiceListType;
  getMessages: GetMessagesDto;
  getRecurrent: InvoicingRecurrentEntity;
  /** Get the id of the selected email template for the specified type */
  getSelectedEmailTemplateIdByType: Scalars['String']['output'];
  getTasks?: Maybe<GetTasksDto>;
  getUnreadCountByPeriod: UnreadCountByPeriodDto;
  hr: HrQuery;
  incorporation: CompanyQuery;
  invoicing: InvoicingQuery;
  john: JohnQuery;
  kb: KbQuery;
  /** List of invoices for payment */
  list: MoniteInvoiceEntityListType;
  log: LogQuery;
  notif: NotificationsQuery;
  notifications: NotificationsQuery2;
  oauth: OAuthQuery;
  onboardingCompletionStatus: OnboardingResponseDto;
  search: SearchQuery;
  /** Send a template email */
  sendEmailWithTemplate: Scalars['Boolean']['output'];
  /** Send a template email (internal) */
  sendEmailWithTemplateData: Scalars['Boolean']['output'];
  settings: SettingsQuery;
  tasksByYear?: Maybe<GetTasksDto>;
  tasksByYearForAccountant?: Maybe<GetTasksDto>;
  transactionRules: TransactionRulesQuery;
  user: UserQuery;
};


export type QueryFindInvoiceArgs = {
  id: Scalars['String']['input'];
  isId: Scalars['Boolean']['input'];
};


export type QueryFindRecurrentForInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
};


export type QueryGetAccountingOnboardingStatusByAdminArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetCopyLinkDataArgs = {
  fileId: Scalars['String']['input'];
};


export type QueryGetEmailTemplateByIdArgs = {
  emailTemplateInput: EmailTemplateInputType;
};


export type QueryGetEmailTemplatesByTypeArgs = {
  emailType: EmailTemplatesTypesEnum;
};


export type QueryGetFilesReceivedByMailArgs = {
  filter?: InputMaybe<FilesReceivedByMailListQueryFilterInputType>;
  pagination?: InputMaybe<PaginationInputType>;
};


export type QueryGetMailInvoicesArgs = {
  filter?: InputMaybe<MailInvoiceFilterInputType>;
  pagination?: InputMaybe<PaginationInputType>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<MailInvoiceSortInput>;
};


export type QueryGetMessagesArgs = {
  chatId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetRecurrentArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetSelectedEmailTemplateIdByTypeArgs = {
  emailType: EmailTemplatesTypesEnum;
};


export type QueryGetTasksArgs = {
  filter: GetTasksInput;
  pagination: PaginationInputType;
};


export type QueryGetUnreadCountByPeriodArgs = {
  periodId: Scalars['String']['input'];
};


export type QuerySendEmailWithTemplateArgs = {
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  emailData: CustomEmailWithTemplateIdAndDocIdInputType;
};


export type QuerySendEmailWithTemplateDataArgs = {
  emailData: CustomEmailWithTemplateIdAndDocIdInputType;
};


export type QueryTasksByYearArgs = {
  input: TasksByYearInput;
  pagination: PaginationInputType;
};


export type QueryTasksByYearForAccountantArgs = {
  input: TasksByYearInput;
  pagination: PaginationInputType;
};

/** Reasons why a document is not needed for a transaction */
export enum ReasonNotNeededEnum {
  BankInterest = 'BANK_INTEREST',
  BankOrPlatformFee = 'BANK_OR_PLATFORM_FEE',
  Cashback = 'CASHBACK',
  ECommercePayout = 'E_COMMERCE_PAYOUT',
  GovernmentOrTaxPayment = 'GOVERNMENT_OR_TAX_PAYMENT',
  InternalTransfer = 'INTERNAL_TRANSFER',
  SalaryOrDirectorPayment = 'SALARY_OR_DIRECTOR_PAYMENT'
}

export type RefreshTransactionsDto = {
  __typename?: 'RefreshTransactionsDto';
  message?: Maybe<Scalars['String']['output']>;
  nextUpdateInSec?: Maybe<Scalars['Float']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RelationTransactionsDocInputDto = {
  bankingTransactionId: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
};

export type ReportCategoryGroupDto = {
  __typename?: 'ReportCategoryGroupDto';
  categoryGroupCategories?: Maybe<Array<CategoryGroupCategoriesDto>>;
  categoryGroupId: Scalars['String']['output'];
  categoryGroupMoneyValues: Array<CategoryMoneyValuesDto>;
  categoryGroupName: Scalars['String']['output'];
  categoryGroupPercentName?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Boolean']['output']>;
};

/** Information about documents attached to the report */
export type ReportDocsMetaInfoType = {
  __typename?: 'ReportDocsMetaInfoType';
  /** Total number of documents uploaded by the client */
  all: Scalars['Int']['output'];
  /** Timestamp indicating when the document upload limit was last changed by the client */
  changedAt: Scalars['DateTimeType']['output'];
  /** Limit on the maximum number of documents that can be uploaded by the client */
  limit: Scalars['Int']['output'];
  /** Number of documents uploaded by the accountant */
  reports: Scalars['Int']['output'];
};

export enum ReportPeriodsUnitsEnum {
  Custom = 'Custom',
  LastQuarter = 'LastQuarter',
  LastSixMonths = 'LastSixMonths',
  LastTwoYears = 'LastTwoYears',
  LastYear = 'LastYear'
}

export type ReviewResultType = {
  __typename?: 'ReviewResultType';
  reviewAnswer: Scalars['String']['output'];
};

export type RowItemDocumentResponseDto = {
  __typename?: 'RowItemDocumentResponseDto';
  discount?: Maybe<Scalars['Float']['output']>;
  discountIsAmount?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  invoiceId: Scalars['String']['output'];
  itemId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  tax?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<InvoicingItemUnitEnum>;
  unitEntity?: Maybe<ItemUnitResponseDto>;
};

export type SaltEdgeWebhookData = {
  __typename?: 'SaltEdgeWebhookData';
  connection_id: Scalars['String']['output'];
  custom_fields?: Maybe<SaltedgeWebhookCustomFields>;
  customer_id: Scalars['String']['output'];
  stage: Scalars['String']['output'];
};

export type SaltedgeConnectionEntity = {
  __typename?: 'SaltedgeConnectionEntity';
  bankingAccounts?: Maybe<Array<BankingAccountEntity>>;
  company: CompanyOpeningType;
  companyId: Scalars['String']['output'];
  connectionId: Scalars['String']['output'];
  consentId: Scalars['String']['output'];
  consentStatus?: Maybe<SaltedgeConsentStatusEnum>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  fromDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  nextRefreshPossibleAt?: Maybe<Scalars['DateTime']['output']>;
  providerCode?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  status: SaltedgeConnectionStatusEnum;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The status of the Saltedge connection */
export enum SaltedgeConnectionStatusEnum {
  Active = 'Active',
  Disabled = 'Disabled',
  Inactive = 'Inactive'
}

/** The status of the Saltedge consent */
export enum SaltedgeConsentStatusEnum {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}

export type SaltedgeDailyRefreshWebhookData = {
  __typename?: 'SaltedgeDailyRefreshWebhookData';
  connection_id: Scalars['String']['output'];
  customer_id: Scalars['String']['output'];
  stage: Scalars['String']['output'];
};

export type SaltedgeDestroyWebhookData = {
  __typename?: 'SaltedgeDestroyWebhookData';
  connection_id: Scalars['String']['output'];
  customer_id: Scalars['String']['output'];
};

export type SaltedgeFailureWebhookData = {
  __typename?: 'SaltedgeFailureWebhookData';
  connection_id: Scalars['String']['output'];
  customer_id: Scalars['String']['output'];
  error_class: Scalars['String']['output'];
  error_message: Scalars['String']['output'];
};

export type SaltedgeWebhookCustomFields = {
  __typename?: 'SaltedgeWebhookCustomFields';
  company_id: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type SearchActionEntity = {
  __typename?: 'SearchActionEntity';
  action: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  important: Scalars['Boolean']['output'];
  keywords: Scalars['String']['output'];
  /** en, nl etc (iso) */
  language: Scalars['String']['output'];
  /** Market id/ids for search */
  marketId: Array<Scalars['Int']['output']>;
  order: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type SearchActionEntityInput = {
  action: Scalars['String']['input'];
  disabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  important: Scalars['Boolean']['input'];
  keywords: Scalars['String']['input'];
  /** en, nl etc (iso) */
  language: Scalars['String']['input'];
  /** Market id/ids for search */
  marketId: Array<Scalars['Int']['input']>;
  order: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};

/** List of finded files */
export type SearchFilesListType = {
  __typename?: 'SearchFilesListType';
  /** Files list */
  files: Array<ExtendedFile>;
  /** Quantity to take */
  limit: Scalars['Float']['output'];
  /** Quantity to skip */
  offset: Scalars['Float']['output'];
  /** Total quantity */
  total: Scalars['Float']['output'];
};

export type SearchMutation = {
  __typename?: 'SearchMutation';
  /** Create an action (if id=null) or update (if id is specified) */
  addOrUpdate: SearchActionEntity;
  /** Delete */
  delete: Scalars['Boolean']['output'];
};


export type SearchMutationAddOrUpdateArgs = {
  model: SearchActionEntityInput;
};


export type SearchMutationDeleteArgs = {
  id: Scalars['String']['input'];
};

export type SearchQuery = {
  __typename?: 'SearchQuery';
  /** List of all actions for editing, sorted by order */
  all: Array<SearchActionEntity>;
  /** List of found actions, sorted by order */
  search: Array<SearchActionEntity>;
};


export type SearchQuerySearchArgs = {
  searchTerm: Scalars['String']['input'];
};

export type SendChargebeeInvoiceToMeritResultType = {
  __typename?: 'SendChargebeeInvoiceToMeritResultType';
  /** Error message if failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Is validation error */
  isValidationError?: Maybe<Scalars['Boolean']['output']>;
  /** Merit bill number */
  meritBillNo?: Maybe<Scalars['String']['output']>;
  /** Merit invoice ID */
  meritInvoiceId?: Maybe<Scalars['String']['output']>;
  /** Success status */
  success: Scalars['Boolean']['output'];
  /** List of validation errors */
  validationErrors?: Maybe<Array<Scalars['String']['output']>>;
};

export type SendExpensePaymentToMeritResultType = {
  __typename?: 'SendExpensePaymentToMeritResultType';
  /** Error message if failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Success status */
  success: Scalars['Boolean']['output'];
};

export type SendIncomePaymentToMeritResultType = {
  __typename?: 'SendIncomePaymentToMeritResultType';
  /** Error message if failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Success status */
  success: Scalars['Boolean']['output'];
};

export type SendTestNotificationInput = {
  code: Scalars['String']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** do not forget to use code "old" simultaneously */
  oldTemplateId?: InputMaybe<Scalars['String']['input']>;
};

export type Settings = {
  __typename?: 'Settings';
  /** Name of setting */
  key: Scalars['String']['output'];
  /** Value of setting (true/false) */
  value: Scalars['Boolean']['output'];
};

export type SettingsInputType = {
  /** Name of setting */
  key: Scalars['String']['input'];
  /** Value of setting (true/false) */
  value: Scalars['Boolean']['input'];
};

export type SettingsMutation = {
  __typename?: 'SettingsMutation';
  /** Enable/disable setting */
  adminChangeSetting: Settings;
  /** Create a new setting */
  adminCreateSetting: Settings;
};


export type SettingsMutationAdminChangeSettingArgs = {
  settingName: Scalars['String']['input'];
};


export type SettingsMutationAdminCreateSettingArgs = {
  settingData: SettingsInputType;
};

export type SettingsQuery = {
  __typename?: 'SettingsQuery';
  /** One setting */
  setting: Settings;
  /** All settings */
  settings: Array<Settings>;
};


export type SettingsQuerySettingArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Sorting */
export type SortInputType = {
  /** Sorting field */
  field?: InputMaybe<Scalars['String']['input']>;
  /** Sorting order */
  type?: InputMaybe<SortTypeEnum>;
};

/** Sort order */
export enum SortTypeEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export type StatementImportInput = {
  /** Banking account of the company to create the transactions on */
  accountId: Scalars['String']['input'];
  /** Accounting file (a_file) of the statement */
  fileId: Scalars['String']['input'];
  rows: Array<StatementImportRowInput>;
};

/** Transactions recognized in a bank statement, ready to be imported to an account */
export type StatementImportPreview = {
  __typename?: 'StatementImportPreview';
  /** Account holder as recognized */
  accountHolder?: Maybe<Scalars['String']['output']>;
  /** Account the duplicates were looked for on: the requested one, else the suggested one */
  accountId?: Maybe<Scalars['String']['output']>;
  /** Company of the statement */
  companyId: Scalars['String']['output'];
  /** Statement currency, the currency of every row */
  currency?: Maybe<Scalars['String']['output']>;
  /** Accounting file (a_file) of the statement */
  fileId: Scalars['String']['output'];
  /** File name */
  fileName: Scalars['String']['output'];
  /** Transactions already imported from this statement */
  importedCount: Scalars['Int']['output'];
  rows: Array<StatementImportRow>;
  /** Statement number as recognized */
  statementNumber?: Maybe<Scalars['String']['output']>;
  /** Account the statement most likely belongs to: the one it was already imported to, otherwise the one the client uploaded it for */
  suggestedAccountId?: Maybe<Scalars['String']['output']>;
};

export type StatementImportResult = {
  __typename?: 'StatementImportResult';
  importedCount: Scalars['Int']['output'];
  /** Created transactions */
  transactionIds: Array<Scalars['String']['output']>;
};

/** A transaction recognized by OCR in a bank statement */
export type StatementImportRow = {
  __typename?: 'StatementImportRow';
  /** Amount as recognized, always positive */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Date as recognized, YYYY-MM-DD */
  date?: Maybe<Scalars['String']['output']>;
  /** Description as recognized */
  description?: Maybe<Scalars['String']['output']>;
  /** Direction as recognized: INCOMING or OUTGOING */
  direction?: Maybe<Scalars['String']['output']>;
  /** A transaction already on the account with the same day, amount and currency: the row is most likely imported already */
  duplicateTransactionId?: Maybe<Scalars['String']['output']>;
  /** Position of the row in the statement */
  index: Scalars['Int']['output'];
  /** Why the row cannot be imported (date, amount or direction not recognized) */
  problem?: Maybe<Scalars['String']['output']>;
};

/** A statement row to import. Date, amount and direction must be the ones the preview returned: they are checked against the statement, not taken from here */
export type StatementImportRowInput = {
  /** StatementImportRow.amount */
  amount: Scalars['Float']['input'];
  /** Category (banking_category_items.id) of the company for the row direction; none means the usual automatic categorization */
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** Counterparty (counterparty.clientId) of the company */
  counterpartyId?: InputMaybe<Scalars['String']['input']>;
  /** StatementImportRow.date */
  date: Scalars['String']['input'];
  /** Transaction description; empty means none */
  description?: InputMaybe<Scalars['String']['input']>;
  /** StatementImportRow.direction */
  direction: Scalars['String']['input'];
  /** StatementImportRow.index */
  index: Scalars['Int']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** All transactions have been saved */
  allTransactionsSaved: Scalars['Boolean']['output'];
  analyzeContractFinished: AnalyzeContractDto;
  automatchingCompleted: AutomatchingCompletedDto;
  bankingAccountStatementDocumentReady: BankingAccountStatementBodyDto;
  /** Rich error details for banking connection processing failures (published alongside bankingConnectionProcess = -1). */
  bankingConnectionError: BankingConnectionErrorDto;
  bankingConnectionProcess: Scalars['Float']['output'];
  categorizationAllTransactionsProceeded: Scalars['Boolean']['output'];
  categorizationBatchProceeded: CategorizationResultWithTimeDto;
  chargebeeWebhookReceived: SubscriptionChangedDto;
  chatMessageReady: MsgNotifPayloadDto;
  /** Document translation completed subscription */
  cmDocTranslationCompleted: CmTranslationCompletedDto;
  /** Document translation error subscription */
  cmDocTranslationFailed: CmTranslationFailedDto;
  contactsExportReady: Array<CounterpartyEntity>;
  contactsImportReady: Array<ImportedContactDto>;
  /** Subscription to the event of transaction conversion completion, the response includes how many seconds are left */
  conversionBatchProceeded: ConversionSubscriptionResultDto;
  /** Subscription to the generation of the list for Enty Wrapped */
  entyWrappedCompleted: Array<Scalars['String']['output']>;
  esignDocSigned: EsignDocsEntity;
  fileDownloadReady: FileDownloadDto;
  hrAgreementDocumentReady: HrDocumentSaveBodyDto;
  incorporationCompanyCardDocumentReady: CompanyCardDocumentReadyEventType;
  incorporationCompanyEstoniaDocumentReady: CompanyOpeningEstoniaDocumentReadyEventType;
  incorporationCompanyMemberDocumentReady: CompanyOpeningMemberDocumentReadyEventType;
  notifCreated: Notification;
  paymentsConnectionStatusChanged: PaymentsConnectionStatusChangedEventType;
  productsExportReady: Array<InvoicingItemEntity>;
  productsImportReady: Array<ImportedProductDto>;
  saltedgeConnectionReady: SaltedgeConnectionEntity;
  toastNotification: ToastNotificationDto;
  transactionsImportReady: BankingAccountEntity;
  typeformDocGenerated: CmDoc;
};


export type SubscriptionAllTransactionsSavedArgs = {
  companyId: Scalars['String']['input'];
};


export type SubscriptionAnalyzeContractFinishedArgs = {
  reqId: Scalars['String']['input'];
};


export type SubscriptionAutomatchingCompletedArgs = {
  companyId: Scalars['String']['input'];
};


export type SubscriptionBankingAccountStatementDocumentReadyArgs = {
  accountId: Scalars['String']['input'];
};


export type SubscriptionBankingConnectionErrorArgs = {
  companyId: Scalars['String']['input'];
};


export type SubscriptionBankingConnectionProcessArgs = {
  companyId: Scalars['String']['input'];
};


export type SubscriptionCategorizationAllTransactionsProceededArgs = {
  companyId: Scalars['String']['input'];
};


export type SubscriptionCategorizationBatchProceededArgs = {
  companyId: Scalars['String']['input'];
};


export type SubscriptionChargebeeWebhookReceivedArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionChatMessageReadyArgs = {
  chatId: Scalars['String']['input'];
};


export type SubscriptionCmDocTranslationCompletedArgs = {
  jobId?: InputMaybe<Scalars['String']['input']>;
  originalDocId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionCmDocTranslationFailedArgs = {
  originalDocId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionContactsExportReadyArgs = {
  companyId: Scalars['String']['input'];
};


export type SubscriptionContactsImportReadyArgs = {
  companyId: Scalars['String']['input'];
};


export type SubscriptionConversionBatchProceededArgs = {
  companyId: Scalars['String']['input'];
};


export type SubscriptionEsignDocSignedArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionFileDownloadReadyArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionHrAgreementDocumentReadyArgs = {
  workerId: Scalars['String']['input'];
};


export type SubscriptionIncorporationCompanyCardDocumentReadyArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionIncorporationCompanyEstoniaDocumentReadyArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionIncorporationCompanyMemberDocumentReadyArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionNotifCreatedArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionPaymentsConnectionStatusChangedArgs = {
  companyId: Scalars['String']['input'];
};


export type SubscriptionProductsExportReadyArgs = {
  companyId: Scalars['String']['input'];
};


export type SubscriptionProductsImportReadyArgs = {
  companyId: Scalars['String']['input'];
};


export type SubscriptionSaltedgeConnectionReadyArgs = {
  companyId: Scalars['String']['input'];
};


export type SubscriptionToastNotificationArgs = {
  companyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type SubscriptionTransactionsImportReadyArgs = {
  accountId: Scalars['String']['input'];
};


export type SubscriptionTypeformDocGeneratedArgs = {
  userId: Scalars['String']['input'];
};

/** Update subscription data */
export type SubscriptionChangedDto = {
  __typename?: 'SubscriptionChangedDto';
  eventName: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SubscriptionInfo = {
  /** Plan ID to which the subscription belongs */
  planId: Scalars['String']['input'];
};

export type SubscriptionInfoAddon = {
  /** Addon Price */
  amount: Scalars['Int']['input'];
  /** Addon ID */
  id: Scalars['String']['input'];
  /** Number of addon units */
  quantity: Scalars['Int']['input'];
};

export type SubscriptionInputType = {
  /** User identifier in the chargebee system */
  customerId: Scalars['String']['input'];
  /** Subscription identifier */
  id: Scalars['String']['input'];
  /** User subscription information */
  info: SubscriptionInfo;
  /** Subscription status */
  status: Scalars['String']['input'];
};

export type Summary = {
  __typename?: 'Summary';
  label?: Maybe<LabelSummary>;
  value?: Maybe<ValueSummary>;
};

export type SumsubMutation = {
  __typename?: 'SumsubMutation';
  /** Generate access token for sumsub SDK */
  generateAccessToken: Scalars['String']['output'];
  /** Generate sumsub permalink */
  generatePermalink: Scalars['String']['output'];
};


export type SumsubMutationGenerateAccessTokenArgs = {
  memberId: Scalars['String']['input'];
};


export type SumsubMutationGeneratePermalinkArgs = {
  memberId: Scalars['String']['input'];
};

export type TaskDto = {
  __typename?: 'TaskDto';
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdUserId: Scalars['String']['output'];
  hasUnread: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastMessage?: Maybe<MessageDto>;
  messagesCount: Scalars['Float']['output'];
  month?: Maybe<Scalars['Float']['output']>;
  participants?: Maybe<Array<Scalars['String']['output']>>;
  payload?: Maybe<TaskPayloadDto>;
  periodFolderId?: Maybe<Scalars['String']['output']>;
  status: ChatStatusEnum;
  subject: Scalars['String']['output'];
  unreadMessagesCount: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TaskPayloadDto = {
  __typename?: 'TaskPayloadDto';
  files?: Maybe<Array<FileDto>>;
  periods?: Maybe<Array<AccountingReportType>>;
  transactions?: Maybe<Array<BankingTransactionEntity>>;
};

export type TasksByYearInput = {
  periodsFolderId: Scalars['String']['input'];
  status?: InputMaybe<Array<ChatStatusEnum>>;
};

export type TaxByClientResponseDto = {
  __typename?: 'TaxByClientResponseDto';
  note: Scalars['String']['output'];
  tax: Scalars['Float']['output'];
};

export enum TaxStatusEnum {
  NonTaxable = 'NonTaxable',
  Taxable = 'Taxable'
}

export type TemplateFilterInputType = {
  /** Template language */
  lang?: InputMaybe<Scalars['String']['input']>;
  /** Search query */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** Tags */
  tags?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateInputType = {
  /** дополнительные названия документов, чтобы шаблон в поиске искался не только по первоначальному названию, но и по другим названиям, перечесление через запятую */
  alterNames?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description: Scalars['String']['input'];
  docType?: InputMaybe<Scalars['String']['input']>;
  financialDoc: Scalars['Boolean']['input'];
  /** Template identifier */
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isFreeDoc?: InputMaybe<Scalars['Boolean']['input']>;
  /** Template language */
  lang: Scalars['String']['input'];
  /** Market, 1 - Estonia, 2 - Nd, 0 - Others */
  marketId: Scalars['Int']['input'];
  /** Name */
  name: Scalars['String']['input'];
  /** Order for sorting */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Template tag, comma separated */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Preview file id */
  templatePreviewFileId?: InputMaybe<Scalars['String']['input']>;
  /** Preview file name */
  templatePreviewName?: InputMaybe<Scalars['String']['input']>;
  /** Typeform URL */
  typeFormDocId: Scalars['String']['input'];
  /** Whether to show a modal with counterparty selection */
  withDocModal: Scalars['Boolean']['input'];
};

export enum TemplatesEnum {
  Acc1 = 'Acc1',
  Acc2 = 'Acc2',
  BankEx = 'BankEX',
  BankingAlert1 = 'BankingAlert1',
  Cm1 = 'CM1',
  Cm2 = 'CM2',
  EsignCm = 'EsignCM',
  EsignHr = 'EsignHR',
  Inc1 = 'Inc1',
  Inc2 = 'Inc2',
  Inc3 = 'Inc3',
  One = 'One',
  Pl1 = 'PL1',
  Pl2 = 'PL2',
  Pl3 = 'PL3',
  Pl4 = 'PL4',
  Pl5 = 'PL5',
  Payroll1 = 'Payroll1',
  Payroll3 = 'Payroll3',
  Vat = 'VAT'
}

/** Notification in toast */
export type ToastNotificationDto = {
  __typename?: 'ToastNotificationDto';
  closedAt?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  expiredAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  link1?: Maybe<Scalars['String']['output']>;
  link1Text?: Maybe<Scalars['String']['output']>;
  link2?: Maybe<Scalars['String']['output']>;
  link2Text?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  priority: NotificationPriority;
  readAt?: Maybe<Scalars['String']['output']>;
  showFrom: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  withToast?: Maybe<Scalars['Boolean']['output']>;
};

/** Which field to sort notifications by */
export enum ToastNotificationSortField {
  ArchivedAt = 'ARCHIVED_AT',
  CreatedAt = 'CREATED_AT'
}

export type ToastNotificationsCountResponse = {
  __typename?: 'ToastNotificationsCountResponse';
  /** Unread notifications count for current company */
  currentCompany: Scalars['Int']['output'];
  /** Unread notifications count for non-current companies of user */
  otherCompanies: Array<CompanyUnreadCount>;
  /** Total unread notifications count */
  total: Scalars['Int']['output'];
};

export type ToastNotificationsFilterInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** true - closed by user (X), false - not closed */
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  withToast?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ToastNotificationsListInput = {
  filters: ToastNotificationsFilterInput;
  pagination: PaginationInputType;
  sort?: InputMaybe<ToastNotificationsSortInput>;
};

export type ToastNotificationsListResponse = {
  __typename?: 'ToastNotificationsListResponse';
  items: Array<Notification>;
  pagination: PaginationResponse;
};

export type ToastNotificationsSortInput = {
  direction: Scalars['String']['input'];
  field: ToastNotificationSortField;
};

export type TransactionDetailsAccountDto = {
  __typename?: 'TransactionDetailsAccountDto';
  /** Custom user-defined name */
  accountName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Original bank name */
  name?: Maybe<Scalars['String']['output']>;
};

export type TransactionDetailsCategoryDto = {
  __typename?: 'TransactionDetailsCategoryDto';
  colour?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type TransactionDetailsCounterpartyDto = {
  __typename?: 'TransactionDetailsCounterpartyDto';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type TransactionDetailsDto = {
  __typename?: 'TransactionDetailsDto';
  /** Accounting document status */
  accStatusId?: Maybe<FileAccStatus>;
  account?: Maybe<TransactionDetailsAccountDto>;
  amount: Scalars['String']['output'];
  bankingCategoryItem?: Maybe<TransactionDetailsCategoryDto>;
  /** Direct ID from transaction table */
  bankingCategoryItemId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  counterparty?: Maybe<TransactionDetailsCounterpartyDto>;
  /** Direct ID from transaction table */
  counterpartyId?: Maybe<Scalars['String']['output']>;
  /** Raw counterparty name from the bank */
  counterpartyName?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  /** Document needed */
  docNeeded: Scalars['Boolean']['output'];
  /** Extra tax agreement */
  extraTaxAgree: Scalars['Boolean']['output'];
  importId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  /** Reason/source for docNeeded state (e.g., user, accountant) */
  reason?: Maybe<Scalars['String']['output']>;
  /** Specific reason when doc is not needed */
  reasonNotNeeded?: Maybe<ReasonNotNeededEnum>;
  transactionDate: Scalars['DateTime']['output'];
  transactionId: Scalars['String']['output'];
  transactionType?: Maybe<Scalars['String']['output']>;
};

export type TransactionDocConnectionDto = {
  __typename?: 'TransactionDocConnectionDto';
  bankingTransactionId: Scalars['String']['output'];
  docInfo?: Maybe<DocumentInfoDto>;
  docInfoId: Scalars['String']['output'];
};

export type TransactionDto = {
  __typename?: 'TransactionDto';
  amount?: Maybe<Scalars['String']['output']>;
  bookingDate?: Maybe<Scalars['DateTime']['output']>;
  creditorName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  docNeeded?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  transactionDocConnections?: Maybe<Array<TransactionDocConnectionDto>>;
  transactionId: Scalars['String']['output'];
  transactionType?: Maybe<Scalars['String']['output']>;
};

export type TransactionForInvoiceDto = {
  __typename?: 'TransactionForInvoiceDto';
  amount?: Maybe<Scalars['String']['output']>;
  bookingDate?: Maybe<Scalars['DateTime']['output']>;
  counterparty?: Maybe<CounterpartyInvoiceConnectionDto>;
  counterpartyName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
  transactionDocConnections?: Maybe<Array<DocumentTransactionLinkDto>>;
  transactionId: Scalars['String']['output'];
};

export type TransactionRuleInputDto = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rule: Scalars['JSON']['input'];
};

export type TransactionRulesMutation = {
  __typename?: 'TransactionRulesMutation';
  /** Create or update transactions rule and possibly apply it */
  createOrUpdateTransactionRule?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple action - Soft delete rules */
  deleteTransactionRules?: Maybe<Scalars['Boolean']['output']>;
};


export type TransactionRulesMutationCreateOrUpdateTransactionRuleArgs = {
  applyRule?: InputMaybe<Scalars['Boolean']['input']>;
  ruleInput: TransactionRuleInputDto;
};


export type TransactionRulesMutationDeleteTransactionRulesArgs = {
  rulesId: Array<Scalars['String']['input']>;
};

export type TransactionRulesQuery = {
  __typename?: 'TransactionRulesQuery';
  /** Get companys transactions rules list */
  getTransactionRulesList?: Maybe<Array<BankingTransactionRuleEntity>>;
};

export enum TransactionTypeEnum {
  All = 'All',
  Incoming = 'Incoming',
  Outcoming = 'Outcoming'
}

export type TransactionsAmountFilterInputDto = {
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionsDocsDto = {
  __typename?: 'TransactionsDocsDto';
  docId: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  fileId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type TransactionsFiltersDto = {
  __typename?: 'TransactionsFiltersDto';
  amount: Array<FiltersItem>;
  attachment: Array<FiltersItem>;
  categories: Array<FiltersItem>;
  counterparty: Array<FiltersItem>;
  imported: Array<FiltersItem>;
  includeTransaction: Array<FiltersItem>;
  status: Array<FiltersItem>;
  suspiciousAlert: Array<FiltersItem>;
  transactionType: Array<FiltersItem>;
};

export type TransactionsFiltersDto2 = {
  __typename?: 'TransactionsFiltersDto2';
  accStatusId?: Maybe<FilterDef>;
  attachment: FilterDef;
  bookingDate: FilterDef;
  categories?: Maybe<CategoriesFilterDto>;
  counterparty: FilterDef;
  imported: FilterDef;
  includeTransaction: FilterDef;
  invoiceVat?: Maybe<FilterDef>;
  status: FilterDef;
  suspiciousAlert: FilterDef;
  transactionDate?: Maybe<FilterDef>;
  transactionType: FilterDef;
};

export type TransactionsPeriodWithDocsInputDto = {
  /** incoming transactions */
  incoming?: InputMaybe<Scalars['Boolean']['input']>;
  /** if a transaction has a file */
  match?: InputMaybe<Scalars['Boolean']['input']>;
  /** outgoing transactions */
  outgoing?: InputMaybe<Scalars['Boolean']['input']>;
  periodId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionsPeriodWithDocsResponseListType = {
  __typename?: 'TransactionsPeriodWithDocsResponseListType';
  /** List */
  list?: Maybe<Array<TransactionDto>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export type TransactionsStatisticsDto = {
  __typename?: 'TransactionsStatisticsDto';
  autoMatchedCount: Scalars['Float']['output'];
  manualMatchedCount: Scalars['Float']['output'];
  totalMatchedCount: Scalars['Float']['output'];
  transactionsCount: Scalars['Float']['output'];
};

/** Files with groupType=transfer */
export type TransferFileDto = {
  __typename?: 'TransferFileDto';
  /** Accounting status */
  accStatusId: FileAccStatus;
  /** File ID */
  id: Scalars['UuidType']['output'];
  /** File name */
  name: Scalars['String']['output'];
  /** Rejection comment */
  rejectionComment?: Maybe<Scalars['String']['output']>;
  /** Rejection reason */
  rejectionReasonId?: Maybe<FileRejectionReason>;
  /** File type */
  type?: Maybe<FileType>;
};

/** Company folders list with pagination */
export type TransferFileListDto = {
  __typename?: 'TransferFileListDto';
  /** Files list */
  files: Array<TransferFileDto>;
  /** Quantity of items to take */
  limit: Scalars['Int']['output'];
  /** Quantity of items to skip */
  offset: Scalars['Int']['output'];
  /** Total quantity */
  total: Scalars['Int']['output'];
};

export type TranslationJob = {
  __typename?: 'TranslationJob';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deeplDocumentId?: Maybe<Scalars['String']['output']>;
  deeplDocumentKey?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nextCheckAt?: Maybe<Scalars['DateTime']['output']>;
  resultFileId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  targetLanguage: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** TSD Tax payment links for YearlyAcc clients */
export type TsdTaxLinkEntity = {
  __typename?: 'TsdTaxLinkEntity';
  /** UUID of the company */
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** UUID of the accountant who originally created the record */
  createdById: Scalars['String']['output'];
  /** Unique UUID of the record */
  id: Scalars['String']['output'];
  /** Link for TSD tax payment */
  link: Scalars['String']['output'];
  /** Reporting month (1-12) */
  month: Scalars['Int']['output'];
  /** ISO period string for frontend convenience (YYYY-MM-DD) */
  periodIso: Scalars['String']['output'];
  /** TSD tax sum to pay */
  sum: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** UUID of the accountant who last updated the record */
  updatedById: Scalars['String']['output'];
  /** Reporting year (e.g., 2026) */
  year: Scalars['Int']['output'];
};

export type UnreadCountByPeriodDto = {
  __typename?: 'UnreadCountByPeriodDto';
  totalUnreadCount: Scalars['Float']['output'];
  unreadMessages: Array<UnreadMessageInfo>;
};

export type UnreadMessageInfo = {
  __typename?: 'UnreadMessageInfo';
  chatId: Scalars['String']['output'];
  unreadByUserCount: Scalars['Float']['output'];
};

export type UpdateCompanyFolderByAdminInputDto = {
  aTransferDate?: InputMaybe<Scalars['DateTime']['input']>;
  airtableBanks?: InputMaybe<Scalars['String']['input']>;
  airtableEcomPlatforms?: InputMaybe<Scalars['String']['input']>;
  taxOfficeAccessStatus?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCompanyFolderInputDto = {
  aTransferDate?: InputMaybe<Scalars['DateTime']['input']>;
  taxOfficeAccessStatus?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCompanyInputType = {
  /** Activity code */
  activityCode?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Field of activity */
  fieldOfActivity?: InputMaybe<Scalars['String']['input']>;
  /** Some Dutch field */
  obNummer?: InputMaybe<Scalars['String']['input']>;
  payrollTaxNumber?: InputMaybe<Scalars['String']['input']>;
  /** Company registry address */
  registryAddress?: InputMaybe<Scalars['String']['input']>;
  /** Company registry code */
  registryCode?: InputMaybe<Scalars['String']['input']>;
  /** Company registry date */
  registryDate?: InputMaybe<Scalars['DateTimeType']['input']>;
  rsin?: InputMaybe<Scalars['String']['input']>;
  /** Share capital in euros */
  shareCapital?: InputMaybe<Scalars['Float']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFinancesSettingsInput = {
  alertOn?: InputMaybe<Scalars['Boolean']['input']>;
  defaultCurrency?: InputMaybe<Scalars['String']['input']>;
  thresholdAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateMonitePayableInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  counterpart_account_id?: InputMaybe<Scalars['String']['input']>;
  counterpart_bank_id?: InputMaybe<Scalars['String']['input']>;
  counterpart_name?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<MoniteCurrencyTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['String']['input']>;
  issued_at?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  tax?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateTaskInput = {
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  periodIds?: InputMaybe<Array<Scalars['String']['input']>>;
  subject?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['String']['input'];
  transactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateTransactionDetailsInput = {
  bankingCategoryItemId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  counterpartyId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['String']['input'];
};

export type UpdateUserInputType = {
  /** Captcha token from widget */
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type UploadCmDocInputType = {
  /** ID of the counterparty */
  counterpartyId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the file-document from filestorage (pdf or docx) */
  fileId: Scalars['String']['input'];
  /** Amount of the Product from invoicing */
  itemAmount?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Product from invoicing */
  itemId?: InputMaybe<Scalars['String']['input']>;
  /** Custom name of the file when uploading the document */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Payload to create or update TSD tax link */
export type UpsertTsdTaxLinkInputDto = {
  /** Payment link URL */
  link: Scalars['String']['input'];
  /** Reporting month (1-12) */
  month: Scalars['Int']['input'];
  /** Tax sum to pay */
  sum: Scalars['Float']['input'];
  /** UUID from a_year_folder table */
  yearFolderId: Scalars['String']['input'];
};

export type User = {
  accessTokens?: InputMaybe<Array<AccessToken>>;
  cmVisited: Scalars['Boolean']['input'];
  createdAt: Scalars['DateTimeType']['input'];
  currentLanguage: Scalars['String']['input'];
  /** Linked eID identities (one per method) */
  eidLinks: Array<UserEidLink>;
  email: Scalars['String']['input'];
  /** When the user set their current email */
  emailSetAt?: InputMaybe<Scalars['DateTimeType']['input']>;
  firstPromoterAuthToken?: InputMaybe<Scalars['String']['input']>;
  firstPromoterId?: InputMaybe<Scalars['Float']['input']>;
  /** Identifier in the CRM system freshworks */
  freshworksId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** Number of articles read in the Knowledge Base */
  kbReadArticles: Scalars['Int']['input'];
  /** Last login date */
  lastLoginAt?: InputMaybe<Scalars['DateTimeType']['input']>;
  login: Scalars['String']['input'];
  /** Current step for the mobile user interface */
  mobileStep?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role: UserRoleEnum;
  surname?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeType']['input']>;
  userCompanies?: InputMaybe<Array<UserCompany>>;
  userFirmCompanies?: InputMaybe<Array<UserFirmCompany>>;
  userFirms?: InputMaybe<Array<UserFirm>>;
};

export type UserAssignRolePayload = {
  __typename?: 'UserAssignRolePayload';
  /** User information */
  user: UserType;
};

/** Change password */
export type UserChangePasswordInputType = {
  /** New user password */
  password: Scalars['String']['input'];
  /** Token ID */
  token: Scalars['String']['input'];
};

export type UserCompany = {
  /** User rights: reader, editor. First and only - editor */
  access: Scalars['String']['input'];
  company: Company;
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  creatorUserId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  /** Current company for the user */
  isCurrent: Scalars['Boolean']['input'];
  updatedAt: Scalars['DateTime']['input'];
  user: User;
  userId: Scalars['String']['input'];
};

/** User role */
export enum UserCompanyRole {
  Editor = 'Editor',
  Reader = 'Reader'
}

export type UserCompanyType = {
  __typename?: 'UserCompanyType';
  /** User rights: reader, editor. First and only - editor */
  access: Scalars['String']['output'];
  company: CompanyOpeningType;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  creatorUserId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** Current company for the user */
  isCurrent: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
  userId: Scalars['String']['output'];
};

export type UserConfirmEmailInputType = {
  /** Token ID */
  token: Scalars['String']['input'];
};

export type UserConfirmTokenCreatePayload = {
  __typename?: 'UserConfirmTokenCreatePayload';
  /** Confirmation token generation result */
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UserCreateInputType = {
  /** Captcha token from widget */
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  /** Email */
  email: Scalars['EmailType']['input'];
  /** From which page the user entered registration */
  from: Scalars['String']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** User password */
  password: Scalars['String']['input'];
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreatedDto = {
  __typename?: 'UserCreatedDto';
  isInvited: Scalars['Boolean']['output'];
  /** Information about the current user */
  user?: Maybe<UserType>;
};

export type UserEidLink = {
  /** ISO-2 country of the linked eID identity */
  country: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** When this method was linked */
  linkedAt: Scalars['DateTimeType']['input'];
  /** eIDEasy method: smart-id / mobile-id / id-card */
  provider: Scalars['String']['input'];
};

export type UserEidLinkType = {
  __typename?: 'UserEidLinkType';
  /** ISO-2 country of the linked eID identity */
  country: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** When this method was linked */
  linkedAt: Scalars['DateTimeType']['output'];
  /** eIDEasy method: smart-id / mobile-id / id-card */
  provider: Scalars['String']['output'];
};

export type UserFirm = {
  access: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  creatorUserId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  firm: FirmType;
  firmId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
  user: User;
  userId: Scalars['String']['input'];
};

export type UserFirmCompany = {
  company: Company;
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  user: User;
  userId: Scalars['String']['input'];
};

export type UserFirmCompanyType = {
  __typename?: 'UserFirmCompanyType';
  company: CompanyOpeningType;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  user: UserType;
  userId: Scalars['String']['output'];
};

export type UserFirmType = {
  __typename?: 'UserFirmType';
  access: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  creatorUserId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  firm: Firm;
  firmId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
  userId: Scalars['String']['output'];
};

export type UserForgotPasswordInputType = {
  /** Captcha token from the widget */
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  /** Email address */
  email: Scalars['EmailType']['input'];
};

export type UserInviteCompanyInput = {
  /** Captcha token from widget */
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  /** Email of the invited user */
  email: Scalars['String']['input'];
  /** Role of the invited user */
  role: UserCompanyRole;
};

export type UserLoginInputType = {
  login: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UserLoginMfaVerifyInputType = {
  /** Current code from the authenticator app */
  code: Scalars['String']['input'];
  /** Challenge token issued with the MFA_REQUIRED error */
  mfaToken: Scalars['String']['input'];
};

export type UserLoginPayload = {
  __typename?: 'UserLoginPayload';
  /** Is the user invited */
  isInvited?: Maybe<Scalars['Boolean']['output']>;
  /** True only when an eID REGISTER flow created a brand-new account; frontend should then prompt for the real email. */
  isNewUser?: Maybe<Scalars['Boolean']['output']>;
  /** Is it the first login with Google/Apple, including registration */
  isSocialRegistration?: Maybe<Scalars['Boolean']['output']>;
  /** Session token */
  sid?: Maybe<Scalars['String']['output']>;
  /** User information */
  user?: Maybe<UserType>;
};

export enum UserLoginSocialTypeEnum {
  Apple = 'Apple',
  Fb = 'FB',
  Google = 'Google'
}

export type UserLogoutPayload = {
  __typename?: 'UserLogoutPayload';
  /** Session token */
  sid: Scalars['String']['output'];
  /** User information */
  user: UserType;
};

export type UserMulticompanyType = {
  __typename?: 'UserMulticompanyType';
  companyId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Current company for the user */
  isCurrent: Scalars['Boolean']['output'];
  marketId?: Maybe<Scalars['Float']['output']>;
  /** Company name */
  name: Scalars['String']['output'];
  /** Plan name */
  planName?: Maybe<Scalars['String']['output']>;
  processStep: Scalars['String']['output'];
};

export type UserMutation = {
  __typename?: 'UserMutation';
  /** Get data manually from chargebee */
  addNewSubscription: Scalars['Boolean']['output'];
  adminDeleteUser: Scalars['String']['output'];
  /** Sends the password restore email to the given user. Manager only, no captcha required */
  adminForgotPassword: UserConfirmTokenCreatePayload;
  adminRestorePassword: Scalars['String']['output'];
  assignAdminRole: UserAssignRolePayload;
  assignUserRole: UserAssignRolePayload;
  changeCurrentCompany: Scalars['Boolean']['output'];
  changeEmail: UserAssignRolePayload;
  changeFreshworksId: UserType;
  changePassword: Scalars['Boolean']['output'];
  /** Subscription change */
  changeSubscription: Scalars['Boolean']['output'];
  /** Remove user from company */
  changeUserRoleInCompany: Scalars['Boolean']['output'];
  /** Finalizes the Payment Components checkout: validates the authorized payment intent and creates/updates the Chargebee subscription consuming it */
  checkoutComponentsFinalize: CheckoutComponentsFinalizePayload;
  /** Creates a Chargebee payment intent for the Payment Components checkout. The amount is calculated on the backend */
  checkoutComponentsIntentCreate: CheckoutComponentsIntentCreatePayload;
  checkoutSessionCreate: CheckoutSessionCreatePayload;
  confirmEmail: UserPayload;
  /** Issue a personal API token for the current company. The secret is returned once and never again */
  createApiToken: ApiTokenCreatePayload;
  createPromoter: UserType;
  deleteAccount: Scalars['Boolean']['output'];
  downloadOldChargebeeInvoices: Scalars['Boolean']['output'];
  /** Finalize the LOGIN or REGISTER flow: exchange the eIDEasy authorization code and return a session. For REGISTER, a new account is created when the eID is unknown (isNewUser=true); known identities are logged in (isNewUser=false). */
  eidEasyAuthComplete: UserLoginPayload;
  /** Build the redirect URL to the eIDEasy authentication page. For purpose=LOGIN the caller MUST be anonymous. For purpose=LINK the caller MUST be authenticated. */
  eidEasyAuthInit: EidEasyAuthInitPayload;
  /** Finalize the LINK flow: bind the verified eID method to the current user. Returns the freshly-created link row. */
  eidEasyLink: UserEidLinkType;
  /** After an eID REGISTER, set the user real email. Validates it, stores it as email+login, and sends the standard confirmation link to the new address. Caller must be the freshly registered (Deactivated) user. */
  eidEasySetEmail: EidEasySetEmailPayload;
  /** Remove the specified eID method from the current user. Idempotent: returns true even if the method was not linked. */
  eidEasyUnlink: Scalars['Boolean']['output'];
  forgotPassword: UserConfirmTokenCreatePayload;
  /** Get token for albato */
  getAlbatoToken: Scalars['String']['output'];
  /** Add user to company */
  inviteUserToCompany: Scalars['Boolean']['output'];
  login: UserLoginPayload;
  loginMfaVerify: UserLoginPayload;
  loginWithSocials: UserLoginPayload;
  logout: UserLogoutPayload;
  /** Password reset for a manager locked out of the admin panel. Ignores addresses that are not a manager's, no captcha required */
  managerForgotPassword: UserConfirmTokenCreatePayload;
  mfaDisable: MfaStatusPayload;
  mfaRecoveryCodesRegenerate: MfaRecoveryCodesPayload;
  mfaSetupConfirm: MfaSetupConfirmPayload;
  mfaSetupInit: MfaSetupPayload;
  newsSubscriptionCreate: Scalars['Boolean']['output'];
  pauseChargebeeSubscription: ChargebeeSubscriptionType;
  /** Remove user from company */
  removeUserFromCompany: Scalars['Boolean']['output'];
  resendConfirmLink: UserConfirmTokenCreatePayload;
  restorePassword: UserPayload;
  /** Revoke (delete) one of the user's API tokens */
  revokeApiToken: Scalars['Boolean']['output'];
  sendCustomEmail: Scalars['Boolean']['output'];
  setCMVisited: Scalars['Boolean']['output'];
  /** Change current language */
  setLanguage: UserType;
  /** Saving the selected user market */
  setMarket: UserType;
  setMobileStep: UserType;
  setOnboardingPollChoices: Scalars['Boolean']['output'];
  updateUser: UserType;
  userCreate: UserCreatedDto;
  visitCreate: UserVisitType;
};


export type UserMutationAdminDeleteUserArgs = {
  userId: Scalars['String']['input'];
};


export type UserMutationAdminForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type UserMutationAdminRestorePasswordArgs = {
  email: Scalars['String']['input'];
};


export type UserMutationAssignAdminRoleArgs = {
  userId: Scalars['String']['input'];
};


export type UserMutationAssignUserRoleArgs = {
  userId: Scalars['String']['input'];
};


export type UserMutationChangeCurrentCompanyArgs = {
  companyId: Scalars['String']['input'];
};


export type UserMutationChangeEmailArgs = {
  email: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type UserMutationChangeFreshworksIdArgs = {
  freshworksId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type UserMutationChangePasswordArgs = {
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type UserMutationChangeSubscriptionArgs = {
  newPlanId: Scalars['String']['input'];
};


export type UserMutationChangeUserRoleInCompanyArgs = {
  changeCompanyRoleInput: ChangeCompanyRoleInput;
};


export type UserMutationCheckoutComponentsFinalizeArgs = {
  addons: CheckoutSessionAddonsInputType;
  couponId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  paymentIntentId: Scalars['String']['input'];
};


export type UserMutationCheckoutComponentsIntentCreateArgs = {
  addons: CheckoutSessionAddonsInputType;
  couponId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type UserMutationCheckoutSessionCreateArgs = {
  addons: CheckoutSessionAddonsInputType;
  id: Scalars['String']['input'];
};


export type UserMutationConfirmEmailArgs = {
  input: UserConfirmEmailInputType;
};


export type UserMutationCreateApiTokenArgs = {
  name: Scalars['String']['input'];
};


export type UserMutationDownloadOldChargebeeInvoicesArgs = {
  password: Scalars['String']['input'];
};


export type UserMutationEidEasyAuthCompleteArgs = {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type UserMutationEidEasyAuthInitArgs = {
  input: EidEasyAuthInitInput;
};


export type UserMutationEidEasyLinkArgs = {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type UserMutationEidEasySetEmailArgs = {
  email: Scalars['String']['input'];
};


export type UserMutationEidEasyUnlinkArgs = {
  method: EidEasyAuthMethod;
};


export type UserMutationForgotPasswordArgs = {
  input: UserForgotPasswordInputType;
};


export type UserMutationInviteUserToCompanyArgs = {
  companyNewUserInput: UserInviteCompanyInput;
};


export type UserMutationLoginArgs = {
  input: UserLoginInputType;
};


export type UserMutationLoginMfaVerifyArgs = {
  input: UserLoginMfaVerifyInputType;
};


export type UserMutationLoginWithSocialsArgs = {
  input: UserSocialLoginInputType;
};


export type UserMutationManagerForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type UserMutationMfaDisableArgs = {
  code: Scalars['String']['input'];
};


export type UserMutationMfaRecoveryCodesRegenerateArgs = {
  code: Scalars['String']['input'];
};


export type UserMutationMfaSetupConfirmArgs = {
  code: Scalars['String']['input'];
};


export type UserMutationNewsSubscriptionCreateArgs = {
  email: Scalars['String']['input'];
  leadFrom: Scalars['String']['input'];
};


export type UserMutationPauseChargebeeSubscriptionArgs = {
  input: ChargebeeStopSubscriptionInputType;
};


export type UserMutationRemoveUserFromCompanyArgs = {
  userId: Scalars['String']['input'];
};


export type UserMutationResendConfirmLinkArgs = {
  input: UserResendLinkInputType;
};


export type UserMutationRestorePasswordArgs = {
  input: UserChangePasswordInputType;
};


export type UserMutationRevokeApiTokenArgs = {
  id: Scalars['String']['input'];
};


export type UserMutationSendCustomEmailArgs = {
  emailData: CustomEmailInputType;
};


export type UserMutationSetLanguageArgs = {
  language: Scalars['String']['input'];
};


export type UserMutationSetMarketArgs = {
  marketId: Scalars['Int']['input'];
};


export type UserMutationSetMobileStepArgs = {
  mobileStep: Scalars['String']['input'];
};


export type UserMutationSetOnboardingPollChoicesArgs = {
  choices: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationUpdateUserArgs = {
  updateUserData: UpdateUserInputType;
};


export type UserMutationUserCreateArgs = {
  input: UserCreateInputType;
};


export type UserMutationVisitCreateArgs = {
  visit: UserVisitCreateInputType;
};

export type UserMyPayload = {
  __typename?: 'UserMyPayload';
  /** User role in the company */
  roleInCompany?: Maybe<UserCompanyRole>;
  /** Information about the current user */
  user?: Maybe<UserType>;
};

export type UserPayload = {
  __typename?: 'UserPayload';
  /** Information about the current user */
  user?: Maybe<UserType>;
};

export type UserQuery = {
  __typename?: 'UserQuery';
  /** Personal API tokens of the user (all companies), newest first */
  apiTokens: Array<ApiToken>;
  /** User query history */
  billsbyClicksList: BillsbyClicksListType;
  /** User invoices in the chargebee system */
  chargebeeInvoiceList: ChargebeeInvoiceListType;
  checkSumOfPassword: Scalars['Boolean']['output'];
  /** Get company users */
  companyUsersList: Array<UserCompanyType>;
  /** User query history */
  createPortalSession: PortalSession;
  /** Visit history */
  emailExists: EmailExistsPayload;
  /** Preliminary price calculation when changing the plan */
  estimateForNewPlan?: Maybe<Estimate>;
  /** All user companies */
  getAllUserCompanies: Array<UserMulticompanyType>;
  /** Onboarding survey results */
  getOnboardingPollChoices?: Maybe<Scalars['String']['output']>;
  /** Is there a subscription to the Control Panel */
  haveControlPanelAccess: Scalars['Boolean']['output'];
  /** All markets (countries) we work with */
  markets: Array<Market>;
  me: UserMyPayload;
  /** Last created meeting pending */
  meeting?: Maybe<IncorporationMeetType>;
  mfaStatus: MfaStatusPayload;
  /** User query history */
  questionList: UserQuestionListType;
  /** User */
  user: UserPayload;
  /** Users with companies for admin panel */
  usersList: UsersListType;
  /** Visit history */
  visitList: UserVisitListType;
};


export type UserQueryBillsbyClicksListArgs = {
  pagination?: InputMaybe<PaginationInputType>;
};


export type UserQueryChargebeeInvoiceListArgs = {
  filter: ChargebeeInvoiceListQueryFilterInputType;
  pagination?: InputMaybe<PaginationInputType>;
  sort?: InputMaybe<ChargebeeInvoiceListQuerySortInputType>;
};


export type UserQueryCheckSumOfPasswordArgs = {
  password: Scalars['String']['input'];
};


export type UserQueryEmailExistsArgs = {
  filter?: InputMaybe<EmailExistsInputType>;
};


export type UserQueryEstimateForNewPlanArgs = {
  newPlanId: Scalars['String']['input'];
};


export type UserQueryGetOnboardingPollChoicesArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type UserQueryMeetingArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type UserQueryQuestionListArgs = {
  filter: UserQuestionListQueryFilterInputType;
  pagination?: InputMaybe<PaginationInputType>;
  sort?: InputMaybe<UserQuestionListQuerySortInputType>;
};


export type UserQueryUserArgs = {
  filter?: InputMaybe<UserQueryFilterInputType>;
};


export type UserQueryUsersListArgs = {
  filter?: InputMaybe<UsersListQueryFilterInputType>;
  pagination?: InputMaybe<PaginationInputType>;
  role?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<UsersListQuerySortInputType>;
};


export type UserQueryVisitListArgs = {
  filter?: InputMaybe<UserVisitListQueryFilterInputType>;
  pagination?: InputMaybe<PaginationInputType>;
  sort?: InputMaybe<SortInputType>;
};

export type UserQueryFilterInputType = {
  /** User ID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Token ID */
  token?: InputMaybe<Scalars['String']['input']>;
};

export type UserQuestionListQueryFilterInputType = {
  /** User identifier */
  userId: Scalars['String']['input'];
};

export type UserQuestionListQuerySortInputType = {
  /** Sorting field */
  field?: InputMaybe<Scalars['String']['input']>;
  /** Sorting order */
  type?: InputMaybe<SortTypeEnum>;
};

export type UserQuestionListType = {
  __typename?: 'UserQuestionListType';
  /** List */
  list?: Maybe<Array<UserQuestionType>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

/** User request */
export type UserQuestionType = {
  __typename?: 'UserQuestionType';
  /** Creation date */
  createdAt: Scalars['DateTimeType']['output'];
  /** Reply email */
  email: Scalars['String']['output'];
  id: Scalars['UuidType']['output'];
  /** Content of the user request */
  question: Scalars['String']['output'];
  /** Source of the user request */
  source: IncorporationMeetSourceEnum;
  /** User identifier */
  userId?: Maybe<Scalars['UuidType']['output']>;
  /** Visitor identifier */
  visitorId: Scalars['UuidType']['output'];
};

/** Password change */
export type UserResendLinkInputType = {
  /** User ID */
  userId: Scalars['String']['input'];
};

/** User role */
export enum UserRoleEnum {
  Accountant = 'Accountant',
  Deactivated = 'Deactivated',
  Invited = 'Invited',
  InvitedAccountant = 'InvitedAccountant',
  Manager = 'Manager',
  User = 'User'
}

export type UserSocialLoginInputType = {
  /** Login method */
  socialType: UserLoginSocialTypeEnum;
  /** idToken */
  token: Scalars['String']['input'];
};

export type UserType = {
  __typename?: 'UserType';
  accessTokens?: Maybe<Array<AccessTokenType>>;
  /** Accounting onboarding */
  accountingOnboarding: Scalars['Boolean']['output'];
  activePlan?: Maybe<ChargebeePlan>;
  chargebeeCustomerId?: Maybe<Scalars['String']['output']>;
  chargebeeSubscriptions: Array<ChargebeeSubscriptionType>;
  cmVisited: Scalars['Boolean']['output'];
  /** User company ID */
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeType']['output'];
  currentLanguage: Scalars['String']['output'];
  /** Linked eID identities (one per method) */
  eidLinks: Array<UserEidLinkType>;
  email: Scalars['String']['output'];
  /** When the user set their current email */
  emailSetAt?: Maybe<Scalars['DateTimeType']['output']>;
  firstPromoterAuthToken?: Maybe<Scalars['String']['output']>;
  firstPromoterId?: Maybe<Scalars['Float']['output']>;
  /** Identifier in the CRM system freshworks */
  freshworksId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Number of articles read in the Knowledge Base */
  kbReadArticles: Scalars['Int']['output'];
  /** Last login date */
  lastLoginAt?: Maybe<Scalars['DateTimeType']['output']>;
  login: Scalars['String']['output'];
  /** Country the user is working with (market with details) */
  market: Market;
  marketId?: Maybe<Scalars['Float']['output']>;
  /** Current step for the mobile user interface */
  mobileStep?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role: UserRoleEnum;
  surname?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeType']['output']>;
  userCompanies?: Maybe<Array<UserCompanyType>>;
  userFirmCompanies?: Maybe<Array<UserFirmCompanyType>>;
  userFirms?: Maybe<Array<UserFirmType>>;
};

export type UserVisitCreateInputType = {
  /** Visited page */
  page: Scalars['String']['input'];
  /** Source of visit */
  referer: Scalars['String']['input'];
};

export type UserVisitListQueryFilterInputType = {
  /** User identifier */
  userId?: InputMaybe<Scalars['String']['input']>;
  /** Visitor identifier */
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type UserVisitListType = {
  __typename?: 'UserVisitListType';
  /** List */
  list?: Maybe<Array<UserVisitType>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

/** Visit history */
export type UserVisitType = {
  __typename?: 'UserVisitType';
  /** Creation date */
  createdAt: Scalars['DateTimeType']['output'];
  id: Scalars['UuidType']['output'];
  /** Visited page */
  page: Scalars['String']['output'];
  /** Source of visit */
  referer: Scalars['String']['output'];
  /** User ID */
  userId?: Maybe<Scalars['String']['output']>;
  /** UTM tags */
  utm: UserVisitUtmType;
  /** Visitor ID */
  visitorId: Scalars['UuidType']['output'];
};

export type UserVisitUtmType = {
  __typename?: 'UserVisitUtmType';
  campaign: Scalars['String']['output'];
  content: Scalars['String']['output'];
  medium: Scalars['String']['output'];
  source: Scalars['String']['output'];
  term: Scalars['String']['output'];
};

export type UserWhatsappNumbers = {
  __typename?: 'UserWhatsappNumbers';
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  hasConsent: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  source: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type UserWithCompanyType = {
  __typename?: 'UserWithCompanyType';
  companyId?: Maybe<Scalars['String']['output']>;
  companyNames?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeType']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastLoginAt?: Maybe<Scalars['DateTimeType']['output']>;
  login: Scalars['String']['output'];
  marketName?: Maybe<Scalars['String']['output']>;
  membersNames?: Maybe<Scalars['String']['output']>;
  resultSumSub?: Maybe<Scalars['String']['output']>;
  role: UserRoleEnum;
  status?: Maybe<Scalars['String']['output']>;
  sumSubStarted?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeType']['output']>;
};

export type UsersListQueryFilterInputType = {
  /** Market */
  marketId?: InputMaybe<Scalars['Int']['input']>;
  /** Search pattern */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Was compliance conducted */
  sumSubStarted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UsersListQuerySortInputType = {
  /** Sorting field */
  field?: InputMaybe<Scalars['String']['input']>;
  /** Sorting order */
  type?: InputMaybe<SortTypeEnum>;
};

/** List of users with companies */
export type UsersListType = {
  __typename?: 'UsersListType';
  /** List */
  list?: Maybe<Array<UserWithCompanyType>>;
  /** Pagination */
  pagination?: Maybe<PaginationType>;
};

export type ValidateClientTextResult = {
  __typename?: 'ValidateClientTextResult';
  foreign_fragments: Array<Scalars['String']['output']>;
  improved_en: Scalars['String']['output'];
  issues: Array<Scalars['String']['output']>;
  language_detected: Scalars['String']['output'];
  needs_improvement: Scalars['Boolean']['output'];
  translation: Scalars['String']['output'];
  translation_language: Scalars['String']['output'];
};

export type ValidateTicketDraftResult = {
  __typename?: 'ValidateTicketDraftResult';
  message: ValidateClientTextResult;
  subject: ValidateClientTextResult;
};

/** Kind of accountant text validated before sending to a client (chat message or ticket subject). */
export enum ValidationKind {
  Message = 'MESSAGE',
  Subject = 'SUBJECT'
}

export type ValueSummary = {
  __typename?: 'ValueSummary';
  confidence?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** VAT status */
export enum VatStatusEnum {
  NotApplicable = 'NotApplicable',
  NotVatable = 'NotVatable',
  Vatable = 'Vatable'
}

export type WhatsappNotificationSettingsType = {
  __typename?: 'WhatsappNotificationSettingsType';
  connectedNumbers: Array<ConnectedNumberType>;
  isNotificationOn: Scalars['Boolean']['output'];
};

export type YearFolder = {
  __typename?: 'YearFolder';
  companyFolder?: Maybe<CompanyFolder>;
  /** Company folder ID */
  companyFolderId: Scalars['UuidType']['output'];
  /** Company ID */
  companyId: Scalars['UuidType']['output'];
  /** File information creation time */
  createdAt?: Maybe<Scalars['DateTimeType']['output']>;
  /** Primary ID */
  id: Scalars['UuidType']['output'];
  /** Folder name */
  name: Scalars['String']['output'];
  periods?: Maybe<Array<AccountingReportType>>;
  totalFilesQty?: Maybe<Scalars['Float']['output']>;
  unreadFilesQty?: Maybe<Scalars['Float']['output']>;
  /** Unread messages count */
  unreadMessagesCount?: Maybe<Scalars['Int']['output']>;
};

export type SearchInvoicesCustomerItem = {
  __typename?: 'searchInvoicesCustomerItem';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  registryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};
